(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("Playable", [], factory);
	else if(typeof exports === 'object')
		exports["Playable"] = factory();
	else
		root["Playable"] = factory();
})(typeof self !== 'undefined' ? self : this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	__webpack_require__.p = typeof window !== 'undefined' && window.__STATICS_BASE_URL__ || __webpack_require__.p;
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 56);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["__extends"] = __extends;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__assign", function() { return __assign; });
/* harmony export (immutable) */ __webpack_exports__["__rest"] = __rest;
/* harmony export (immutable) */ __webpack_exports__["__decorate"] = __decorate;
/* harmony export (immutable) */ __webpack_exports__["__param"] = __param;
/* harmony export (immutable) */ __webpack_exports__["__metadata"] = __metadata;
/* harmony export (immutable) */ __webpack_exports__["__awaiter"] = __awaiter;
/* harmony export (immutable) */ __webpack_exports__["__generator"] = __generator;
/* harmony export (immutable) */ __webpack_exports__["__exportStar"] = __exportStar;
/* harmony export (immutable) */ __webpack_exports__["__values"] = __values;
/* harmony export (immutable) */ __webpack_exports__["__read"] = __read;
/* harmony export (immutable) */ __webpack_exports__["__spread"] = __spread;
/* harmony export (immutable) */ __webpack_exports__["__await"] = __await;
/* harmony export (immutable) */ __webpack_exports__["__asyncGenerator"] = __asyncGenerator;
/* harmony export (immutable) */ __webpack_exports__["__asyncDelegator"] = __asyncDelegator;
/* harmony export (immutable) */ __webpack_exports__["__asyncValues"] = __asyncValues;
/* harmony export (immutable) */ __webpack_exports__["__makeTemplateObject"] = __makeTemplateObject;
/* harmony export (immutable) */ __webpack_exports__["__importStar"] = __importStar;
/* harmony export (immutable) */ __webpack_exports__["__importDefault"] = __importDefault;
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = Object.setPrototypeOf ||
    ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
    function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };

function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = Object.assign || function __assign(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
}

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
}

function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __param(paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
}

function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function __awaiter(thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __exportStar(m, exports) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}

function __values(o) {
    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
    if (m) return m.call(o);
    return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}

function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
    function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
    function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);  }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
}

function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
    function verb(n, f) { if (o[n]) i[n] = function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; }; }
}

function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator];
    return m ? m.call(o) : typeof __values === "function" ? __values(o) : o[Symbol.iterator]();
}

function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};

function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result.default = mod;
    return result;
}

function __importDefault(mod) {
    return (mod && mod.__esModule) ? mod : { default: mod };
}


/***/ }),
/* 1 */,
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var media_stream_1 = __webpack_require__(82);
exports.MediaStreamTypes = media_stream_1.MediaStreamTypes;
exports.MediaStreamDeliveryPriority = media_stream_1.MediaStreamDeliveryPriority;
var ui_1 = tslib_1.__importDefault(__webpack_require__(83));
exports.UI_EVENTS = ui_1.default;
var video_1 = tslib_1.__importDefault(__webpack_require__(84));
exports.VIDEO_EVENTS = video_1.default;
var errors_1 = tslib_1.__importDefault(__webpack_require__(85));
exports.ERRORS = errors_1.default;
var text_labels_1 = tslib_1.__importDefault(__webpack_require__(86));
exports.TEXT_LABELS = text_labels_1.default;
var engine_states_1 = tslib_1.__importDefault(__webpack_require__(87));
exports.STATES = engine_states_1.default;
var live_state_1 = tslib_1.__importDefault(__webpack_require__(88));
exports.LiveState = live_state_1.default;


/***/ }),
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
function htmlToElement(html) {
    var div = document.createElement('div');
    div.innerHTML = html.trim();
    return div.firstChild;
}
exports.default = htmlToElement;


/***/ }),
/* 7 */
/***/ (function(module, exports) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
// css base code, injected by the css-loader
module.exports = function(useSourceMap) {
	var list = [];

	// return the list of modules as css string
	list.toString = function toString() {
		return this.map(function (item) {
			var content = cssWithMappingToString(item, useSourceMap);
			if(item[2]) {
				return "@media " + item[2] + "{" + content + "}";
			} else {
				return content;
			}
		}).join("");
	};

	// import a list of modules into the list
	list.i = function(modules, mediaQuery) {
		if(typeof modules === "string")
			modules = [[null, modules, ""]];
		var alreadyImportedModules = {};
		for(var i = 0; i < this.length; i++) {
			var id = this[i][0];
			if(typeof id === "number")
				alreadyImportedModules[id] = true;
		}
		for(i = 0; i < modules.length; i++) {
			var item = modules[i];
			// skip already imported module
			// this implementation is not 100% perfect for weird media query combinations
			//  when a module is imported multiple times with different media queries.
			//  I hope this will never occur (Hey this way we have smaller bundles)
			if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
				if(mediaQuery && !item[2]) {
					item[2] = mediaQuery;
				} else if(mediaQuery) {
					item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
				}
				list.push(item);
			}
		}
	};
	return list;
};

function cssWithMappingToString(item, useSourceMap) {
	var content = item[1] || '';
	var cssMapping = item[3];
	if (!cssMapping) {
		return content;
	}

	if (useSourceMap && typeof btoa === 'function') {
		var sourceMapping = toComment(cssMapping);
		var sourceURLs = cssMapping.sources.map(function (source) {
			return '/*# sourceURL=' + cssMapping.sourceRoot + source + ' */'
		});

		return [content].concat(sourceURLs).concat([sourceMapping]).join('\n');
	}

	return [content].join('\n');
}

// Adapted from convert-source-map (MIT)
function toComment(sourceMap) {
	// eslint-disable-next-line no-undef
	var base64 = btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap))));
	var data = 'sourceMappingURL=data:application/json;charset=utf-8;base64,' + base64;

	return '/*# ' + data + ' */';
}


/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/

var stylesInDom = {};

var	memoize = function (fn) {
	var memo;

	return function () {
		if (typeof memo === "undefined") memo = fn.apply(this, arguments);
		return memo;
	};
};

var isOldIE = memoize(function () {
	// Test for IE <= 9 as proposed by Browserhacks
	// @see http://browserhacks.com/#hack-e71d8692f65334173fee715c222cb805
	// Tests for existence of standard globals is to allow style-loader
	// to operate correctly into non-standard environments
	// @see https://github.com/webpack-contrib/style-loader/issues/177
	return window && document && document.all && !window.atob;
});

var getElement = (function (fn) {
	var memo = {};

	return function(selector) {
		if (typeof memo[selector] === "undefined") {
			memo[selector] = fn.call(this, selector);
		}

		return memo[selector]
	};
})(function (target) {
	return document.querySelector(target)
});

var singleton = null;
var	singletonCounter = 0;
var	stylesInsertedAtTop = [];

var	fixUrls = __webpack_require__(96);

module.exports = function(list, options) {
	if (typeof DEBUG !== "undefined" && DEBUG) {
		if (typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
	}

	options = options || {};

	options.attrs = typeof options.attrs === "object" ? options.attrs : {};

	// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
	// tags it will allow on a page
	if (!options.singleton) options.singleton = isOldIE();

	// By default, add <style> tags to the <head> element
	if (!options.insertInto) options.insertInto = "head";

	// By default, add <style> tags to the bottom of the target
	if (!options.insertAt) options.insertAt = "bottom";

	var styles = listToStyles(list, options);

	addStylesToDom(styles, options);

	return function update (newList) {
		var mayRemove = [];

		for (var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];

			domStyle.refs--;
			mayRemove.push(domStyle);
		}

		if(newList) {
			var newStyles = listToStyles(newList, options);
			addStylesToDom(newStyles, options);
		}

		for (var i = 0; i < mayRemove.length; i++) {
			var domStyle = mayRemove[i];

			if(domStyle.refs === 0) {
				for (var j = 0; j < domStyle.parts.length; j++) domStyle.parts[j]();

				delete stylesInDom[domStyle.id];
			}
		}
	};
};

function addStylesToDom (styles, options) {
	for (var i = 0; i < styles.length; i++) {
		var item = styles[i];
		var domStyle = stylesInDom[item.id];

		if(domStyle) {
			domStyle.refs++;

			for(var j = 0; j < domStyle.parts.length; j++) {
				domStyle.parts[j](item.parts[j]);
			}

			for(; j < item.parts.length; j++) {
				domStyle.parts.push(addStyle(item.parts[j], options));
			}
		} else {
			var parts = [];

			for(var j = 0; j < item.parts.length; j++) {
				parts.push(addStyle(item.parts[j], options));
			}

			stylesInDom[item.id] = {id: item.id, refs: 1, parts: parts};
		}
	}
}

function listToStyles (list, options) {
	var styles = [];
	var newStyles = {};

	for (var i = 0; i < list.length; i++) {
		var item = list[i];
		var id = options.base ? item[0] + options.base : item[0];
		var css = item[1];
		var media = item[2];
		var sourceMap = item[3];
		var part = {css: css, media: media, sourceMap: sourceMap};

		if(!newStyles[id]) styles.push(newStyles[id] = {id: id, parts: [part]});
		else newStyles[id].parts.push(part);
	}

	return styles;
}

function insertStyleElement (options, style) {
	var target = getElement(options.insertInto)

	if (!target) {
		throw new Error("Couldn't find a style target. This probably means that the value for the 'insertInto' parameter is invalid.");
	}

	var lastStyleElementInsertedAtTop = stylesInsertedAtTop[stylesInsertedAtTop.length - 1];

	if (options.insertAt === "top") {
		if (!lastStyleElementInsertedAtTop) {
			target.insertBefore(style, target.firstChild);
		} else if (lastStyleElementInsertedAtTop.nextSibling) {
			target.insertBefore(style, lastStyleElementInsertedAtTop.nextSibling);
		} else {
			target.appendChild(style);
		}
		stylesInsertedAtTop.push(style);
	} else if (options.insertAt === "bottom") {
		target.appendChild(style);
	} else {
		throw new Error("Invalid value for parameter 'insertAt'. Must be 'top' or 'bottom'.");
	}
}

function removeStyleElement (style) {
	if (style.parentNode === null) return false;
	style.parentNode.removeChild(style);

	var idx = stylesInsertedAtTop.indexOf(style);
	if(idx >= 0) {
		stylesInsertedAtTop.splice(idx, 1);
	}
}

function createStyleElement (options) {
	var style = document.createElement("style");

	options.attrs.type = "text/css";

	addAttrs(style, options.attrs);
	insertStyleElement(options, style);

	return style;
}

function createLinkElement (options) {
	var link = document.createElement("link");

	options.attrs.type = "text/css";
	options.attrs.rel = "stylesheet";

	addAttrs(link, options.attrs);
	insertStyleElement(options, link);

	return link;
}

function addAttrs (el, attrs) {
	Object.keys(attrs).forEach(function (key) {
		el.setAttribute(key, attrs[key]);
	});
}

function addStyle (obj, options) {
	var style, update, remove, result;

	// If a transform function was defined, run it on the css
	if (options.transform && obj.css) {
	    result = options.transform(obj.css);

	    if (result) {
	    	// If transform returns a value, use that instead of the original css.
	    	// This allows running runtime transformations on the css.
	    	obj.css = result;
	    } else {
	    	// If the transform function returns a falsy value, don't add this css.
	    	// This allows conditional loading of css
	    	return function() {
	    		// noop
	    	};
	    }
	}

	if (options.singleton) {
		var styleIndex = singletonCounter++;

		style = singleton || (singleton = createStyleElement(options));

		update = applyToSingletonTag.bind(null, style, styleIndex, false);
		remove = applyToSingletonTag.bind(null, style, styleIndex, true);

	} else if (
		obj.sourceMap &&
		typeof URL === "function" &&
		typeof URL.createObjectURL === "function" &&
		typeof URL.revokeObjectURL === "function" &&
		typeof Blob === "function" &&
		typeof btoa === "function"
	) {
		style = createLinkElement(options);
		update = updateLink.bind(null, style, options);
		remove = function () {
			removeStyleElement(style);

			if(style.href) URL.revokeObjectURL(style.href);
		};
	} else {
		style = createStyleElement(options);
		update = applyToTag.bind(null, style);
		remove = function () {
			removeStyleElement(style);
		};
	}

	update(obj);

	return function updateStyle (newObj) {
		if (newObj) {
			if (
				newObj.css === obj.css &&
				newObj.media === obj.media &&
				newObj.sourceMap === obj.sourceMap
			) {
				return;
			}

			update(obj = newObj);
		} else {
			remove();
		}
	};
}

var replaceText = (function () {
	var textStore = [];

	return function (index, replacement) {
		textStore[index] = replacement;

		return textStore.filter(Boolean).join('\n');
	};
})();

function applyToSingletonTag (style, index, remove, obj) {
	var css = remove ? "" : obj.css;

	if (style.styleSheet) {
		style.styleSheet.cssText = replaceText(index, css);
	} else {
		var cssNode = document.createTextNode(css);
		var childNodes = style.childNodes;

		if (childNodes[index]) style.removeChild(childNodes[index]);

		if (childNodes.length) {
			style.insertBefore(cssNode, childNodes[index]);
		} else {
			style.appendChild(cssNode);
		}
	}
}

function applyToTag (style, obj) {
	var css = obj.css;
	var media = obj.media;

	if(media) {
		style.setAttribute("media", media)
	}

	if(style.styleSheet) {
		style.styleSheet.cssText = css;
	} else {
		while(style.firstChild) {
			style.removeChild(style.firstChild);
		}

		style.appendChild(document.createTextNode(css));
	}
}

function updateLink (link, options, obj) {
	var css = obj.css;
	var sourceMap = obj.sourceMap;

	/*
		If convertToAbsoluteUrls isn't defined, but sourcemaps are enabled
		and there is no publicPath defined then lets turn convertToAbsoluteUrls
		on by default.  Otherwise default to the convertToAbsoluteUrls option
		directly
	*/
	var autoFixUrls = options.convertToAbsoluteUrls === undefined && sourceMap;

	if (options.convertToAbsoluteUrls || autoFixUrls) {
		css = fixUrls(css);
	}

	if (sourceMap) {
		// http://stackoverflow.com/a/26603875
		css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
	}

	var blob = new Blob([css], { type: "text/css" });

	var oldSrc = link.href;

	link.href = URL.createObjectURL(blob);

	if(oldSrc) URL.revokeObjectURL(oldSrc);
}


/***/ }),
/* 9 */,
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var stylable_1 = tslib_1.__importDefault(__webpack_require__(31));
var View = /** @class */ (function (_super) {
    tslib_1.__extends(View, _super);
    function View() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return View;
}(stylable_1.default));
exports.default = View;


/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
function getElementByHook(element, hook) {
    return element.querySelector("[data-hook=\"" + hook + "\"]");
}
exports.default = getElementByHook;


/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.PLAYER_API_PROPERTY = '___playerAPI';
var checkDescriptorsOnEquality = function (desc1, desc2) {
    return desc1.value === desc2.value &&
        desc1.get === desc2.get &&
        desc1.set === desc2.set;
};
// tslint:disable-next-line
var playerAPI = function (name) { return function (target, property, descriptor) {
    var methodName = name || property;
    if (!target[exports.PLAYER_API_PROPERTY]) {
        target[exports.PLAYER_API_PROPERTY] = {};
    }
    if (target[exports.PLAYER_API_PROPERTY][methodName]) {
        if (!checkDescriptorsOnEquality(target[exports.PLAYER_API_PROPERTY][methodName], descriptor)) {
            throw new Error("Method \"" + methodName + "\" for public API in " + target.constructor.name + " is already defined");
        }
    }
    target[exports.PLAYER_API_PROPERTY][methodName] = descriptor;
}; };
exports.default = playerAPI;


/***/ }),
/* 13 */,
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.KEYCODES = {
    SPACE_BAR: 32,
    ENTER: 13,
    TAB: 9,
    LEFT_ARROW: 37,
    RIGHT_ARROW: 39,
    UP_ARROW: 38,
    DOWN_ARROW: 40,
    DEBUG_KEY: 68,
};
var KeyboardInterceptorCore = /** @class */ (function () {
    function KeyboardInterceptorCore(config) {
        this.config = config;
        this._bindCallbacks();
        this._bindEvents();
    }
    KeyboardInterceptorCore.prototype._bindCallbacks = function () {
        this._processKeyboardInput = this._processKeyboardInput.bind(this);
    };
    KeyboardInterceptorCore.prototype._bindEvents = function () {
        this.config.node.addEventListener('keydown', this._processKeyboardInput, false);
    };
    KeyboardInterceptorCore.prototype._unbindEvents = function () {
        this.config.node.removeEventListener('keydown', this._processKeyboardInput, false);
    };
    KeyboardInterceptorCore.prototype._processKeyboardInput = function (e) {
        if (this.config.callbacks[e.keyCode]) {
            this.config.callbacks[e.keyCode](e);
        }
    };
    KeyboardInterceptorCore.prototype.destroy = function () {
        this._unbindEvents();
        delete this.config;
    };
    return KeyboardInterceptorCore;
}());
exports.default = KeyboardInterceptorCore;


/***/ }),
/* 15 */,
/* 16 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
function toggleNodeClass(node, className, shouldAdd) {
    if (shouldAdd) {
        node.classList.add(className);
    }
    else {
        node.classList.remove(className);
    }
}
exports.default = toggleNodeClass;


/***/ }),
/* 18 */,
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var IPHONE_PATTERN = /iPhone/;
var IPOD_PATTERN = /iPod/;
var IPAD_PATTERN = /iPad/;
var DESKTOP_SAFARI_PATTERN = /^((?!chrome|android|iphone|ipod|ipad).)*safari/i;
// There is some iPhone/iPad/iPod in Windows Phone...
// https://msdn.microsoft.com/en-us/library/hh869301(v=vs.85).aspx
var isIE = !!window.MSStream;
var getUserAgent = function () { return window.navigator && window.navigator.userAgent; };
var isIPhone = function () { return !isIE && IPHONE_PATTERN.test(getUserAgent()); };
exports.isIPhone = isIPhone;
var isIPod = function () { return !isIE && IPOD_PATTERN.test(getUserAgent()); };
exports.isIPod = isIPod;
var isIPad = function () { return !isIE && IPAD_PATTERN.test(getUserAgent()); };
exports.isIPad = isIPad;
var isIOS = function () { return isIPhone() || isIPod() || isIPad(); };
exports.isIOS = isIOS;
var isAndroid = function () { return /(android)/i.test(getUserAgent()); };
exports.isAndroid = isAndroid;
var isDesktopSafari = function () { return DESKTOP_SAFARI_PATTERN.test(getUserAgent()); };
exports.isDesktopSafari = isDesktopSafari;


/***/ }),
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
function getTimePercent(time, durationTime) {
    if (!durationTime) {
        return 0;
    }
    return parseFloat((time / durationTime * 100).toFixed(1));
}
exports.getTimePercent = getTimePercent;
function getOverallBufferedPercent(buffered, currentTime, duration) {
    if (currentTime === void 0) { currentTime = 0; }
    if (duration === void 0) { duration = 0; }
    if (!buffered || !buffered.length || !duration) {
        return 0;
    }
    var info = getNearestBufferSegmentInfo(buffered, currentTime);
    return getTimePercent(info.end, duration);
}
exports.getOverallBufferedPercent = getOverallBufferedPercent;
function getOverallPlayedPercent(currentTime, duration) {
    if (currentTime === void 0) { currentTime = 0; }
    if (duration === void 0) { duration = 0; }
    return getTimePercent(currentTime, duration);
}
exports.getOverallPlayedPercent = getOverallPlayedPercent;
function geOverallBufferLength(buffered) {
    var size = 0;
    if (!buffered || !buffered.length) {
        return size;
    }
    for (var i = 0; i < buffered.length; i += 1) {
        size += buffered.end(i) - buffered.start(i);
    }
    return size;
}
exports.geOverallBufferLength = geOverallBufferLength;
function getNearestBufferSegmentInfo(buffered, currentTime) {
    var i = 0;
    if (!buffered || !buffered.length) {
        return null;
    }
    while (i < buffered.length - 1 &&
        !(buffered.start(i) <= currentTime && currentTime <= buffered.end(i))) {
        i += 1;
    }
    return {
        start: buffered.start(i),
        end: buffered.end(i),
    };
}
exports.getNearestBufferSegmentInfo = getNearestBufferSegmentInfo;


/***/ }),
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var SINGLETON = 'SINGLETON';
var TRANSIENT = 'TRANSIENT';
var SCOPED = 'SCOPED';
exports.default = {
    SINGLETON: SINGLETON,
    TRANSIENT: TRANSIENT,
    SCOPED: SCOPED,
};


/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
}
Object.defineProperty(exports, "__esModule", { value: true });
var dependency_container_1 = __importDefault(__webpack_require__(39));
var root_container_1 = __importDefault(__webpack_require__(78));
var event_emitter_1 = __importDefault(__webpack_require__(103));
var playback_engine_1 = __importDefault(__webpack_require__(57));
var theme_1 = __importDefault(__webpack_require__(32));
var text_map_1 = __importDefault(__webpack_require__(116));
var full_screen_manager_1 = __importDefault(__webpack_require__(118));
var live_state_engine_1 = __importDefault(__webpack_require__(121));
var keyboard_control_1 = __importDefault(__webpack_require__(33));
var mouse_interceptor_1 = __importDefault(__webpack_require__(122));
var debug_panel_1 = __importDefault(__webpack_require__(123));
var screen_1 = __importDefault(__webpack_require__(130));
var interaction_indicator_1 = __importDefault(__webpack_require__(136));
var overlay_1 = __importDefault(__webpack_require__(149));
var loader_1 = __importDefault(__webpack_require__(156));
var main_ui_block_1 = __importDefault(__webpack_require__(162));
var top_block_1 = __importDefault(__webpack_require__(168));
var title_1 = __importDefault(__webpack_require__(174));
var live_indicator_1 = __importDefault(__webpack_require__(181));
var bottom_block_1 = __importDefault(__webpack_require__(187));
var progress_1 = __importDefault(__webpack_require__(193));
var play_1 = __importDefault(__webpack_require__(211));
var time_1 = __importDefault(__webpack_require__(220));
var volume_1 = __importDefault(__webpack_require__(227));
var full_screen_1 = __importDefault(__webpack_require__(237));
var logo_1 = __importDefault(__webpack_require__(246));
var tooltip_1 = __webpack_require__(34);
var asClass = dependency_container_1.default.asClass;
exports.modules = {
    RootContainer: root_container_1.default,
    EventEmitter: event_emitter_1.default,
    Engine: playback_engine_1.default,
    ThemeService: theme_1.default,
    TextMap: text_map_1.default,
    FullScreenManager: full_screen_manager_1.default,
    LiveStateEngine: live_state_engine_1.default,
    KeyboardInterceptor: keyboard_control_1.default,
    MouseInterceptor: mouse_interceptor_1.default,
    DebugPanel: debug_panel_1.default,
    Screen: screen_1.default,
    InteractionIndicator: interaction_indicator_1.default,
    Overlay: overlay_1.default,
    Loader: loader_1.default,
    MainUIBlock: main_ui_block_1.default,
    TopBlock: top_block_1.default,
    LiveIndicator: live_indicator_1.default,
    Title: title_1.default,
    BottomBlock: bottom_block_1.default,
    ProgressControl: progress_1.default,
    PlayControl: play_1.default,
    TimeControl: time_1.default,
    VolumeControl: volume_1.default,
    FullScreenControl: full_screen_1.default,
    Logo: logo_1.default,
    TooltipService: tooltip_1.TooltipService,
};
var DIModules = Object.keys(exports.modules).reduce(function (DIModules, key) {
    var module = exports.modules[key];
    if (!module.moduleName) {
        throw new Error("No moduleName in module: " + key);
    }
    DIModules[module.moduleName] = asClass(module).scoped();
    return DIModules;
}, {});
exports.default = DIModules;


/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var extendStyles_1 = tslib_1.__importDefault(__webpack_require__(92));
var Stylable = /** @class */ (function () {
    function Stylable(theme) {
        this._themeStyles = {};
        var moduleTheme = this.constructor._moduleTheme;
        if (theme && moduleTheme) {
            theme.registerModuleTheme(this, moduleTheme);
            this._themeStyles = theme.get(this);
        }
    }
    Stylable.setTheme = function (theme) {
        this._moduleTheme = theme;
    };
    Stylable.extendStyleNames = function (styles) {
        this._styles = extendStyles_1.default(this._styles, styles);
    };
    Stylable.resetStyles = function () {
        this._styles = {};
    };
    Object.defineProperty(Stylable.prototype, "themeStyles", {
        get: function () {
            return this._themeStyles;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Stylable.prototype, "styleNames", {
        get: function () {
            // NOTE: TS does not work with instance static fields + generic type
            return this.constructor._styles || {};
        },
        enumerable: true,
        configurable: true
    });
    Stylable._styles = {};
    return Stylable;
}());
exports.default = Stylable;


/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var transperentizeColor_1 = tslib_1.__importDefault(__webpack_require__(110));
exports.transperentizeColor = transperentizeColor_1.default;
var theme_service_1 = tslib_1.__importDefault(__webpack_require__(112));
exports.DEFAULT_THEME_CONFIG = theme_service_1.DEFAULT_THEME_CONFIG;
exports.default = theme_service_1.default;


/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var index_1 = __webpack_require__(2);
var device_detection_1 = __webpack_require__(19);
var keyboard_interceptor_1 = tslib_1.__importDefault(__webpack_require__(14));
exports.AMOUNT_TO_SKIP_SECONDS = 5;
exports.AMOUNT_TO_CHANGE_VOLUME = 10;
var KeyboardControl = /** @class */ (function () {
    function KeyboardControl(_a) {
        var config = _a.config, eventEmitter = _a.eventEmitter, rootContainer = _a.rootContainer, engine = _a.engine, debugPanel = _a.debugPanel;
        this._eventEmitter = eventEmitter;
        this._engine = engine;
        this._debugPanel = debugPanel;
        this._rootNode = rootContainer.node;
        if (device_detection_1.isIPhone() || device_detection_1.isIPod() || device_detection_1.isIPad() || device_detection_1.isAndroid()) {
            this._isEnabled = false;
        }
        else {
            this._isEnabled = config.disableControlWithKeyboard !== false;
        }
        this.initInterceptor();
    }
    KeyboardControl.prototype.initInterceptor = function () {
        var _this = this;
        if (this._isEnabled) {
            this._keyboardInterceptor = new keyboard_interceptor_1.default({
                node: this._rootNode,
                callbacks: (_a = {},
                    _a[keyboard_interceptor_1.KEYCODES.DEBUG_KEY] = function (e) {
                        if (e.ctrlKey && e.shiftKey) {
                            _this._debugPanel.show();
                        }
                    },
                    _a[keyboard_interceptor_1.KEYCODES.TAB] = function () {
                        _this._eventEmitter.emit(index_1.UI_EVENTS.KEYBOARD_KEYDOWN_INTERCEPTED);
                    },
                    _a[keyboard_interceptor_1.KEYCODES.SPACE_BAR] = function (e) {
                        e.preventDefault();
                        _this._eventEmitter.emit(index_1.UI_EVENTS.KEYBOARD_KEYDOWN_INTERCEPTED);
                        _this._eventEmitter.emit(index_1.UI_EVENTS.TOGGLE_PLAYBACK_WITH_KEYBOARD_TRIGGERED);
                        _this._engine.togglePlayback();
                    },
                    _a[keyboard_interceptor_1.KEYCODES.LEFT_ARROW] = function (e) {
                        if (_this._engine.isSeekAvailable) {
                            e.preventDefault();
                            _this._eventEmitter.emit(index_1.UI_EVENTS.KEYBOARD_KEYDOWN_INTERCEPTED);
                            _this._eventEmitter.emit(index_1.UI_EVENTS.GO_BACKWARD_WITH_KEYBOARD_TRIGGERED);
                            _this._engine.goBackward(exports.AMOUNT_TO_SKIP_SECONDS);
                        }
                    },
                    _a[keyboard_interceptor_1.KEYCODES.RIGHT_ARROW] = function (e) {
                        if (_this._engine.isSeekAvailable) {
                            e.preventDefault();
                            _this._eventEmitter.emit(index_1.UI_EVENTS.KEYBOARD_KEYDOWN_INTERCEPTED);
                            _this._eventEmitter.emit(index_1.UI_EVENTS.GO_FORWARD_WITH_KEYBOARD_TRIGGERED);
                            _this._engine.goForward(exports.AMOUNT_TO_SKIP_SECONDS);
                        }
                    },
                    _a[keyboard_interceptor_1.KEYCODES.UP_ARROW] = function (e) {
                        e.preventDefault();
                        _this._eventEmitter.emit(index_1.UI_EVENTS.KEYBOARD_KEYDOWN_INTERCEPTED);
                        _this._eventEmitter.emit(index_1.UI_EVENTS.INCREASE_VOLUME_WITH_KEYBOARD_TRIGGERED);
                        _this._engine.increaseVolume(exports.AMOUNT_TO_CHANGE_VOLUME);
                    },
                    _a[keyboard_interceptor_1.KEYCODES.DOWN_ARROW] = function (e) {
                        e.preventDefault();
                        _this._eventEmitter.emit(index_1.UI_EVENTS.KEYBOARD_KEYDOWN_INTERCEPTED);
                        _this._eventEmitter.emit(index_1.UI_EVENTS.DECREASE_VOLUME_WITH_KEYBOARD_TRIGGERED);
                        _this._engine.decreaseVolume(exports.AMOUNT_TO_CHANGE_VOLUME);
                    },
                    _a),
            });
        }
        var _a;
    };
    KeyboardControl.prototype.destroyInterceptor = function () {
        if (this._keyboardInterceptor) {
            this._keyboardInterceptor.destroy();
        }
    };
    KeyboardControl.prototype.destroy = function () {
        this.destroyInterceptor();
        delete this._rootNode;
        delete this._eventEmitter;
        delete this._engine;
        delete this._debugPanel;
    };
    KeyboardControl.moduleName = 'keyboardControl';
    KeyboardControl.dependencies = [
        'engine',
        'eventEmitter',
        'rootContainer',
        'config',
        'debugPanel',
    ];
    return KeyboardControl;
}());
exports.default = KeyboardControl;


/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tooltip_1 = __webpack_require__(44);
exports.Tooltip = tooltip_1.default;
var tooltip_service_1 = __webpack_require__(200);
exports.TooltipService = tooltip_service_1.default;
var getTooltipPositionByReferenceNode_1 = __webpack_require__(46);
exports.getTooltipPositionByReferenceNode = getTooltipPositionByReferenceNode_1.default;


/***/ }),
/* 35 */,
/* 36 */,
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/**
 * `true` if we are running inside a web browser, `false` otherwise (e.g. running inside Node.js).
 */
exports.isBrowser = typeof window !== 'undefined';
/**
 * This is a map which lists native support of formats and APIs.
 * It gets filled during runtime with the relevant values to the current environment.
 */
exports.NativeEnvironmentSupport = {
    MSE: false,
    HLS: false,
    DASH: false,
    MP4: false,
    WEBM: false,
};
/* ignore coverage */
function detectEnvironment() {
    if (!exports.isBrowser) {
        return; // Not in a browser
    }
    exports.NativeEnvironmentSupport.MSE =
        'WebKitMediaSource' in window || 'MediaSource' in window;
    var video = document.createElement('video');
    if (typeof video.canPlayType !== 'function') {
        return; // env doesn't support HTMLMediaElement (e.g PhantomJS)
    }
    if (video.canPlayType('application/x-mpegURL') ||
        video.canPlayType('application/vnd.apple.mpegURL')) {
        exports.NativeEnvironmentSupport.HLS = true;
    }
    if (video.canPlayType('application/dash+xml')) {
        exports.NativeEnvironmentSupport.DASH = true;
    }
    if (video.canPlayType('video/mp4')) {
        exports.NativeEnvironmentSupport.MP4 = true;
    }
    if (video.canPlayType('video/webm')) {
        exports.NativeEnvironmentSupport.WEBM = true;
    }
}
detectEnvironment(); // Run once


/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var dependency_container_1 = tslib_1.__importDefault(__webpack_require__(39));
var player_facade_1 = tslib_1.__importDefault(__webpack_require__(76));
var default_modules_1 = tslib_1.__importDefault(__webpack_require__(30));
var default_set_1 = tslib_1.__importDefault(__webpack_require__(252));
var additionalModules = {};
var playbackAdapters = default_set_1.default.slice();
exports.container = dependency_container_1.default.createContainer();
exports.container.register(default_modules_1.default);
function registerModule(id, config) {
    additionalModules[id] = config;
}
exports.registerModule = registerModule;
function registerPlaybackAdapter(adapter) {
    playbackAdapters.push(adapter);
}
exports.registerPlaybackAdapter = registerPlaybackAdapter;
function clearAdditionalModules() {
    additionalModules = {};
}
exports.clearAdditionalModules = clearAdditionalModules;
function clearPlaybackAdapters() {
    playbackAdapters = default_set_1.default.slice();
}
exports.clearPlaybackAdapters = clearPlaybackAdapters;
function create(params, themeConfig) {
    if (params === void 0) { params = {}; }
    var scope = exports.container.createScope();
    var additionalModuleNames = Object.keys(additionalModules);
    if (additionalModuleNames.length) {
        additionalModuleNames.forEach(function (moduleName) {
            return scope.registerClass(moduleName, additionalModules[moduleName]);
        });
    }
    scope.registerValue('availablePlaybackAdapters', playbackAdapters);
    return new player_facade_1.default(params, scope, default_modules_1.default, additionalModules, themeConfig);
}
exports.create = create;


/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var createContainer_1 = tslib_1.__importDefault(__webpack_require__(72));
var Lifetime_1 = tslib_1.__importDefault(__webpack_require__(29));
var registrations_1 = tslib_1.__importDefault(__webpack_require__(40));
exports.default = tslib_1.__assign({ createContainer: createContainer_1.default,
    Lifetime: Lifetime_1.default }, registrations_1.default);


/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var tslib_2 = __webpack_require__(0);
var Lifetime_1 = tslib_1.__importDefault(__webpack_require__(29));
var NotAFunctionError_1 = tslib_1.__importDefault(__webpack_require__(73));
exports.PROPERTY_FOR_DEPENDENCIES = 'dependencies';
var makeOptions = function (defaults, input) { return tslib_2.__assign({}, defaults, input); };
exports.makeFluidInterface = function (obj) {
    var setLifetime = function (value) {
        obj.lifetime = value;
        return obj;
    };
    return {
        setLifetime: setLifetime,
        transient: function () { return setLifetime(Lifetime_1.default.TRANSIENT); },
        scoped: function () { return setLifetime(Lifetime_1.default.SCOPED); },
        singleton: function () { return setLifetime(Lifetime_1.default.SINGLETON); },
    };
};
exports.asValue = function (value) {
    var resolve = function () { return value; };
    return {
        resolve: resolve,
        lifetime: Lifetime_1.default.TRANSIENT,
    };
};
exports.asFunction = function (fn, opts) {
    if (typeof fn !== 'function') {
        throw new NotAFunctionError_1.default('asFunction', 'function', typeof fn);
    }
    var defaults = {
        lifetime: Lifetime_1.default.TRANSIENT,
    };
    opts = makeOptions(defaults, opts);
    var resolve = generateResolve(fn);
    var result = {
        resolve: resolve,
        lifetime: opts.lifetime,
    };
    result.resolve = resolve.bind(result);
    tslib_2.__assign(result, exports.makeFluidInterface(result));
    return result;
};
exports.asClass = function (Type, opts) {
    if (typeof Type !== 'function') {
        throw new NotAFunctionError_1.default('asClass', 'class', typeof Type);
    }
    var defaults = {
        lifetime: Lifetime_1.default.TRANSIENT,
    };
    opts = makeOptions(defaults, opts);
    // A function to handle object construction for us, as to make the generateResolve more reusable
    var newClass = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return new (Type.bind.apply(Type, [void 0].concat(args)))();
    };
    var resolve = generateResolve(newClass, Type);
    var result = {
        resolve: resolve,
        lifetime: opts.lifetime,
    };
    result.resolve = resolve.bind(result);
    tslib_2.__assign(result, exports.makeFluidInterface(result));
    return result;
};
function generateResolve(fn, dependencyParseTarget) {
    // If the function used for dependency parsing is falsy, use the supplied function
    if (!dependencyParseTarget) {
        dependencyParseTarget = fn;
    }
    // Try to resolve the dependencies
    var dependencies = dependencyParseTarget[exports.PROPERTY_FOR_DEPENDENCIES] || [];
    // Use a regular function instead of an arrow function to facilitate binding to the registration.
    return function resolve(container) {
        if (dependencies.length > 0) {
            var wrapper = dependencies.reduce(function (wrapper, d) {
                wrapper[d] = container.resolve(d);
                return wrapper;
            }, {});
            return fn(wrapper, container);
        }
        return fn(container);
    };
}
exports.default = {
    asValue: exports.asValue,
    asFunction: exports.asFunction,
    asClass: exports.asClass,
};


/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var ExtendableError = /** @class */ (function (_super) {
    tslib_1.__extends(ExtendableError, _super);
    function ExtendableError(message) {
        var _this = _super.call(this, message) || this;
        Object.defineProperty(_this, 'message', {
            enumerable: false,
            value: message,
        });
        Object.defineProperty(_this, 'name', {
            enumerable: false,
            value: _this.constructor.name,
        });
        Error.captureStackTrace(_this, _this.constructor);
        return _this;
    }
    return ExtendableError;
}(Error));
exports.default = ExtendableError;


/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
function camelToKebab(string) {
    return string.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase();
}
exports.default = camelToKebab;


/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
function formatTime(seconds) {
    var isValid = !isNaN(seconds) && isFinite(seconds);
    var isNegative = isValid && seconds < 0;
    var date = new Date(null);
    date.setSeconds(isValid ? Math.abs(Math.floor(seconds)) : 0);
    // get HH:mm:ss part, remove hours if they are "00:"
    var time = date
        .toISOString()
        .substr(11, 8)
        .replace(/^00:/, '');
    return isNegative ? "-" + time : time;
}
exports.default = formatTime;


/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var templates_1 = __webpack_require__(45);
var htmlToElement_1 = tslib_1.__importDefault(__webpack_require__(6));
var getElementByHook_1 = tslib_1.__importDefault(__webpack_require__(11));
var stylable_1 = tslib_1.__importDefault(__webpack_require__(31));
var tooltip_scss_1 = tslib_1.__importDefault(__webpack_require__(198));
var Tooltip = /** @class */ (function (_super) {
    tslib_1.__extends(Tooltip, _super);
    function Tooltip() {
        var _this = _super.call(this) || this;
        _this._isHidden = true;
        _this._initDOM();
        return _this;
    }
    Tooltip.prototype._initDOM = function () {
        this._$node = htmlToElement_1.default(templates_1.tooltipTemplate({
            styles: this.styleNames,
        }));
        this._$tooltipInner = getElementByHook_1.default(this._$node, 'tooltipInner');
    };
    Object.defineProperty(Tooltip.prototype, "node", {
        get: function () {
            return this._$node;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Tooltip.prototype, "isHidden", {
        get: function () {
            return this._isHidden;
        },
        enumerable: true,
        configurable: true
    });
    Tooltip.prototype.show = function () {
        if (!this._isHidden) {
            return;
        }
        this._isHidden = false;
        this._$node.classList.add(this.styleNames.tooltipVisible);
    };
    Tooltip.prototype.hide = function () {
        if (this._isHidden) {
            return;
        }
        this._isHidden = true;
        this._$node.classList.remove(this.styleNames.tooltipVisible);
    };
    Tooltip.prototype.setText = function (text) {
        this._$tooltipInner.innerText = text;
    };
    Tooltip.prototype.setStyle = function (style) {
        var _this = this;
        Object.keys(style).forEach(function (styleKey) {
            _this._$node.style[styleKey] = style[styleKey];
        });
    };
    Tooltip.prototype.destroy = function () {
        this._$node = null;
        this._$tooltipInner = null;
    };
    return Tooltip;
}(stylable_1.default));
Tooltip.extendStyleNames(tooltip_scss_1.default);
exports.default = Tooltip;


/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tooltip_dot_1 = __webpack_require__(196);
exports.tooltipTemplate = tooltip_dot_1.default;
var tooltipContainer_dot_1 = __webpack_require__(197);
exports.tooltipContainerTemplate = tooltipContainer_dot_1.default;


/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var types_1 = __webpack_require__(47);
function calcTooltipCenterX(tooltipReferenceOffsetX, tooltipReferenceWidth) {
    return tooltipReferenceOffsetX + tooltipReferenceWidth / 2;
}
function getTooltipPositionByReferenceNode(tooltipReferenceNode, tooltipContainerNode, tooltipCenterXfn) {
    if (tooltipCenterXfn === void 0) { tooltipCenterXfn = calcTooltipCenterX; }
    var tooltipReferenceRect = tooltipReferenceNode.getBoundingClientRect();
    var tooltipContainerRect = tooltipContainerNode.getBoundingClientRect();
    var tooltipPlacement = tooltipReferenceRect.top > tooltipContainerRect.top
        ? types_1.ITooltipPositionPlacement.BOTTOM
        : types_1.ITooltipPositionPlacement.TOP;
    var tooltipReferenceOffsetX = tooltipReferenceRect.left - tooltipContainerRect.left;
    var tooltipCenterX = tooltipCenterXfn(tooltipReferenceOffsetX, tooltipReferenceRect.width);
    return { placement: tooltipPlacement, x: tooltipCenterX };
}
exports.default = getTooltipPositionByReferenceNode;


/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var ITooltipPositionPlacement;
(function (ITooltipPositionPlacement) {
    ITooltipPositionPlacement["TOP"] = "top";
    ITooltipPositionPlacement["BOTTOM"] = "bottom";
})(ITooltipPositionPlacement || (ITooltipPositionPlacement = {}));
exports.ITooltipPositionPlacement = ITooltipPositionPlacement;


/***/ }),
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var playerFactoryMethods = tslib_1.__importStar(__webpack_require__(38));
tslib_1.__exportStar(__webpack_require__(38), exports);
var constants_1 = __webpack_require__(2);
exports.UI_EVENTS = constants_1.UI_EVENTS;
exports.VIDEO_EVENTS = constants_1.VIDEO_EVENTS;
exports.TEXT_LABELS = constants_1.TEXT_LABELS;
exports.MEDIA_STREAM_TYPES = constants_1.MediaStreamTypes;
exports.MEDIA_STREAM_DELIVERY_PRIORITY = constants_1.MediaStreamDeliveryPriority;
exports.ENGINE_STATES = constants_1.STATES;
exports.LIVE_STATES = constants_1.LiveState;
var default_modules_1 = __webpack_require__(30);
var player_api_decorator_1 = tslib_1.__importDefault(__webpack_require__(12));
exports.playerAPIDecorator = player_api_decorator_1.default;
var tooltip_1 = __webpack_require__(34);
exports.Tooltip = tooltip_1.Tooltip;
var default_modules_2 = __webpack_require__(30);
exports.DefaultModules = default_modules_2.modules;
var defaultExport = tslib_1.__assign({}, playerFactoryMethods, { UI_EVENTS: constants_1.UI_EVENTS,
    VIDEO_EVENTS: constants_1.VIDEO_EVENTS,
    TEXT_LABELS: constants_1.TEXT_LABELS,
    MEDIA_STREAM_TYPES: constants_1.MediaStreamTypes,
    MEDIA_STREAM_DELIVERY_PRIORITY: constants_1.MediaStreamDeliveryPriority,
    ENGINE_STATES: constants_1.STATES,
    LIVE_STATES: constants_1.LiveState,
    DefaultModules: default_modules_1.modules });
exports.default = defaultExport;


/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var player_api_decorator_1 = tslib_1.__importDefault(__webpack_require__(12));
var state_engine_1 = tslib_1.__importDefault(__webpack_require__(105));
var native_events_broadcaster_1 = tslib_1.__importDefault(__webpack_require__(106));
var adapters_strategy_1 = tslib_1.__importDefault(__webpack_require__(107));
var device_detection_1 = __webpack_require__(19);
var index_1 = __webpack_require__(2);
exports.STATES = index_1.STATES;
var PreloadTypes;
(function (PreloadTypes) {
    PreloadTypes["NONE"] = "none";
    PreloadTypes["METADATA"] = "metadata";
    PreloadTypes["AUTO"] = "auto";
})(PreloadTypes = exports.PreloadTypes || (exports.PreloadTypes = {}));
//TODO: Find source of problem with native HLS on Safari, when playing state triggered but actual playing is delayed
var Engine = /** @class */ (function () {
    function Engine(_a) {
        var eventEmitter = _a.eventEmitter, config = _a.config, _b = _a.availablePlaybackAdapters, availablePlaybackAdapters = _b === void 0 ? [] : _b;
        this._eventEmitter = eventEmitter;
        this._currentSrc = null;
        this._createVideoTag(config.videoElement);
        this._stateEngine = new state_engine_1.default(eventEmitter, this._video);
        this._nativeEventsBroadcaster = new native_events_broadcaster_1.default(eventEmitter, this._video);
        this._adapterStrategy = new adapters_strategy_1.default(this._eventEmitter, this._video, availablePlaybackAdapters);
        this._applyConfig(config);
    }
    Engine.prototype._createVideoTag = function (videoElement) {
        if (videoElement && videoElement.tagName === 'VIDEO') {
            this._video = videoElement;
        }
        else {
            this._video = document.createElement('video');
        }
    };
    Engine.prototype._applyConfig = function (config) {
        if (config === void 0) { config = {}; }
        var preload = config.preload, autoPlay = config.autoPlay, loop = config.loop, muted = config.muted, volume = config.volume, playInline = config.playInline, src = config.src;
        this.setPreload(preload);
        this.setAutoPlay(autoPlay);
        this.setLoop(loop);
        this.setMute(muted);
        this.setVolume(volume);
        this.setPlayInline(playInline);
        this.setSrc(src);
    };
    Engine.prototype.getNode = function () {
        return this._video;
    };
    Engine.prototype._getViewDimensions = function () {
        return {
            width: this._video.offsetWidth,
            height: this._video.offsetHeight,
        };
    };
    Object.defineProperty(Engine.prototype, "isDynamicContent", {
        get: function () {
            if (!this.attachedAdapter) {
                return false;
            }
            return this.attachedAdapter.isDynamicContent;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Engine.prototype, "isDynamicContentEnded", {
        get: function () {
            if (!this.attachedAdapter) {
                return false;
            }
            return this.attachedAdapter.isDynamicContentEnded;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Engine.prototype, "isSeekAvailable", {
        get: function () {
            if (!this.attachedAdapter) {
                return false;
            }
            return this.attachedAdapter.isSeekAvailable;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Engine.prototype, "isMetadataLoaded", {
        get: function () {
            return this._stateEngine.isMetadataLoaded;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Engine.prototype, "isPreloadAvailable", {
        get: function () {
            if (device_detection_1.isIPad() || device_detection_1.isIPhone() || device_detection_1.isIPod() || device_detection_1.isAndroid()) {
                return false;
            }
            return this.getPreload() !== 'none';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Engine.prototype, "isAutoPlayAvailable", {
        get: function () {
            if (device_detection_1.isIPad() || device_detection_1.isIPhone() || device_detection_1.isIPod() || device_detection_1.isAndroid()) {
                return false;
            }
            return this.getAutoPlay();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Engine.prototype, "isSyncWithLive", {
        get: function () {
            if (!this.attachedAdapter) {
                return false;
            }
            return this.attachedAdapter.isSyncWithLive;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Engine.prototype, "attachedAdapter", {
        get: function () {
            return this._adapterStrategy.attachedAdapter;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Method for setting source of video to player.
     * @param src Array with multiple sources
     * @example
     * player.setSrc([
     *   'https://my-url/video.mp4',
     *   'https://my-url/video.webm',
     *   'https://my-url/video.m3u8'
     * ]);
     * @note
     * Read more about [video source](/video-source)
     */
    Engine.prototype.setSrc = function (src) {
        if (src === this._currentSrc) {
            return;
        }
        this._stateEngine.clearTimestamps();
        this._currentSrc = src;
        this._adapterStrategy.connectAdapter(this._currentSrc);
        this._stateEngine.setState(index_1.STATES.SRC_SET);
    };
    /**
     * Return current source of video
     * @example
     * player.getSrc(); // ['https://my-url/video.mp4']
     */
    Engine.prototype.getSrc = function () {
        return this._currentSrc;
    };
    /**
     * Method for starting playback of video
     * @example
     * player.play();
     */
    Engine.prototype.play = function () {
        var _this = this;
        //Workaround for triggering functionality that requires user event pipe
        this._eventEmitter.emit(index_1.VIDEO_EVENTS.PLAY_REQUEST_TRIGGERED);
        this._pauseRequested = false;
        if (!this._playPromise) {
            this._playPromise = this._video.play();
            if (this._playPromise !== undefined) {
                this._playPromise
                    .then(function () {
                    _this._playPromise = null;
                    if (_this._pauseRequested) {
                        _this.pause();
                    }
                })
                    .catch(function (event) {
                    _this._eventEmitter.emit(index_1.VIDEO_EVENTS.PLAY_ABORTED, event);
                    _this._playPromise = null;
                });
            }
        }
    };
    /**
     * Method for pausing playback of video
     * @example
     * player.pause();
     */
    Engine.prototype.pause = function () {
        if (this._playPromise) {
            this._pauseRequested = true;
        }
        else {
            this._video.pause();
            this._pauseRequested = false;
        }
    };
    /**
     * Method for toggling(play\pause) playback of video
     * @example
     * player.togglePlayback();
     */
    Engine.prototype.togglePlayback = function () {
        if (this.isVideoPaused) {
            this.play();
        }
        else {
            this.pause();
        }
    };
    Object.defineProperty(Engine.prototype, "isVideoPaused", {
        /**
         * High level status of video playback. Returns true if playback is paused.
         * For more advance state use `getCurrentPlaybackState`
         * @example
         * player.play();
         * console.log(player.isVideoPaused);
         */
        get: function () {
            return this._video.paused;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Engine.prototype, "isVideoEnded", {
        /**
         * High level status of video playback. Returns true if playback is ended. Also note, that `isPaused` will return `true` if playback is ended also.
         * For more advance state use `getCurrentPlaybackState`
         * @example
         * player.play();
         * console.log(player.isVideoEnded);
         */
        get: function () {
            return this._video.ended;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Method for synchronize current playback with live point. Available only if you playing live source.
     * @example
     * player.syncWithLive();
     */
    Engine.prototype.syncWithLive = function () {
        if (this.attachedAdapter &&
            this.attachedAdapter.isDynamicContent &&
            !this.attachedAdapter.isDynamicContentEnded &&
            !this.isSyncWithLive) {
            this.setCurrentTime(this.attachedAdapter.syncWithLiveTime);
            this.play();
        }
    };
    /**
     * Method for going forward in playback by your value
     * @param sec - Value in seconds
     * @example
     * player.goForward(5);
     */
    Engine.prototype.goForward = function (sec) {
        var duration = this.getDurationTime();
        if (duration) {
            var current = this.getCurrentTime();
            this.setCurrentTime(Math.min(current + sec, duration));
        }
    };
    /**
     * Method for going backward in playback by your value
     * @param sec - Value in seconds
     * @example
     * player.goBackward(5);
     */
    Engine.prototype.goBackward = function (sec) {
        var duration = this.getDurationTime();
        if (duration) {
            var current = this.getCurrentTime();
            this.setCurrentTime(Math.max(current - sec, 0));
        }
    };
    /**
     * Set volume
     * @param volume - Volume value `0..100`
     * @example
     * player.setVolume(50);
     */
    Engine.prototype.setVolume = function (volume) {
        var parsedVolume = Number(volume);
        this._video.volume = isNaN(parsedVolume)
            ? 1
            : Math.max(0, Math.min(Number(volume) / 100, 1));
    };
    /**
     * Get volume
     * @example
     * player.getVolume(); // 50
     */
    Engine.prototype.getVolume = function () {
        return this._video.volume * 100;
    };
    /**
     * Method for increasing current volume by value
     * @param value - Value from 0 to 100
     * @example
     * player.increaseVolume(30);
     */
    Engine.prototype.increaseVolume = function (value) {
        this.setVolume(this.getVolume() + value);
    };
    /**
     * Method for decreasing current volume by value
     * @param value - Value from 0 to 100
     * @example
     * player.decreaseVolume(30);
     */
    Engine.prototype.decreaseVolume = function (value) {
        this.setVolume(this.getVolume() - value);
    };
    /**
     * Mute or unmute the video
     * @param isMuted - `true` to mute the video.
     * @example
     * player.setMute(true);
     */
    Engine.prototype.setMute = function (isMuted) {
        this._video.muted = Boolean(isMuted);
    };
    /**
     * Get mute flag
     * @example
     * player.getMute(); // true
     */
    Engine.prototype.getMute = function () {
        return this._video.muted;
    };
    /**
     * Set autoPlay flag
     * @example
     * player.setAutoPlay();
     */
    Engine.prototype.setAutoPlay = function (isAutoPlay) {
        this._video.autoplay = Boolean(isAutoPlay);
    };
    /**
     * Get autoPlay flag
     * @example
     * player.getAutoPlay(); // true
     */
    Engine.prototype.getAutoPlay = function () {
        return this._video.autoplay;
    };
    /**
     * Set loop flag
     * @param isLoop - If `true` video will be played again after it will finish
     * @example
     * player.setLoop(true);
     */
    Engine.prototype.setLoop = function (isLoop) {
        this._video.loop = Boolean(isLoop);
    };
    /**
     * Get loop flag
     * @example
     * player.getLoop(); // true
     */
    Engine.prototype.getLoop = function () {
        return this._video.loop;
    };
    /**
     * Method for setting playback rate
     */
    Engine.prototype.setPlaybackRate = function (rate) {
        this._video.playbackRate = rate;
    };
    /**
     * Return current playback rate
     */
    Engine.prototype.getPlaybackRate = function () {
        return this._video.playbackRate;
    };
    /**
     * Set preload type
     * @example
     * player.setPreload('none');
     */
    Engine.prototype.setPreload = function (preload) {
        this._video.preload = preload || 'auto';
    };
    /**
     * Return preload type
     * @example
     * player.getPreload(); // none
     */
    Engine.prototype.getPreload = function () {
        return this._video.preload;
    };
    /**
     * Return current time of video playback
     * @example
     * player.getCurrentTime(); //  60.139683
     */
    Engine.prototype.getCurrentTime = function () {
        return this._video.currentTime;
    };
    /**
     * Method for seeking to time in video
     * @param time - Time in seconds
     * @example
     * player.goTo(34);
     */
    Engine.prototype.setCurrentTime = function (time) {
        this._video.currentTime = time;
    };
    /**
     * Return duration of video
     * @example
     * player.getDurationTime(); // 180.149745
     */
    Engine.prototype.getDurationTime = function () {
        return this._video.duration || 0;
    };
    /**
     * Return real width of video from metadata
     * @example
     * player.getVideoWidth(); // 400
     */
    Engine.prototype.getVideoWidth = function () {
        return this._video.videoWidth;
    };
    /**
     * Return real height of video from metadata
     * @example
     * player.getVideoHeight(); // 225
     */
    Engine.prototype.getVideoHeight = function () {
        return this._video.videoHeight;
    };
    Engine.prototype.getBuffered = function () {
        return this._video.buffered;
    };
    /**
     * Set playInline flag
     * @param isPlayInline - If `false` - video will be played in full screen, `true` - inline
     * @example
     * player.setPlayInline(true);
     */
    Engine.prototype.setPlayInline = function (isPlayInline) {
        if (isPlayInline) {
            this._video.setAttribute('playsInline', isPlayInline);
        }
    };
    /**
     * Get playInline flag
     * @example
     * player.getPlayInline(); // true
     */
    Engine.prototype.getPlayInline = function () {
        return this._video.getAttribute('playsInline');
    };
    /**
     * Return current state of playback
     */
    Engine.prototype.getCurrentState = function () {
        return this._stateEngine.getState();
    };
    /**
     * Return object with internal debug info
     *
     * @example
     * player.getDebugInfo();
     *
     * @note
     * The above command returns JSON structured like this:
     *
     * @example
     * {
     *   "type": "HLS",
     *   "viewDimensions": {
     *     "width": 700,
     *     "height": 394
     *   }
     *   "url": "https://example.com/video.m3u8",
     *   "currentTime": 22.092514,
     *   "duration": 60.139683,
     *   "loadingStateTimestamps": {
     *     "metadata-loaded": 76,
     *     "ready-to-play": 67
     *   },
     *   "bitrates": [
     *     // Different for different type of streams
     *     { ... },
     *     { ... }
     *   ],
     *   "currentBitrate": { ... },
     *   "overallBufferLength": 60.139683,
     *   "nearestBufferSegInfo": {
     *     "start": 0,
     *     "end": 60.139683
     *   }
     * }
     */
    Engine.prototype.getDebugInfo = function () {
        var _a = this._video, duration = _a.duration, currentTime = _a.currentTime;
        var data;
        if (this._adapterStrategy.attachedAdapter) {
            data = this._adapterStrategy.attachedAdapter.debugInfo;
        }
        return tslib_1.__assign({}, data, { viewDimensions: this._getViewDimensions(), currentTime: currentTime,
            duration: duration, loadingStateTimestamps: this._stateEngine.getStateTimestamps() });
    };
    Engine.prototype.destroy = function () {
        this._stateEngine.destroy();
        this._nativeEventsBroadcaster.destroy();
        this._adapterStrategy.destroy();
        this._video.parentNode && this._video.parentNode.removeChild(this._video);
        delete this._stateEngine;
        delete this._nativeEventsBroadcaster;
        delete this._adapterStrategy;
        delete this._eventEmitter;
        delete this._video;
    };
    Engine.moduleName = 'engine';
    Engine.dependencies = ['eventEmitter', 'config', 'availablePlaybackAdapters'];
    tslib_1.__decorate([
        player_api_decorator_1.default()
    ], Engine.prototype, "setSrc", null);
    tslib_1.__decorate([
        player_api_decorator_1.default()
    ], Engine.prototype, "getSrc", null);
    tslib_1.__decorate([
        player_api_decorator_1.default()
    ], Engine.prototype, "play", null);
    tslib_1.__decorate([
        player_api_decorator_1.default()
    ], Engine.prototype, "pause", null);
    tslib_1.__decorate([
        player_api_decorator_1.default()
    ], Engine.prototype, "togglePlayback", null);
    tslib_1.__decorate([
        player_api_decorator_1.default()
    ], Engine.prototype, "isVideoPaused", null);
    tslib_1.__decorate([
        player_api_decorator_1.default()
    ], Engine.prototype, "isVideoEnded", null);
    tslib_1.__decorate([
        player_api_decorator_1.default()
    ], Engine.prototype, "syncWithLive", null);
    tslib_1.__decorate([
        player_api_decorator_1.default()
    ], Engine.prototype, "goForward", null);
    tslib_1.__decorate([
        player_api_decorator_1.default()
    ], Engine.prototype, "goBackward", null);
    tslib_1.__decorate([
        player_api_decorator_1.default()
    ], Engine.prototype, "setVolume", null);
    tslib_1.__decorate([
        player_api_decorator_1.default()
    ], Engine.prototype, "getVolume", null);
    tslib_1.__decorate([
        player_api_decorator_1.default()
    ], Engine.prototype, "increaseVolume", null);
    tslib_1.__decorate([
        player_api_decorator_1.default()
    ], Engine.prototype, "decreaseVolume", null);
    tslib_1.__decorate([
        player_api_decorator_1.default()
    ], Engine.prototype, "setMute", null);
    tslib_1.__decorate([
        player_api_decorator_1.default()
    ], Engine.prototype, "getMute", null);
    tslib_1.__decorate([
        player_api_decorator_1.default()
    ], Engine.prototype, "setAutoPlay", null);
    tslib_1.__decorate([
        player_api_decorator_1.default()
    ], Engine.prototype, "getAutoPlay", null);
    tslib_1.__decorate([
        player_api_decorator_1.default()
    ], Engine.prototype, "setLoop", null);
    tslib_1.__decorate([
        player_api_decorator_1.default()
    ], Engine.prototype, "getLoop", null);
    tslib_1.__decorate([
        player_api_decorator_1.default()
    ], Engine.prototype, "setPlaybackRate", null);
    tslib_1.__decorate([
        player_api_decorator_1.default()
    ], Engine.prototype, "getPlaybackRate", null);
    tslib_1.__decorate([
        player_api_decorator_1.default()
    ], Engine.prototype, "setPreload", null);
    tslib_1.__decorate([
        player_api_decorator_1.default()
    ], Engine.prototype, "getPreload", null);
    tslib_1.__decorate([
        player_api_decorator_1.default()
    ], Engine.prototype, "getCurrentTime", null);
    tslib_1.__decorate([
        player_api_decorator_1.default('goTo')
    ], Engine.prototype, "setCurrentTime", null);
    tslib_1.__decorate([
        player_api_decorator_1.default()
    ], Engine.prototype, "getDurationTime", null);
    tslib_1.__decorate([
        player_api_decorator_1.default('getVideoRealWidth')
    ], Engine.prototype, "getVideoWidth", null);
    tslib_1.__decorate([
        player_api_decorator_1.default('getVideoRealHeight')
    ], Engine.prototype, "getVideoHeight", null);
    tslib_1.__decorate([
        player_api_decorator_1.default()
    ], Engine.prototype, "setPlayInline", null);
    tslib_1.__decorate([
        player_api_decorator_1.default()
    ], Engine.prototype, "getPlayInline", null);
    tslib_1.__decorate([
        player_api_decorator_1.default('getCurrentPlaybackState')
    ], Engine.prototype, "getCurrentState", null);
    tslib_1.__decorate([
        player_api_decorator_1.default()
    ], Engine.prototype, "getDebugInfo", null);
    return Engine;
}());
exports.default = Engine;


/***/ }),
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var tslib_2 = __webpack_require__(0);
var registrations_1 = __webpack_require__(40);
var ResolutionError_1 = tslib_1.__importDefault(__webpack_require__(74));
var nameValueToObject_1 = tslib_1.__importDefault(__webpack_require__(75));
var Lifetime_1 = tslib_1.__importDefault(__webpack_require__(29));
var FAMILY_TREE = '__familyTree__';
function createContainer(options, __parentContainer) {
    options = tslib_2.__assign({}, options);
    // The resolution stack is used to keep track
    // of what modules are being resolved, so when
    // an error occurs, we have something to present
    // to the poor developer who fucked up.
    var resolutionStack = [];
    // Internal registration store.
    var registrations = {};
    // The container being exposed.
    var container = {
        options: options,
        get registrations() {
            return tslib_2.__assign({}, __parentContainer && __parentContainer.registrations, registrations);
        },
    };
    // Track the family tree.
    var familyTree = __parentContainer
        ? [container].concat(__parentContainer[FAMILY_TREE])
        : [container];
    container[FAMILY_TREE] = familyTree;
    container.cache = {};
    container.createScope = function () { return createContainer(options, container); };
    container.register = function (name, registration) {
        var obj = nameValueToObject_1.default(name, registration);
        Object.keys(obj).forEach(function (key) {
            registrations[key] = obj[key];
        });
        return container;
    };
    var makeRegister = function (fn, verbatimValue) {
        return function (name, value, opts) {
            // This ensures that we can support name+value style and object style.
            var obj = nameValueToObject_1.default(name, value);
            Object.keys(obj).forEach(function (key) {
                var valueToRegister = obj[key];
                // If we have options, copy them over.
                opts = tslib_2.__assign({}, opts);
                /* ignore coverage */
                if (!verbatimValue && Array.isArray(valueToRegister)) {
                    // The ('name', [value, opts]) style
                    opts = tslib_2.__assign({}, opts, valueToRegister[1]);
                    valueToRegister = valueToRegister[0];
                }
                container.register(key, fn(valueToRegister, opts));
            });
            // Chaining
            return container;
        };
    };
    container.registerFunction = makeRegister(registrations_1.asFunction);
    container.registerClass = makeRegister(registrations_1.asClass);
    container.registerValue = makeRegister(registrations_1.asValue, /* verbatimValue: */ true);
    container.resolve = function (name) {
        // We need a reference to the root container,
        // so we can retrieve and store singletons.
        var root = familyTree[familyTree.length - 1];
        try {
            // Grab the registration by name.
            var registration = container.registrations[name];
            if (resolutionStack.indexOf(name) > -1) {
                throw new ResolutionError_1.default(name, resolutionStack, 'Cyclic dependencies detected.');
            }
            if (!registration) {
                throw new ResolutionError_1.default(name, resolutionStack);
            }
            // Pushes the currently-resolving module name onto the stack
            resolutionStack.push(name);
            // Do the thing
            var cached = void 0;
            var resolved = void 0;
            switch (registration.lifetime) {
                case Lifetime_1.default.TRANSIENT:
                    // Transient lifetime means resolve every time.
                    resolved = registration.resolve(container);
                    break;
                case Lifetime_1.default.SINGLETON:
                    // Singleton lifetime means cache at all times, regardless of scope.
                    cached = root.cache[name];
                    if (cached === undefined) {
                        resolved = registration.resolve(container);
                        root.cache[name] = resolved;
                    }
                    else {
                        resolved = cached;
                    }
                    break;
                case Lifetime_1.default.SCOPED:
                    // Scoped lifetime means that the container
                    // that resolves the registration also caches it.
                    // When a registration is not found, we travel up
                    // the family tree until we find one that is cached.
                    // Note: The first element in the family tree is this container.
                    for (var _i = 0, familyTree_1 = familyTree; _i < familyTree_1.length; _i++) {
                        var c = familyTree_1[_i];
                        cached = c.cache[name];
                        if (cached !== undefined) {
                            // We found one!
                            resolved = cached;
                            break;
                        }
                    }
                    // If we still have not found one, we need to resolve and cache it.
                    if (cached === undefined) {
                        resolved = registration.resolve(container);
                        container.cache[name] = resolved;
                    }
                    break;
                default:
                    throw new ResolutionError_1.default(name, resolutionStack, "Unknown lifetime \"" + registration.lifetime + "\"");
            }
            // Pop it from the stack again, ready for the next resolution
            resolutionStack.pop();
            return resolved;
        }
        catch (err) {
            // When we get an error we need to reset the stack.
            resolutionStack = [];
            throw err;
        }
    };
    // Finally return the container
    return container;
}
exports.default = createContainer;


/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var ExtendableError_1 = tslib_1.__importDefault(__webpack_require__(41));
var NotAFunctionError = /** @class */ (function (_super) {
    tslib_1.__extends(NotAFunctionError, _super);
    function NotAFunctionError(functionName, expectedType, givenType) {
        return _super.call(this, "The function " + functionName + " expected a " + expectedType + ", " + givenType + " given.") || this;
    }
    return NotAFunctionError;
}(ExtendableError_1.default));
exports.default = NotAFunctionError;


/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var ExtendableError_1 = tslib_1.__importDefault(__webpack_require__(41));
var createErrorMessage = function (name, resolutionStack, message) {
    resolutionStack = resolutionStack.slice();
    resolutionStack.push(name);
    var resolutionPathString = resolutionStack.join(' -> ');
    var msg = "Could not resolve '" + name + "'.";
    if (message) {
        msg += " " + message + " \n\n Resolution path: " + resolutionPathString;
    }
    return msg;
};
var ResolutionError = /** @class */ (function (_super) {
    tslib_1.__extends(ResolutionError, _super);
    function ResolutionError(name, resolutionStack, message) {
        return _super.call(this, createErrorMessage(name, resolutionStack, message)) || this;
    }
    return ResolutionError;
}(ExtendableError_1.default));
exports.default = ResolutionError;


/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
function default_1(name, value) {
    var obj = name;
    if (typeof obj !== 'object') {
        obj = tslib_1.__assign((_a = {}, _a[name] = value, _a));
    }
    return obj;
    var _a;
}
exports.default = default_1;


/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
}
Object.defineProperty(exports, "__esModule", { value: true });
var config_1 = __importDefault(__webpack_require__(77));
var player_api_decorator_1 = __webpack_require__(12);
var Player = /** @class */ (function () {
    function Player(params, scope, defaultModules, additionalModules, themeConfig) {
        if (additionalModules === void 0) { additionalModules = {}; }
        scope.registerValue({
            config: config_1.default(params),
        });
        scope.registerValue({
            themeConfig: themeConfig,
        });
        this._config = scope.resolve('config');
        this._resolveDefaultModules(scope, defaultModules);
        this._resolveAdditionalModules(scope, additionalModules);
    }
    /*
      Separation for default and additional modules is needed
      for future implementation of public methods of resolved modules and
      could be abolished in future
    */
    Player.prototype._resolveDefaultModules = function (scope, modules) {
        var _this = this;
        this._defaultModules = Object.keys(modules).reduce(function (modules, moduleName) {
            var resolvedModule = scope.resolve(moduleName);
            _this._addPlayerAPIFromModule(resolvedModule, moduleName);
            modules[moduleName] = resolvedModule;
            return modules;
        }, {});
    };
    Player.prototype._resolveAdditionalModules = function (scope, modules) {
        var _this = this;
        this._additionalModules = Object.keys(modules).reduce(function (modules, moduleName) {
            var resolvedModule = scope.resolve(moduleName);
            _this._addPlayerAPIFromModule(resolvedModule, moduleName);
            modules[moduleName] = resolvedModule;
            return modules;
        }, {});
    };
    Player.prototype._getWrappedCallToModuleFunction = function (module, _moduleName, fn) {
        var _this = this;
        // TODO: do we need `_moduleName` as second parameter?
        return function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            if (_this._destroyed) {
                throw new Error('Player instance is destroyed');
            }
            return fn.apply(module, args);
        };
    };
    Player.prototype._getPlayerAPIMethodDescriptor = function (module, moduleName, descriptor) {
        var playerMethodDescriptor = {
            enumerable: true,
            configurable: true,
        };
        var get = descriptor.get, set = descriptor.set, value = descriptor.value;
        if (get) {
            playerMethodDescriptor.get = this._getWrappedCallToModuleFunction(module, moduleName, get);
        }
        if (set) {
            playerMethodDescriptor.set = this._getWrappedCallToModuleFunction(module, moduleName, set);
        }
        if (value) {
            playerMethodDescriptor.value = this._getWrappedCallToModuleFunction(module, moduleName, value);
        }
        return playerMethodDescriptor;
    };
    Player.prototype._addPlayerAPIFromModule = function (module, moduleName) {
        var _this = this;
        if (module[player_api_decorator_1.PLAYER_API_PROPERTY]) {
            Object.keys(module[player_api_decorator_1.PLAYER_API_PROPERTY]).forEach(function (apiKey) {
                if (_this[apiKey]) {
                    throw new Error("API method " + apiKey + " is already defined in Player facade");
                }
                Object.defineProperty(_this, apiKey, _this._getPlayerAPIMethodDescriptor(module, moduleName, module[player_api_decorator_1.PLAYER_API_PROPERTY][apiKey]));
            });
        }
    };
    Player.prototype._clearPlayerAPIForModule = function (module) {
        var _this = this;
        if (module[player_api_decorator_1.PLAYER_API_PROPERTY]) {
            Object.keys(module[player_api_decorator_1.PLAYER_API_PROPERTY]).forEach(function (apiKey) {
                delete _this[apiKey];
            });
        }
    };
    Player.prototype.destroy = function () {
        var _this = this;
        Object.keys(this._defaultModules).forEach(function (moduleName) {
            var module = _this._defaultModules[moduleName];
            _this._clearPlayerAPIForModule(module);
            module.destroy();
        });
        Object.keys(this._additionalModules).forEach(function (moduleName) {
            var module = _this._additionalModules[moduleName];
            _this._clearPlayerAPIForModule(module);
            if (module.destroy) {
                module.destroy();
            }
        });
        delete this._defaultModules;
        delete this._additionalModules;
        delete this._config;
        this._destroyed = true;
    };
    return Player;
}());
exports.default = Player;


/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var device_detection_1 = __webpack_require__(19);
var convertUIConfigForIOS = function (params) { return (tslib_1.__assign({}, params, { showInteractionIndicator: false, screen: tslib_1.__assign({}, params.screen, { disableClickProcessing: true, nativeControls: true }), title: false, loader: false, controls: false })); };
var convertUIConfigForAndroid = function (params) { return (tslib_1.__assign({}, params, { screen: tslib_1.__assign({}, params.screen, { disableClickProcessing: true }) })); };
var convertToDeviceRelatedConfig = function (params) {
    if (device_detection_1.isIOS()) {
        return convertUIConfigForIOS(params);
    }
    if (device_detection_1.isAndroid()) {
        return convertUIConfigForAndroid(params);
    }
    return params;
};
exports.default = convertToDeviceRelatedConfig;


/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var focus_source_1 = tslib_1.__importDefault(__webpack_require__(79));
var focus_within_1 = tslib_1.__importDefault(__webpack_require__(81));
var player_api_decorator_1 = tslib_1.__importDefault(__webpack_require__(12));
var index_1 = __webpack_require__(2);
var root_container_view_1 = tslib_1.__importDefault(__webpack_require__(89));
var element_queries_1 = tslib_1.__importDefault(__webpack_require__(97));
var DEFAULT_CONFIG = {
    fillAllSpace: false,
};
var RootContainer = /** @class */ (function () {
    function RootContainer(_a) {
        var eventEmitter = _a.eventEmitter, config = _a.config, engine = _a.engine;
        this._eventEmitter = eventEmitter;
        this._engine = engine;
        this.isHidden = false;
        this._initUI(config);
        this._bindEvents();
    }
    Object.defineProperty(RootContainer.prototype, "node", {
        /**
         * Getter for DOM node with player UI element
         * (use it only for debug, if you need attach player to your document use `attachToElement` method)
         */
        get: function () {
            return this.view.getNode();
        },
        enumerable: true,
        configurable: true
    });
    RootContainer.prototype._bindEvents = function () {
        this._eventEmitter.on(index_1.UI_EVENTS.FULLSCREEN_STATUS_CHANGED, this.view.setFullScreenStatus, this.view);
    };
    RootContainer.prototype._unbindEvents = function () {
        this._eventEmitter.off(index_1.UI_EVENTS.FULLSCREEN_STATUS_CHANGED, this.view.setFullScreenStatus, this.view);
    };
    RootContainer.prototype._initUI = function (config) {
        var sizeConfig = tslib_1.__assign({}, config.size);
        this.view = new root_container_view_1.default({
            width: sizeConfig.width || null,
            height: sizeConfig.height || null,
            fillAllSpace: config.fillAllSpace || DEFAULT_CONFIG.fillAllSpace,
        });
    };
    RootContainer.prototype.appendComponentNode = function (node) {
        this.view.appendComponentNode(node);
    };
    RootContainer.prototype._enableFocusInterceptors = function () {
        if (!this._disengageFocusWithin) {
            this._disengageFocusWithin = focus_within_1.default();
        }
        if (!this._disengageFocusSource) {
            focus_source_1.default.engage();
            this._disengageFocusSource = focus_source_1.default.disengage;
        }
    };
    RootContainer.prototype._disableFocusInterceptors = function () {
        if (this._disengageFocusSource) {
            this._disengageFocusSource();
            delete this._disengageFocusSource;
        }
        if (this._disengageFocusWithin) {
            this._disengageFocusWithin();
            delete this._disengageFocusWithin;
        }
    };
    /**
     * Method for attaching player node to your container
     * It's important to call this methods after `DOMContentLoaded` event!
     *
     * @example
     * document.addEventListener('DOMContentLoaded', function() {
     *   const config = { src: 'http://my-url/video.mp4' }
     *   const player = Playable.create(config);
     *
     *   player.attachToElement(document.getElementById('content'));
     * });
     */
    RootContainer.prototype.attachToElement = function (node) {
        this._enableFocusInterceptors();
        node.appendChild(this.node);
        if (!this._elementQueries) {
            // NOTE: required for valid work of player "media queries"
            this._elementQueries = new element_queries_1.default(this.node);
        }
    };
    /**
     * Method for setting width of player
     * @param width - Desired width of player in pixels
     * @example
     * player.setWidth(400);
     */
    RootContainer.prototype.setWidth = function (width) {
        this.view.setWidth(width);
        this._eventEmitter.emit(index_1.UI_EVENTS.PLAYER_WIDTH_CHANGE_TRIGGERED, width);
    };
    /**
     * Return current width of player in pixels
     * @example
     * player.getWidth(); // 400
     */
    RootContainer.prototype.getWidth = function () {
        return this.view.getWidth();
    };
    /**
     * Method for setting width of player
     * @param height - Desired height of player in pixels
     * @example
     * player.setHeight(225);
     */
    RootContainer.prototype.setHeight = function (height) {
        this.view.setHeight(height);
        this._eventEmitter.emit(index_1.UI_EVENTS.PLAYER_HEIGHT_CHANGE_TRIGGERED, height);
    };
    /**
     * Return current height of player in pixels
     * @example
     * player.getHeight(); // 225
     */
    RootContainer.prototype.getHeight = function () {
        return this.view.getHeight();
    };
    /**
     * Method for allowing player fill all available space
     * @param flag - `true` for allowing
     * @example
     * player.setFillAllSpace(true);
     */
    RootContainer.prototype.setFillAllSpace = function (flag) {
        this.view.setFillAllSpaceFlag(flag);
    };
    /**
     * Hide whole ui
     * @example
     * player.hide();
     */
    RootContainer.prototype.hide = function () {
        this.isHidden = true;
        this.view.hide();
    };
    /**
     * Show whole ui
     * @example
     * player.show();
     */
    RootContainer.prototype.show = function () {
        this.isHidden = false;
        this.view.show();
    };
    RootContainer.prototype.destroy = function () {
        this._unbindEvents();
        this._disableFocusInterceptors();
        if (this._elementQueries) {
            this._elementQueries.destroy();
            delete this._elementQueries;
        }
        this.view.destroy();
        delete this.view;
        delete this._engine;
        delete this._eventEmitter;
    };
    RootContainer.moduleName = 'rootContainer';
    RootContainer.dependencies = ['eventEmitter', 'config', 'engine'];
    tslib_1.__decorate([
        player_api_decorator_1.default()
    ], RootContainer.prototype, "node", null);
    tslib_1.__decorate([
        player_api_decorator_1.default()
    ], RootContainer.prototype, "attachToElement", null);
    tslib_1.__decorate([
        player_api_decorator_1.default()
    ], RootContainer.prototype, "setWidth", null);
    tslib_1.__decorate([
        player_api_decorator_1.default()
    ], RootContainer.prototype, "getWidth", null);
    tslib_1.__decorate([
        player_api_decorator_1.default()
    ], RootContainer.prototype, "setHeight", null);
    tslib_1.__decorate([
        player_api_decorator_1.default()
    ], RootContainer.prototype, "getHeight", null);
    tslib_1.__decorate([
        player_api_decorator_1.default()
    ], RootContainer.prototype, "setFillAllSpace", null);
    tslib_1.__decorate([
        player_api_decorator_1.default()
    ], RootContainer.prototype, "hide", null);
    tslib_1.__decorate([
        player_api_decorator_1.default()
    ], RootContainer.prototype, "show", null);
    return RootContainer;
}());
exports.default = RootContainer;


/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// Code from ally.js
/*
  add data-focus-source attribute to html element containing "key", "pointer" or "script"
  depending on the input method used to change focus.

  USAGE:
    style/focus-source()

    body :focus {
      outline: 1px solid grey;
    }

    html[data-focus-source="key"] body :focus {
      outline: 5px solid red;
    }

    html[data-focus-source="key"] body :focus {
      outline: 1px solid blue;
    }

  NOTE: I don't have a GamePad to test, if you do and you want to
  implement an observer for https://w3c.github.io/gamepad/ - send a PR!

  Alternate implementation: https://github.com/alice/modality
*/
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var interaction_type_1 = tslib_1.__importDefault(__webpack_require__(80));
// preferring focusin/out because they are synchronous in IE10+11
var supportsFocusIn = typeof document !== 'undefined' && 'onfocusin' in document;
var focusEventName = supportsFocusIn ? 'focusin' : 'focus';
var blurEventName = supportsFocusIn ? 'focusout' : 'blur';
// interface to read interaction-type-listener state
var interactionTypeHandler;
// keep track of last focus source
var current = null;
// overwrite focus source for use with the every upcoming focus event
var lock = null;
// keep track of ever having used a particular input method to change focus
var used = {
    pointer: false,
    key: false,
    script: false,
    initial: false,
};
function handleFocusEvent(event) {
    var source = '';
    if (event.type === focusEventName) {
        var interactionType = interactionTypeHandler.get();
        source =
            lock ||
                (interactionType.pointer && 'pointer') ||
                (interactionType.key && 'key') ||
                'script';
    }
    else if (event.type === 'initial') {
        source = 'initial';
    }
    document.documentElement.setAttribute('data-focus-source', source);
    if (event.type !== blurEventName) {
        used[source] = true;
        current = source;
    }
}
function getCurrentFocusSource() {
    return current;
}
function getUsedFocusSource(source) {
    return used[source];
}
function lockFocusSource(source) {
    lock = source;
}
function unlockFocusSource() {
    lock = false;
}
function disengage() {
    // clear dom state
    handleFocusEvent({ type: blurEventName });
    current = lock = null;
    Object.keys(used).forEach(function (key) {
        used[key] = false;
    });
    // kill interaction type identification listener
    interaction_type_1.default.disengage();
    document.documentElement.removeEventListener(focusEventName, handleFocusEvent, true);
    document.documentElement.removeEventListener(blurEventName, handleFocusEvent, true);
    document.documentElement.removeAttribute('data-focus-source');
}
function engage() {
    document.documentElement.addEventListener(focusEventName, handleFocusEvent, true);
    document.documentElement.addEventListener(blurEventName, handleFocusEvent, true);
    // enable the interaction type identification observer
    interactionTypeHandler = interaction_type_1.default.engage();
    // set up initial dom state
    handleFocusEvent({ type: 'initial' });
    return {
        used: getUsedFocusSource,
        current: getCurrentFocusSource,
        lock: lockFocusSource,
        unlock: unlockFocusSource,
    };
}
exports.default = { engage: engage, disengage: disengage };


/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// Code from ally.js
Object.defineProperty(exports, "__esModule", { value: true });
/*
  Observe keyboard-, pointer-, mouse- and touch-events so that a query for
  the current interaction type can be made at any time. For pointer interaction
  this observer is limited to pointer button down/up - move is not observed!

  USAGE:
    var listener = engage();
    listener.get() === {pointer: Boolean, key: Boolean}
*/
// counters to track primary input
var _activePointers = 0;
var _activeKeys = 0;
var pointerStartEvents = [
    'touchstart',
    'pointerdown',
    'MSPointerDown',
    'mousedown',
];
var pointerEndEvents = [
    'touchend',
    'touchcancel',
    'pointerup',
    'MSPointerUp',
    'pointercancel',
    'MSPointerCancel',
    'mouseup',
];
function handleWindowBlurEvent() {
    // reset internal counters when window loses focus
    _activePointers = 0;
    _activeKeys = 0;
}
function handlePointerStartEvent(event) {
    if (event.isPrimary === false) {
        // ignore non-primary pointer events
        // https://w3c.github.io/pointerevents/#widl-PointerEvent-isPrimary
        return;
    }
    // mousedown without following mouseup
    // (likely not possible in Chrome)
    _activePointers += 1;
}
function handlePointerEndEvent(event) {
    if (event.isPrimary === false) {
        // ignore non-primary pointer events
        // https://w3c.github.io/pointerevents/#widl-PointerEvent-isPrimary
        return;
    }
    else if (event.touches) {
        _activePointers = event.touches.length;
        return;
    }
    // delay reset to when the current handlers are executed
    (window.setImmediate || window.setTimeout)(function () {
        // mouseup without prior mousedown
        // (drag something out of the window)
        _activePointers = Math.max(_activePointers - 1, 0);
    });
}
function handleKeyStartEvent(event) {
    // ignore modifier keys
    switch (event.keyCode || event.which) {
        case 16: // space
        case 17: // control
        case 18: // alt
        case 91: // command left
        case 93:// command right
            return;
        default:
            break;
    }
    // keydown without a following keyup
    // (may happen on CMD+TAB)
    _activeKeys += 1;
}
function handleKeyEndEvent(event) {
    // ignore modifier keys
    switch (event.keyCode || event.which) {
        case 16: // space
        case 17: // control
        case 18: // alt
        case 91: // command left
        case 93:// command right
            return;
        default:
            break;
    }
    // delay reset to when the current handlers are executed
    (window.setImmediate || window.setTimeout)(function () {
        // keyup without prior keydown
        // (may happen on CMD+R)
        _activeKeys = Math.max(_activeKeys - 1, 0);
    });
}
function getInteractionType() {
    return {
        pointer: Boolean(_activePointers),
        key: Boolean(_activeKeys),
    };
}
function disengage() {
    _activePointers = _activeKeys = 0;
    window.removeEventListener('blur', handleWindowBlurEvent, false);
    document.documentElement.removeEventListener('keydown', handleKeyStartEvent, true);
    document.documentElement.removeEventListener('keyup', handleKeyEndEvent, true);
    pointerStartEvents.forEach(function (event) {
        document.documentElement.removeEventListener(event, handlePointerStartEvent, true);
    });
    pointerEndEvents.forEach(function (event) {
        document.documentElement.removeEventListener(event, handlePointerEndEvent, true);
    });
}
function engage() {
    // window blur must be in bubble phase so it won't capture regular blurs
    window.addEventListener('blur', handleWindowBlurEvent, false);
    // handlers to identify the method of focus change
    document.documentElement.addEventListener('keydown', handleKeyStartEvent, true);
    document.documentElement.addEventListener('keyup', handleKeyEndEvent, true);
    pointerStartEvents.forEach(function (event) {
        document.documentElement.addEventListener(event, handlePointerStartEvent, true);
    });
    pointerEndEvents.forEach(function (event) {
        document.documentElement.addEventListener(event, handlePointerEndEvent, true);
    });
    return {
        get: getInteractionType,
    };
}
exports.default = { engage: engage, disengage: disengage };


/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
// inspired by https://gist.github.com/aFarkas/a7e0d85450f323d5e164
var focusWithin = function () {
    var slice = [].slice;
    var removeClass = function (elem) {
        elem.classList.remove('focus-within');
    };
    var update = (function () {
        var running;
        var last;
        var action = function () {
            var element = document.activeElement;
            running = false;
            if (last !== element) {
                last = element;
                slice
                    .call(document.getElementsByClassName('focus-within'))
                    .forEach(removeClass);
                while (element && element.classList) {
                    element.classList.add('focus-within');
                    element = element.parentNode;
                }
            }
        };
        return function () {
            if (!running) {
                requestAnimationFrame(action);
                running = true;
            }
        };
    })();
    document.addEventListener('focus', update, true);
    document.addEventListener('blur', update, true);
    update();
    return function () {
        document.removeEventListener('focus', update, true);
        document.removeEventListener('blur', update, true);
    };
};
exports.default = focusWithin;


/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var MediaStreamTypes;
(function (MediaStreamTypes) {
    MediaStreamTypes["MP4"] = "MP4";
    MediaStreamTypes["WEBM"] = "WEBM";
    MediaStreamTypes["HLS"] = "HLS";
    MediaStreamTypes["DASH"] = "DASH";
})(MediaStreamTypes || (MediaStreamTypes = {}));
exports.MediaStreamTypes = MediaStreamTypes;
var MediaStreamDeliveryPriority;
(function (MediaStreamDeliveryPriority) {
    MediaStreamDeliveryPriority[MediaStreamDeliveryPriority["NATIVE_PROGRESSIVE"] = 0] = "NATIVE_PROGRESSIVE";
    MediaStreamDeliveryPriority[MediaStreamDeliveryPriority["ADAPTIVE_VIA_MSE"] = 1] = "ADAPTIVE_VIA_MSE";
    MediaStreamDeliveryPriority[MediaStreamDeliveryPriority["NATIVE_ADAPTIVE"] = 2] = "NATIVE_ADAPTIVE";
    MediaStreamDeliveryPriority[MediaStreamDeliveryPriority["FORCED"] = 3] = "FORCED";
})(MediaStreamDeliveryPriority || (MediaStreamDeliveryPriority = {}));
exports.MediaStreamDeliveryPriority = MediaStreamDeliveryPriority;


/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var UI_EVENTS = {
    PLAY_TRIGGERED: 'ui-play-triggered',
    PLAY_OVERLAY_TRIGGERED: 'ui-play-overlay-triggered',
    PAUSE_TRIGGERED: 'ui-pause-triggered',
    PROGRESS_CHANGE_TRIGGERED: 'ui-progress-change-triggered',
    VOLUME_CHANGE_TRIGGERED: 'ui-volume-change-triggered',
    MUTE_STATUS_TRIGGERED: 'ui-mute-status-triggered',
    FULLSCREEN_STATUS_CHANGED: 'ui-fullscreen-status-changed',
    MOUSE_ENTER_ON_PLAYER_TRIGGERED: 'ui-mouse-enter-on-player-triggered',
    MOUSE_MOVE_ON_PLAYER_TRIGGERED: 'ui-mouse-move-on-player-triggered',
    MOUSE_LEAVE_ON_PLAYER_TRIGGERED: 'ui-mouse-leave-on-player-triggered',
    CONTROL_BLOCK_HIDE_TRIGGERED: 'ui-control-block-hide-triggered',
    CONTROL_BLOCK_SHOW_TRIGGERED: 'ui-control-block-show-triggered',
    PROGRESS_MANIPULATION_STARTED: 'ui-progress-manipulation-started',
    PROGRESS_MANIPULATION_ENDED: 'ui-progress-manipulation-ended',
    KEYBOARD_KEYDOWN_INTERCEPTED: 'ui-keyboard-keydown-intercepted',
    LOADER_SHOW_TRIGGERED: 'ui-loader-show-triggered',
    LOADER_HIDE_TRIGGERED: 'ui-loader-hide-triggered',
    LOADING_COVER_SHOW_TRIGGERED: 'ui-loading-cover-show-triggered',
    LOADING_COVER_HIDE_TRIGGERED: 'ui-loading-cover-hide-triggered',
    TOGGLE_PLAYBACK_WITH_KEYBOARD_TRIGGERED: 'ui-toggle-playback-with-keyboard-triggered',
    GO_BACKWARD_WITH_KEYBOARD_TRIGGERED: 'ui-go-backward-with-keyboard-triggered',
    GO_FORWARD_WITH_KEYBOARD_TRIGGERED: 'ui-go-forward-with-keyboard-triggered',
    INCREASE_VOLUME_WITH_KEYBOARD_TRIGGERED: 'ui-increase-volume-with-keyboard-triggered',
    DECREASE_VOLUME_WITH_KEYBOARD_TRIGGERED: 'ui-decrease-volume-with-keyboard-triggered',
    MUTE_SOUND_WITH_KEYBOARD_TRIGGERED: 'ui-mute-sound-with-keyboard-triggered',
    UNMUTE_SOUND_WITH_KEYBOARD_TRIGGERED: 'ui-unmute-sound-with-keyboard-triggered',
    HIDE_INTERACTION_INDICATOR_TRIGGERED: 'ui-hide-interaction-indicator-triggered',
    PLAYER_WIDTH_CHANGE_TRIGGERED: 'ui-player-width-change-triggered',
    PLAYER_HEIGHT_CHANGE_TRIGGERED: 'ui-player-height-change-triggered',
    PLAY_WITH_SCREEN_CLICK_TRIGGERED: 'ui-play-with-screen-click-triggered',
    PAUSE_WITH_SCREEN_CLICK_TRIGGERED: 'ui-pause-with-screen-click-triggered',
    CONTROL_DRAG_START: 'ui-control-drag-start',
    CONTROL_DRAG_END: 'ui-control-drag-end',
    MAIN_BLOCK_HIDE_TRIGGERED: 'ui-main-block-hide-triggered',
    MAIN_BLOCK_SHOW_TRIGGERED: 'ui-main-block-show-triggered',
};
exports.default = UI_EVENTS;


/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var VIDEO_EVENTS = {
    ERROR: 'error',
    STATE_CHANGED: 'state-changed',
    LIVE_STATE_CHANGED: 'live-state-changed',
    DYNAMIC_CONTENT_ENDED: 'dynamic-content-ended',
    CHUNK_LOADED: 'chunk-loaded',
    CURRENT_TIME_UPDATED: 'current-time-updated',
    DURATION_UPDATED: 'duration-updated',
    VOLUME_STATUS_CHANGED: 'volume-status-changed',
    VOLUME_CHANGED: 'volume-changed',
    MUTE_CHANGED: 'mute-changed',
    SEEK_IN_PROGRESS: 'seek-in-progress',
    UPLOAD_STALLED: 'upload-stalled',
    UPLOAD_SUSPEND: 'upload-suspend',
    PLAY_REQUEST_TRIGGERED: 'play-request-triggered',
    PLAY_ABORTED: 'play-aborted',
    UNKNOWN: 'unknown',
};
exports.default = VIDEO_EVENTS;


/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var Errors = {
    SRC_PARSE: 'error-src-parse',
    MANIFEST_LOAD: 'error-manifest-load',
    MANIFEST_PARSE: 'error-manifest-parse',
    MANIFEST_INCOMPATIBLE: 'error-manifest-incompatible',
    LEVEL_LOAD: 'error-level-load',
    CONTENT_LOAD: 'error-content-load',
    CONTENT_PARSE: 'error-content-parse',
    MEDIA: 'error-media',
    UNKNOWN: 'error-unknown',
};
exports.default = Errors;


/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    LOGO_LABEL: 'logo-label',
    LOGO_TOOLTIP: 'logo-tooltip',
    LIVE_INDICATOR_TEXT: 'live-indicator-text',
    LIVE_SYNC_LABEL: 'live-sync-button-label',
    LIVE_SYNC_TOOLTIP: 'live-sync-button-tooltip',
    ENTER_FULL_SCREEN_LABEL: 'enter-full-screen-label',
    ENTER_FULL_SCREEN_TOOLTIP: 'enter-full-screen-tooltip',
    EXIT_FULL_SCREEN_LABEL: 'exit-full-screen-label',
    EXIT_FULL_SCREEN_TOOLTIP: 'exit-full-screen-tooltip',
    PLAY_CONTROL_LABEL: 'play-control-label',
    PAUSE_CONTROL_LABEL: 'pause-control-label',
    PROGRESS_CONTROL_LABEL: 'progress-control-label',
    PROGRESS_CONTROL_VALUE: 'progress-control-value',
    UNMUTE_CONTROL_LABEL: 'unmute-control-label',
    UNMUTE_CONTROL_TOOLTIP: 'unmute-control-label',
    MUTE_CONTROL_LABEL: 'mute-control-label',
    MUTE_CONTROL_TOOLTIP: 'mute-control-tooltip',
    VOLUME_CONTROL_LABEL: 'volume-control-label',
    VOLUME_CONTROL_VALUE: 'volume-control-value',
};


/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var STATES = {
    SRC_SET: 'src-set',
    LOAD_STARTED: 'load-started',
    METADATA_LOADED: 'metadata-loaded',
    READY_TO_PLAY: 'ready-to-play',
    SEEK_IN_PROGRESS: 'seek-in-progress',
    PLAY_REQUESTED: 'play-requested',
    WAITING: 'waiting',
    PLAYING: 'playing',
    PAUSED: 'paused',
    ENDED: 'ended',
};
exports.default = STATES;


/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var LiveState;
(function (LiveState) {
    LiveState["NONE"] = "none";
    LiveState["INITIAL"] = "initial";
    LiveState["NOT_SYNC"] = "not-sync";
    LiveState["SYNC"] = "sync";
    LiveState["ENDED"] = "ended";
})(LiveState || (LiveState = {}));
exports.default = LiveState;


/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var htmlToElement_1 = tslib_1.__importDefault(__webpack_require__(6));
var templates_1 = __webpack_require__(90);
var view_1 = tslib_1.__importDefault(__webpack_require__(10));
var root_container_scss_1 = tslib_1.__importDefault(__webpack_require__(94));
var RootContainerView = /** @class */ (function (_super) {
    tslib_1.__extends(RootContainerView, _super);
    function RootContainerView(config) {
        var _this = _super.call(this) || this;
        var width = config.width, height = config.height, fillAllSpace = config.fillAllSpace;
        _this._$node = htmlToElement_1.default(templates_1.containerTemplate({ styles: _this.styleNames }));
        _this.setFillAllSpaceFlag(fillAllSpace);
        _this.setWidth(width);
        _this.setHeight(height);
        return _this;
    }
    RootContainerView.prototype.setWidth = function (width) {
        if (!width) {
            return;
        }
        this._width = width;
        this._$node.style.width = this._width + "px";
    };
    RootContainerView.prototype.setHeight = function (height) {
        if (!height) {
            return;
        }
        this._height = height;
        this._$node.style.height = this._height + "px";
    };
    RootContainerView.prototype.getWidth = function () {
        return this._width;
    };
    RootContainerView.prototype.getHeight = function () {
        return this._height;
    };
    RootContainerView.prototype.show = function () {
        this._$node.classList.add(this.styleNames.hidden);
    };
    RootContainerView.prototype.hide = function () {
        this._$node.classList.remove(this.styleNames.hidden);
    };
    RootContainerView.prototype.appendComponentNode = function (node) {
        this._$node.appendChild(node);
    };
    RootContainerView.prototype.getNode = function () {
        return this._$node;
    };
    RootContainerView.prototype.setFullScreenStatus = function (isFullScreen) {
        if (isFullScreen) {
            this._$node.setAttribute('data-in-full-screen', 'true');
            this._$node.classList.add(this.styleNames.fullScreen);
        }
        else {
            this._$node.setAttribute('data-in-full-screen', 'false');
            this._$node.classList.remove(this.styleNames.fullScreen);
        }
    };
    RootContainerView.prototype.setFillAllSpaceFlag = function (isFillAllSpace) {
        if (isFillAllSpace === void 0) { isFillAllSpace = false; }
        if (isFillAllSpace) {
            this._$node.classList.add(this.styleNames.fillAllSpace);
        }
        else {
            this._$node.classList.remove(this.styleNames.fillAllSpace);
        }
    };
    RootContainerView.prototype.destroy = function () {
        if (this._$node.parentNode) {
            this._$node.parentNode.removeChild(this._$node);
        }
        delete this._$node;
    };
    return RootContainerView;
}(view_1.default));
RootContainerView.extendStyleNames(root_container_scss_1.default);
exports.default = RootContainerView;


/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var container_dot_1 = __webpack_require__(91);
exports.containerTemplate = container_dot_1.default;


/***/ }),
/* 91 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = anonymous;
function anonymous(props
/*``*/) {
var out='<div data-hook="player-container" tabindex="0" class="'+(props.styles.videoWrapper)+'"></div>';return out;
}

/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var classnames_1 = tslib_1.__importDefault(__webpack_require__(93));
function extendStyles(sourceStyles, partialStyles) {
    var styles = tslib_1.__assign({}, sourceStyles);
    Object.keys(partialStyles).forEach(function (styleName) {
        styles[styleName] = styles[styleName]
            ? classnames_1.default(styles[styleName], partialStyles[styleName])
            : partialStyles[styleName];
    });
    return styles;
}
exports.default = extendStyles;


/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2016 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg)) {
				classes.push(classNames.apply(null, arg));
			} else if (argType === 'object') {
				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if (typeof module !== 'undefined' && module.exports) {
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
			return classNames;
		}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {
		window.classNames = classNames;
	}
}());


/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(95);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"singleton":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(8)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--9-1!../../../node_modules/postcss-loader/lib/index.js??ref--9-2!../../../node_modules/sass-loader/lib/loader.js??ref--9-3!./root-container.scss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js??ref--9-1!../../../node_modules/postcss-loader/lib/index.js??ref--9-2!../../../node_modules/sass-loader/lib/loader.js??ref--9-3!./root-container.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(false);
// imports


// module
exports.push([module.i, "._8Oqb5{display:-webkit-box;display:-ms-flexbox;display:flex;padding:0;cursor:pointer;-webkit-transition-duration:.2s;transition-duration:.2s;-webkit-transition-property:opacity;transition-property:opacity;opacity:1;border:0;border-radius:0;outline:none;background-color:transparent;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center}._8Oqb5:hover{opacity:.7}._5shSG{visibility:hidden!important;width:0!important;min-width:0!important;height:0!important;min-height:0!important;margin:0!important;padding:0!important;opacity:0!important}._26REE{font-family:HelveticaNeueW01-45Ligh,HelveticaNeueW02-45Ligh,HelveticaNeueW10-45Ligh,Helvetica Neue,Helvetica,Arial,\\\\30E1\\30A4\\30EA\\30AA,meiryo,\\\\30D2\\30E9\\30AE\\30CE\\89D2\\30B4 pro w3,hiragino kaku gothic pro;line-height:0;position:relative;overflow:hidden;height:inherit;outline:none}._26REE *,._26REE :after,._26REE :before{-webkit-box-sizing:content-box;box-sizing:content-box;outline:none}._26REE button{font-family:inherit;font-size:100%;line-height:1.15;overflow:visible;margin:0;text-transform:none;-webkit-appearance:button}._26REE button::-moz-focus-inner{padding:0;border-style:none}._26REE button:-moz-focusring{outline:1px dotted ButtonText}._26REE ._33e9i{display:none}.b_TCu,.OXwhe{width:100%!important;height:100%!important}[data-focus-source=key] [data-hook=player-container] button.focus-within,[data-focus-source=key] [data-hook=player-container] img.focus-within,[data-focus-source=key] [data-hook=player-container] input.focus-within,[data-focus-source=script] [data-hook=player-container] button.focus-within,[data-focus-source=script] [data-hook=player-container] img.focus-within,[data-focus-source=script] [data-hook=player-container] input.focus-within{-webkit-box-shadow:0 0 0 2px rgba(56,153,236,.8);box-shadow:0 0 0 2px rgba(56,153,236,.8)}", ""]);

// exports
exports.locals = {
	"controlButton": "_8Oqb5",
	"hidden": "_5shSG",
	"videoWrapper": "_26REE",
	"fullScreenControl": "_33e9i",
	"fillAllSpace": "b_TCu",
	"fullScreen": "OXwhe"
};

/***/ }),
/* 96 */
/***/ (function(module, exports) {


/**
 * When source maps are enabled, `style-loader` uses a link element with a data-uri to
 * embed the css on the page. This breaks all relative urls because now they are relative to a
 * bundle instead of the current page.
 *
 * One solution is to only use full urls, but that may be impossible.
 *
 * Instead, this function "fixes" the relative urls to be absolute according to the current page location.
 *
 * A rudimentary test suite is located at `test/fixUrls.js` and can be run via the `npm test` command.
 *
 */

module.exports = function (css) {
  // get current location
  var location = typeof window !== "undefined" && window.location;

  if (!location) {
    throw new Error("fixUrls requires window.location");
  }

	// blank or null?
	if (!css || typeof css !== "string") {
	  return css;
  }

  var baseUrl = location.protocol + "//" + location.host;
  var currentDir = baseUrl + location.pathname.replace(/\/[^\/]*$/, "/");

	// convert each url(...)
	/*
	This regular expression is just a way to recursively match brackets within
	a string.

	 /url\s*\(  = Match on the word "url" with any whitespace after it and then a parens
	   (  = Start a capturing group
	     (?:  = Start a non-capturing group
	         [^)(]  = Match anything that isn't a parentheses
	         |  = OR
	         \(  = Match a start parentheses
	             (?:  = Start another non-capturing groups
	                 [^)(]+  = Match anything that isn't a parentheses
	                 |  = OR
	                 \(  = Match a start parentheses
	                     [^)(]*  = Match anything that isn't a parentheses
	                 \)  = Match a end parentheses
	             )  = End Group
              *\) = Match anything and then a close parens
          )  = Close non-capturing group
          *  = Match anything
       )  = Close capturing group
	 \)  = Match a close parens

	 /gi  = Get all matches, not the first.  Be case insensitive.
	 */
	var fixedCss = css.replace(/url\s*\(((?:[^)(]|\((?:[^)(]+|\([^)(]*\))*\))*)\)/gi, function(fullMatch, origUrl) {
		// strip quotes (if they exist)
		var unquotedOrigUrl = origUrl
			.trim()
			.replace(/^"(.*)"$/, function(o, $1){ return $1; })
			.replace(/^'(.*)'$/, function(o, $1){ return $1; });

		// already a full url? no change
		if (/^(#|data:|http:\/\/|https:\/\/|file:\/\/\/)/i.test(unquotedOrigUrl)) {
		  return fullMatch;
		}

		// convert the url to a full url
		var newUrl;

		if (unquotedOrigUrl.indexOf("//") === 0) {
		  	//TODO: should we add protocol?
			newUrl = unquotedOrigUrl;
		} else if (unquotedOrigUrl.indexOf("/") === 0) {
			// path should be relative to the base url
			newUrl = baseUrl + unquotedOrigUrl; // already starts with '/'
		} else {
			// path should be relative to current directory
			newUrl = currentDir + unquotedOrigUrl.replace(/^\.\//, ""); // Strip leading './'
		}

		// send back the fixed url(...)
		return "url(" + JSON.stringify(newUrl) + ")";
	});

	// send back the fixed css
	return fixedCss;
};


/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var element_queries_1 = __webpack_require__(98);
exports.default = element_queries_1.default;


/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var resize_observer_polyfill_1 = tslib_1.__importDefault(__webpack_require__(99));
var getQueriesForElement_1 = tslib_1.__importDefault(__webpack_require__(100));
var DEFAULT_QUERY_PREFIX = 'data';
var ElementQueries = /** @class */ (function () {
    function ElementQueries(element, _a) {
        var _b = (_a === void 0 ? {} : _a).prefix, prefix = _b === void 0 ? DEFAULT_QUERY_PREFIX : _b;
        var _this = this;
        this._element = element;
        this._queryPrefix = prefix;
        this._queries = getQueriesForElement_1.default(element, prefix);
        if (this._queries.length) {
            this._observer = new resize_observer_polyfill_1.default(function (_a) {
                var entry = _a[0];
                _this._onResized(entry.contentRect.width);
            });
            this._observer.observe(element);
        }
    }
    ElementQueries.prototype._getQueryAttributeValue = function (mode, elementWidth) {
        return this._queries
            .filter(function (query) { return query.mode === mode && query.width >= elementWidth; })
            .map(function (query) { return query.width + "px"; })
            .join(' ');
    };
    ElementQueries.prototype._setQueryAttribute = function (mode, elementWidth) {
        var attributeName = this._queryPrefix + "-" + mode + "-width";
        var attributeValue = this._getQueryAttributeValue(mode, elementWidth);
        if (attributeValue) {
            this._element.setAttribute(attributeName, attributeValue);
        }
        else {
            this._element.removeAttribute(attributeName);
        }
    };
    ElementQueries.prototype._onResized = function (width) {
        this._setQueryAttribute('min', width);
        this._setQueryAttribute('max', width);
    };
    ElementQueries.prototype.destroy = function () {
        if (this._observer) {
            this._observer.unobserve(this._element);
            this._observer = null;
        }
    };
    return ElementQueries;
}());
exports.default = ElementQueries;


/***/ }),
/* 99 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(global) {/**
 * A collection of shims that provide minimal functionality of the ES6 collections.
 *
 * These implementations are not meant to be used outside of the ResizeObserver
 * modules as they cover only a limited range of use cases.
 */
/* eslint-disable require-jsdoc, valid-jsdoc */
var MapShim = (function () {
    if (typeof Map !== 'undefined') {
        return Map;
    }

    /**
     * Returns index in provided array that matches the specified key.
     *
     * @param {Array<Array>} arr
     * @param {*} key
     * @returns {number}
     */
    function getIndex(arr, key) {
        var result = -1;

        arr.some(function (entry, index) {
            if (entry[0] === key) {
                result = index;

                return true;
            }

            return false;
        });

        return result;
    }

    return (function () {
        function anonymous() {
            this.__entries__ = [];
        }

        var prototypeAccessors = { size: { configurable: true } };

        /**
         * @returns {boolean}
         */
        prototypeAccessors.size.get = function () {
            return this.__entries__.length;
        };

        /**
         * @param {*} key
         * @returns {*}
         */
        anonymous.prototype.get = function (key) {
            var index = getIndex(this.__entries__, key);
            var entry = this.__entries__[index];

            return entry && entry[1];
        };

        /**
         * @param {*} key
         * @param {*} value
         * @returns {void}
         */
        anonymous.prototype.set = function (key, value) {
            var index = getIndex(this.__entries__, key);

            if (~index) {
                this.__entries__[index][1] = value;
            } else {
                this.__entries__.push([key, value]);
            }
        };

        /**
         * @param {*} key
         * @returns {void}
         */
        anonymous.prototype.delete = function (key) {
            var entries = this.__entries__;
            var index = getIndex(entries, key);

            if (~index) {
                entries.splice(index, 1);
            }
        };

        /**
         * @param {*} key
         * @returns {void}
         */
        anonymous.prototype.has = function (key) {
            return !!~getIndex(this.__entries__, key);
        };

        /**
         * @returns {void}
         */
        anonymous.prototype.clear = function () {
            this.__entries__.splice(0);
        };

        /**
         * @param {Function} callback
         * @param {*} [ctx=null]
         * @returns {void}
         */
        anonymous.prototype.forEach = function (callback, ctx) {
            var this$1 = this;
            if ( ctx === void 0 ) ctx = null;

            for (var i = 0, list = this$1.__entries__; i < list.length; i += 1) {
                var entry = list[i];

                callback.call(ctx, entry[1], entry[0]);
            }
        };

        Object.defineProperties( anonymous.prototype, prototypeAccessors );

        return anonymous;
    }());
})();

/**
 * Detects whether window and document objects are available in current environment.
 */
var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined' && window.document === document;

// Returns global object of a current environment.
var global$1 = (function () {
    if (typeof global !== 'undefined' && global.Math === Math) {
        return global;
    }

    if (typeof self !== 'undefined' && self.Math === Math) {
        return self;
    }

    if (typeof window !== 'undefined' && window.Math === Math) {
        return window;
    }

    // eslint-disable-next-line no-new-func
    return Function('return this')();
})();

/**
 * A shim for the requestAnimationFrame which falls back to the setTimeout if
 * first one is not supported.
 *
 * @returns {number} Requests' identifier.
 */
var requestAnimationFrame$1 = (function () {
    if (typeof requestAnimationFrame === 'function') {
        // It's required to use a bounded function because IE sometimes throws
        // an "Invalid calling object" error if rAF is invoked without the global
        // object on the left hand side.
        return requestAnimationFrame.bind(global$1);
    }

    return function (callback) { return setTimeout(function () { return callback(Date.now()); }, 1000 / 60); };
})();

// Defines minimum timeout before adding a trailing call.
var trailingTimeout = 2;

/**
 * Creates a wrapper function which ensures that provided callback will be
 * invoked only once during the specified delay period.
 *
 * @param {Function} callback - Function to be invoked after the delay period.
 * @param {number} delay - Delay after which to invoke callback.
 * @returns {Function}
 */
var throttle = function (callback, delay) {
    var leadingCall = false,
        trailingCall = false,
        lastCallTime = 0;

    /**
     * Invokes the original callback function and schedules new invocation if
     * the "proxy" was called during current request.
     *
     * @returns {void}
     */
    function resolvePending() {
        if (leadingCall) {
            leadingCall = false;

            callback();
        }

        if (trailingCall) {
            proxy();
        }
    }

    /**
     * Callback invoked after the specified delay. It will further postpone
     * invocation of the original function delegating it to the
     * requestAnimationFrame.
     *
     * @returns {void}
     */
    function timeoutCallback() {
        requestAnimationFrame$1(resolvePending);
    }

    /**
     * Schedules invocation of the original function.
     *
     * @returns {void}
     */
    function proxy() {
        var timeStamp = Date.now();

        if (leadingCall) {
            // Reject immediately following calls.
            if (timeStamp - lastCallTime < trailingTimeout) {
                return;
            }

            // Schedule new call to be in invoked when the pending one is resolved.
            // This is important for "transitions" which never actually start
            // immediately so there is a chance that we might miss one if change
            // happens amids the pending invocation.
            trailingCall = true;
        } else {
            leadingCall = true;
            trailingCall = false;

            setTimeout(timeoutCallback, delay);
        }

        lastCallTime = timeStamp;
    }

    return proxy;
};

// Minimum delay before invoking the update of observers.
var REFRESH_DELAY = 20;

// A list of substrings of CSS properties used to find transition events that
// might affect dimensions of observed elements.
var transitionKeys = ['top', 'right', 'bottom', 'left', 'width', 'height', 'size', 'weight'];

// Check if MutationObserver is available.
var mutationObserverSupported = typeof MutationObserver !== 'undefined';

/**
 * Singleton controller class which handles updates of ResizeObserver instances.
 */
var ResizeObserverController = function() {
    this.connected_ = false;
    this.mutationEventsAdded_ = false;
    this.mutationsObserver_ = null;
    this.observers_ = [];

    this.onTransitionEnd_ = this.onTransitionEnd_.bind(this);
    this.refresh = throttle(this.refresh.bind(this), REFRESH_DELAY);
};

/**
 * Adds observer to observers list.
 *
 * @param {ResizeObserverSPI} observer - Observer to be added.
 * @returns {void}
 */


/**
 * Holds reference to the controller's instance.
 *
 * @private {ResizeObserverController}
 */


/**
 * Keeps reference to the instance of MutationObserver.
 *
 * @private {MutationObserver}
 */

/**
 * Indicates whether DOM listeners have been added.
 *
 * @private {boolean}
 */
ResizeObserverController.prototype.addObserver = function (observer) {
    if (!~this.observers_.indexOf(observer)) {
        this.observers_.push(observer);
    }

    // Add listeners if they haven't been added yet.
    if (!this.connected_) {
        this.connect_();
    }
};

/**
 * Removes observer from observers list.
 *
 * @param {ResizeObserverSPI} observer - Observer to be removed.
 * @returns {void}
 */
ResizeObserverController.prototype.removeObserver = function (observer) {
    var observers = this.observers_;
    var index = observers.indexOf(observer);

    // Remove observer if it's present in registry.
    if (~index) {
        observers.splice(index, 1);
    }

    // Remove listeners if controller has no connected observers.
    if (!observers.length && this.connected_) {
        this.disconnect_();
    }
};

/**
 * Invokes the update of observers. It will continue running updates insofar
 * it detects changes.
 *
 * @returns {void}
 */
ResizeObserverController.prototype.refresh = function () {
    var changesDetected = this.updateObservers_();

    // Continue running updates if changes have been detected as there might
    // be future ones caused by CSS transitions.
    if (changesDetected) {
        this.refresh();
    }
};

/**
 * Updates every observer from observers list and notifies them of queued
 * entries.
 *
 * @private
 * @returns {boolean} Returns "true" if any observer has detected changes in
 *  dimensions of it's elements.
 */
ResizeObserverController.prototype.updateObservers_ = function () {
    // Collect observers that have active observations.
    var activeObservers = this.observers_.filter(function (observer) {
        return observer.gatherActive(), observer.hasActive();
    });

    // Deliver notifications in a separate cycle in order to avoid any
    // collisions between observers, e.g. when multiple instances of
    // ResizeObserver are tracking the same element and the callback of one
    // of them changes content dimensions of the observed target. Sometimes
    // this may result in notifications being blocked for the rest of observers.
    activeObservers.forEach(function (observer) { return observer.broadcastActive(); });

    return activeObservers.length > 0;
};

/**
 * Initializes DOM listeners.
 *
 * @private
 * @returns {void}
 */
ResizeObserverController.prototype.connect_ = function () {
    // Do nothing if running in a non-browser environment or if listeners
    // have been already added.
    if (!isBrowser || this.connected_) {
        return;
    }

    // Subscription to the "Transitionend" event is used as a workaround for
    // delayed transitions. This way it's possible to capture at least the
    // final state of an element.
    document.addEventListener('transitionend', this.onTransitionEnd_);

    window.addEventListener('resize', this.refresh);

    if (mutationObserverSupported) {
        this.mutationsObserver_ = new MutationObserver(this.refresh);

        this.mutationsObserver_.observe(document, {
            attributes: true,
            childList: true,
            characterData: true,
            subtree: true
        });
    } else {
        document.addEventListener('DOMSubtreeModified', this.refresh);

        this.mutationEventsAdded_ = true;
    }

    this.connected_ = true;
};

/**
 * Removes DOM listeners.
 *
 * @private
 * @returns {void}
 */
ResizeObserverController.prototype.disconnect_ = function () {
    // Do nothing if running in a non-browser environment or if listeners
    // have been already removed.
    if (!isBrowser || !this.connected_) {
        return;
    }

    document.removeEventListener('transitionend', this.onTransitionEnd_);
    window.removeEventListener('resize', this.refresh);

    if (this.mutationsObserver_) {
        this.mutationsObserver_.disconnect();
    }

    if (this.mutationEventsAdded_) {
        document.removeEventListener('DOMSubtreeModified', this.refresh);
    }

    this.mutationsObserver_ = null;
    this.mutationEventsAdded_ = false;
    this.connected_ = false;
};

/**
 * "Transitionend" event handler.
 *
 * @private
 * @param {TransitionEvent} event
 * @returns {void}
 */
ResizeObserverController.prototype.onTransitionEnd_ = function (ref) {
        var propertyName = ref.propertyName; if ( propertyName === void 0 ) propertyName = '';

    // Detect whether transition may affect dimensions of an element.
    var isReflowProperty = transitionKeys.some(function (key) {
        return !!~propertyName.indexOf(key);
    });

    if (isReflowProperty) {
        this.refresh();
    }
};

/**
 * Returns instance of the ResizeObserverController.
 *
 * @returns {ResizeObserverController}
 */
ResizeObserverController.getInstance = function () {
    if (!this.instance_) {
        this.instance_ = new ResizeObserverController();
    }

    return this.instance_;
};

ResizeObserverController.instance_ = null;

/**
 * Defines non-writable/enumerable properties of the provided target object.
 *
 * @param {Object} target - Object for which to define properties.
 * @param {Object} props - Properties to be defined.
 * @returns {Object} Target object.
 */
var defineConfigurable = (function (target, props) {
    for (var i = 0, list = Object.keys(props); i < list.length; i += 1) {
        var key = list[i];

        Object.defineProperty(target, key, {
            value: props[key],
            enumerable: false,
            writable: false,
            configurable: true
        });
    }

    return target;
});

/**
 * Returns the global object associated with provided element.
 *
 * @param {Object} target
 * @returns {Object}
 */
var getWindowOf = (function (target) {
    // Assume that the element is an instance of Node, which means that it
    // has the "ownerDocument" property from which we can retrieve a
    // corresponding global object.
    var ownerGlobal = target && target.ownerDocument && target.ownerDocument.defaultView;

    // Return the local global object if it's not possible extract one from
    // provided element.
    return ownerGlobal || global$1;
});

// Placeholder of an empty content rectangle.
var emptyRect = createRectInit(0, 0, 0, 0);

/**
 * Converts provided string to a number.
 *
 * @param {number|string} value
 * @returns {number}
 */
function toFloat(value) {
    return parseFloat(value) || 0;
}

/**
 * Extracts borders size from provided styles.
 *
 * @param {CSSStyleDeclaration} styles
 * @param {...string} positions - Borders positions (top, right, ...)
 * @returns {number}
 */
function getBordersSize(styles) {
    var positions = [], len = arguments.length - 1;
    while ( len-- > 0 ) positions[ len ] = arguments[ len + 1 ];

    return positions.reduce(function (size, position) {
        var value = styles['border-' + position + '-width'];

        return size + toFloat(value);
    }, 0);
}

/**
 * Extracts paddings sizes from provided styles.
 *
 * @param {CSSStyleDeclaration} styles
 * @returns {Object} Paddings box.
 */
function getPaddings(styles) {
    var positions = ['top', 'right', 'bottom', 'left'];
    var paddings = {};

    for (var i = 0, list = positions; i < list.length; i += 1) {
        var position = list[i];

        var value = styles['padding-' + position];

        paddings[position] = toFloat(value);
    }

    return paddings;
}

/**
 * Calculates content rectangle of provided SVG element.
 *
 * @param {SVGGraphicsElement} target - Element content rectangle of which needs
 *      to be calculated.
 * @returns {DOMRectInit}
 */
function getSVGContentRect(target) {
    var bbox = target.getBBox();

    return createRectInit(0, 0, bbox.width, bbox.height);
}

/**
 * Calculates content rectangle of provided HTMLElement.
 *
 * @param {HTMLElement} target - Element for which to calculate the content rectangle.
 * @returns {DOMRectInit}
 */
function getHTMLElementContentRect(target) {
    // Client width & height properties can't be
    // used exclusively as they provide rounded values.
    var clientWidth = target.clientWidth;
    var clientHeight = target.clientHeight;

    // By this condition we can catch all non-replaced inline, hidden and
    // detached elements. Though elements with width & height properties less
    // than 0.5 will be discarded as well.
    //
    // Without it we would need to implement separate methods for each of
    // those cases and it's not possible to perform a precise and performance
    // effective test for hidden elements. E.g. even jQuery's ':visible' filter
    // gives wrong results for elements with width & height less than 0.5.
    if (!clientWidth && !clientHeight) {
        return emptyRect;
    }

    var styles = getWindowOf(target).getComputedStyle(target);
    var paddings = getPaddings(styles);
    var horizPad = paddings.left + paddings.right;
    var vertPad = paddings.top + paddings.bottom;

    // Computed styles of width & height are being used because they are the
    // only dimensions available to JS that contain non-rounded values. It could
    // be possible to utilize the getBoundingClientRect if only it's data wasn't
    // affected by CSS transformations let alone paddings, borders and scroll bars.
    var width = toFloat(styles.width),
        height = toFloat(styles.height);

    // Width & height include paddings and borders when the 'border-box' box
    // model is applied (except for IE).
    if (styles.boxSizing === 'border-box') {
        // Following conditions are required to handle Internet Explorer which
        // doesn't include paddings and borders to computed CSS dimensions.
        //
        // We can say that if CSS dimensions + paddings are equal to the "client"
        // properties then it's either IE, and thus we don't need to subtract
        // anything, or an element merely doesn't have paddings/borders styles.
        if (Math.round(width + horizPad) !== clientWidth) {
            width -= getBordersSize(styles, 'left', 'right') + horizPad;
        }

        if (Math.round(height + vertPad) !== clientHeight) {
            height -= getBordersSize(styles, 'top', 'bottom') + vertPad;
        }
    }

    // Following steps can't be applied to the document's root element as its
    // client[Width/Height] properties represent viewport area of the window.
    // Besides, it's as well not necessary as the <html> itself neither has
    // rendered scroll bars nor it can be clipped.
    if (!isDocumentElement(target)) {
        // In some browsers (only in Firefox, actually) CSS width & height
        // include scroll bars size which can be removed at this step as scroll
        // bars are the only difference between rounded dimensions + paddings
        // and "client" properties, though that is not always true in Chrome.
        var vertScrollbar = Math.round(width + horizPad) - clientWidth;
        var horizScrollbar = Math.round(height + vertPad) - clientHeight;

        // Chrome has a rather weird rounding of "client" properties.
        // E.g. for an element with content width of 314.2px it sometimes gives
        // the client width of 315px and for the width of 314.7px it may give
        // 314px. And it doesn't happen all the time. So just ignore this delta
        // as a non-relevant.
        if (Math.abs(vertScrollbar) !== 1) {
            width -= vertScrollbar;
        }

        if (Math.abs(horizScrollbar) !== 1) {
            height -= horizScrollbar;
        }
    }

    return createRectInit(paddings.left, paddings.top, width, height);
}

/**
 * Checks whether provided element is an instance of the SVGGraphicsElement.
 *
 * @param {Element} target - Element to be checked.
 * @returns {boolean}
 */
var isSVGGraphicsElement = (function () {
    // Some browsers, namely IE and Edge, don't have the SVGGraphicsElement
    // interface.
    if (typeof SVGGraphicsElement !== 'undefined') {
        return function (target) { return target instanceof getWindowOf(target).SVGGraphicsElement; };
    }

    // If it's so, then check that element is at least an instance of the
    // SVGElement and that it has the "getBBox" method.
    // eslint-disable-next-line no-extra-parens
    return function (target) { return target instanceof getWindowOf(target).SVGElement && typeof target.getBBox === 'function'; };
})();

/**
 * Checks whether provided element is a document element (<html>).
 *
 * @param {Element} target - Element to be checked.
 * @returns {boolean}
 */
function isDocumentElement(target) {
    return target === getWindowOf(target).document.documentElement;
}

/**
 * Calculates an appropriate content rectangle for provided html or svg element.
 *
 * @param {Element} target - Element content rectangle of which needs to be calculated.
 * @returns {DOMRectInit}
 */
function getContentRect(target) {
    if (!isBrowser) {
        return emptyRect;
    }

    if (isSVGGraphicsElement(target)) {
        return getSVGContentRect(target);
    }

    return getHTMLElementContentRect(target);
}

/**
 * Creates rectangle with an interface of the DOMRectReadOnly.
 * Spec: https://drafts.fxtf.org/geometry/#domrectreadonly
 *
 * @param {DOMRectInit} rectInit - Object with rectangle's x/y coordinates and dimensions.
 * @returns {DOMRectReadOnly}
 */
function createReadOnlyRect(ref) {
    var x = ref.x;
    var y = ref.y;
    var width = ref.width;
    var height = ref.height;

    // If DOMRectReadOnly is available use it as a prototype for the rectangle.
    var Constr = typeof DOMRectReadOnly !== 'undefined' ? DOMRectReadOnly : Object;
    var rect = Object.create(Constr.prototype);

    // Rectangle's properties are not writable and non-enumerable.
    defineConfigurable(rect, {
        x: x, y: y, width: width, height: height,
        top: y,
        right: x + width,
        bottom: height + y,
        left: x
    });

    return rect;
}

/**
 * Creates DOMRectInit object based on the provided dimensions and the x/y coordinates.
 * Spec: https://drafts.fxtf.org/geometry/#dictdef-domrectinit
 *
 * @param {number} x - X coordinate.
 * @param {number} y - Y coordinate.
 * @param {number} width - Rectangle's width.
 * @param {number} height - Rectangle's height.
 * @returns {DOMRectInit}
 */
function createRectInit(x, y, width, height) {
    return { x: x, y: y, width: width, height: height };
}

/**
 * Class that is responsible for computations of the content rectangle of
 * provided DOM element and for keeping track of it's changes.
 */
var ResizeObservation = function(target) {
    this.broadcastWidth = 0;
    this.broadcastHeight = 0;
    this.contentRect_ = createRectInit(0, 0, 0, 0);

    this.target = target;
};

/**
 * Updates content rectangle and tells whether it's width or height properties
 * have changed since the last broadcast.
 *
 * @returns {boolean}
 */


/**
 * Reference to the last observed content rectangle.
 *
 * @private {DOMRectInit}
 */


/**
 * Broadcasted width of content rectangle.
 *
 * @type {number}
 */
ResizeObservation.prototype.isActive = function () {
    var rect = getContentRect(this.target);

    this.contentRect_ = rect;

    return rect.width !== this.broadcastWidth || rect.height !== this.broadcastHeight;
};

/**
 * Updates 'broadcastWidth' and 'broadcastHeight' properties with a data
 * from the corresponding properties of the last observed content rectangle.
 *
 * @returns {DOMRectInit} Last observed content rectangle.
 */
ResizeObservation.prototype.broadcastRect = function () {
    var rect = this.contentRect_;

    this.broadcastWidth = rect.width;
    this.broadcastHeight = rect.height;

    return rect;
};

var ResizeObserverEntry = function(target, rectInit) {
    var contentRect = createReadOnlyRect(rectInit);

    // According to the specification following properties are not writable
    // and are also not enumerable in the native implementation.
    //
    // Property accessors are not being used as they'd require to define a
    // private WeakMap storage which may cause memory leaks in browsers that
    // don't support this type of collections.
    defineConfigurable(this, { target: target, contentRect: contentRect });
};

var ResizeObserverSPI = function(callback, controller, callbackCtx) {
    this.activeObservations_ = [];
    this.observations_ = new MapShim();

    if (typeof callback !== 'function') {
        throw new TypeError('The callback provided as parameter 1 is not a function.');
    }

    this.callback_ = callback;
    this.controller_ = controller;
    this.callbackCtx_ = callbackCtx;
};

/**
 * Starts observing provided element.
 *
 * @param {Element} target - Element to be observed.
 * @returns {void}
 */


/**
 * Registry of the ResizeObservation instances.
 *
 * @private {Map<Element, ResizeObservation>}
 */


/**
 * Public ResizeObserver instance which will be passed to the callback
 * function and used as a value of it's "this" binding.
 *
 * @private {ResizeObserver}
 */

/**
 * Collection of resize observations that have detected changes in dimensions
 * of elements.
 *
 * @private {Array<ResizeObservation>}
 */
ResizeObserverSPI.prototype.observe = function (target) {
    if (!arguments.length) {
        throw new TypeError('1 argument required, but only 0 present.');
    }

    // Do nothing if current environment doesn't have the Element interface.
    if (typeof Element === 'undefined' || !(Element instanceof Object)) {
        return;
    }

    if (!(target instanceof getWindowOf(target).Element)) {
        throw new TypeError('parameter 1 is not of type "Element".');
    }

    var observations = this.observations_;

    // Do nothing if element is already being observed.
    if (observations.has(target)) {
        return;
    }

    observations.set(target, new ResizeObservation(target));

    this.controller_.addObserver(this);

    // Force the update of observations.
    this.controller_.refresh();
};

/**
 * Stops observing provided element.
 *
 * @param {Element} target - Element to stop observing.
 * @returns {void}
 */
ResizeObserverSPI.prototype.unobserve = function (target) {
    if (!arguments.length) {
        throw new TypeError('1 argument required, but only 0 present.');
    }

    // Do nothing if current environment doesn't have the Element interface.
    if (typeof Element === 'undefined' || !(Element instanceof Object)) {
        return;
    }

    if (!(target instanceof getWindowOf(target).Element)) {
        throw new TypeError('parameter 1 is not of type "Element".');
    }

    var observations = this.observations_;

    // Do nothing if element is not being observed.
    if (!observations.has(target)) {
        return;
    }

    observations.delete(target);

    if (!observations.size) {
        this.controller_.removeObserver(this);
    }
};

/**
 * Stops observing all elements.
 *
 * @returns {void}
 */
ResizeObserverSPI.prototype.disconnect = function () {
    this.clearActive();
    this.observations_.clear();
    this.controller_.removeObserver(this);
};

/**
 * Collects observation instances the associated element of which has changed
 * it's content rectangle.
 *
 * @returns {void}
 */
ResizeObserverSPI.prototype.gatherActive = function () {
        var this$1 = this;

    this.clearActive();

    this.observations_.forEach(function (observation) {
        if (observation.isActive()) {
            this$1.activeObservations_.push(observation);
        }
    });
};

/**
 * Invokes initial callback function with a list of ResizeObserverEntry
 * instances collected from active resize observations.
 *
 * @returns {void}
 */
ResizeObserverSPI.prototype.broadcastActive = function () {
    // Do nothing if observer doesn't have active observations.
    if (!this.hasActive()) {
        return;
    }

    var ctx = this.callbackCtx_;

    // Create ResizeObserverEntry instance for every active observation.
    var entries = this.activeObservations_.map(function (observation) {
        return new ResizeObserverEntry(observation.target, observation.broadcastRect());
    });

    this.callback_.call(ctx, entries, ctx);
    this.clearActive();
};

/**
 * Clears the collection of active observations.
 *
 * @returns {void}
 */
ResizeObserverSPI.prototype.clearActive = function () {
    this.activeObservations_.splice(0);
};

/**
 * Tells whether observer has active observations.
 *
 * @returns {boolean}
 */
ResizeObserverSPI.prototype.hasActive = function () {
    return this.activeObservations_.length > 0;
};

// Registry of internal observers. If WeakMap is not available use current shim
// for the Map collection as it has all required methods and because WeakMap
// can't be fully polyfilled anyway.
var observers = typeof WeakMap !== 'undefined' ? new WeakMap() : new MapShim();

/**
 * ResizeObserver API. Encapsulates the ResizeObserver SPI implementation
 * exposing only those methods and properties that are defined in the spec.
 */
var ResizeObserver = function(callback) {
    if (!(this instanceof ResizeObserver)) {
        throw new TypeError('Cannot call a class as a function.');
    }
    if (!arguments.length) {
        throw new TypeError('1 argument required, but only 0 present.');
    }

    var controller = ResizeObserverController.getInstance();
    var observer = new ResizeObserverSPI(callback, controller, this);

    observers.set(this, observer);
};

// Expose public methods of ResizeObserver.
['observe', 'unobserve', 'disconnect'].forEach(function (method) {
    ResizeObserver.prototype[method] = function () {
        return (ref = observers.get(this))[method].apply(ref, arguments);
        var ref;
    };
});

var index = (function () {
    // Export existing implementation if available.
    if (typeof global$1.ResizeObserver !== 'undefined') {
        return global$1.ResizeObserver;
    }

    return ResizeObserver;
})();

/* harmony default export */ __webpack_exports__["default"] = (index);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(16)))

/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var utils_1 = __webpack_require__(101);
var isElementMatchesSelector_1 = tslib_1.__importDefault(__webpack_require__(102));
// NOTE: "inspired" by https://github.com/marcj/css-element-queries/blob/1.0.2/src/ElementQueries.js#L340-L393
var CSS_SELECTOR_PATTERN = /,?[\s\t]*([^,\n]*?)((?:\[[\s\t]*?(?:[a-z-]+-)?(?:min|max)-width[\s\t]*?[~$\^]?=[\s\t]*?"[^"]*?"[\s\t]*?])+)([^,\n\s\{]*)/gim;
var QUERY_ATTR_PATTERN = /\[[\s\t]*?(?:([a-z-]+)-)?(min|max)-width[\s\t]*?[~$\^]?=[\s\t]*?"([^"]*?)"[\s\t]*?]/gim;
function getQueriesFromCssSelector(cssSelector) {
    var results = [];
    if (cssSelector.indexOf('min-width') === -1 &&
        cssSelector.indexOf('max-width') === -1) {
        return [];
    }
    cssSelector = cssSelector.replace(/'/g, '"');
    utils_1.forEachMatch(cssSelector, CSS_SELECTOR_PATTERN, function (match) {
        var _a = match.slice(1), selectorPart1 = _a[0], attribute = _a[1], selectorPart2 = _a[2];
        var selector = selectorPart1 + selectorPart2;
        utils_1.forEachMatch(attribute, QUERY_ATTR_PATTERN, function (match) {
            var _a = match.slice(1), _b = _a[0], prefix = _b === void 0 ? '' : _b, mode = _a[1], width = _a[2];
            results.push({
                selector: selector,
                prefix: prefix,
                mode: mode,
                width: parseInt(width, 10),
            });
        });
    });
    return results;
}
function getQueriesFromRules(rules) {
    return utils_1.reduce(rules, function (results, rule) {
        // https://developer.mozilla.org/en-US/docs/Web/API/CSSRule
        // CSSRule.STYLE_RULE
        if (rule.type === 1) {
            var selector = rule.selectorText || rule.cssText;
            return results.concat(getQueriesFromCssSelector(selector));
        }
        // NOTE: add other `CSSRule` types if required.
        // Example - https://github.com/marcj/css-element-queries/blob/1.0.2/src/ElementQueries.js#L384-L390
        return results;
    }, []);
}
function getQueries() {
    return utils_1.reduce(document.styleSheets, function (results, styleSheet) {
        var rules = styleSheet.cssRules || styleSheet.rules;
        if (rules) {
            return results.concat(getQueriesFromRules(rules));
        }
        if (styleSheet.cssText) {
            return results.concat(getQueriesFromCssSelector(styleSheet.cssText));
        }
        return results;
    }, []);
}
function getQueriesForElement(element, prefix) {
    if (prefix === void 0) { prefix = ''; }
    var matchedSelectors = new Map();
    var queries = [];
    getQueries().forEach(function (query) {
        if (!matchedSelectors.has(query.selector)) {
            matchedSelectors.set(query.selector, isElementMatchesSelector_1.default(element, query.selector));
        }
        if (!matchedSelectors.get(query.selector)) {
            return;
        }
        if (query.prefix === prefix &&
            !queries.some(function (_query) { return _query.mode === query.mode && _query.width === query.width; })) {
            queries.push({
                mode: query.mode,
                width: query.width,
            });
        }
    });
    return queries.sort(function (a, b) { return a.width - b.width; });
}
exports.default = getQueriesForElement;


/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
function reduce(arrayLike, callback, initialValue) {
    return Array.prototype.reduce.call(arrayLike, callback, initialValue);
}
exports.reduce = reduce;
function forEachMatch(string, pattern, callback) {
    var match = pattern.exec(string);
    while (match !== null) {
        callback(match);
        match = pattern.exec(string);
    }
}
exports.forEachMatch = forEachMatch;


/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var ALIASES = [
    'matches',
    'webkitMatchesSelector',
    'mozMatchesSelector',
    'msMatchesSelector',
];
var matchesSelectorFn;
for (var i = 0; i < ALIASES.length; i++) {
    matchesSelectorFn = Element.prototype[ALIASES[i]];
    if (matchesSelectorFn) {
        break;
    }
}
var isElementMatchesSelector = matchesSelectorFn
    ? function (element, selector) { return matchesSelectorFn.call(element, selector); }
    : function (element, selector) {
        return Array.prototype.indexOf.call(document.querySelectorAll(selector), element) !== -1;
    };
exports.default = isElementMatchesSelector;


/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var eventemitter3_1 = __webpack_require__(104);
var player_api_decorator_1 = tslib_1.__importDefault(__webpack_require__(12));
var EventEmitterModule = /** @class */ (function (_super) {
    tslib_1.__extends(EventEmitterModule, _super);
    function EventEmitterModule() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Method for adding listeners of events inside player.
     * You can check all events inside `Playable.UI_EVENTS` and `Playable.VIDEO_EVENTS`
     *
     * @param event - The Event name, such as `Playable.UI_EVENTS.PLAY_TRIGGERED`
     * @param fn - A function callback to execute when the event is triggered.
     * @param context - Value to use as `this` (i.e the reference Object) when executing callback.
     *
     * @example
     * const Playable = require('playable');
     * const player = Playable.create();
     *
     * player.on(Playable.UI_EVENTS.PLAY_TRIGGERED, () => {
     *   // Will be executed after you will click on play button
     * });
     *
     * // To supply a context value for `this` when the callback is invoked,
     * // pass the optional context argument
     * player.on(Playable.VIDEO_EVENTS.UPLOAD_STALLED, this.handleStalledUpload, this);
     */
    EventEmitterModule.prototype.on = function (event, fn, context) {
        return _super.prototype.on.call(this, event, fn, context);
    };
    /**
     * Method for removing listeners of events inside player.
     *
     * @param event - The Event name, such as `Playable.UI_EVENTS.PLAY_TRIGGERED`
     * @param fn - Only remove the listeners that match this function.
     * @param context - Only remove the listeners that have this context.
     * @param once - Only remove one-time listeners.
     *
     * @example
     * const Playable = require('playable');
     * const player = Playable.create();
     *
     * const callback = function() {
     *   // Code to handle some kind of event
     * };
     *
     * // ... Now callback will be called when some one will pause the video ...
     * player.on(Playable.UI_EVENTS.PAUSE_TRIGGERED, callback);
     *
     * // ... callback will no longer be called.
     * player.off(Playable.UI_EVENTS.PAUSE_TRIGGERED, callback);
     *
     * // ... remove all handlers for event UI_EVENTS.PAUSE_TRIGGERED.
     * player.off(Playable.UI_EVENTS.PAUSE_TRIGGERED);
     */
    EventEmitterModule.prototype.off = function (event, fn, context, once) {
        return _super.prototype.off.call(this, event, fn, context, once);
    };
    EventEmitterModule.prototype.destroy = function () {
        var _this = this;
        this.eventNames().forEach(function (eventName) {
            _this.removeAllListeners(eventName);
        });
    };
    EventEmitterModule.moduleName = 'eventEmitter';
    tslib_1.__decorate([
        player_api_decorator_1.default()
    ], EventEmitterModule.prototype, "on", null);
    tslib_1.__decorate([
        player_api_decorator_1.default()
    ], EventEmitterModule.prototype, "off", null);
    return EventEmitterModule;
}(eventemitter3_1.EventEmitter));
exports.default = EventEmitterModule;


/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var has = Object.prototype.hasOwnProperty
  , prefix = '~';

/**
 * Constructor to create a storage for our `EE` objects.
 * An `Events` instance is a plain object whose properties are event names.
 *
 * @constructor
 * @api private
 */
function Events() {}

//
// We try to not inherit from `Object.prototype`. In some engines creating an
// instance in this way is faster than calling `Object.create(null)` directly.
// If `Object.create(null)` is not supported we prefix the event names with a
// character to make sure that the built-in object properties are not
// overridden or used as an attack vector.
//
if (Object.create) {
  Events.prototype = Object.create(null);

  //
  // This hack is needed because the `__proto__` property is still inherited in
  // some old browsers like Android 4, iPhone 5.1, Opera 11 and Safari 5.
  //
  if (!new Events().__proto__) prefix = false;
}

/**
 * Representation of a single event listener.
 *
 * @param {Function} fn The listener function.
 * @param {Mixed} context The context to invoke the listener with.
 * @param {Boolean} [once=false] Specify if the listener is a one-time listener.
 * @constructor
 * @api private
 */
function EE(fn, context, once) {
  this.fn = fn;
  this.context = context;
  this.once = once || false;
}

/**
 * Minimal `EventEmitter` interface that is molded against the Node.js
 * `EventEmitter` interface.
 *
 * @constructor
 * @api public
 */
function EventEmitter() {
  this._events = new Events();
  this._eventsCount = 0;
}

/**
 * Return an array listing the events for which the emitter has registered
 * listeners.
 *
 * @returns {Array}
 * @api public
 */
EventEmitter.prototype.eventNames = function eventNames() {
  var names = []
    , events
    , name;

  if (this._eventsCount === 0) return names;

  for (name in (events = this._events)) {
    if (has.call(events, name)) names.push(prefix ? name.slice(1) : name);
  }

  if (Object.getOwnPropertySymbols) {
    return names.concat(Object.getOwnPropertySymbols(events));
  }

  return names;
};

/**
 * Return the listeners registered for a given event.
 *
 * @param {String|Symbol} event The event name.
 * @param {Boolean} exists Only check if there are listeners.
 * @returns {Array|Boolean}
 * @api public
 */
EventEmitter.prototype.listeners = function listeners(event, exists) {
  var evt = prefix ? prefix + event : event
    , available = this._events[evt];

  if (exists) return !!available;
  if (!available) return [];
  if (available.fn) return [available.fn];

  for (var i = 0, l = available.length, ee = new Array(l); i < l; i++) {
    ee[i] = available[i].fn;
  }

  return ee;
};

/**
 * Calls each of the listeners registered for a given event.
 *
 * @param {String|Symbol} event The event name.
 * @returns {Boolean} `true` if the event had listeners, else `false`.
 * @api public
 */
EventEmitter.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
  var evt = prefix ? prefix + event : event;

  if (!this._events[evt]) return false;

  var listeners = this._events[evt]
    , len = arguments.length
    , args
    , i;

  if (listeners.fn) {
    if (listeners.once) this.removeListener(event, listeners.fn, undefined, true);

    switch (len) {
      case 1: return listeners.fn.call(listeners.context), true;
      case 2: return listeners.fn.call(listeners.context, a1), true;
      case 3: return listeners.fn.call(listeners.context, a1, a2), true;
      case 4: return listeners.fn.call(listeners.context, a1, a2, a3), true;
      case 5: return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;
      case 6: return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
    }

    for (i = 1, args = new Array(len -1); i < len; i++) {
      args[i - 1] = arguments[i];
    }

    listeners.fn.apply(listeners.context, args);
  } else {
    var length = listeners.length
      , j;

    for (i = 0; i < length; i++) {
      if (listeners[i].once) this.removeListener(event, listeners[i].fn, undefined, true);

      switch (len) {
        case 1: listeners[i].fn.call(listeners[i].context); break;
        case 2: listeners[i].fn.call(listeners[i].context, a1); break;
        case 3: listeners[i].fn.call(listeners[i].context, a1, a2); break;
        case 4: listeners[i].fn.call(listeners[i].context, a1, a2, a3); break;
        default:
          if (!args) for (j = 1, args = new Array(len -1); j < len; j++) {
            args[j - 1] = arguments[j];
          }

          listeners[i].fn.apply(listeners[i].context, args);
      }
    }
  }

  return true;
};

/**
 * Add a listener for a given event.
 *
 * @param {String|Symbol} event The event name.
 * @param {Function} fn The listener function.
 * @param {Mixed} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @api public
 */
EventEmitter.prototype.on = function on(event, fn, context) {
  var listener = new EE(fn, context || this)
    , evt = prefix ? prefix + event : event;

  if (!this._events[evt]) this._events[evt] = listener, this._eventsCount++;
  else if (!this._events[evt].fn) this._events[evt].push(listener);
  else this._events[evt] = [this._events[evt], listener];

  return this;
};

/**
 * Add a one-time listener for a given event.
 *
 * @param {String|Symbol} event The event name.
 * @param {Function} fn The listener function.
 * @param {Mixed} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @api public
 */
EventEmitter.prototype.once = function once(event, fn, context) {
  var listener = new EE(fn, context || this, true)
    , evt = prefix ? prefix + event : event;

  if (!this._events[evt]) this._events[evt] = listener, this._eventsCount++;
  else if (!this._events[evt].fn) this._events[evt].push(listener);
  else this._events[evt] = [this._events[evt], listener];

  return this;
};

/**
 * Remove the listeners of a given event.
 *
 * @param {String|Symbol} event The event name.
 * @param {Function} fn Only remove the listeners that match this function.
 * @param {Mixed} context Only remove the listeners that have this context.
 * @param {Boolean} once Only remove one-time listeners.
 * @returns {EventEmitter} `this`.
 * @api public
 */
EventEmitter.prototype.removeListener = function removeListener(event, fn, context, once) {
  var evt = prefix ? prefix + event : event;

  if (!this._events[evt]) return this;
  if (!fn) {
    if (--this._eventsCount === 0) this._events = new Events();
    else delete this._events[evt];
    return this;
  }

  var listeners = this._events[evt];

  if (listeners.fn) {
    if (
         listeners.fn === fn
      && (!once || listeners.once)
      && (!context || listeners.context === context)
    ) {
      if (--this._eventsCount === 0) this._events = new Events();
      else delete this._events[evt];
    }
  } else {
    for (var i = 0, events = [], length = listeners.length; i < length; i++) {
      if (
           listeners[i].fn !== fn
        || (once && !listeners[i].once)
        || (context && listeners[i].context !== context)
      ) {
        events.push(listeners[i]);
      }
    }

    //
    // Reset the array, or remove it completely if we have no more listeners.
    //
    if (events.length) this._events[evt] = events.length === 1 ? events[0] : events;
    else if (--this._eventsCount === 0) this._events = new Events();
    else delete this._events[evt];
  }

  return this;
};

/**
 * Remove all listeners, or those of the specified event.
 *
 * @param {String|Symbol} [event] The event name.
 * @returns {EventEmitter} `this`.
 * @api public
 */
EventEmitter.prototype.removeAllListeners = function removeAllListeners(event) {
  var evt;

  if (event) {
    evt = prefix ? prefix + event : event;
    if (this._events[evt]) {
      if (--this._eventsCount === 0) this._events = new Events();
      else delete this._events[evt];
    }
  } else {
    this._events = new Events();
    this._eventsCount = 0;
  }

  return this;
};

//
// Alias methods names because people roll like that.
//
EventEmitter.prototype.off = EventEmitter.prototype.removeListener;
EventEmitter.prototype.addListener = EventEmitter.prototype.on;

//
// This function doesn't apply anymore.
//
EventEmitter.prototype.setMaxListeners = function setMaxListeners() {
  return this;
};

//
// Expose the prefix.
//
EventEmitter.prefixed = prefix;

//
// Allow `EventEmitter` to be imported as module namespace.
//
EventEmitter.EventEmitter = EventEmitter;

//
// Expose the module.
//
if (true) {
  module.exports = EventEmitter;
}


/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var index_1 = __webpack_require__(2);
exports.NATIVE_VIDEO_EVENTS_TO_STATE = [
    'loadstart',
    'loadedmetadata',
    'canplay',
    'play',
    'playing',
    'pause',
    'ended',
    'waiting',
    'seeking',
    'seeked',
];
var StateEngine = /** @class */ (function () {
    function StateEngine(eventEmitter, video) {
        this._eventEmitter = eventEmitter;
        this._video = video;
        this._currentState = null;
        this._isMetadataLoaded = false;
        this._statesTimestamps = {};
        this._bindCallbacks();
        this._bindEvents();
    }
    StateEngine.prototype._bindCallbacks = function () {
        this._processEventFromVideo = this._processEventFromVideo.bind(this);
    };
    StateEngine.prototype._bindEvents = function () {
        var _this = this;
        exports.NATIVE_VIDEO_EVENTS_TO_STATE.forEach(function (event) {
            return _this._video.addEventListener(event, _this._processEventFromVideo);
        });
    };
    StateEngine.prototype._unbindEvents = function () {
        var _this = this;
        exports.NATIVE_VIDEO_EVENTS_TO_STATE.forEach(function (event) {
            return _this._video.removeEventListener(event, _this._processEventFromVideo);
        });
    };
    StateEngine.prototype.clearTimestamps = function () {
        this._statesTimestamps = {};
    };
    StateEngine.prototype._setInitialTimeStamp = function () {
        this._initialTimeStamp = Date.now();
    };
    StateEngine.prototype._setStateTimestamp = function (state) {
        if (!this._statesTimestamps[state]) {
            this._statesTimestamps[state] = Date.now() - this._initialTimeStamp;
            this._setInitialTimeStamp();
        }
    };
    StateEngine.prototype.getStateTimestamps = function () {
        return this._statesTimestamps;
    };
    StateEngine.prototype._processEventFromVideo = function (event) {
        if (event === void 0) { event = {}; }
        var videoEl = this._video;
        switch (event.type) {
            case 'loadstart': {
                this._setInitialTimeStamp();
                this.setState(index_1.STATES.LOAD_STARTED);
                break;
            }
            case 'loadedmetadata': {
                this._setStateTimestamp(index_1.STATES.METADATA_LOADED);
                this.setState(index_1.STATES.METADATA_LOADED);
                this._isMetadataLoaded = true;
                break;
            }
            case 'canplay': {
                this._setStateTimestamp(index_1.STATES.READY_TO_PLAY);
                this.setState(index_1.STATES.READY_TO_PLAY);
                break;
            }
            case 'play': {
                this.setState(index_1.STATES.PLAY_REQUESTED);
                break;
            }
            case 'playing': {
                // Event 'playing' also triggers even when play request aborted by browser. So we need to check if video is actualy playing
                if (!videoEl.paused) {
                    this.setState(index_1.STATES.PLAYING);
                }
                break;
            }
            case 'waiting': {
                this.setState(index_1.STATES.WAITING);
                break;
            }
            case 'pause': {
                // No need to set state PAUSED since there was no actual playing of any parts of video
                if (videoEl.played.length) {
                    this.setState(index_1.STATES.PAUSED);
                }
                break;
            }
            case 'ended': {
                this.setState(index_1.STATES.ENDED);
                break;
            }
            case 'seeking': {
                this.setState(index_1.STATES.SEEK_IN_PROGRESS);
                break;
            }
            case 'seeked': {
                this.setState(videoEl.paused ? index_1.STATES.PAUSED : index_1.STATES.PLAYING);
                break;
            }
            default:
                break;
        }
    };
    StateEngine.prototype.setState = function (state) {
        if (state === this._currentState) {
            return;
        }
        //This case is happens only with dash.js sometimes when manifest got some problems
        if (this._currentState === index_1.STATES.METADATA_LOADED) {
            if (state === index_1.STATES.SEEK_IN_PROGRESS || state === index_1.STATES.PAUSED) {
                return;
            }
        }
        this._eventEmitter.emit(index_1.VIDEO_EVENTS.STATE_CHANGED, {
            prevState: this._currentState,
            nextState: state,
        });
        this._currentState = state;
    };
    Object.defineProperty(StateEngine.prototype, "isMetadataLoaded", {
        get: function () {
            return this._isMetadataLoaded;
        },
        enumerable: true,
        configurable: true
    });
    StateEngine.prototype.getState = function () {
        return this._currentState;
    };
    StateEngine.prototype.destroy = function () {
        this._unbindEvents();
        delete this._eventEmitter;
        delete this._video;
    };
    StateEngine.dependencies = ['eventEmitter', 'config'];
    return StateEngine;
}());
exports.default = StateEngine;


/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var index_1 = __webpack_require__(2);
exports.NATIVE_VIDEO_TO_BROADCAST = [
    'progress',
    'error',
    'stalled',
    'suspend',
    'durationchange',
    'timeupdate',
    'volumechange',
    'seeking',
];
var NativeEventsBroadcaster = /** @class */ (function () {
    function NativeEventsBroadcaster(eventEmitter, video) {
        this._eventEmitter = eventEmitter;
        this._video = video;
        this._currentMute = this._video.muted;
        this._currentVolume = this._video.volume;
        this._bindCallbacks();
        this._bindEvents();
    }
    NativeEventsBroadcaster.prototype._bindCallbacks = function () {
        this._processEventFromVideo = this._processEventFromVideo.bind(this);
    };
    NativeEventsBroadcaster.prototype._bindEvents = function () {
        var _this = this;
        exports.NATIVE_VIDEO_TO_BROADCAST.forEach(function (event) {
            return _this._video.addEventListener(event, _this._processEventFromVideo);
        });
    };
    NativeEventsBroadcaster.prototype._unbindEvents = function () {
        var _this = this;
        exports.NATIVE_VIDEO_TO_BROADCAST.forEach(function (event) {
            return _this._video.removeEventListener(event, _this._processEventFromVideo);
        });
    };
    NativeEventsBroadcaster.prototype._processEventFromVideo = function (event) {
        if (event === void 0) { event = {}; }
        var videoEl = this._video;
        switch (event.type) {
            case 'progress': {
                this._eventEmitter.emit(index_1.VIDEO_EVENTS.CHUNK_LOADED);
                break;
            }
            case 'stalled': {
                this._eventEmitter.emit(index_1.VIDEO_EVENTS.UPLOAD_STALLED);
                break;
            }
            case 'suspend': {
                this._eventEmitter.emit(index_1.VIDEO_EVENTS.UPLOAD_SUSPEND);
                break;
            }
            case 'seeking': {
                this._eventEmitter.emit(index_1.VIDEO_EVENTS.SEEK_IN_PROGRESS, videoEl.currentTime);
                break;
            }
            case 'durationchange': {
                this._eventEmitter.emit(index_1.VIDEO_EVENTS.DURATION_UPDATED, videoEl.duration);
                break;
            }
            case 'timeupdate': {
                this._eventEmitter.emit(index_1.VIDEO_EVENTS.CURRENT_TIME_UPDATED, videoEl.currentTime);
                break;
            }
            case 'volumechange': {
                if (this._currentVolume !== videoEl.volume) {
                    this._currentVolume = videoEl.volume * 100;
                    this._eventEmitter.emit(index_1.VIDEO_EVENTS.VOLUME_CHANGED, this._currentVolume);
                }
                if (this._currentMute !== videoEl.muted) {
                    this._currentMute = videoEl.muted;
                    this._eventEmitter.emit(index_1.VIDEO_EVENTS.MUTE_CHANGED, this._currentMute);
                }
                this._eventEmitter.emit(index_1.VIDEO_EVENTS.VOLUME_STATUS_CHANGED, {
                    volume: videoEl.volume,
                    muted: videoEl.muted,
                });
                break;
            }
            default:
                break;
        }
    };
    NativeEventsBroadcaster.prototype.destroy = function () {
        this._unbindEvents();
        delete this._video;
        delete this._eventEmitter;
    };
    return NativeEventsBroadcaster;
}());
exports.default = NativeEventsBroadcaster;


/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var constants_1 = __webpack_require__(2);
var playback_resolution_1 = __webpack_require__(108);
var detect_stream_type_1 = __webpack_require__(109);
var AdaptersStrategy = /** @class */ (function () {
    function AdaptersStrategy(eventEmitter, video, playbackAdapters) {
        if (playbackAdapters === void 0) { playbackAdapters = []; }
        var _this = this;
        this._video = video;
        this._eventEmitter = eventEmitter;
        this._playableAdapters = [];
        this._availableAdapters = [];
        this._attachedAdapter = null;
        playbackAdapters.forEach(function (adapter) {
            return adapter.isSupported() &&
                _this._availableAdapters.push(new adapter(eventEmitter));
        });
    }
    AdaptersStrategy.prototype._autoDetectSourceTypes = function (mediaSources) {
        var _this = this;
        return mediaSources.map(function (mediaSource) {
            if (typeof mediaSource === 'string') {
                var type = detect_stream_type_1.getStreamType(mediaSource);
                if (!type) {
                    _this._eventEmitter.emit(constants_1.VIDEO_EVENTS.ERROR, {
                        errorType: constants_1.ERRORS.SRC_PARSE,
                        streamSrc: mediaSource,
                    });
                }
                return { url: mediaSource, type: type };
            }
            return mediaSource;
        });
    };
    AdaptersStrategy.prototype._resolvePlayableAdapters = function (src) {
        if (!src) {
            this._playableAdapters = [];
            return;
        }
        var mediaSources = [].concat(src);
        var mediaStreams = this._autoDetectSourceTypes(mediaSources);
        this._playableAdapters = playback_resolution_1.resolveAdapters(mediaStreams, this._availableAdapters);
    };
    AdaptersStrategy.prototype._connectAdapterToVideo = function () {
        if (this._playableAdapters.length > 0) {
            // Use the first PlayableStream for now
            // Later, we can use the others as fallback
            this._attachedAdapter = this._playableAdapters[0];
            this._attachedAdapter.attach(this._video);
        }
    };
    AdaptersStrategy.prototype._detachCurrentAdapter = function () {
        if (this._attachedAdapter) {
            this._attachedAdapter.detach(this._video);
            this._attachedAdapter = null;
        }
    };
    Object.defineProperty(AdaptersStrategy.prototype, "attachedAdapter", {
        get: function () {
            return this._attachedAdapter;
        },
        enumerable: true,
        configurable: true
    });
    AdaptersStrategy.prototype.connectAdapter = function (src) {
        this._detachCurrentAdapter();
        this._resolvePlayableAdapters(src);
        this._connectAdapterToVideo();
    };
    AdaptersStrategy.prototype.destroy = function () {
        this._detachCurrentAdapter();
        delete this._attachedAdapter;
        delete this._availableAdapters;
        delete this._playableAdapters;
        delete this._video;
    };
    return AdaptersStrategy;
}());
exports.default = AdaptersStrategy;


/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
function resolveAdapters(mediaStreams, availableAdapters) {
    var playableAdapters = [];
    var groupedStreams = groupStreamsByMediaType(mediaStreams);
    var groupedStreamKeys = Object.keys(groupedStreams);
    availableAdapters.forEach(function (adapter) {
        for (var i = 0; i < groupedStreamKeys.length; i += 1) {
            var mediaType = groupedStreamKeys[i];
            var mediaStreams_1 = groupedStreams[mediaType];
            if (adapter.canPlay(mediaType)) {
                adapter.setMediaStreams(mediaStreams_1);
                playableAdapters.push(adapter);
                break;
            }
        }
    });
    playableAdapters.sort(function (firstAdapter, secondAdapter) {
        return secondAdapter.mediaStreamDeliveryPriority -
            firstAdapter.mediaStreamDeliveryPriority;
    });
    return playableAdapters;
}
exports.resolveAdapters = resolveAdapters;
function groupStreamsByMediaType(mediaStreams) {
    var typeMap = {};
    mediaStreams.forEach(function (mediaStream) {
        if (!mediaStream.type) {
            return;
        }
        if (!Array.isArray(typeMap[mediaStream.type])) {
            typeMap[mediaStream.type] = [];
        }
        typeMap[mediaStream.type].push(mediaStream);
    });
    return typeMap;
}


/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var constants_1 = __webpack_require__(2);
var extensionsMap = Object.create(null);
extensionsMap.mp4 = constants_1.MediaStreamTypes.MP4;
extensionsMap.webm = constants_1.MediaStreamTypes.WEBM;
extensionsMap.m3u8 = constants_1.MediaStreamTypes.HLS;
extensionsMap.mpd = constants_1.MediaStreamTypes.DASH;
var anchorElement = document.createElement('a');
function getStreamType(url) {
    anchorElement.href = url;
    var streamType = extensionsMap[getExtFromPath(anchorElement.pathname)];
    return streamType || false;
}
exports.getStreamType = getStreamType;
function getExtFromPath(path) {
    return path.split('.').pop();
}
exports.getExtFromPath = getExtFromPath;


/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var hexToRgb_1 = tslib_1.__importDefault(__webpack_require__(111));
function transperentizeColor(color, alpha) {
    var _a = hexToRgb_1.default(color), r = _a.r, g = _a.g, b = _a.b;
    return "rgba(" + r + "," + g + "," + b + "," + alpha + ")";
}
exports.default = transperentizeColor;


/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var SHORTHAND_HEX_COLOR_PATTERN = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
var HEX_COLOR_PATTERN = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i;
function hexToRgb(hex) {
    hex = hex.replace(SHORTHAND_HEX_COLOR_PATTERN, function (_, r, g, b) { return r + r + g + g + b + b; });
    var result = hex.match(HEX_COLOR_PATTERN);
    return result
        ? {
            r: parseInt(result[1], 16),
            g: parseInt(result[2], 16),
            b: parseInt(result[3], 16),
        }
        : null;
}
exports.default = hexToRgb;


/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var style_sheet_1 = __webpack_require__(113);
var player_api_decorator_1 = tslib_1.__importDefault(__webpack_require__(12));
var DEFAULT_THEME_CONFIG = {
    color: '#FFF',
    liveColor: '#ea492e',
    progressColor: '#FFF',
};
exports.DEFAULT_THEME_CONFIG = DEFAULT_THEME_CONFIG;
var ThemeService = /** @class */ (function () {
    function ThemeService(_a) {
        var themeConfig = _a.themeConfig;
        var _this = this;
        this._styleSheet = new style_sheet_1.StyleSheet();
        this._styleSheet.update(tslib_1.__assign({}, DEFAULT_THEME_CONFIG, themeConfig));
        // setTimeout here is for calling `attach` after all modules resolved.
        setTimeout(function () {
            _this._styleSheet && _this._styleSheet.attach();
        }, 0);
    }
    /**
     * Method for setting theme for player instance
     *
     * @example
     * player.updateTheme({
     *   progressColor: "#AEAD22"
     * })
     * @note
     *
     * You can check info about theming [here](/themes)
     *
     * @param themeConfig - Theme config
     *
     */
    ThemeService.prototype.updateTheme = function (themeConfig) {
        this._styleSheet.update(themeConfig);
    };
    ThemeService.prototype.registerModuleTheme = function (module, rules) {
        this._styleSheet.registerModuleTheme(module, rules);
    };
    ThemeService.prototype.get = function (module) {
        return this._styleSheet.getModuleClassNames(module);
    };
    ThemeService.prototype.destroy = function () {
        delete this._styleSheet;
    };
    ThemeService.moduleName = 'theme';
    ThemeService.dependencies = ['themeConfig'];
    tslib_1.__decorate([
        player_api_decorator_1.default()
    ], ThemeService.prototype, "updateTheme", null);
    return ThemeService;
}());
exports.default = ThemeService;


/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var camelToKebab_1 = tslib_1.__importDefault(__webpack_require__(42));
var generateClassNames_1 = tslib_1.__importDefault(__webpack_require__(114));
var StyleSheet = /** @class */ (function () {
    function StyleSheet() {
        this._rulesByModule = new Map();
        this._classNamesByModule = new Map();
        this._data = {};
    }
    StyleSheet.prototype.attach = function () {
        var _this = this;
        this._styleNode = this._styleNode || document.createElement('style');
        var discoveredStyles = [];
        this._rulesByModule.forEach(function (_, module) {
            discoveredStyles.push(_this._getModuleCSS(module));
        });
        this._styleNode.innerHTML = discoveredStyles.join(' ');
        document.getElementsByTagName('head')[0].appendChild(this._styleNode);
    };
    StyleSheet.prototype.update = function (data) {
        this._data = tslib_1.__assign({}, this._data, data);
        if (this._styleNode) {
            this.attach();
        }
    };
    StyleSheet.prototype.registerModuleTheme = function (module, rules) {
        //todo maybe we would like to update overrides for module? Or at least show warning instead of Error
        if (this._rulesByModule.get(module)) {
            throw new Error('can`t register multiple themes for one module');
        }
        this._rulesByModule.set(module, rules);
        this._classNamesByModule.set(module, generateClassNames_1.default(rules));
    };
    StyleSheet.prototype.getModuleClassNames = function (module) {
        return this._classNamesByModule.get(module);
    };
    StyleSheet.prototype._getModuleCSS = function (module) {
        var _this = this;
        var moduleRules = this._rulesByModule.get(module);
        var moduleClassNames = this._classNamesByModule.get(module);
        if (!moduleRules || !moduleClassNames) {
            return '';
        }
        return Object.keys(moduleRules)
            .map(function (classImportName) {
            return _this._getRuleCSS(moduleRules[classImportName], moduleClassNames[classImportName]);
        })
            .join(' ');
    };
    StyleSheet.prototype._getRuleCSS = function (rule, ruleClassName) {
        var _this = this;
        if (!rule || !ruleClassName) {
            return '';
        }
        var complexRuleNames = Object.keys(rule)
            .filter(function (ruleName) { return typeof rule[ruleName] === 'object'; })
            .map(function (ruleName) { return (ruleName.indexOf('&') !== -1 ? ruleName : "& " + ruleName); });
        var complexRules = complexRuleNames
            .map(function (ruleName) {
            var selector = ruleName.replace(/&/g, "." + ruleClassName);
            //don't want to allow deep nesting now, maybe later
            return selector + " {" + _this._getRuleStyles(rule[ruleName]) + "}";
        })
            .join(' ');
        return "." + ruleClassName + " {" + this._getRuleStyles(rule) + "} " + complexRules;
    };
    StyleSheet.prototype._getRuleStyles = function (rule) {
        var _this = this;
        var simpleRuleNames = Object.keys(rule).filter(function (ruleName) { return typeof rule[ruleName] !== 'object'; });
        return simpleRuleNames
            .map(function (ruleName) {
            return camelToKebab_1.default(ruleName) + ": " + (typeof rule[ruleName] === 'function'
                ? rule[ruleName](_this._data)
                : rule[ruleName]);
        })
            .join('; ');
    };
    return StyleSheet;
}());
exports.StyleSheet = StyleSheet;


/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var getUniqueId_1 = tslib_1.__importDefault(__webpack_require__(115));
function getUniqueClassName(classImportName) {
    return "wix-playable--" + getUniqueId_1.default(classImportName);
}
function generateClassNames(rules) {
    return Object.keys(rules).reduce(function (acc, classImportName) {
        return (tslib_1.__assign({}, acc, (_a = {}, _a[classImportName] = getUniqueClassName(classImportName), _a)));
        var _a;
    }, {});
}
exports.default = generateClassNames;


/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var camelToKebab_1 = tslib_1.__importDefault(__webpack_require__(42));
var generatedIds = new Map();
function getUniquePostfix(className) {
    if (generatedIds.has(className)) {
        var newID = generatedIds.get(className) + 1;
        generatedIds.set(className, newID);
        return "" + newID;
    }
    generatedIds.set(className, 0);
    return '';
}
function getUniqueId(classImportName) {
    var kebabName = camelToKebab_1.default(classImportName);
    return "" + kebabName + getUniquePostfix(kebabName);
}
exports.default = getUniqueId;


/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var default_texts_1 = tslib_1.__importDefault(__webpack_require__(117));
var TextMap = /** @class */ (function () {
    function TextMap(_a) {
        var config = _a.config;
        this._textMap = tslib_1.__assign({}, default_texts_1.default, config.texts);
    }
    TextMap.prototype.get = function (id, args) {
        if (!this._textMap) {
            return;
        }
        var text = this._textMap[id];
        if (typeof text === 'function') {
            return text(args);
        }
        return text;
    };
    TextMap.prototype.destroy = function () {
        delete this._textMap;
    };
    TextMap.moduleName = 'textMap';
    TextMap.dependencies = ['config'];
    return TextMap;
}());
exports.default = TextMap;


/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var constants_1 = __webpack_require__(2);
var map = (_a = {},
    _a[constants_1.TEXT_LABELS.LOGO_LABEL] = 'Watch On Site',
    _a[constants_1.TEXT_LABELS.LOGO_TOOLTIP] = 'Watch On Site',
    _a[constants_1.TEXT_LABELS.LIVE_INDICATOR_TEXT] = function (_a) {
        var isEnded = _a.isEnded;
        return !isEnded ? 'Live' : 'Live Ended';
    },
    _a[constants_1.TEXT_LABELS.LIVE_SYNC_LABEL] = 'Sync to Live',
    _a[constants_1.TEXT_LABELS.LIVE_SYNC_TOOLTIP] = 'Sync to Live',
    _a[constants_1.TEXT_LABELS.PAUSE_CONTROL_LABEL] = 'Pause',
    _a[constants_1.TEXT_LABELS.PLAY_CONTROL_LABEL] = 'Play',
    _a[constants_1.TEXT_LABELS.PROGRESS_CONTROL_LABEL] = 'Progress control',
    _a[constants_1.TEXT_LABELS.PROGRESS_CONTROL_VALUE] = function (_a) {
        var percent = _a.percent;
        return "Already played " + percent + "%";
    },
    _a[constants_1.TEXT_LABELS.MUTE_CONTROL_LABEL] = 'Mute',
    _a[constants_1.TEXT_LABELS.MUTE_CONTROL_TOOLTIP] = 'Mute',
    _a[constants_1.TEXT_LABELS.UNMUTE_CONTROL_LABEL] = 'Unmute',
    _a[constants_1.TEXT_LABELS.UNMUTE_CONTROL_TOOLTIP] = 'Unmute',
    _a[constants_1.TEXT_LABELS.VOLUME_CONTROL_LABEL] = 'Volume control',
    _a[constants_1.TEXT_LABELS.VOLUME_CONTROL_VALUE] = function (_a) {
        var volume = _a.volume;
        return "Volume is " + volume + "%";
    },
    _a[constants_1.TEXT_LABELS.ENTER_FULL_SCREEN_LABEL] = 'Enter full screen mode',
    _a[constants_1.TEXT_LABELS.ENTER_FULL_SCREEN_TOOLTIP] = 'Enter full screen mode',
    _a[constants_1.TEXT_LABELS.EXIT_FULL_SCREEN_LABEL] = 'Exit full screen mode',
    _a[constants_1.TEXT_LABELS.EXIT_FULL_SCREEN_TOOLTIP] = 'Exit full screen mode',
    _a);
exports.default = map;
var _a;


/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var device_detection_1 = __webpack_require__(19);
var player_api_decorator_1 = tslib_1.__importDefault(__webpack_require__(12));
var desktop_1 = tslib_1.__importDefault(__webpack_require__(119));
var ios_1 = tslib_1.__importDefault(__webpack_require__(120));
var index_1 = __webpack_require__(2);
var DEFAULT_CONFIG = {
    exitFullScreenOnEnd: true,
    enterFullScreenOnPlay: false,
    exitFullScreenOnPause: false,
    pauseVideoOnFullScreenExit: false,
};
var FullScreenManager = /** @class */ (function () {
    function FullScreenManager(_a) {
        var eventEmitter = _a.eventEmitter, engine = _a.engine, rootContainer = _a.rootContainer, config = _a.config;
        this._exitFullScreenOnEnd = false;
        this._enterFullScreenOnPlay = false;
        this._exitFullScreenOnPause = false;
        this._pauseVideoOnFullScreenExit = false;
        this._eventEmitter = eventEmitter;
        this._engine = engine;
        if (config.fullScreen === false) {
            this._isEnabled = false;
        }
        else {
            this._isEnabled = true;
            var _config = tslib_1.__assign({}, DEFAULT_CONFIG, config.fullScreen);
            this._exitFullScreenOnEnd = _config.exitFullScreenOnEnd;
            this._enterFullScreenOnPlay = _config.enterFullScreenOnPlay;
            this._exitFullScreenOnPause = _config.exitFullScreenOnPause;
            this._pauseVideoOnFullScreenExit = _config.pauseVideoOnFullScreenExit;
        }
        this._onChange = this._onChange.bind(this);
        if (device_detection_1.isIOS()) {
            this._helper = new ios_1.default(this._engine.getNode(), this._onChange);
        }
        else {
            this._helper = new desktop_1.default(rootContainer.node, this._onChange);
        }
        this._bindEvents();
    }
    FullScreenManager.prototype._onChange = function () {
        if (!this._helper.isInFullScreen && this._pauseVideoOnFullScreenExit) {
            this._engine.pause();
        }
        this._eventEmitter.emit(index_1.UI_EVENTS.FULLSCREEN_STATUS_CHANGED, this._helper.isInFullScreen);
    };
    FullScreenManager.prototype._bindEvents = function () {
        this._eventEmitter.on(index_1.VIDEO_EVENTS.STATE_CHANGED, this._processNextStateFromEngine, this);
        this._eventEmitter.on(index_1.VIDEO_EVENTS.PLAY_REQUEST_TRIGGERED, this._enterOnPlayRequested, this);
    };
    FullScreenManager.prototype._unbindEvents = function () {
        this._eventEmitter.off(index_1.VIDEO_EVENTS.STATE_CHANGED, this._processNextStateFromEngine, this);
        this._eventEmitter.off(index_1.VIDEO_EVENTS.PLAY_REQUEST_TRIGGERED, this._enterOnPlayRequested, this);
    };
    FullScreenManager.prototype._exitOnEnd = function () {
        if (this._exitFullScreenOnEnd && this.isInFullScreen) {
            this.exitFullScreen();
        }
    };
    FullScreenManager.prototype._enterOnPlayRequested = function () {
        if (this._enterFullScreenOnPlay && !this.isInFullScreen) {
            this.enterFullScreen();
        }
    };
    FullScreenManager.prototype._exitOnPauseRequested = function () {
        if (this._exitFullScreenOnPause && this.isInFullScreen) {
            this.exitFullScreen();
        }
    };
    FullScreenManager.prototype._processNextStateFromEngine = function (_a) {
        var nextState = _a.nextState;
        switch (nextState) {
            case index_1.STATES.ENDED: {
                this._exitOnEnd();
                break;
            }
            case index_1.STATES.PAUSED: {
                this._exitOnPauseRequested();
                break;
            }
            /* ignore coverage */
            default:
                break;
        }
    };
    /**
     * Player would try to enter fullscreen mode.
     * Behavior of fullscreen mode on different platforms may differ.
     * @example
     * player.enterFullScreen();
     */
    FullScreenManager.prototype.enterFullScreen = function () {
        if (!this.isEnabled) {
            return;
        }
        this._helper.request();
    };
    /**
     * Player would try to exit fullscreen mode.
     * @example
     * player.exitFullScreen();
     */
    FullScreenManager.prototype.exitFullScreen = function () {
        if (!this.isEnabled) {
            return;
        }
        this._helper.exit();
    };
    Object.defineProperty(FullScreenManager.prototype, "isInFullScreen", {
        /**
         * Return true if player is in full screen
         * @example
         * console.log(player.isInFullScreen); // false
         */
        get: function () {
            if (!this.isEnabled) {
                return false;
            }
            return this._helper.isInFullScreen;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FullScreenManager.prototype, "isEnabled", {
        get: function () {
            return this._helper.isEnabled && this._isEnabled;
        },
        enumerable: true,
        configurable: true
    });
    FullScreenManager.prototype.destroy = function () {
        this._unbindEvents();
        this._helper.destroy();
        delete this._eventEmitter;
        delete this._engine;
    };
    FullScreenManager.moduleName = 'fullScreenManager';
    FullScreenManager.dependencies = ['eventEmitter', 'engine', 'rootContainer', 'config'];
    tslib_1.__decorate([
        player_api_decorator_1.default()
    ], FullScreenManager.prototype, "enterFullScreen", null);
    tslib_1.__decorate([
        player_api_decorator_1.default()
    ], FullScreenManager.prototype, "exitFullScreen", null);
    tslib_1.__decorate([
        player_api_decorator_1.default()
    ], FullScreenManager.prototype, "isInFullScreen", null);
    return FullScreenManager;
}());
exports.default = FullScreenManager;


/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var fnMap = [
    [
        'requestFullscreen',
        'exitFullscreen',
        'fullscreenElement',
        'fullscreenEnabled',
        'fullscreenchange',
        'fullscreenerror',
    ],
    // new WebKit
    [
        'webkitRequestFullscreen',
        'webkitExitFullscreen',
        'webkitFullscreenElement',
        'webkitFullscreenEnabled',
        'webkitfullscreenchange',
        'webkitfullscreenerror',
    ],
    // old WebKit (Safari 5.1)
    [
        'webkitRequestFullScreen',
        'webkitCancelFullScreen',
        'webkitCurrentFullScreenElement',
        'webkitCancelFullScreen',
        'webkitfullscreenchange',
        'webkitfullscreenerror',
    ],
    [
        'mozRequestFullScreen',
        'mozCancelFullScreen',
        'mozFullScreenElement',
        'mozFullScreenEnabled',
        'mozfullscreenchange',
        'mozfullscreenerror',
    ],
    [
        'msRequestFullscreen',
        'msExitFullscreen',
        'msFullscreenElement',
        'msFullscreenEnabled',
        'MSFullscreenChange',
        'MSFullscreenError',
    ],
];
/* ignore coverage */
function getFullScreenFn() {
    var ret = {};
    for (var i = 0; i < fnMap.length; i += 1) {
        if (fnMap[i][1] in document) {
            for (var j = 0; j < fnMap[i].length; j += 1) {
                ret[fnMap[0][j]] = fnMap[i][j];
            }
            return ret;
        }
    }
    return false;
}
var DesktopFullScreen = /** @class */ (function () {
    function DesktopFullScreen(elem, callback) {
        this._elem = elem;
        this._callback = callback;
        this._fullscreenFn = getFullScreenFn();
        this._bindEvents();
    }
    Object.defineProperty(DesktopFullScreen.prototype, "isAPIExist", {
        get: function () {
            return Boolean(this._fullscreenFn);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DesktopFullScreen.prototype, "isInFullScreen", {
        get: function () {
            return Boolean(document[this._fullscreenFn.fullscreenElement]);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DesktopFullScreen.prototype, "isEnabled", {
        get: function () {
            return this.isAPIExist && document[this._fullscreenFn.fullscreenEnabled];
        },
        enumerable: true,
        configurable: true
    });
    DesktopFullScreen.prototype._bindEvents = function () {
        document.addEventListener(this._fullscreenFn.fullscreenchange, this._callback);
    };
    DesktopFullScreen.prototype._unbindEvents = function () {
        document.removeEventListener(this._fullscreenFn.fullscreenchange, this._callback);
    };
    DesktopFullScreen.prototype.request = function () {
        if (!this.isEnabled) {
            return;
        }
        var request = this._fullscreenFn.requestFullscreen;
        // Work around Safari 5.1 bug: reports support for
        // keyboard in fullscreen even though it doesn't.
        // Browser sniffing, since the alternative with
        // setTimeout is even worse.
        if (/5\.1[.\d]* Safari/.test(navigator.userAgent)) {
            this._elem[request]();
        }
        else {
            this._elem[request](Element.ALLOW_KEYBOARD_INPUT);
        }
    };
    DesktopFullScreen.prototype.exit = function () {
        if (!this.isEnabled) {
            return;
        }
        document[this._fullscreenFn.exitFullscreen]();
    };
    DesktopFullScreen.prototype.destroy = function () {
        this._unbindEvents();
        delete this._elem;
        delete this._callback;
    };
    return DesktopFullScreen;
}());
exports.default = DesktopFullScreen;


/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var HAVE_METADATA = 1;
var isFullScreenRequested = false;
var IOSFullScreen = /** @class */ (function () {
    function IOSFullScreen(elem, callback) {
        this._elem = elem;
        this._callback = callback;
        this._bindEvents();
        this._enterWhenHasMetaData = this._enterWhenHasMetaData.bind(this);
    }
    Object.defineProperty(IOSFullScreen.prototype, "isAPIExist", {
        get: function () {
            return Boolean(this._elem && this._elem.webkitSupportsFullscreen);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IOSFullScreen.prototype, "isInFullScreen", {
        get: function () {
            return Boolean(this._elem && this._elem.webkitDisplayingFullscreen);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IOSFullScreen.prototype, "isEnabled", {
        get: function () {
            return this.isAPIExist;
        },
        enumerable: true,
        configurable: true
    });
    IOSFullScreen.prototype._bindEvents = function () {
        this._elem.addEventListener('webkitbeginfullscreen', this._callback);
        this._elem.addEventListener('webkitendfullscreen', this._callback);
    };
    IOSFullScreen.prototype._unbindEvents = function () {
        this._elem.removeEventListener('webkitbeginfullscreen', this._callback);
        this._elem.removeEventListener('webkitendfullscreen', this._callback);
        this._elem.removeEventListener('loadedmetadata', this._enterWhenHasMetaData);
    };
    IOSFullScreen.prototype._enterWhenHasMetaData = function () {
        this._elem.removeEventListener('loadedmetadata', this._enterWhenHasMetaData);
        isFullScreenRequested = false;
        this._elem.webkitEnterFullscreen();
    };
    IOSFullScreen.prototype.request = function () {
        if (!this.isEnabled || this.isInFullScreen) {
            return false;
        }
        try {
            this._elem.webkitEnterFullscreen();
        }
        catch (e) {
            if (this._elem.readyState < HAVE_METADATA) {
                if (isFullScreenRequested) {
                    return;
                }
                this._elem.addEventListener('loadedmetadata', this._enterWhenHasMetaData);
                isFullScreenRequested = true;
            }
        }
    };
    IOSFullScreen.prototype.exit = function () {
        if (!this.isEnabled || !this.isInFullScreen) {
            return false;
        }
        this._elem.webkitExitFullscreen();
    };
    IOSFullScreen.prototype.destroy = function () {
        this._unbindEvents();
        delete this._elem;
        delete this._callback;
    };
    return IOSFullScreen;
}());
exports.default = IOSFullScreen;


/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var constants_1 = __webpack_require__(2);
var SEEK_BY_UI_EVENTS = [
    constants_1.UI_EVENTS.GO_FORWARD_WITH_KEYBOARD_TRIGGERED,
    constants_1.UI_EVENTS.GO_BACKWARD_WITH_KEYBOARD_TRIGGERED,
    constants_1.UI_EVENTS.PROGRESS_CHANGE_TRIGGERED,
];
var LiveStateEngine = /** @class */ (function () {
    function LiveStateEngine(_a) {
        var eventEmitter = _a.eventEmitter, engine = _a.engine;
        this._eventEmitter = eventEmitter;
        this._engine = engine;
        this._state = constants_1.LiveState.NONE;
        this._isSeekedByUIWhilePlaying = null;
        this._bindEvents();
    }
    LiveStateEngine.prototype.getState = function () {
        return this._state;
    };
    LiveStateEngine.prototype._bindEvents = function () {
        var _this = this;
        this._eventEmitter.on(constants_1.VIDEO_EVENTS.STATE_CHANGED, this._processStateChange, this);
        SEEK_BY_UI_EVENTS.forEach(function (event) {
            _this._eventEmitter.on(event, _this._processSeekByUI, _this);
        });
        this._eventEmitter.on(constants_1.VIDEO_EVENTS.DYNAMIC_CONTENT_ENDED, this._onDynamicContentEnded, this);
    };
    LiveStateEngine.prototype._unbindEvents = function () {
        var _this = this;
        this._eventEmitter.off(constants_1.VIDEO_EVENTS.STATE_CHANGED, this._processStateChange, this);
        SEEK_BY_UI_EVENTS.forEach(function (event) {
            _this._eventEmitter.on(event, _this._processSeekByUI, _this);
        });
    };
    LiveStateEngine.prototype._processStateChange = function (_a) {
        var prevState = _a.prevState, nextState = _a.nextState;
        if (nextState === constants_1.STATES.SRC_SET) {
            this._setState(constants_1.LiveState.NONE);
            return;
        }
        if (!this._engine.isDynamicContent || this._engine.isDynamicContentEnded) {
            return;
        }
        switch (nextState) {
            case constants_1.STATES.METADATA_LOADED:
                this._setState(constants_1.LiveState.INITIAL);
                break;
            case constants_1.STATES.PLAY_REQUESTED:
                if (this._state === constants_1.LiveState.INITIAL) {
                    this._engine.syncWithLive();
                }
                break;
            case constants_1.STATES.PLAYING:
                // NOTE: skip PLAYING event after events like `WAITING` and other not important events.
                if (this._state === constants_1.LiveState.INITIAL ||
                    this._state === constants_1.LiveState.NOT_SYNC ||
                    this._isSeekedByUIWhilePlaying) {
                    this._setState(this._engine.isSyncWithLive ? constants_1.LiveState.SYNC : constants_1.LiveState.NOT_SYNC);
                    this._isSeekedByUIWhilePlaying = false;
                }
                break;
            case constants_1.STATES.PAUSED:
                // NOTE: process `PAUSED` event only `PLAYING`, to be sure its not related with `WAITING` events
                if (prevState === constants_1.STATES.PLAYING) {
                    this._setState(constants_1.LiveState.NOT_SYNC);
                }
                break;
            default:
                break;
        }
    };
    LiveStateEngine.prototype._processSeekByUI = function () {
        if (this._engine.isDynamicContent &&
            this._engine.getCurrentState() === constants_1.STATES.PLAYING) {
            // NOTE: flag should be handled on `PLAYING` state in `_processStateChange`
            this._isSeekedByUIWhilePlaying = true;
        }
    };
    LiveStateEngine.prototype._onDynamicContentEnded = function () {
        this._setState(constants_1.LiveState.ENDED);
    };
    LiveStateEngine.prototype._setState = function (state) {
        if (this._state !== state) {
            var prevState = this._state;
            var nextState = state;
            this._state = state;
            this._eventEmitter.emit(constants_1.VIDEO_EVENTS.LIVE_STATE_CHANGED, {
                prevState: prevState,
                nextState: nextState,
            });
        }
    };
    LiveStateEngine.prototype.destroy = function () {
        this._eventEmitter = null;
        this._engine = null;
        this._state = null;
    };
    LiveStateEngine.moduleName = 'liveStateEngine';
    LiveStateEngine.dependencies = ['eventEmitter', 'engine'];
    return LiveStateEngine;
}());
exports.default = LiveStateEngine;


/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var index_1 = __webpack_require__(2);
var MouseInterceptor = /** @class */ (function () {
    function MouseInterceptor(_a) {
        var eventEmitter = _a.eventEmitter, rootContainer = _a.rootContainer;
        this._eventEmitter = eventEmitter;
        this._rootNode = rootContainer.node;
        this._bindCallbacks();
        this._bindEvents();
    }
    MouseInterceptor.prototype._bindCallbacks = function () {
        this._broadcastMouseEnter = this._broadcastMouseEnter.bind(this);
        this._broadcastMouseMove = this._broadcastMouseMove.bind(this);
        this._broadcastMouseLeave = this._broadcastMouseLeave.bind(this);
    };
    MouseInterceptor.prototype._bindEvents = function () {
        this._rootNode.addEventListener('mouseenter', this._broadcastMouseEnter);
        this._rootNode.addEventListener('mousemove', this._broadcastMouseMove);
        this._rootNode.addEventListener('mouseleave', this._broadcastMouseLeave);
    };
    MouseInterceptor.prototype._unbindEvents = function () {
        this._rootNode.removeEventListener('mouseenter', this._broadcastMouseEnter);
        this._rootNode.removeEventListener('mousemove', this._broadcastMouseMove);
        this._rootNode.removeEventListener('mouseleave', this._broadcastMouseLeave);
    };
    MouseInterceptor.prototype._broadcastMouseEnter = function () {
        this._eventEmitter.emit(index_1.UI_EVENTS.MOUSE_ENTER_ON_PLAYER_TRIGGERED);
    };
    MouseInterceptor.prototype._broadcastMouseMove = function () {
        this._eventEmitter.emit(index_1.UI_EVENTS.MOUSE_MOVE_ON_PLAYER_TRIGGERED);
    };
    MouseInterceptor.prototype._broadcastMouseLeave = function () {
        this._eventEmitter.emit(index_1.UI_EVENTS.MOUSE_LEAVE_ON_PLAYER_TRIGGERED);
    };
    MouseInterceptor.prototype.destroy = function () {
        this._unbindEvents();
        delete this._rootNode;
        delete this._eventEmitter;
    };
    MouseInterceptor.moduleName = 'mouseInterceptor';
    MouseInterceptor.dependencies = ['eventEmitter', 'rootContainer'];
    return MouseInterceptor;
}());
exports.default = MouseInterceptor;


/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var constants_1 = __webpack_require__(2);
var debug_panel_view_1 = tslib_1.__importDefault(__webpack_require__(124));
var UPDATE_TIME = 1000;
var DebugPanel = /** @class */ (function () {
    function DebugPanel(_a) {
        var engine = _a.engine, rootContainer = _a.rootContainer;
        this._engine = engine;
        this._bindCallbacks();
        this._initUI();
        this.hide();
        rootContainer.appendComponentNode(this.node);
    }
    Object.defineProperty(DebugPanel.prototype, "node", {
        get: function () {
            return this.view.getNode();
        },
        enumerable: true,
        configurable: true
    });
    DebugPanel.prototype._initUI = function () {
        this.view = new debug_panel_view_1.default({
            callbacks: {
                onCloseButtonClick: this.hide,
            },
        });
    };
    DebugPanel.prototype._bindCallbacks = function () {
        this.updateInfo = this.updateInfo.bind(this);
        this.hide = this.hide.bind(this);
    };
    DebugPanel.prototype.getDebugInfo = function () {
        var _a = this._engine.getDebugInfo(), url = _a.url, type = _a.type, deliveryPriority = _a.deliveryPriority, currentBitrate = _a.currentBitrate, overallBufferLength = _a.overallBufferLength, nearestBufferSegInfo = _a.nearestBufferSegInfo, viewDimensions = _a.viewDimensions, currentTime = _a.currentTime, duration = _a.duration, loadingStateTimestamps = _a.loadingStateTimestamps;
        return {
            url: url,
            type: type,
            deliveryPriority: constants_1.MediaStreamDeliveryPriority[deliveryPriority],
            currentBitrate: currentBitrate,
            overallBufferLength: overallBufferLength,
            nearestBufferSegInfo: nearestBufferSegInfo,
            viewDimensions: viewDimensions,
            currentTime: currentTime,
            duration: duration,
            loadingStateTimestamps: loadingStateTimestamps,
        };
    };
    DebugPanel.prototype.updateInfo = function () {
        this.view.setInfo(this.getDebugInfo());
    };
    DebugPanel.prototype.setUpdateInterval = function () {
        this.clearUpdateInterval();
        this._interval = setInterval(this.updateInfo, UPDATE_TIME);
    };
    DebugPanel.prototype.clearUpdateInterval = function () {
        clearInterval(this._interval);
    };
    DebugPanel.prototype.show = function () {
        if (this.isHidden) {
            this.updateInfo();
            this.setUpdateInterval();
            this.view.show();
            this.isHidden = false;
        }
    };
    DebugPanel.prototype.hide = function () {
        if (!this.isHidden) {
            this.clearUpdateInterval();
            this.view.hide();
            this.isHidden = true;
        }
    };
    DebugPanel.prototype.destroy = function () {
        this.clearUpdateInterval();
        this.view.destroy();
        delete this.view;
    };
    DebugPanel.moduleName = 'debugPanel';
    DebugPanel.View = debug_panel_view_1.default;
    DebugPanel.dependencies = ['engine', 'rootContainer'];
    return DebugPanel;
}());
exports.default = DebugPanel;


/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var view_1 = tslib_1.__importDefault(__webpack_require__(10));
var templates_1 = __webpack_require__(125);
var syntaxHighlight_1 = tslib_1.__importDefault(__webpack_require__(127));
var htmlToElement_1 = tslib_1.__importDefault(__webpack_require__(6));
var getElementByHook_1 = tslib_1.__importDefault(__webpack_require__(11));
var toggleNodeClass_1 = tslib_1.__importDefault(__webpack_require__(17));
var debug_panel_scss_1 = tslib_1.__importDefault(__webpack_require__(128));
var DebugPanelView = /** @class */ (function (_super) {
    tslib_1.__extends(DebugPanelView, _super);
    function DebugPanelView(config) {
        var _this = _super.call(this) || this;
        var callbacks = config.callbacks;
        _this._callbacks = callbacks;
        _this._initDOM();
        _this._bindEvents();
        return _this;
    }
    DebugPanelView.prototype._initDOM = function () {
        this._$node = htmlToElement_1.default(templates_1.debugPanelTemplate({
            styles: this.styleNames,
        }));
        this._$closeButton = getElementByHook_1.default(this._$node, 'debug-panel-close-button');
        this._$infoContainer = getElementByHook_1.default(this._$node, 'debug-panel-info-container');
    };
    DebugPanelView.prototype._bindEvents = function () {
        this._$closeButton.addEventListener('click', this._callbacks.onCloseButtonClick);
    };
    DebugPanelView.prototype._unbindEvents = function () {
        this._$closeButton.removeEventListener('click', this._callbacks.onCloseButtonClick);
    };
    DebugPanelView.prototype.show = function () {
        toggleNodeClass_1.default(this._$node, this.styleNames.hidden, false);
    };
    DebugPanelView.prototype.hide = function () {
        toggleNodeClass_1.default(this._$node, this.styleNames.hidden, true);
    };
    DebugPanelView.prototype.setInfo = function (info) {
        this._$infoContainer.innerHTML = syntaxHighlight_1.default(JSON.stringify(info, undefined, 4), this.styleNames);
    };
    DebugPanelView.prototype.getNode = function () {
        return this._$node;
    };
    DebugPanelView.prototype.destroy = function () {
        this._unbindEvents();
        if (this._$node.parentNode) {
            this._$node.parentNode.removeChild(this._$node);
        }
        delete this._$node;
        delete this._$closeButton;
        delete this._$infoContainer;
        delete this._callbacks;
    };
    return DebugPanelView;
}(view_1.default));
DebugPanelView.extendStyleNames(debug_panel_scss_1.default);
exports.default = DebugPanelView;


/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var debug_panel_dot_1 = __webpack_require__(126);
exports.debugPanelTemplate = debug_panel_dot_1.default;


/***/ }),
/* 126 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = anonymous;
function anonymous(props
/*``*/) {
var out='<div class="'+(props.styles.debugPanel)+'"> <div class="'+(props.styles.closeButton)+'" data-hook="debug-panel-close-button" > x </div> <pre class="'+(props.styles.infoContainer)+'" data-hook="debug-panel-info-container" > </pre></div>';return out;
}

/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
function syntaxHighlight(json, styleNames) {
    json = json
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;');
    return json.replace(/("(\\u[a-zA-Z0-9]{4}|\\[^u]|[^\\"])*"(\s*:)?|\b(true|false|null)\b|-?\d+(?:\.\d*)?(?:[eE][+-]?\d+)?)/g, function (match) {
        var cls = styleNames.number;
        if (/^"/.test(match)) {
            if (/:$/.test(match)) {
                cls = styleNames.key;
            }
            else {
                cls = styleNames.string;
            }
        }
        else if (/true|false/.test(match)) {
            cls = styleNames.boolean;
        }
        else if (/null/.test(match)) {
            cls = styleNames.null;
        }
        return "<span class=\"" + cls + "\">" + match + "</span>";
    });
}
exports.default = syntaxHighlight;


/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(129);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"singleton":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(8)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--9-1!../../../../node_modules/postcss-loader/lib/index.js??ref--9-2!../../../../node_modules/sass-loader/lib/loader.js??ref--9-3!./debug-panel.scss", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js??ref--9-1!../../../../node_modules/postcss-loader/lib/index.js??ref--9-2!../../../../node_modules/sass-loader/lib/loader.js??ref--9-3!./debug-panel.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(false);
// imports


// module
exports.push([module.i, "._21kHg{display:-webkit-box;display:-ms-flexbox;display:flex;padding:0;cursor:pointer;-webkit-transition-duration:.2s;transition-duration:.2s;-webkit-transition-property:opacity;transition-property:opacity;opacity:1;border:0;border-radius:0;outline:none;background-color:transparent;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center}._21kHg:hover{opacity:.7}.pYcDu{visibility:hidden!important;width:0!important;min-width:0!important;height:0!important;min-height:0!important;margin:0!important;padding:0!important;opacity:0!important}._37yuv{z-index:10000;left:10px;overflow:scroll;width:400px;height:250px;border-radius:3px;background-color:rgba(0,0,0,.95)}._37yuv,._37yuv ._32rJ_{position:absolute;top:10px}._37yuv ._32rJ_{right:5px;cursor:pointer;color:#fff}._37yuv ._32rJ_:hover{opacity:.8}._37yuv ._1-ZcL{font-size:8px;line-height:8px;margin:5px;padding:5px;color:#fff}._37yuv ._1-ZcL .YAxnZ{color:green}._37yuv ._1-ZcL ._3_cSV{color:#ff8c00}._37yuv ._1-ZcL .nMwdY{color:blue}._37yuv ._1-ZcL ._3KjsN{color:#f0f}._37yuv ._1-ZcL ._3E3hj{color:#fff}", ""]);

// exports
exports.locals = {
	"controlButton": "_21kHg",
	"hidden": "pYcDu",
	"debugPanel": "_37yuv",
	"closeButton": "_32rJ_",
	"infoContainer": "_1-ZcL",
	"string": "YAxnZ",
	"number": "_3_cSV",
	"boolean": "nMwdY",
	"null": "_3KjsN",
	"key": "_3E3hj"
};

/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var index_1 = __webpack_require__(2);
var screen_view_1 = tslib_1.__importDefault(__webpack_require__(131));
var PLAYBACK_CHANGE_TIMEOUT = 300;
var DEFAULT_CONFIG = {
    disableClickProcessing: false,
    nativeControls: false,
};
var Screen = /** @class */ (function () {
    function Screen(_a) {
        var config = _a.config, eventEmitter = _a.eventEmitter, engine = _a.engine, fullScreenManager = _a.fullScreenManager, interactionIndicator = _a.interactionIndicator, rootContainer = _a.rootContainer;
        this._eventEmitter = eventEmitter;
        this._engine = engine;
        this._fullScreenManager = fullScreenManager;
        this._interactionIndicator = interactionIndicator;
        this._isInFullScreen = false;
        this.isHidden = false;
        this._delayedToggleVideoPlaybackTimeout = null;
        var screenConfig = tslib_1.__assign({}, DEFAULT_CONFIG, config.screen);
        this._isClickProcessingDisabled = screenConfig.disableClickProcessing;
        this._bindCallbacks();
        this._initUI(screenConfig.nativeControls);
        this._bindEvents();
        rootContainer.appendComponentNode(this.node);
    }
    Object.defineProperty(Screen.prototype, "node", {
        get: function () {
            return this.view.getNode();
        },
        enumerable: true,
        configurable: true
    });
    Screen.prototype._bindCallbacks = function () {
        this._processNodeClick = this._processNodeClick.bind(this);
        this._processNodeDblClick = this._processNodeDblClick.bind(this);
        this._toggleVideoPlayback = this._toggleVideoPlayback.bind(this);
    };
    Screen.prototype._initUI = function (isNativeControls) {
        var config = {
            nativeControls: isNativeControls,
            callbacks: {
                onWrapperMouseClick: this._processNodeClick,
                onWrapperMouseDblClick: this._processNodeDblClick,
            },
            playbackViewNode: this._engine.getNode(),
        };
        this.view = new screen_view_1.default(config);
    };
    Screen.prototype._bindEvents = function () {
        this._eventEmitter.on(index_1.UI_EVENTS.FULLSCREEN_STATUS_CHANGED, this._setFullScreenStatus, this);
        this._eventEmitter.on(index_1.UI_EVENTS.PLAY_OVERLAY_TRIGGERED, this.view.focusOnNode, this.view);
    };
    Screen.prototype._unbindEvents = function () {
        this._eventEmitter.off(index_1.UI_EVENTS.FULLSCREEN_STATUS_CHANGED, this._setFullScreenStatus, this);
        this._eventEmitter.off(index_1.UI_EVENTS.PLAY_OVERLAY_TRIGGERED, this.view.focusOnNode, this.view);
    };
    Screen.prototype.showTopShadow = function () {
        this.view.showTopShadow();
    };
    Screen.prototype.hideTopShadow = function () {
        this.view.hideTopShadow();
    };
    Screen.prototype.showBottomShadow = function () {
        this.view.showBottomShadow();
    };
    Screen.prototype.hideBottomShadow = function () {
        this.view.hideBottomShadow();
    };
    Screen.prototype._setFullScreenStatus = function (isInFullScreen) {
        this._isInFullScreen = isInFullScreen;
    };
    Screen.prototype._processNodeClick = function () {
        if (this._isClickProcessingDisabled) {
            return;
        }
        this._showPlaybackChangeIndicator();
        if (!this._fullScreenManager.isEnabled ||
            this._fullScreenManager._enterFullScreenOnPlay) {
            this._toggleVideoPlayback();
        }
        else {
            this._setDelayedPlaybackToggle();
        }
    };
    Screen.prototype._processNodeDblClick = function () {
        if (this._isClickProcessingDisabled) {
            return;
        }
        if (this._fullScreenManager.isEnabled ||
            !this._fullScreenManager._enterFullScreenOnPlay) {
            if (this._isDelayedPlaybackToggleExist) {
                this._clearDelayedPlaybackToggle();
                this._hideDelayedPlaybackChangeIndicator();
            }
            this._toggleFullScreen();
        }
    };
    Screen.prototype._showPlaybackChangeIndicator = function () {
        var state = this._engine.getCurrentState();
        if (state === index_1.STATES.PLAY_REQUESTED || state === index_1.STATES.PLAYING) {
            this._interactionIndicator.showPause();
        }
        else {
            this._interactionIndicator.showPlay();
        }
    };
    Screen.prototype._hideDelayedPlaybackChangeIndicator = function () {
        this._interactionIndicator.hideIcons();
    };
    Screen.prototype._setDelayedPlaybackToggle = function () {
        this._clearDelayedPlaybackToggle();
        this._delayedToggleVideoPlaybackTimeout = setTimeout(this._toggleVideoPlayback, PLAYBACK_CHANGE_TIMEOUT);
    };
    Screen.prototype._clearDelayedPlaybackToggle = function () {
        clearTimeout(this._delayedToggleVideoPlaybackTimeout);
        this._delayedToggleVideoPlaybackTimeout = null;
    };
    Object.defineProperty(Screen.prototype, "_isDelayedPlaybackToggleExist", {
        get: function () {
            return Boolean(this._delayedToggleVideoPlaybackTimeout);
        },
        enumerable: true,
        configurable: true
    });
    Screen.prototype._toggleVideoPlayback = function () {
        this._clearDelayedPlaybackToggle();
        var state = this._engine.getCurrentState();
        if (state === index_1.STATES.PLAY_REQUESTED || state === index_1.STATES.PLAYING) {
            this._eventEmitter.emit(index_1.UI_EVENTS.PAUSE_WITH_SCREEN_CLICK_TRIGGERED);
            this._engine.pause();
        }
        else {
            this._eventEmitter.emit(index_1.UI_EVENTS.PLAY_WITH_SCREEN_CLICK_TRIGGERED);
            this._engine.play();
        }
    };
    Screen.prototype._toggleFullScreen = function () {
        if (this._isInFullScreen) {
            this._exitFullScreen();
        }
        else {
            this._enterFullScreen();
        }
    };
    Screen.prototype.hide = function () {
        if (!this.isHidden) {
            this.view.hide();
            this.isHidden = true;
        }
    };
    Screen.prototype.show = function () {
        if (this.isHidden) {
            this.view.show();
            this.isHidden = false;
        }
    };
    Screen.prototype._enterFullScreen = function () {
        this._fullScreenManager.enterFullScreen();
    };
    Screen.prototype._exitFullScreen = function () {
        this._fullScreenManager.exitFullScreen();
    };
    Screen.prototype.destroy = function () {
        this._unbindEvents();
        this._clearDelayedPlaybackToggle();
        this.view.destroy();
        delete this.view;
        delete this._interactionIndicator;
        delete this._eventEmitter;
        delete this._engine;
        delete this._fullScreenManager;
    };
    Screen.moduleName = 'screen';
    Screen.View = screen_view_1.default;
    Screen.dependencies = [
        'engine',
        'eventEmitter',
        'config',
        'fullScreenManager',
        'interactionIndicator',
        'rootContainer',
    ];
    return Screen;
}());
exports.default = Screen;


/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var view_1 = tslib_1.__importDefault(__webpack_require__(10));
var templates_1 = __webpack_require__(132);
var htmlToElement_1 = tslib_1.__importDefault(__webpack_require__(6));
var getElementByHook_1 = tslib_1.__importDefault(__webpack_require__(11));
var toggleNodeClass_1 = tslib_1.__importDefault(__webpack_require__(17));
var screen_scss_1 = tslib_1.__importDefault(__webpack_require__(134));
var ScreenView = /** @class */ (function (_super) {
    tslib_1.__extends(ScreenView, _super);
    function ScreenView(config) {
        var _this = _super.call(this) || this;
        var callbacks = config.callbacks, nativeControls = config.nativeControls, playbackViewNode = config.playbackViewNode;
        _this._isNativeControls = nativeControls;
        _this._callbacks = callbacks;
        _this._initDOM(playbackViewNode);
        _this._bindEvents();
        return _this;
    }
    ScreenView.prototype._initDOM = function (playbackViewNode) {
        this._$node = htmlToElement_1.default(templates_1.screenTemplate({
            styles: this.styleNames,
        }));
        this._$topBackground = getElementByHook_1.default(this._$node, 'screen-top-background');
        this._$bottomBackground = getElementByHook_1.default(this._$node, 'screen-bottom-background');
        if (this._isNativeControls) {
            playbackViewNode.setAttribute('controls', 'true');
        }
        playbackViewNode.setAttribute('tabindex', String(-1));
        this._$node.appendChild(playbackViewNode);
    };
    ScreenView.prototype._bindEvents = function () {
        this._$node.addEventListener('click', this._callbacks.onWrapperMouseClick);
        this._$node.addEventListener('dblclick', this._callbacks.onWrapperMouseDblClick);
    };
    ScreenView.prototype._unbindEvents = function () {
        this._$node.removeEventListener('click', this._callbacks.onWrapperMouseClick);
        this._$node.removeEventListener('dblclick', this._callbacks.onWrapperMouseDblClick);
    };
    ScreenView.prototype.focusOnNode = function () {
        this._$node.focus();
    };
    ScreenView.prototype.show = function () {
        toggleNodeClass_1.default(this._$node, this.styleNames.hidden, false);
    };
    ScreenView.prototype.hide = function () {
        toggleNodeClass_1.default(this._$node, this.styleNames.hidden, true);
    };
    ScreenView.prototype.getNode = function () {
        return this._$node;
    };
    ScreenView.prototype.showTopShadow = function () {
        this._$topBackground.classList.add(this.styleNames.visible);
    };
    ScreenView.prototype.hideTopShadow = function () {
        this._$topBackground.classList.remove(this.styleNames.visible);
    };
    ScreenView.prototype.showBottomShadow = function () {
        if (!this._isNativeControls) {
            this._$bottomBackground.classList.add(this.styleNames.visible);
        }
    };
    ScreenView.prototype.hideBottomShadow = function () {
        this._$bottomBackground.classList.remove(this.styleNames.visible);
    };
    ScreenView.prototype.appendComponentNode = function (node) {
        this._$node.appendChild(node);
    };
    ScreenView.prototype.destroy = function () {
        this._unbindEvents();
        if (this._$node.parentNode) {
            this._$node.parentNode.removeChild(this._$node);
        }
        delete this._$node;
        delete this._$topBackground;
        delete this._$bottomBackground;
        delete this._callbacks;
    };
    return ScreenView;
}(view_1.default));
ScreenView.extendStyleNames(screen_scss_1.default);
exports.default = ScreenView;


/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var screen_dot_1 = __webpack_require__(133);
exports.screenTemplate = screen_dot_1.default;


/***/ }),
/* 133 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = anonymous;
function anonymous(props
/*``*/) {
var out='<div class="'+(props.styles.screen)+'" data-hook="screen-block"> <div class="'+(props.styles.screenTopBackground)+'" data-hook="screen-top-background"> </div> <div class="'+(props.styles.screenBottomBackground)+'" data-hook="screen-bottom-background"> </div></div>';return out;
}

/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(135);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"singleton":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(8)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--9-1!../../../../node_modules/postcss-loader/lib/index.js??ref--9-2!../../../../node_modules/sass-loader/lib/loader.js??ref--9-3!./screen.scss", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js??ref--9-1!../../../../node_modules/postcss-loader/lib/index.js??ref--9-2!../../../../node_modules/sass-loader/lib/loader.js??ref--9-3!./screen.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(false);
// imports


// module
exports.push([module.i, "._2BkXt{position:absolute;z-index:50;top:0;right:0;bottom:0;left:0;background-color:#000}._2BkXt,._2BkXt video{width:100%;height:100%}._2BkXt video{position:relative;z-index:0}._378gi,.KiGq3{position:absolute;z-index:1;right:0;left:0;visibility:hidden;height:182px;-webkit-transition:opacity .2s,visibility .2s;transition:opacity .2s,visibility .2s;opacity:0;background-size:100% 182px}._378gi.CHkoC,.KiGq3.CHkoC{visibility:visible;opacity:1}._378gi{top:0;background-image:-webkit-gradient(linear,left bottom,left top,from(transparent),color-stop(24%,rgba(0,0,0,.03)),color-stop(50%,rgba(0,0,0,.15)),color-stop(75%,rgba(0,0,0,.3)),to(rgba(0,0,0,.4)));background-image:linear-gradient(0deg,transparent,rgba(0,0,0,.03) 24%,rgba(0,0,0,.15) 50%,rgba(0,0,0,.3) 75%,rgba(0,0,0,.4))}.KiGq3{bottom:0;background-image:-webkit-gradient(linear,left top,left bottom,from(transparent),color-stop(24%,rgba(0,0,0,.03)),color-stop(50%,rgba(0,0,0,.15)),color-stop(75%,rgba(0,0,0,.3)),to(rgba(0,0,0,.4)));background-image:linear-gradient(180deg,transparent,rgba(0,0,0,.03) 24%,rgba(0,0,0,.15) 50%,rgba(0,0,0,.3) 75%,rgba(0,0,0,.4))}", ""]);

// exports
exports.locals = {
	"screen": "_2BkXt",
	"screenTopBackground": "_378gi",
	"screenBottomBackground": "KiGq3",
	"visible": "CHkoC"
};

/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var index_1 = __webpack_require__(2);
var interaction_indicator_view_1 = tslib_1.__importDefault(__webpack_require__(137));
var InteractionIndicator = /** @class */ (function () {
    function InteractionIndicator(_a) {
        var eventEmitter = _a.eventEmitter, engine = _a.engine, config = _a.config, rootContainer = _a.rootContainer;
        this._eventEmitter = eventEmitter;
        this._engine = engine;
        this._initUI();
        this._bindEvents();
        rootContainer.appendComponentNode(this.node);
        if (config.showInteractionIndicator === false) {
            this.hide();
        }
    }
    Object.defineProperty(InteractionIndicator.prototype, "node", {
        get: function () {
            return this.view.getNode();
        },
        enumerable: true,
        configurable: true
    });
    InteractionIndicator.prototype._initUI = function () {
        this.view = new interaction_indicator_view_1.default();
    };
    InteractionIndicator.prototype._bindEvents = function () {
        this._eventEmitter.on(index_1.UI_EVENTS.TOGGLE_PLAYBACK_WITH_KEYBOARD_TRIGGERED, this._showPlaybackChangeIndicator, this);
        this._eventEmitter.on(index_1.UI_EVENTS.GO_BACKWARD_WITH_KEYBOARD_TRIGGERED, this.showRewind, this);
        this._eventEmitter.on(index_1.UI_EVENTS.GO_FORWARD_WITH_KEYBOARD_TRIGGERED, this.showForward, this);
        this._eventEmitter.on(index_1.UI_EVENTS.INCREASE_VOLUME_WITH_KEYBOARD_TRIGGERED, this.showIncreaseVolume, this);
        this._eventEmitter.on(index_1.UI_EVENTS.DECREASE_VOLUME_WITH_KEYBOARD_TRIGGERED, this.showDecreaseVolume, this);
        this._eventEmitter.on(index_1.UI_EVENTS.MUTE_SOUND_WITH_KEYBOARD_TRIGGERED, this.showMute, this);
        this._eventEmitter.on(index_1.UI_EVENTS.UNMUTE_SOUND_WITH_KEYBOARD_TRIGGERED, this.showIncreaseVolume, this);
    };
    InteractionIndicator.prototype.showPause = function () {
        this.view.activatePauseIcon();
    };
    InteractionIndicator.prototype.showPlay = function () {
        this.view.activatePlayIcon();
    };
    InteractionIndicator.prototype.showRewind = function () {
        this.view.activateRewindIcon();
    };
    InteractionIndicator.prototype.showForward = function () {
        this.view.activateForwardIcon();
    };
    InteractionIndicator.prototype.showMute = function () {
        this.view.activateMuteVolumeIcon();
    };
    InteractionIndicator.prototype.showIncreaseVolume = function () {
        this.view.activateIncreaseVolumeIcon();
    };
    InteractionIndicator.prototype.showDecreaseVolume = function () {
        this.view.activateDecreaseVolumeIcon();
    };
    InteractionIndicator.prototype.hideIcons = function () {
        this.view.deactivateIcon();
        this._eventEmitter.emit(index_1.UI_EVENTS.HIDE_INTERACTION_INDICATOR_TRIGGERED);
    };
    InteractionIndicator.prototype.show = function () {
        this.view.hide();
    };
    InteractionIndicator.prototype.hide = function () {
        this.view.show();
    };
    InteractionIndicator.prototype._unbindEvents = function () {
        this._eventEmitter.off(index_1.UI_EVENTS.TOGGLE_PLAYBACK_WITH_KEYBOARD_TRIGGERED, this._showPlaybackChangeIndicator, this);
        this._eventEmitter.off(index_1.UI_EVENTS.GO_BACKWARD_WITH_KEYBOARD_TRIGGERED, this.showRewind, this);
        this._eventEmitter.off(index_1.UI_EVENTS.GO_FORWARD_WITH_KEYBOARD_TRIGGERED, this.showForward, this);
        this._eventEmitter.off(index_1.UI_EVENTS.INCREASE_VOLUME_WITH_KEYBOARD_TRIGGERED, this.showIncreaseVolume, this);
        this._eventEmitter.off(index_1.UI_EVENTS.DECREASE_VOLUME_WITH_KEYBOARD_TRIGGERED, this.showDecreaseVolume, this);
        this._eventEmitter.off(index_1.UI_EVENTS.MUTE_SOUND_WITH_KEYBOARD_TRIGGERED, this.showMute, this);
        this._eventEmitter.off(index_1.UI_EVENTS.UNMUTE_SOUND_WITH_KEYBOARD_TRIGGERED, this.showIncreaseVolume, this);
    };
    InteractionIndicator.prototype._showPlaybackChangeIndicator = function () {
        var state = this._engine.getCurrentState();
        if (state === index_1.STATES.PLAY_REQUESTED || state === index_1.STATES.PLAYING) {
            this.view.activatePauseIcon();
        }
        else {
            this.view.activatePlayIcon();
        }
    };
    InteractionIndicator.prototype.destroy = function () {
        this._unbindEvents();
        this.view.destroy();
        delete this.view;
        delete this._eventEmitter;
        delete this._engine;
    };
    InteractionIndicator.moduleName = 'interactionIndicator';
    InteractionIndicator.View = interaction_indicator_view_1.default;
    InteractionIndicator.dependencies = ['engine', 'eventEmitter', 'config', 'rootContainer'];
    return InteractionIndicator;
}());
exports.default = InteractionIndicator;


/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var view_1 = tslib_1.__importDefault(__webpack_require__(10));
var templates_1 = __webpack_require__(138);
var htmlToElement_1 = tslib_1.__importDefault(__webpack_require__(6));
var interaction_indicator_scss_1 = tslib_1.__importDefault(__webpack_require__(147));
var SECONDS_COUNT = 5;
var InteractionIndicatorView = /** @class */ (function (_super) {
    tslib_1.__extends(InteractionIndicatorView, _super);
    function InteractionIndicatorView() {
        var _this = _super.call(this) || this;
        _this._$node = htmlToElement_1.default(templates_1.containerTemplate({
            styles: _this.styleNames,
        }));
        _this._playIcon = templates_1.playIconTemplate({
            styles: _this.styleNames,
        });
        _this._pauseIcon = templates_1.pauseIconTemplate({
            styles: _this.styleNames,
        });
        _this._forwardIcon = templates_1.forwardIconTemplate({
            texts: {
                SECONDS_COUNT: SECONDS_COUNT,
            },
            styles: _this.styleNames,
        });
        _this._rewindIcon = templates_1.rewindIconTemplate({
            texts: {
                SECONDS_COUNT: SECONDS_COUNT,
            },
            styles: _this.styleNames,
        });
        _this._increaseVolumeIcon = templates_1.increaseVolumeIconTemplate({
            styles: _this.styleNames,
        });
        _this._decreaseVolumeIcon = templates_1.decreaseVolumeIconTemplate({
            styles: _this.styleNames,
        });
        _this._muteIcon = templates_1.muteIconTemplate({
            styles: _this.styleNames,
        });
        return _this;
    }
    InteractionIndicatorView.prototype.activatePlayIcon = function () {
        this._$node.innerHTML = this._playIcon;
    };
    InteractionIndicatorView.prototype.activatePauseIcon = function () {
        this._$node.innerHTML = this._pauseIcon;
    };
    InteractionIndicatorView.prototype.activateForwardIcon = function () {
        this._$node.innerHTML = this._forwardIcon;
    };
    InteractionIndicatorView.prototype.activateRewindIcon = function () {
        this._$node.innerHTML = this._rewindIcon;
    };
    InteractionIndicatorView.prototype.activateIncreaseVolumeIcon = function () {
        this._$node.innerHTML = this._increaseVolumeIcon;
    };
    InteractionIndicatorView.prototype.activateDecreaseVolumeIcon = function () {
        this._$node.innerHTML = this._decreaseVolumeIcon;
    };
    InteractionIndicatorView.prototype.activateMuteVolumeIcon = function () {
        this._$node.innerHTML = this._muteIcon;
    };
    InteractionIndicatorView.prototype.deactivateIcon = function () {
        this._$node.innerHTML = '';
    };
    InteractionIndicatorView.prototype.hide = function () {
        this._$node.classList.add(this.styleNames.hidden);
    };
    InteractionIndicatorView.prototype.show = function () {
        this._$node.classList.remove(this.styleNames.hidden);
    };
    InteractionIndicatorView.prototype.getNode = function () {
        return this._$node;
    };
    InteractionIndicatorView.prototype.destroy = function () {
        if (this._$node.parentNode) {
            this._$node.parentNode.removeChild(this._$node);
        }
        delete this._$node;
    };
    return InteractionIndicatorView;
}(view_1.default));
InteractionIndicatorView.extendStyleNames(interaction_indicator_scss_1.default);
exports.default = InteractionIndicatorView;


/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var container_dot_1 = __webpack_require__(139);
exports.containerTemplate = container_dot_1.default;
var playIcon_dot_1 = __webpack_require__(140);
exports.playIconTemplate = playIcon_dot_1.default;
var pauseIcon_dot_1 = __webpack_require__(141);
exports.pauseIconTemplate = pauseIcon_dot_1.default;
var forwardIcon_dot_1 = __webpack_require__(142);
exports.forwardIconTemplate = forwardIcon_dot_1.default;
var rewindIcon_dot_1 = __webpack_require__(143);
exports.rewindIconTemplate = rewindIcon_dot_1.default;
var increaseVolumeIcon_dot_1 = __webpack_require__(144);
exports.increaseVolumeIconTemplate = increaseVolumeIcon_dot_1.default;
var decreaseVolumeIcon_dot_1 = __webpack_require__(145);
exports.decreaseVolumeIconTemplate = decreaseVolumeIcon_dot_1.default;
var muteIcon_dot_1 = __webpack_require__(146);
exports.muteIconTemplate = muteIcon_dot_1.default;


/***/ }),
/* 139 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = anonymous;
function anonymous(props
/*``*/) {
var out='<div class="'+(props.styles.iconContainer)+'"></div>';return out;
}

/***/ }),
/* 140 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = anonymous;
function anonymous(props
/*``*/) {
var out='<div class="'+(props.styles.icon)+'"> <svg class="'+(props.styles.playIcon)+' '+(props.styles.animatedIcon)+'" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 11 14"> <path fill="#FFF" fill-rule="evenodd" d="M.079 0L0 14l10.5-7.181z"/> </svg></div>';return out;
}

/***/ }),
/* 141 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = anonymous;
function anonymous(props
/*``*/) {
var out='<div class="'+(props.styles.icon)+'"> <svg class="'+(props.styles.pauseIcon)+' '+(props.styles.animatedIcon)+'" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 10 14"> <path fill="#FFF" fill-rule="evenodd" d="M7 0h3v14H7V0zM0 0h3v14H0V0z"/> </svg></div>';return out;
}

/***/ }),
/* 142 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = anonymous;
function anonymous(props
/*``*/) {
var out='<div class="'+(props.styles.icon)+'"> <div class="'+(props.styles.seconds)+'"> <span>'+(props.texts.SECONDS_COUNT)+'</span> </div> <svg class="'+(props.styles.animatedIcon)+'" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 34 34"> <path fill="#FFF" fill-rule="evenodd" d="M17 0c4.59 0 8.84 1.87 11.9 4.93V1.7h3.4v10.2H22.1V8.5h5.44C24.99 5.27 21.25 3.4 17 3.4 9.52 3.4 3.4 9.52 3.4 17c0 7.48 6.12 13.6 13.6 13.6 7.48 0 13.6-6.12 13.6-13.6H34c0 9.35-7.65 17-17 17S0 26.35 0 17 7.65 0 17 0z"/> </svg></div>';return out;
}

/***/ }),
/* 143 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = anonymous;
function anonymous(props
/*``*/) {
var out='<div class="'+(props.styles.icon)+'"> <div class="'+(props.styles.seconds)+'"> <span>'+(props.texts.SECONDS_COUNT)+'</span> </div> <svg class="'+(props.styles.animatedIcon)+'" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 34 34"> <path fill="#FFF" fill-rule="evenodd" d="M17 0C12.41 0 8.16 1.87 5.1 4.93V1.7H1.7v10.2h10.2V8.5H6.46C9.01 5.27 12.75 3.4 17 3.4c7.48 0 13.6 6.12 13.6 13.6 0 7.48-6.12 13.6-13.6 13.6-7.48 0-13.6-6.12-13.6-13.6H0c0 9.35 7.65 17 17 17s17-7.65 17-17S26.35 0 17 0z"/> </svg></div>';return out;
}

/***/ }),
/* 144 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = anonymous;
function anonymous(props
/*``*/) {
var out='<div class="'+(props.styles.icon)+'"> <svg class="'+(props.styles.animatedIcon)+'" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 17 14"> <g fill="none" fill-rule="evenodd"> <path fill="#FFF" d="M0 3.919h2.993v5.97H0V3.92zm2.995-.015L7 .924v12L2.995 9.882v-5.98z"/> <path stroke="#FFF" d="M12.793 13.716a9.607 9.607 0 0 0 0-13.586M9.853 10.837a5.45 5.45 0 0 0 0-7.707"/> </g> </svg></div>';return out;
}

/***/ }),
/* 145 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = anonymous;
function anonymous(props
/*``*/) {
var out='<div class="'+(props.styles.icon)+'"> <svg class="'+(props.styles.animatedIcon)+'" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 17 14"> <g fill="none" fill-rule="evenodd"> <path fill="#FFF" d="M0 3.919h2.993v5.97H0V3.92zm2.995-.015L7 .924v12L2.995 9.882v-5.98z"/> <path stroke="#FFF" d="M9.853 10.837a5.45 5.45 0 0 0 0-7.707"/> </g> </svg></div>';return out;
}

/***/ }),
/* 146 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = anonymous;
function anonymous(props
/*``*/) {
var out='<div class="'+(props.styles.icon)+'"> <svg class="'+(props.styles.animatedIcon)+'" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 17 14"> <g fill="#FFF" fill-rule="evenodd"> <path fill="#FFF" d="M0 3.919h2.993v5.97H0V3.92zm2.995-.015L7 .924v12L2.995 9.882v-5.98z"/> <path stroke="#FFF" d="M13 6.257l-2.05-2.05-.743.743L12.257 7l-2.05 2.05.743.743L13 7.743l2.05 2.05.743-.743L13.743 7l2.05-2.05-.743-.743L13 6.257z"/> </g> </svg></div>';return out;
}

/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(148);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"singleton":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(8)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--9-1!../../../../node_modules/postcss-loader/lib/index.js??ref--9-2!../../../../node_modules/sass-loader/lib/loader.js??ref--9-3!./interaction-indicator.scss", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js??ref--9-1!../../../../node_modules/postcss-loader/lib/index.js??ref--9-2!../../../../node_modules/sass-loader/lib/loader.js??ref--9-3!./interaction-indicator.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(false);
// imports


// module
exports.push([module.i, "._3Io1T{position:absolute;z-index:100;top:0;right:0;bottom:0;left:0;pointer-events:none}._3Io1T,._3Io1T ._13XFX{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center}._3Io1T ._13XFX{font-size:9px;line-height:9px;position:relative;-webkit-animation-name:_1fCmD;animation-name:_1fCmD;opacity:0;border-radius:100px;background-color:rgba(0,0,0,.5)}._3Io1T ._13XFX,._3Io1T .fL-ty{-webkit-animation-duration:.5s;animation-duration:.5s}._3Io1T .fL-ty{-webkit-animation-name:_2wrJx;animation-name:_2wrJx}._3Io1T .jzAPG{position:relative;left:3px}._3Io1T ._2yEqv{margin:5px 0}._3Io1T ._2wxwo{position:absolute;top:0;right:0;bottom:0;left:0;display:-webkit-box;display:-ms-flexbox;display:flex;min-width:5px;min-height:8px;color:#fff;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center}._3Io1T ._2wxwo span{display:block}@-webkit-keyframes _2wrJx{0%{width:22px;height:22px}to{width:30px;height:30px}}@keyframes _2wrJx{0%{width:22px;height:22px}to{width:30px;height:30px}}@-webkit-keyframes _1fCmD{0%{width:22px;height:22px;padding:19px;opacity:.9}to{font-size:14px;line-height:14px;width:30px;height:30px;padding:25px;opacity:0}}@keyframes _1fCmD{0%{width:22px;height:22px;padding:19px;opacity:.9}to{font-size:14px;line-height:14px;width:30px;height:30px;padding:25px;opacity:0}}", ""]);

// exports
exports.locals = {
	"iconContainer": "_3Io1T",
	"icon": "_13XFX",
	"fadeOut": "_1fCmD",
	"animatedIcon": "fL-ty",
	"iconSize": "_2wrJx",
	"playIcon": "jzAPG",
	"pauseIcon": "_2yEqv",
	"seconds": "_2wxwo"
};

/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var index_1 = __webpack_require__(2);
var player_api_decorator_1 = tslib_1.__importDefault(__webpack_require__(12));
var overlay_view_1 = tslib_1.__importDefault(__webpack_require__(150));
var Overlay = /** @class */ (function () {
    function Overlay(_a) {
        var config = _a.config, eventEmitter = _a.eventEmitter, engine = _a.engine, rootContainer = _a.rootContainer, theme = _a.theme;
        this.isHidden = false;
        this._eventEmitter = eventEmitter;
        this._engine = engine;
        this._theme = theme;
        this._bindEvents();
        this._initUI(config.overlay && config.overlay.poster);
        rootContainer.appendComponentNode(this.node);
        if (config.overlay === false) {
            this.hide();
        }
    }
    Object.defineProperty(Overlay.prototype, "node", {
        get: function () {
            return this.view.getNode();
        },
        enumerable: true,
        configurable: true
    });
    Overlay.prototype._initUI = function (poster) {
        var config = {
            callbacks: {
                onPlayClick: this._playVideo,
            },
            src: poster,
            theme: this._theme,
        };
        this.view = new Overlay.View(config);
    };
    Overlay.prototype._bindEvents = function () {
        this._playVideo = this._playVideo.bind(this);
        this._eventEmitter.on(index_1.VIDEO_EVENTS.STATE_CHANGED, this._updatePlayingStatus, this);
    };
    Overlay.prototype._updatePlayingStatus = function (_a) {
        var nextState = _a.nextState;
        if (nextState === index_1.STATES.PLAY_REQUESTED) {
            this._hideContent();
        }
        else if (nextState === index_1.STATES.ENDED) {
            this._showContent();
        }
    };
    Overlay.prototype._playVideo = function () {
        this._engine.play();
        this._eventEmitter.emit(index_1.UI_EVENTS.PLAY_OVERLAY_TRIGGERED);
    };
    Overlay.prototype._hideContent = function () {
        this.view.hideContent();
    };
    Overlay.prototype._showContent = function () {
        this.view.showContent();
    };
    Overlay.prototype.hide = function () {
        this.isHidden = true;
        this.view.hide();
    };
    Overlay.prototype.show = function () {
        this.isHidden = false;
        this.view.show();
    };
    /**
     * Method for setting overlay poster
     * @param src - Source of image
     * @example
     * player.setPoster('https://example.com/poster.png');
     *
     */
    Overlay.prototype.setPoster = function (src) {
        this.view.setPoster(src);
    };
    Overlay.prototype._unbindEvents = function () {
        this._eventEmitter.off(index_1.VIDEO_EVENTS.STATE_CHANGED, this._updatePlayingStatus, this);
    };
    Overlay.prototype.destroy = function () {
        this._unbindEvents();
        this.view.destroy();
        delete this.view;
        delete this._eventEmitter;
        delete this._engine;
    };
    Overlay.moduleName = 'overlay';
    Overlay.View = overlay_view_1.default;
    Overlay.dependencies = [
        'engine',
        'eventEmitter',
        'config',
        'rootContainer',
        'theme',
    ];
    tslib_1.__decorate([
        player_api_decorator_1.default()
    ], Overlay.prototype, "setPoster", null);
    return Overlay;
}());
exports.default = Overlay;


/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var view_1 = tslib_1.__importDefault(__webpack_require__(10));
var templates_1 = __webpack_require__(151);
var htmlToElement_1 = tslib_1.__importDefault(__webpack_require__(6));
var getElementByHook_1 = tslib_1.__importDefault(__webpack_require__(11));
var overlay_theme_1 = tslib_1.__importDefault(__webpack_require__(153));
var overlay_scss_1 = tslib_1.__importDefault(__webpack_require__(154));
var OverlayView = /** @class */ (function (_super) {
    tslib_1.__extends(OverlayView, _super);
    function OverlayView(config) {
        var _this = _super.call(this, config.theme) || this;
        var callbacks = config.callbacks, src = config.src;
        _this._callbacks = callbacks;
        _this._initDOM();
        _this._bindEvents();
        _this.setPoster(src);
        return _this;
    }
    OverlayView.prototype._initDOM = function () {
        this._$node = htmlToElement_1.default(templates_1.overlayTemplate({
            styles: this.styleNames,
            themeStyles: this.themeStyles,
        }));
        this._$content = getElementByHook_1.default(this._$node, 'overlay-content');
        this._$playButton = getElementByHook_1.default(this._$node, 'overlay-play-button');
    };
    OverlayView.prototype._bindEvents = function () {
        this._$playButton.addEventListener('click', this._callbacks.onPlayClick);
    };
    OverlayView.prototype._unbindEvents = function () {
        this._$playButton.removeEventListener('click', this._callbacks.onPlayClick);
    };
    OverlayView.prototype.getNode = function () {
        return this._$node;
    };
    OverlayView.prototype.hideContent = function () {
        this._$node.classList.remove(this.styleNames.active);
    };
    OverlayView.prototype.showContent = function () {
        this._$node.classList.add(this.styleNames.active);
    };
    OverlayView.prototype.hide = function () {
        this._$node.classList.add(this.styleNames.hidden);
    };
    OverlayView.prototype.show = function () {
        this._$node.classList.remove(this.styleNames.hidden);
    };
    OverlayView.prototype.setPoster = function (src) {
        this._$content.style.backgroundImage = src ? "url('" + src + "')" : 'none';
    };
    OverlayView.prototype.destroy = function () {
        this._unbindEvents();
        if (this._$node.parentNode) {
            this._$node.parentNode.removeChild(this._$node);
        }
        delete this._$node;
        delete this._$content;
        delete this._$playButton;
    };
    return OverlayView;
}(view_1.default));
OverlayView.setTheme(overlay_theme_1.default);
OverlayView.extendStyleNames(overlay_scss_1.default);
exports.default = OverlayView;


/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var overlay_dot_1 = __webpack_require__(152);
exports.overlayTemplate = overlay_dot_1.default;


/***/ }),
/* 152 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = anonymous;
function anonymous(props
/*``*/) {
var out='<div class="'+(props.styles.overlay)+' '+(props.styles.active)+'" data-hook="overlay" > <div class="'+(props.styles.poster)+'" data-hook="overlay-content" > </div> <div class="'+(props.styles.icon)+'" data-hook="overlay-play-button" > <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 36 36" preserveAspectRatio="xMidYMin slice" width="100%" style="padding-bottom: 100%; height: 1px; overflow: visible" > <!-- padding-bottom: 100% * height/width --> <g         fill="none"         fill-rule="evenodd" > <circle           cx="18" cy="18" r="17" class="'+(props.themeStyles.overlayPlaySvgStroke)+'"           stroke-width="2" /> <path class="'+(props.themeStyles.overlayPlaySvgFill)+'" d="M23.935 17.708l-10.313 6.033V11.676z" /> </g> </svg> </div></div>';return out;
}

/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    overlayPlaySvgFill: {
        fill: function (data) { return data.color; },
    },
    overlayPlaySvgStroke: {
        stroke: function (data) { return data.color; },
    },
};


/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(155);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"singleton":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(8)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--9-1!../../../../node_modules/postcss-loader/lib/index.js??ref--9-2!../../../../node_modules/sass-loader/lib/loader.js??ref--9-3!./overlay.scss", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js??ref--9-1!../../../../node_modules/postcss-loader/lib/index.js??ref--9-2!../../../../node_modules/sass-loader/lib/loader.js??ref--9-3!./overlay.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(false);
// imports


// module
exports.push([module.i, "._3zlvH{display:-webkit-box;display:-ms-flexbox;display:flex;padding:0;cursor:pointer;-webkit-transition-duration:.2s;transition-duration:.2s;-webkit-transition-property:opacity;transition-property:opacity;opacity:1;border:0;border-radius:0;outline:none;background-color:transparent;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center}._3zlvH:hover{opacity:.7}._2j5rK{visibility:hidden!important;width:0!important;min-width:0!important;height:0!important;min-height:0!important;margin:0!important;padding:0!important;opacity:0!important}._3rYQ2{position:absolute;z-index:100;top:0;right:0;bottom:0;left:0;display:none}._3rYQ2._1FTmR{display:-webkit-box;display:-ms-flexbox;display:flex}._2MAjg,._3rYQ2._1FTmR{-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center}._2MAjg{right:0;bottom:0;background:#000 no-repeat 50%;background-size:cover}._2MAjg,._2MAjg:before{position:absolute;top:0;left:0;width:100%;height:100%}._2MAjg:before{content:\"\";background-color:rgba(0,0,0,.35)}._3yVeB{position:relative;width:71px;height:71px;cursor:pointer;opacity:1}div[data-hook=player-container][data-max-width~=\"550px\"] ._3yVeB{width:54px;height:54px}div[data-hook=player-container][data-max-width~=\"400px\"] ._3yVeB{width:36px;height:36px}._3yVeB:hover{opacity:.8}", ""]);

// exports
exports.locals = {
	"controlButton": "_3zlvH",
	"hidden": "_2j5rK",
	"overlay": "_3rYQ2",
	"active": "_1FTmR",
	"poster": "_2MAjg",
	"icon": "_3yVeB"
};

/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var index_1 = __webpack_require__(2);
var loader_view_1 = tslib_1.__importDefault(__webpack_require__(157));
exports.DELAYED_SHOW_TIMEOUT = 100;
var Loader = /** @class */ (function () {
    function Loader(_a) {
        var config = _a.config, eventEmitter = _a.eventEmitter, engine = _a.engine, rootContainer = _a.rootContainer;
        this._eventEmitter = eventEmitter;
        this.isHidden = false;
        this._engine = engine;
        this._bindCallbacks();
        this._initUI();
        this._bindEvents();
        this._hideContent();
        rootContainer.appendComponentNode(this.node);
        if (config.loader === false) {
            this.hide();
        }
    }
    Object.defineProperty(Loader.prototype, "node", {
        get: function () {
            return this.view.getNode();
        },
        enumerable: true,
        configurable: true
    });
    Loader.prototype._bindCallbacks = function () {
        this._showContent = this._showContent.bind(this);
        this._hideContent = this._hideContent.bind(this);
    };
    Loader.prototype._bindEvents = function () {
        this._eventEmitter.on(index_1.VIDEO_EVENTS.STATE_CHANGED, this._checkForWaitingState, this);
        this._eventEmitter.on(index_1.VIDEO_EVENTS.UPLOAD_SUSPEND, this.hide, this);
    };
    Loader.prototype._checkForWaitingState = function (_a) {
        var nextState = _a.nextState;
        switch (nextState) {
            case index_1.STATES.SEEK_IN_PROGRESS:
                this.startDelayedShow();
                break;
            case index_1.STATES.WAITING:
                this.startDelayedShow();
                break;
            case index_1.STATES.LOAD_STARTED:
                if (this._engine.isPreloadAvailable) {
                    this._showContent();
                }
                break;
            case index_1.STATES.READY_TO_PLAY:
                this.stopDelayedShow();
                this._hideContent();
                break;
            case index_1.STATES.PLAYING:
                this.stopDelayedShow();
                this._hideContent();
                break;
            case index_1.STATES.PAUSED:
                this.stopDelayedShow();
                this._hideContent();
                break;
            /* ignore coverage */
            default:
                break;
        }
    };
    Loader.prototype._initUI = function () {
        this.view = new Loader.View();
    };
    Loader.prototype._showContent = function () {
        if (this.isHidden) {
            this._eventEmitter.emit(index_1.UI_EVENTS.LOADER_SHOW_TRIGGERED);
            this.view.showContent();
            this.isHidden = false;
        }
    };
    Loader.prototype._hideContent = function () {
        if (!this.isHidden) {
            this._eventEmitter.emit(index_1.UI_EVENTS.LOADER_HIDE_TRIGGERED);
            this.view.hideContent();
            this.isHidden = true;
        }
    };
    Loader.prototype.hide = function () {
        this.view.hide();
    };
    Loader.prototype.show = function () {
        this.view.show();
    };
    Loader.prototype.startDelayedShow = function () {
        if (this.isDelayedShowScheduled) {
            this.stopDelayedShow();
        }
        this._delayedShowTimeout = setTimeout(this._showContent, exports.DELAYED_SHOW_TIMEOUT);
    };
    Loader.prototype.stopDelayedShow = function () {
        clearTimeout(this._delayedShowTimeout);
        this._delayedShowTimeout = null;
    };
    Object.defineProperty(Loader.prototype, "isDelayedShowScheduled", {
        get: function () {
            return Boolean(this._delayedShowTimeout);
        },
        enumerable: true,
        configurable: true
    });
    Loader.prototype._unbindEvents = function () {
        this._eventEmitter.off(index_1.VIDEO_EVENTS.STATE_CHANGED, this._checkForWaitingState, this);
        this._eventEmitter.off(index_1.VIDEO_EVENTS.UPLOAD_SUSPEND, this.hide, this);
    };
    Loader.prototype.destroy = function () {
        this._unbindEvents();
        this.stopDelayedShow();
        this.view.destroy();
        delete this.view;
        delete this._eventEmitter;
        delete this._engine;
    };
    Loader.moduleName = 'loader';
    Loader.View = loader_view_1.default;
    Loader.dependencies = ['engine', 'eventEmitter', 'config', 'rootContainer'];
    return Loader;
}());
exports.default = Loader;


/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var view_1 = tslib_1.__importDefault(__webpack_require__(10));
var templates_1 = __webpack_require__(158);
var htmlToElement_1 = tslib_1.__importDefault(__webpack_require__(6));
var loader_scss_1 = tslib_1.__importDefault(__webpack_require__(160));
var LoaderView = /** @class */ (function (_super) {
    tslib_1.__extends(LoaderView, _super);
    function LoaderView() {
        var _this = _super.call(this) || this;
        _this._$node = htmlToElement_1.default(templates_1.loaderTemplate({
            styles: _this.styleNames,
        }));
        return _this;
    }
    LoaderView.prototype.getNode = function () {
        return this._$node;
    };
    LoaderView.prototype.showContent = function () {
        this._$node.classList.add(this.styleNames.active);
    };
    LoaderView.prototype.hideContent = function () {
        this._$node.classList.remove(this.styleNames.active);
    };
    LoaderView.prototype.hide = function () {
        this._$node.classList.add(this.styleNames.hidden);
    };
    LoaderView.prototype.show = function () {
        this._$node.classList.remove(this.styleNames.hidden);
    };
    LoaderView.prototype.destroy = function () {
        if (this._$node.parentNode) {
            this._$node.parentNode.removeChild(this._$node);
        }
        delete this._$node;
    };
    return LoaderView;
}(view_1.default));
LoaderView.extendStyleNames(loader_scss_1.default);
exports.default = LoaderView;


/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var loader_dot_1 = __webpack_require__(159);
exports.loaderTemplate = loader_dot_1.default;


/***/ }),
/* 159 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = anonymous;
function anonymous(props
/*``*/) {
var out='<div class="'+(props.styles.loader)+' '+(props.styles.active)+'" data-hook="loader" ></div>';return out;
}

/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(161);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"singleton":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(8)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--9-1!../../../../node_modules/postcss-loader/lib/index.js??ref--9-2!../../../../node_modules/sass-loader/lib/loader.js??ref--9-3!./loader.scss", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js??ref--9-1!../../../../node_modules/postcss-loader/lib/index.js??ref--9-2!../../../../node_modules/sass-loader/lib/loader.js??ref--9-3!./loader.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(false);
// imports


// module
exports.push([module.i, ".urklQ{display:-webkit-box;display:-ms-flexbox;display:flex;padding:0;cursor:pointer;-webkit-transition-duration:.2s;transition-duration:.2s;-webkit-transition-property:opacity;transition-property:opacity;opacity:1;border:0;border-radius:0;outline:none;background-color:transparent;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.urklQ:hover{opacity:.7}.BSe_s{visibility:hidden!important;width:0!important;min-width:0!important;height:0!important;min-height:0!important;margin:0!important;padding:0!important;opacity:0!important}._1Na--{position:absolute;z-index:90;top:50%;left:50%;display:none;clip:rect(0,48px,48px,24px);width:42px;height:42px;margin-top:-21px;margin-left:-21px;-webkit-animation:_3L8bZ 1s linear infinite;animation:_3L8bZ 1s linear infinite;color:#fff}._1Na--._8OHrj{display:block}._1Na--:after{clip:rect(4px,48px,48px,24px);-webkit-animation:_2XbOB 1s linear infinite;animation:_2XbOB 1s linear infinite}._1Na--:after,._1Na--:before{position:absolute;top:0;right:0;bottom:0;left:0;content:\"\";border:3px solid currentColor;border-radius:50%}._1Na--:before{clip:rect(0,48px,48px,24px);-webkit-animation:_34a7j 1s linear infinite;animation:_34a7j 1s linear infinite}@-webkit-keyframes _2XbOB{50%{clip:rect(42px,48px,48px,24px);-webkit-animation-timing-function:ease-in-out;animation-timing-function:ease-in-out}}@keyframes _2XbOB{50%{clip:rect(42px,48px,48px,24px);-webkit-animation-timing-function:ease-in-out;animation-timing-function:ease-in-out}}@-webkit-keyframes _34a7j{50%{clip:rect(0,48px,9px,24px);-webkit-transform:rotate(135deg);transform:rotate(135deg);-webkit-animation-timing-function:ease-in-out;animation-timing-function:ease-in-out}}@keyframes _34a7j{50%{clip:rect(0,48px,9px,24px);-webkit-transform:rotate(135deg);transform:rotate(135deg);-webkit-animation-timing-function:ease-in-out;animation-timing-function:ease-in-out}}@-webkit-keyframes _3L8bZ{0%{-webkit-transform:rotate(0);transform:rotate(0);-webkit-animation-timing-function:ease-out;animation-timing-function:ease-out}45%{-webkit-transform:rotate(18deg);transform:rotate(18deg);color:#fff}55%{-webkit-transform:rotate(54deg);transform:rotate(54deg)}to{-webkit-transform:rotate(1turn);transform:rotate(1turn)}}@keyframes _3L8bZ{0%{-webkit-transform:rotate(0);transform:rotate(0);-webkit-animation-timing-function:ease-out;animation-timing-function:ease-out}45%{-webkit-transform:rotate(18deg);transform:rotate(18deg);color:#fff}55%{-webkit-transform:rotate(54deg);transform:rotate(54deg)}to{-webkit-transform:rotate(1turn);transform:rotate(1turn)}}", ""]);

// exports
exports.locals = {
	"controlButton": "urklQ",
	"hidden": "BSe_s",
	"loader": "_1Na--",
	"rotate": "_3L8bZ",
	"active": "_8OHrj",
	"clip": "_2XbOB",
	"clip-reverse": "_34a7j",
	"clipReverse": "_34a7j"
};

/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var index_1 = __webpack_require__(2);
var player_api_decorator_1 = tslib_1.__importDefault(__webpack_require__(12));
var main_ui_block_view_1 = tslib_1.__importDefault(__webpack_require__(163));
var HIDE_BLOCK_TIMEOUT = 2000;
var DEFAULT_CONFIG = {
    shouldAlwaysShow: false,
};
var MainUIBlock = /** @class */ (function () {
    function MainUIBlock(dependencies) {
        this._hideTimeout = null;
        this._isContentShowingEnabled = true;
        this._isContentShown = false;
        this._shouldShowContent = true;
        this._shouldAlwaysShow = false;
        this._isDragging = false;
        var config = dependencies.config, eventEmitter = dependencies.eventEmitter, rootContainer = dependencies.rootContainer, tooltipService = dependencies.tooltipService, topBlock = dependencies.topBlock, bottomBlock = dependencies.bottomBlock;
        this._eventEmitter = eventEmitter;
        this._topBlock = topBlock;
        this._bottomBlock = bottomBlock;
        this.isHidden = false;
        var mainBlockConfig = tslib_1.__assign({}, DEFAULT_CONFIG, config.controls);
        this._shouldAlwaysShow = mainBlockConfig.shouldAlwaysShow;
        this._initUI({
            tooltipContainer: tooltipService.tooltipContainerNode,
            topBlock: topBlock.node,
            bottomBlock: bottomBlock.node,
        });
        this._bindViewCallbacks();
        this._bindEvents();
        rootContainer.appendComponentNode(this.view.getNode());
        if (config.controls === false) {
            this.hide();
        }
    }
    Object.defineProperty(MainUIBlock.prototype, "node", {
        get: function () {
            return this.view.getNode();
        },
        enumerable: true,
        configurable: true
    });
    MainUIBlock.prototype._initUI = function (elements) {
        this.view = new MainUIBlock.View({ elements: elements });
    };
    MainUIBlock.prototype._bindViewCallbacks = function () {
        this._startHideBlockTimeout = this._startHideBlockTimeout.bind(this);
        this._tryShowContent = this._tryShowContent.bind(this);
        this._tryHideContent = this._tryHideContent.bind(this);
    };
    MainUIBlock.prototype._bindEvents = function () {
        this._eventEmitter.on(index_1.UI_EVENTS.MOUSE_MOVE_ON_PLAYER_TRIGGERED, this._startHideBlockTimeout);
        this._eventEmitter.on(index_1.UI_EVENTS.MOUSE_LEAVE_ON_PLAYER_TRIGGERED, this._tryHideContent);
        this._eventEmitter.on(index_1.UI_EVENTS.KEYBOARD_KEYDOWN_INTERCEPTED, this._startHideBlockTimeout);
        this._eventEmitter.on(index_1.UI_EVENTS.LOADER_HIDE_TRIGGERED, this._startHideBlockTimeout);
        this._eventEmitter.on(index_1.VIDEO_EVENTS.STATE_CHANGED, this._updatePlayingStatus, this);
        this._eventEmitter.on(index_1.UI_EVENTS.CONTROL_DRAG_START, this._onControlDragStart, this);
        this._eventEmitter.on(index_1.UI_EVENTS.CONTROL_DRAG_END, this._onControlDragEnd, this);
    };
    MainUIBlock.prototype._unbindEvents = function () {
        this._eventEmitter.off(index_1.UI_EVENTS.MOUSE_MOVE_ON_PLAYER_TRIGGERED, this._startHideBlockTimeout);
        this._eventEmitter.off(index_1.UI_EVENTS.MOUSE_LEAVE_ON_PLAYER_TRIGGERED, this._tryHideContent);
        this._eventEmitter.off(index_1.UI_EVENTS.KEYBOARD_KEYDOWN_INTERCEPTED, this._startHideBlockTimeout);
        this._eventEmitter.off(index_1.UI_EVENTS.LOADER_HIDE_TRIGGERED, this._startHideBlockTimeout);
        this._eventEmitter.off(index_1.VIDEO_EVENTS.STATE_CHANGED, this._updatePlayingStatus, this);
        this._eventEmitter.off(index_1.UI_EVENTS.CONTROL_DRAG_START, this._onControlDragStart, this);
        this._eventEmitter.off(index_1.UI_EVENTS.CONTROL_DRAG_END, this._onControlDragEnd, this);
    };
    MainUIBlock.prototype._updatePlayingStatus = function (_a) {
        var nextState = _a.nextState;
        switch (nextState) {
            case index_1.STATES.PLAY_REQUESTED: {
                this._shouldShowContent = false;
                this._startHideBlockTimeout();
                break;
            }
            case index_1.STATES.ENDED: {
                this._shouldShowContent = true;
                this._tryShowContent();
                break;
            }
            case index_1.STATES.PAUSED: {
                this._shouldShowContent = true;
                this._tryShowContent();
                break;
            }
            case index_1.STATES.SRC_SET: {
                this._shouldShowContent = true;
                this._tryShowContent();
                break;
            }
            default:
                break;
        }
    };
    Object.defineProperty(MainUIBlock.prototype, "_isBlockFocused", {
        get: function () {
            return this._bottomBlock.isFocused;
        },
        enumerable: true,
        configurable: true
    });
    MainUIBlock.prototype._startHideBlockTimeout = function () {
        this._stopHideBlockTimeout();
        this._tryShowContent();
        this._hideTimeout = setTimeout(this._tryHideContent, HIDE_BLOCK_TIMEOUT);
    };
    MainUIBlock.prototype._stopHideBlockTimeout = function () {
        if (this._hideTimeout) {
            clearTimeout(this._hideTimeout);
        }
    };
    MainUIBlock.prototype._tryShowContent = function () {
        if (this._isContentShowingEnabled) {
            this._showContent();
        }
    };
    MainUIBlock.prototype._onControlDragStart = function () {
        this._isDragging = true;
    };
    MainUIBlock.prototype._onControlDragEnd = function () {
        this._isDragging = false;
        this._tryHideContent();
    };
    MainUIBlock.prototype._showContent = function () {
        if (this.isHidden || this._isContentShown) {
            return;
        }
        this._eventEmitter.emit(index_1.UI_EVENTS.MAIN_BLOCK_SHOW_TRIGGERED);
        this._bottomBlock.showContent();
        this._topBlock.showContent();
        this._isContentShown = true;
    };
    MainUIBlock.prototype._tryHideContent = function () {
        if (!this._isBlockFocused &&
            !this._isDragging &&
            !this._shouldShowContent &&
            !this._shouldAlwaysShow) {
            this._hideContent();
        }
    };
    MainUIBlock.prototype._hideContent = function () {
        if (this.isHidden || !this._isContentShown) {
            return;
        }
        this._eventEmitter.emit(index_1.UI_EVENTS.MAIN_BLOCK_HIDE_TRIGGERED);
        this._bottomBlock.hideContent();
        this._topBlock.hideContent();
        this._isContentShown = false;
    };
    MainUIBlock.prototype.disableShowingContent = function () {
        this._isContentShowingEnabled = false;
        this._hideContent();
    };
    MainUIBlock.prototype.enableShowingContent = function () {
        this._isContentShowingEnabled = true;
        if (this._shouldShowContent) {
            this._showContent();
        }
    };
    MainUIBlock.prototype.hide = function () {
        this.isHidden = true;
        this._topBlock.hide();
        this._bottomBlock.hide();
    };
    MainUIBlock.prototype.show = function () {
        this.isHidden = false;
        this._topBlock.show();
        this._bottomBlock.show();
    };
    /**
     * Method for allowing bottom block to be always shown.
     * @param flag - `true` for showing always
     * @example
     * player.setControlsShouldAlwaysShow(true);
     *
     */
    MainUIBlock.prototype.setShouldAlwaysShow = function (flag) {
        this._shouldAlwaysShow = flag;
        if (this._shouldAlwaysShow) {
            this._tryShowContent();
        }
        else {
            this._startHideBlockTimeout();
        }
    };
    MainUIBlock.prototype.destroy = function () {
        this._stopHideBlockTimeout();
        this._unbindEvents();
        delete this._eventEmitter;
        delete this._topBlock;
        delete this._bottomBlock;
    };
    MainUIBlock.moduleName = 'mainUIBlock';
    MainUIBlock.View = main_ui_block_view_1.default;
    MainUIBlock.dependencies = [
        'config',
        'rootContainer',
        'tooltipService',
        'eventEmitter',
        'topBlock',
        'bottomBlock',
    ];
    tslib_1.__decorate([
        player_api_decorator_1.default('setControlsShouldAlwaysShow')
    ], MainUIBlock.prototype, "setShouldAlwaysShow", null);
    return MainUIBlock;
}());
exports.default = MainUIBlock;


/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var view_1 = tslib_1.__importDefault(__webpack_require__(10));
var templates_1 = __webpack_require__(164);
var htmlToElement_1 = tslib_1.__importDefault(__webpack_require__(6));
var main_ui_block_scss_1 = tslib_1.__importDefault(__webpack_require__(166));
var MainUIBlockView = /** @class */ (function (_super) {
    tslib_1.__extends(MainUIBlockView, _super);
    function MainUIBlockView(config) {
        var _this = _super.call(this) || this;
        _this._initDOM(config.elements);
        return _this;
    }
    MainUIBlockView.prototype._initDOM = function (elements) {
        this.$node = htmlToElement_1.default(templates_1.mainUIBlockTemplate({
            styles: this.styleNames,
        }));
        var $tooltipContainerWrapper = document.createElement('div');
        $tooltipContainerWrapper.classList.add(this.styleNames['tooltip-container-wrapper']);
        $tooltipContainerWrapper.appendChild(elements.tooltipContainer);
        this.$node.appendChild(elements.topBlock);
        this.$node.appendChild($tooltipContainerWrapper);
        this.$node.appendChild(elements.bottomBlock);
    };
    MainUIBlockView.prototype.getNode = function () {
        return this.$node;
    };
    MainUIBlockView.prototype.destroy = function () {
        if (this.$node.parentNode) {
            this.$node.parentNode.removeChild(this.$node);
        }
        delete this.$node;
    };
    return MainUIBlockView;
}(view_1.default));
MainUIBlockView.extendStyleNames(main_ui_block_scss_1.default);
exports.default = MainUIBlockView;


/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var mainUIBlock_dot_1 = __webpack_require__(165);
exports.mainUIBlockTemplate = mainUIBlock_dot_1.default;


/***/ }),
/* 165 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = anonymous;
function anonymous(props
/*``*/) {
var out='<div class="'+(props.styles['main-ui-block'])+'"></div>';return out;
}

/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(167);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"singleton":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(8)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--9-1!../../../../node_modules/postcss-loader/lib/index.js??ref--9-2!../../../../node_modules/sass-loader/lib/loader.js??ref--9-3!./main-ui-block.scss", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js??ref--9-1!../../../../node_modules/postcss-loader/lib/index.js??ref--9-2!../../../../node_modules/sass-loader/lib/loader.js??ref--9-3!./main-ui-block.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(false);
// imports


// module
exports.push([module.i, "._7suHs{position:absolute;top:0;right:0;bottom:0;left:0;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}._7suHs ._1L5i7{position:relative;-webkit-box-flex:2;-ms-flex-positive:2;flex-grow:2}", ""]);

// exports
exports.locals = {
	"main-ui-block": "_7suHs",
	"mainUiBlock": "_7suHs",
	"tooltip-container-wrapper": "_1L5i7",
	"tooltipContainerWrapper": "_1L5i7"
};

/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var top_block_view_1 = tslib_1.__importDefault(__webpack_require__(169));
var TopBlock = /** @class */ (function () {
    function TopBlock(dependencies) {
        var screen = dependencies.screen;
        this._screen = screen;
        this.isHidden = false;
        this._initUI(this._getElementsNodes(dependencies));
    }
    TopBlock.prototype._initUI = function (elementNodes) {
        var config = {
            elements: elementNodes,
        };
        this.view = new TopBlock.View(config);
    };
    TopBlock.prototype._getElementsNodes = function (dependencies) {
        var title = dependencies.title, liveIndicator = dependencies.liveIndicator;
        return {
            title: title.node,
            liveIndicator: liveIndicator.node,
        };
    };
    Object.defineProperty(TopBlock.prototype, "node", {
        get: function () {
            return this.view.getNode();
        },
        enumerable: true,
        configurable: true
    });
    TopBlock.prototype.hide = function () {
        this.isHidden = true;
        this.view.hide();
    };
    TopBlock.prototype.show = function () {
        this.isHidden = false;
        this.view.show();
    };
    TopBlock.prototype.showContent = function () {
        this._screen.showTopShadow();
        this.view.showContent();
    };
    TopBlock.prototype.hideContent = function () {
        this._screen.hideTopShadow();
        this.view.hideContent();
    };
    TopBlock.prototype.destroy = function () {
        delete this._screen;
    };
    TopBlock.moduleName = 'topBlock';
    TopBlock.View = top_block_view_1.default;
    TopBlock.dependencies = ['config', 'screen', 'title', 'liveIndicator'];
    return TopBlock;
}());
exports.default = TopBlock;


/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var view_1 = tslib_1.__importDefault(__webpack_require__(10));
var htmlToElement_1 = tslib_1.__importDefault(__webpack_require__(6));
var getElementByHook_1 = tslib_1.__importDefault(__webpack_require__(11));
var templates_1 = __webpack_require__(170);
var top_block_scss_1 = tslib_1.__importDefault(__webpack_require__(172));
var TopBlockView = /** @class */ (function (_super) {
    tslib_1.__extends(TopBlockView, _super);
    function TopBlockView(config) {
        var _this = _super.call(this) || this;
        var elements = config.elements;
        _this._initDOM(elements);
        _this._bindEvents();
        return _this;
    }
    TopBlockView.prototype._initDOM = function (elements) {
        this._$node = htmlToElement_1.default(templates_1.topBlockTemplate({
            styles: this.styleNames,
        }));
        var $titleContainer = getElementByHook_1.default(this._$node, 'title-container');
        var $liveIndicatorContainer = getElementByHook_1.default(this._$node, 'live-indicator-container');
        $titleContainer.appendChild(elements.title);
        $liveIndicatorContainer.appendChild(elements.liveIndicator);
    };
    TopBlockView.prototype._preventClickPropagation = function (e) {
        e.stopPropagation();
    };
    TopBlockView.prototype._bindEvents = function () {
        this._$node.addEventListener('click', this._preventClickPropagation);
    };
    TopBlockView.prototype._unbindEvents = function () {
        this._$node.removeEventListener('click', this._preventClickPropagation);
    };
    TopBlockView.prototype.show = function () {
        this._$node.classList.remove(this.styleNames.hidden);
    };
    TopBlockView.prototype.hide = function () {
        this._$node.classList.add(this.styleNames.hidden);
    };
    TopBlockView.prototype.getNode = function () {
        return this._$node;
    };
    TopBlockView.prototype.showContent = function () {
        this._$node.classList.add(this.styleNames.activated);
    };
    TopBlockView.prototype.hideContent = function () {
        this._$node.classList.remove(this.styleNames.activated);
    };
    TopBlockView.prototype.destroy = function () {
        this._unbindEvents();
        if (this._$node.parentNode) {
            this._$node.parentNode.removeChild(this._$node);
        }
        delete this._$node;
    };
    return TopBlockView;
}(view_1.default));
TopBlockView.extendStyleNames(top_block_scss_1.default);
exports.default = TopBlockView;


/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var top_block_dot_1 = __webpack_require__(171);
exports.topBlockTemplate = top_block_dot_1.default;


/***/ }),
/* 171 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = anonymous;
function anonymous(props
/*``*/) {
var out='<div data-hook="top-block" class="'+(props.styles.topBlock)+'"> <div class="'+(props.styles.elementsContainer)+'"> <div class="'+(props.styles.liveIndicatorContainer)+'" data-hook="live-indicator-container"> </div> <div class="'+(props.styles.titleContainer)+'" data-hook="title-container"> </div> </div></div>';return out;
}

/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(173);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"singleton":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(8)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--9-1!../../../../node_modules/postcss-loader/lib/index.js??ref--9-2!../../../../node_modules/sass-loader/lib/loader.js??ref--9-3!./top-block.scss", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js??ref--9-1!../../../../node_modules/postcss-loader/lib/index.js??ref--9-2!../../../../node_modules/sass-loader/lib/loader.js??ref--9-3!./top-block.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(false);
// imports


// module
exports.push([module.i, "._2Dvac{display:-webkit-box;display:-ms-flexbox;display:flex;padding:0;cursor:pointer;-webkit-transition-duration:.2s;transition-duration:.2s;-webkit-transition-property:opacity;transition-property:opacity;opacity:1;border:0;border-radius:0;outline:none;background-color:transparent;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center}._2Dvac:hover{opacity:.7}.W49Tb{visibility:hidden!important;width:0!important;min-width:0!important;height:0!important;min-height:0!important;margin:0!important;padding:0!important;opacity:0!important}._1y8j9{z-index:60}._1y8j9::-moz-focus-inner{border:0}._1y8j9._1dglr .lehDu,._1y8j9._3fsIZ .lehDu{opacity:1}._1-GHI{-webkit-box-flex:0;-ms-flex-positive:0;flex-grow:0}._2J-Gh{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;margin-top:20px;margin-left:20px;-webkit-box-align:center;-ms-flex-align:center;align-items:center}div[data-hook=player-container][data-in-full-screen=true] ._2J-Gh{margin-top:30px;margin-left:30px}div[data-hook=player-container][data-max-width~=\"550px\"] ._2J-Gh{margin-top:15px;margin-left:15px}div[data-hook=player-container][data-max-width~=\"280px\"] ._2J-Gh{margin-top:12px;margin-left:12px}.lehDu{max-width:calc(100% - 200px);-webkit-transition:opacity .2s,visibility .2s;transition:opacity .2s,visibility .2s;opacity:0;-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1}", ""]);

// exports
exports.locals = {
	"controlButton": "_2Dvac",
	"hidden": "W49Tb",
	"topBlock": "_1y8j9",
	"activated": "_3fsIZ",
	"titleContainer": "lehDu",
	"focus-within": "_1dglr",
	"focusWithin": "_1dglr",
	"liveIndicatorContainer": "_1-GHI",
	"elementsContainer": "_2J-Gh"
};

/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var title_view_1 = tslib_1.__importDefault(__webpack_require__(175));
var player_api_decorator_1 = tslib_1.__importDefault(__webpack_require__(12));
var TitleControl = /** @class */ (function () {
    function TitleControl(_a) {
        var config = _a.config, theme = _a.theme;
        this._theme = theme;
        this._bindCallbacks();
        this._initUI();
        if (config.title) {
            this.setTitleClickCallback(config.title.callback || null);
            this.setTitle(config.title.text);
        }
        else if (config.title === false) {
            this.hide();
        }
    }
    Object.defineProperty(TitleControl.prototype, "node", {
        get: function () {
            return this.view.getNode();
        },
        enumerable: true,
        configurable: true
    });
    TitleControl.prototype._bindCallbacks = function () {
        this._triggerCallback = this._triggerCallback.bind(this);
    };
    TitleControl.prototype._initUI = function () {
        var config = {
            theme: this._theme,
            callbacks: {
                onClick: this._triggerCallback,
            },
        };
        this.view = new TitleControl.View(config);
        this.view.setTitle();
    };
    /**
     * Display title text over the video. If you want to have clickable title, use `setTitleClickCallback`
     *
     * @param title - Text for the video title
     *
     * @example
     * player.setTitle('Your awesome video title here');
     *
     * @note
     * [Live Demo](https://jsfiddle.net/bodia/243k6m0u/)
     */
    TitleControl.prototype.setTitle = function (title) {
        this.view.setTitle(title);
    };
    /**
     * Method for attaching callback for click on title
     *
     * @param callback - Your function
     *
     * @example
     * const callback = () => {
     *   console.log('Click on title);
     * }
     * player.setTitleClickCallback(callback);
     *
     */
    TitleControl.prototype.setTitleClickCallback = function (callback) {
        this._callback = callback;
        this.view.setDisplayAsLink(Boolean(this._callback));
    };
    TitleControl.prototype._triggerCallback = function () {
        if (this._callback) {
            this._callback();
        }
    };
    TitleControl.prototype.hide = function () {
        this.isHidden = true;
        this.view.hide();
    };
    TitleControl.prototype.show = function () {
        this.isHidden = false;
        this.view.show();
    };
    TitleControl.prototype.destroy = function () {
        this.view.destroy();
        delete this.view;
        delete this.isHidden;
    };
    TitleControl.moduleName = 'title';
    TitleControl.View = title_view_1.default;
    TitleControl.dependencies = ['config', 'theme'];
    tslib_1.__decorate([
        player_api_decorator_1.default()
    ], TitleControl.prototype, "setTitle", null);
    tslib_1.__decorate([
        player_api_decorator_1.default()
    ], TitleControl.prototype, "setTitleClickCallback", null);
    return TitleControl;
}());
exports.default = TitleControl;


/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var view_1 = tslib_1.__importDefault(__webpack_require__(10));
var templates_1 = __webpack_require__(176);
var htmlToElement_1 = tslib_1.__importDefault(__webpack_require__(6));
var getElementByHook_1 = tslib_1.__importDefault(__webpack_require__(11));
var toggleNodeClass_1 = tslib_1.__importDefault(__webpack_require__(17));
var title_theme_1 = tslib_1.__importDefault(__webpack_require__(178));
var title_scss_1 = tslib_1.__importDefault(__webpack_require__(179));
var TitleView = /** @class */ (function (_super) {
    tslib_1.__extends(TitleView, _super);
    function TitleView(config) {
        var _this = this;
        var callbacks = config.callbacks, theme = config.theme;
        _this = _super.call(this, theme) || this;
        _this._callbacks = callbacks;
        _this._initDOM();
        _this._bindEvents();
        return _this;
    }
    TitleView.prototype._initDOM = function () {
        this._$node = htmlToElement_1.default(templates_1.titleTemplate({ styles: this.styleNames, themeStyles: this.themeStyles }));
        this._$title = getElementByHook_1.default(this._$node, 'video-title');
    };
    TitleView.prototype._bindEvents = function () {
        this._$title.addEventListener('click', this._callbacks.onClick);
    };
    TitleView.prototype._unbindEvents = function () {
        this._$title.removeEventListener('click', this._callbacks.onClick);
    };
    TitleView.prototype.setDisplayAsLink = function (flag) {
        toggleNodeClass_1.default(this._$title, this.styleNames.link, flag);
    };
    TitleView.prototype.setTitle = function (title) {
        // TODO: mb move this logic to controller? title.isHidden is out of control of this method
        // TODO: what if we call with empty value `.setTitle('')` and then call `.show()` method? Mb clear value anyway?
        if (title) {
            this.show();
            this._$title.innerHTML = title;
        }
        else {
            this.hide();
        }
    };
    TitleView.prototype.show = function () {
        this._$node.classList.remove(this.styleNames.hidden);
    };
    TitleView.prototype.hide = function () {
        this._$node.classList.add(this.styleNames.hidden);
    };
    TitleView.prototype.getNode = function () {
        return this._$node;
    };
    TitleView.prototype.destroy = function () {
        this._unbindEvents();
        if (this._$node.parentNode) {
            this._$node.parentNode.removeChild(this._$node);
        }
        delete this._$node;
        delete this._$title;
    };
    return TitleView;
}(view_1.default));
TitleView.setTheme(title_theme_1.default);
TitleView.extendStyleNames(title_scss_1.default);
exports.default = TitleView;


/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var title_dot_1 = __webpack_require__(177);
exports.titleTemplate = title_dot_1.default;


/***/ }),
/* 177 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = anonymous;
function anonymous(props
/*``*/) {
var out='<div> <div class="'+(props.styles.title)+' '+(props.themeStyles.titleText)+'" data-hook="video-title"></div></div>';return out;
}

/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    titleText: {
        color: function (data) { return data.color; },
    },
};


/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(180);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"singleton":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(8)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--9-1!../../../../node_modules/postcss-loader/lib/index.js??ref--9-2!../../../../node_modules/sass-loader/lib/loader.js??ref--9-3!./title.scss", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js??ref--9-1!../../../../node_modules/postcss-loader/lib/index.js??ref--9-2!../../../../node_modules/sass-loader/lib/loader.js??ref--9-3!./title.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(false);
// imports


// module
exports.push([module.i, "._1j-33{display:-webkit-box;display:-ms-flexbox;display:flex;padding:0;cursor:pointer;-webkit-transition-duration:.2s;transition-duration:.2s;-webkit-transition-property:opacity;transition-property:opacity;opacity:1;border:0;border-radius:0;outline:none;background-color:transparent;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center}._1j-33:hover{opacity:.7}._2Z2j_{visibility:hidden!important;width:0!important;min-width:0!important;height:0!important;min-height:0!important;margin:0!important;padding:0!important;opacity:0!important}._2kWrc{font-size:16px;line-height:17px;overflow:hidden;white-space:nowrap;text-overflow:ellipsis}div[data-hook=player-container][data-max-width~=\"550px\"] ._2kWrc{font-size:14px;line-height:15px}div[data-hook=player-container][data-max-width~=\"300px\"] ._2kWrc{font-size:12px;line-height:13px}div[data-hook=player-container][data-in-full-screen=true] ._2kWrc{font-size:20px;line-height:20px}._2kWrc._1lhrh{cursor:pointer}", ""]);

// exports
exports.locals = {
	"controlButton": "_1j-33",
	"hidden": "_2Z2j_",
	"title": "_2kWrc",
	"link": "_1lhrh"
};

/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
}
Object.defineProperty(exports, "__esModule", { value: true });
var live_indicator_view_1 = __importDefault(__webpack_require__(182));
var constants_1 = __webpack_require__(2);
var LiveIndicator = /** @class */ (function () {
    function LiveIndicator(_a) {
        var engine = _a.engine, eventEmitter = _a.eventEmitter, textMap = _a.textMap, tooltipService = _a.tooltipService;
        this._isHidden = true;
        this._isActive = false;
        this._isEnded = false;
        this._engine = engine;
        this._eventEmitter = eventEmitter;
        this._textMap = textMap;
        this._tooltipService = tooltipService;
        this._bindCallbacks();
        this._initUI();
        this._bindEvents();
    }
    Object.defineProperty(LiveIndicator.prototype, "node", {
        get: function () {
            return this.view.getNode();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LiveIndicator.prototype, "isHidden", {
        get: function () {
            return this._isHidden;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LiveIndicator.prototype, "isActive", {
        get: function () {
            return this._isActive;
        },
        enumerable: true,
        configurable: true
    });
    LiveIndicator.prototype.show = function () {
        this._toggle(true);
    };
    LiveIndicator.prototype.hide = function () {
        this._toggle(false);
    };
    LiveIndicator.prototype._initUI = function () {
        this.view = new LiveIndicator.View({
            callbacks: {
                onClick: this._syncWithLive,
            },
            textMap: this._textMap,
            tooltipService: this._tooltipService,
        });
    };
    LiveIndicator.prototype._bindCallbacks = function () {
        this._syncWithLive = this._syncWithLive.bind(this);
    };
    LiveIndicator.prototype._bindEvents = function () {
        this._eventEmitter.on(constants_1.VIDEO_EVENTS.LIVE_STATE_CHANGED, this._processStateChange, this);
    };
    LiveIndicator.prototype._unbindEvents = function () {
        this._eventEmitter.off(constants_1.VIDEO_EVENTS.LIVE_STATE_CHANGED, this._processStateChange, this);
    };
    LiveIndicator.prototype._processStateChange = function (_a) {
        var nextState = _a.nextState;
        switch (nextState) {
            case constants_1.LiveState.NONE:
                this._toggle(false);
                this._toggleActive(false);
                this._toggleEnded(false);
                break;
            case constants_1.LiveState.INITIAL:
                this._toggle(true);
                break;
            case constants_1.LiveState.SYNC:
                this._toggleActive(true);
                break;
            case constants_1.LiveState.NOT_SYNC:
                this._toggleActive(false);
                break;
            case constants_1.LiveState.ENDED:
                this._toggleActive(false);
                this._toggleEnded(true);
                break;
            default:
                break;
        }
    };
    LiveIndicator.prototype._syncWithLive = function () {
        if (!this._isEnded) {
            this._engine.syncWithLive();
        }
    };
    LiveIndicator.prototype._toggle = function (shouldShow) {
        this._isHidden = !shouldShow;
        this.view.toggle(shouldShow);
    };
    LiveIndicator.prototype._toggleActive = function (shouldActivate) {
        this._isActive = shouldActivate;
        this.view.toggleActive(shouldActivate);
    };
    LiveIndicator.prototype._toggleEnded = function (isEnded) {
        this._isEnded = isEnded;
        this.view.toggleEnded(isEnded);
    };
    LiveIndicator.prototype.destroy = function () {
        this._unbindEvents();
        this.view.destroy();
        delete this.view;
        delete this._engine;
        delete this._eventEmitter;
        delete this._textMap;
    };
    LiveIndicator.moduleName = 'liveIndicator';
    LiveIndicator.View = live_indicator_view_1.default;
    LiveIndicator.dependencies = ['engine', 'eventEmitter', 'textMap', 'tooltipService'];
    return LiveIndicator;
}());
exports.default = LiveIndicator;


/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var view_1 = tslib_1.__importDefault(__webpack_require__(10));
var templates_1 = __webpack_require__(183);
var htmlToElement_1 = tslib_1.__importDefault(__webpack_require__(6));
var getElementByHook_1 = tslib_1.__importDefault(__webpack_require__(11));
var toggleNodeClass_1 = tslib_1.__importDefault(__webpack_require__(17));
var live_indicator_scss_1 = tslib_1.__importDefault(__webpack_require__(185));
var constants_1 = __webpack_require__(2);
var LiveIndicatorView = /** @class */ (function (_super) {
    tslib_1.__extends(LiveIndicatorView, _super);
    function LiveIndicatorView(config) {
        var _this = _super.call(this) || this;
        _this._callbacks = config.callbacks;
        _this._textMap = config.textMap;
        _this._tooltipService = config.tooltipService;
        _this._initDOM();
        _this._bindEvents();
        return _this;
    }
    LiveIndicatorView.prototype._initDOM = function () {
        this._$node = htmlToElement_1.default(templates_1.liveIndicatorTemplate({
            styles: this.styleNames,
            themeStyles: this.themeStyles,
            texts: {},
        }));
        this._$liveIndicatorText = getElementByHook_1.default(this._$node, 'live-indicator-text');
        this._tooltipReference = this._tooltipService.createReference(this._$node, {
            text: this._textMap.get(constants_1.TEXT_LABELS.LIVE_SYNC_TOOLTIP),
        });
        // NOTE: LIVE indicator is hidden and inactive by default
        this.toggle(false);
        this.toggleActive(false);
        this.toggleEnded(false);
    };
    LiveIndicatorView.prototype._bindEvents = function () {
        this._$node.addEventListener('click', this._callbacks.onClick);
    };
    LiveIndicatorView.prototype._unbindEvents = function () {
        this._$node.removeEventListener('click', this._callbacks.onClick);
    };
    LiveIndicatorView.prototype.toggleActive = function (shouldActivate) {
        toggleNodeClass_1.default(this._$node, this.styleNames.active, shouldActivate);
    };
    LiveIndicatorView.prototype.toggleEnded = function (isEnded) {
        toggleNodeClass_1.default(this._$node, this.styleNames.ended, isEnded);
        this._$liveIndicatorText.innerText = this._textMap.get(constants_1.TEXT_LABELS.LIVE_INDICATOR_TEXT, { isEnded: isEnded });
        this._$liveIndicatorText.setAttribute('aria-label', !isEnded ? this._textMap.get(constants_1.TEXT_LABELS.LIVE_SYNC_LABEL) : '');
        if (isEnded) {
            this._tooltipReference.disable();
        }
        else {
            this._tooltipReference.enable();
        }
    };
    LiveIndicatorView.prototype.show = function () {
        this.toggle(true);
    };
    LiveIndicatorView.prototype.hide = function () {
        this.toggle(false);
    };
    LiveIndicatorView.prototype.toggle = function (shouldShow) {
        toggleNodeClass_1.default(this._$node, this.styleNames.hidden, !shouldShow);
    };
    LiveIndicatorView.prototype.getNode = function () {
        return this._$node;
    };
    LiveIndicatorView.prototype.destroy = function () {
        this._unbindEvents();
        this._tooltipReference.destroy();
        if (this._$node.parentNode) {
            this._$node.parentNode.removeChild(this._$node);
        }
        delete this._$node;
        delete this._$liveIndicatorText;
        delete this._callbacks;
        delete this._textMap;
    };
    return LiveIndicatorView;
}(view_1.default));
LiveIndicatorView.extendStyleNames(live_indicator_scss_1.default);
exports.default = LiveIndicatorView;


/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var live_indicator_dot_1 = __webpack_require__(184);
exports.liveIndicatorTemplate = live_indicator_dot_1.default;


/***/ }),
/* 184 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = anonymous;
function anonymous(props
/*``*/) {
var out='<div class="'+(props.styles.liveIndicator)+' '+(props.styles.hidden)+'"> <span class="'+(props.styles.liveIndicatorText)+'" aria-label="'+(props.texts.label || '')+'" data-hook="live-indicator-text"> '+(props.texts.text || '')+' </span></div>';return out;
}

/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(186);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"singleton":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(8)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--9-1!../../../../node_modules/postcss-loader/lib/index.js??ref--9-2!../../../../node_modules/sass-loader/lib/loader.js??ref--9-3!./live-indicator.scss", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js??ref--9-1!../../../../node_modules/postcss-loader/lib/index.js??ref--9-2!../../../../node_modules/sass-loader/lib/loader.js??ref--9-3!./live-indicator.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(false);
// imports


// module
exports.push([module.i, ".pK9Pr{display:-webkit-box;display:-ms-flexbox;display:flex;padding:0;cursor:pointer;-webkit-transition-duration:.2s;transition-duration:.2s;-webkit-transition-property:opacity;transition-property:opacity;opacity:1;border:0;border-radius:0;outline:none;background-color:transparent;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.pK9Pr:hover{opacity:.7}._2ctl5{visibility:hidden!important;width:0!important;min-width:0!important;height:0!important;min-height:0!important;margin:0!important;padding:0!important;opacity:0!important}._1PK0H{position:relative;margin-right:15px;padding:5px 6px;cursor:pointer;-webkit-transition:background-color .2s;transition:background-color .2s;color:#fff;background-color:#959595}div[data-hook=player-container][data-in-full-screen=true] ._1PK0H{margin-right:20px}div[data-hook=player-container][data-max-width~=\"550px\"] ._1PK0H{margin-right:10px}div[data-hook=player-container][data-max-width~=\"280px\"] ._1PK0H{margin-right:10px;padding:2px 3px}._1PK0H.nLCXk{cursor:default}._1PK0H._1yK8x,._1PK0H:hover:not(.nLCXk){background-color:#ea492e}._2j4WZ{font-size:12px;line-height:14px;text-transform:uppercase}div[data-hook=player-container][data-max-width~=\"280px\"] ._2j4WZ{font-size:10px;line-height:12px}", ""]);

// exports
exports.locals = {
	"controlButton": "pK9Pr",
	"hidden": "_2ctl5",
	"liveIndicator": "_1PK0H",
	"ended": "nLCXk",
	"active": "_1yK8x",
	"liveIndicatorText": "_2j4WZ"
};

/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var player_api_decorator_1 = tslib_1.__importDefault(__webpack_require__(12));
var bottom_block_view_1 = tslib_1.__importDefault(__webpack_require__(188));
var BottomBlock = /** @class */ (function () {
    function BottomBlock(dependencies) {
        this._isBlockFocused = false;
        this.isHidden = false;
        var config = dependencies.config, screen = dependencies.screen;
        this._screen = screen;
        this._bindViewCallbacks();
        this._initUI(this._getElementsNodes(dependencies));
        this._initLogo(config.logo);
    }
    BottomBlock.prototype._getElementsNodes = function (dependencies) {
        var playControl = dependencies.playControl, progressControl = dependencies.progressControl, timeControl = dependencies.timeControl, volumeControl = dependencies.volumeControl, fullScreenControl = dependencies.fullScreenControl, logo = dependencies.logo;
        return {
            play: playControl.node,
            progress: progressControl.node,
            time: timeControl.node,
            volume: volumeControl.node,
            fullScreen: fullScreenControl.node,
            logo: logo.node,
        };
    };
    Object.defineProperty(BottomBlock.prototype, "node", {
        get: function () {
            return this.view.getNode();
        },
        enumerable: true,
        configurable: true
    });
    BottomBlock.prototype._initUI = function (elementNodes) {
        var config = {
            elements: elementNodes,
            callbacks: {
                onBlockMouseMove: this._setFocusState,
                onBlockMouseOut: this._removeFocusState,
            },
        };
        this.view = new BottomBlock.View(config);
    };
    BottomBlock.prototype._initLogo = function (logoConfig) {
        if (logoConfig) {
            if (typeof logoConfig === 'object') {
                this.setLogoAlwaysShowFlag(logoConfig.showAlways);
            }
        }
        else {
            this.hideLogo();
        }
    };
    BottomBlock.prototype._bindViewCallbacks = function () {
        this._setFocusState = this._setFocusState.bind(this);
        this._removeFocusState = this._removeFocusState.bind(this);
    };
    BottomBlock.prototype._setFocusState = function () {
        this._isBlockFocused = true;
    };
    BottomBlock.prototype._removeFocusState = function () {
        this._isBlockFocused = false;
    };
    Object.defineProperty(BottomBlock.prototype, "isFocused", {
        get: function () {
            return this._isBlockFocused;
        },
        enumerable: true,
        configurable: true
    });
    BottomBlock.prototype.showContent = function () {
        this._screen.showBottomShadow();
        this.view.showContent();
    };
    BottomBlock.prototype.hideContent = function () {
        this._screen.hideBottomShadow();
        this.view.hideContent();
    };
    BottomBlock.prototype.hide = function () {
        this.isHidden = true;
        this.view.hide();
    };
    BottomBlock.prototype.show = function () {
        this.isHidden = false;
        this.view.show();
    };
    /**
     * Method for allowing logo to be always shown in bottom block
     * @param flag - `true` for showing always
     * @example
     * player.setLogoAlwaysShowFlag(true);
     *
     */
    BottomBlock.prototype.setLogoAlwaysShowFlag = function (flag) {
        this.view.setShouldLogoShowAlwaysFlag(flag);
    };
    /**
     * Method for hidding logo. If you use `setLogoAlwaysShowFlag` or `setControlsShouldAlwaysShow`, logo would automaticaly appear.
     * @example
     * player.hideLogo();
     */
    BottomBlock.prototype.hideLogo = function () {
        this.view.hideLogo();
    };
    BottomBlock.prototype.destroy = function () {
        this.view.destroy();
        delete this.view;
        delete this._screen;
    };
    BottomBlock.moduleName = 'bottomBlock';
    BottomBlock.View = bottom_block_view_1.default;
    BottomBlock.dependencies = [
        'config',
        'screen',
        'playControl',
        'progressControl',
        'timeControl',
        'volumeControl',
        'fullScreenControl',
        'logo',
    ];
    tslib_1.__decorate([
        player_api_decorator_1.default()
    ], BottomBlock.prototype, "setLogoAlwaysShowFlag", null);
    tslib_1.__decorate([
        player_api_decorator_1.default()
    ], BottomBlock.prototype, "hideLogo", null);
    return BottomBlock;
}());
exports.default = BottomBlock;


/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var view_1 = tslib_1.__importDefault(__webpack_require__(10));
var htmlToElement_1 = tslib_1.__importDefault(__webpack_require__(6));
var getElementByHook_1 = tslib_1.__importDefault(__webpack_require__(11));
var toggleNodeClass_1 = tslib_1.__importDefault(__webpack_require__(17));
var templates_1 = __webpack_require__(189);
var bottom_block_scss_1 = tslib_1.__importDefault(__webpack_require__(191));
var BottomBlockView = /** @class */ (function (_super) {
    tslib_1.__extends(BottomBlockView, _super);
    function BottomBlockView(config) {
        var _this = _super.call(this) || this;
        var callbacks = config.callbacks, elements = config.elements;
        _this._callbacks = callbacks;
        _this._initDOM(elements);
        _this._bindEvents();
        return _this;
    }
    BottomBlockView.prototype._initDOM = function (elements) {
        this._$node = htmlToElement_1.default(templates_1.bottomBlockTemplate({
            styles: this.styleNames,
        }));
        var $playContainer = getElementByHook_1.default(this._$node, 'play-container');
        var $volumeContainer = getElementByHook_1.default(this._$node, 'volume-container');
        var $timeContainer = getElementByHook_1.default(this._$node, 'time-container');
        var $fullScreenContainer = getElementByHook_1.default(this._$node, 'full-screen-container');
        var $logoContainer = getElementByHook_1.default(this._$node, 'logo-container');
        var $progressBarContainer = getElementByHook_1.default(this._$node, 'progress-bar-container');
        $playContainer.appendChild(elements.play);
        $volumeContainer.appendChild(elements.volume);
        $timeContainer.appendChild(elements.time);
        $fullScreenContainer.appendChild(elements.fullScreen);
        $logoContainer.appendChild(elements.logo);
        $progressBarContainer.appendChild(elements.progress);
    };
    BottomBlockView.prototype._preventClickPropagation = function (e) {
        e.stopPropagation();
    };
    BottomBlockView.prototype._bindEvents = function () {
        this._$node.addEventListener('click', this._preventClickPropagation);
        this._$node.addEventListener('mousemove', this._callbacks.onBlockMouseMove);
        this._$node.addEventListener('mouseleave', this._callbacks.onBlockMouseOut);
    };
    BottomBlockView.prototype._unbindEvents = function () {
        this._$node.removeEventListener('click', this._preventClickPropagation);
        this._$node.removeEventListener('mousemove', this._callbacks.onBlockMouseMove);
        this._$node.removeEventListener('mouseleave', this._callbacks.onBlockMouseOut);
    };
    BottomBlockView.prototype.setShouldLogoShowAlwaysFlag = function (isShowAlways) {
        toggleNodeClass_1.default(this._$node, this.styleNames.showLogoAlways, isShowAlways);
        this._$node.classList.remove(this.styleNames.logoHidden);
    };
    BottomBlockView.prototype.hideLogo = function () {
        this._$node.classList.add(this.styleNames.logoHidden);
    };
    BottomBlockView.prototype.show = function () {
        this._$node.classList.remove(this.styleNames.hidden);
    };
    BottomBlockView.prototype.hide = function () {
        this._$node.classList.add(this.styleNames.hidden);
    };
    BottomBlockView.prototype.getNode = function () {
        return this._$node;
    };
    BottomBlockView.prototype.showContent = function () {
        this._$node.classList.add(this.styleNames.activated);
    };
    BottomBlockView.prototype.hideContent = function () {
        this._$node.classList.remove(this.styleNames.activated);
    };
    BottomBlockView.prototype.destroy = function () {
        this._unbindEvents();
        if (this._$node.parentNode) {
            this._$node.parentNode.removeChild(this._$node);
        }
        delete this._$node;
    };
    return BottomBlockView;
}(view_1.default));
BottomBlockView.extendStyleNames(bottom_block_scss_1.default);
exports.default = BottomBlockView;


/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var bottom_block_dot_1 = __webpack_require__(190);
exports.bottomBlockTemplate = bottom_block_dot_1.default;


/***/ }),
/* 190 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = anonymous;
function anonymous(props
/*``*/) {
var out='<div data-hook="bottom-block" class="'+(props.styles.bottomBlock)+'"> <div class="'+(props.styles.progressBarContainer)+'" data-hook="progress-bar-container"> </div> <div class="'+(props.styles.elementsContainer)+'"> <div class="'+(props.styles.controlsContainerLeft)+'" data-hook="controls-container-left"> <div class="'+(props.styles.playContainer)+'" data-hook="play-container"> </div> <div class="'+(props.styles.volumeContainer)+'" data-hook="volume-container"> </div> <div class="'+(props.styles.timeContainer)+'" data-hook="time-container"> </div> </div> <div class="'+(props.styles.controlsContainerRight)+'" data-hook="controls-container-right"> <div class="'+(props.styles.fullScreenContainer)+'" data-hook="full-screen-container"> </div> </div> <div class="'+(props.styles.logoContainer)+'" data-hook="logo-container"> </div> </div></div>';return out;
}

/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(192);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"singleton":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(8)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--9-1!../../../../node_modules/postcss-loader/lib/index.js??ref--9-2!../../../../node_modules/sass-loader/lib/loader.js??ref--9-3!./bottom-block.scss", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js??ref--9-1!../../../../node_modules/postcss-loader/lib/index.js??ref--9-2!../../../../node_modules/sass-loader/lib/loader.js??ref--9-3!./bottom-block.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(false);
// imports


// module
exports.push([module.i, "._2YPR9{display:-webkit-box;display:-ms-flexbox;display:flex;padding:0;cursor:pointer;-webkit-transition-duration:.2s;transition-duration:.2s;-webkit-transition-property:opacity;transition-property:opacity;opacity:1;border:0;border-radius:0;outline:none;background-color:transparent;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center}._2YPR9:hover{opacity:.7}._2Cj7y{visibility:hidden!important;width:0!important;min-width:0!important;height:0!important;min-height:0!important;margin:0!important;padding:0!important;opacity:0!important}._1P1pP{z-index:60;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}._1P1pP::-moz-focus-inner{border:0}._1P1pP._1k9ny ._1DOeD,._1P1pP._1k9ny ._1EpsK,._1P1pP._1k9ny ._12S4N,._1P1pP._1k9ny .SCHHb,._1P1pP._1RXHz ._1EpsK,._1P1pP._3ILvj ._1DOeD,._1P1pP._3ILvj ._1EpsK,._1P1pP._3ILvj ._12S4N,._1P1pP._3ILvj .SCHHb{opacity:1}._1P1pP.eTtXe ._1EpsK{display:none}.BjAFQ{display:-webkit-box;display:-ms-flexbox;display:flex;width:100%;-webkit-box-flex:2;-ms-flex-positive:2;flex-grow:2}._1DOeD{position:relative;top:2px;padding:0 20px}div[data-hook=player-container][data-in-full-screen=true] ._1DOeD{top:3px;padding:0 30px}div[data-hook=player-container][data-max-width~=\"550px\"] ._1DOeD{padding:0 15px}div[data-hook=player-container][data-max-width~=\"280px\"] ._1DOeD{padding:0 12px}._1DOeD,._1EpsK,._12S4N,.SCHHb{-webkit-transition:opacity .2s,visibility .2s;transition:opacity .2s,visibility .2s;opacity:0}._12S4N,.SCHHb{position:relative;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-flex:1;-ms-flex:1;flex:1;width:100%;max-width:100%;-webkit-box-align:center;-ms-flex-align:center;align-items:center}._12S4N{-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end}._1EpsK,._12S4N,.SCHHb{height:54px}div[data-hook=player-container][data-in-full-screen=true] ._1EpsK,div[data-hook=player-container][data-in-full-screen=true] ._12S4N,div[data-hook=player-container][data-in-full-screen=true] .SCHHb{height:80px}div[data-hook=player-container][data-max-width~=\"550px\"] ._1EpsK,div[data-hook=player-container][data-max-width~=\"550px\"] ._12S4N,div[data-hook=player-container][data-max-width~=\"550px\"] .SCHHb{height:42px}div[data-hook=player-container][data-max-width~=\"350px\"] ._1EpsK,div[data-hook=player-container][data-max-width~=\"350px\"] ._12S4N,div[data-hook=player-container][data-max-width~=\"350px\"] .SCHHb{height:36px}._2H8hr{margin-right:9px;margin-left:13px}div[data-hook=player-container][data-in-full-screen=true] ._2H8hr{margin-right:20px;margin-left:20px}div[data-hook=player-container][data-max-width~=\"550px\"] ._2H8hr{margin-left:7px}div[data-hook=player-container][data-max-width~=\"280px\"] ._2H8hr{margin-left:4px}._1RDJ6{margin-right:15px}div[data-hook=player-container][data-in-full-screen=true] ._1RDJ6{margin-right:20px}._2VCoz{margin-right:18px}div[data-hook=player-container][data-in-full-screen=true] ._2VCoz{margin-right:30px}div[data-hook=player-container][data-max-width~=\"400px\"] ._2VCoz{display:none}._3Krux{margin-right:14px;margin-left:5px}div[data-hook=player-container][data-max-width~=\"550px\"] ._3Krux{margin-right:7px}div[data-hook=player-container][data-in-full-screen=true] ._3Krux{margin-right:25px;margin-left:0}._1EpsK{display:-webkit-box;display:-ms-flexbox;display:flex;margin-right:20px}div[data-hook=player-container][data-max-width~=\"550px\"] ._1EpsK{margin-right:15px;margin-left:1px}div[data-hook=player-container][data-in-full-screen=true] ._1EpsK{margin-right:30px;margin-left:0}div[data-hook=player-container][data-max-width~=\"280px\"] ._1EpsK{margin-right:12px}", ""]);

// exports
exports.locals = {
	"controlButton": "_2YPR9",
	"hidden": "_2Cj7y",
	"bottomBlock": "_1P1pP",
	"activated": "_3ILvj",
	"progressBarContainer": "_1DOeD",
	"controlsContainerLeft": "SCHHb",
	"controlsContainerRight": "_12S4N",
	"logoContainer": "_1EpsK",
	"focus-within": "_1k9ny",
	"focusWithin": "_1k9ny",
	"showLogoAlways": "_1RXHz",
	"logoHidden": "eTtXe",
	"elementsContainer": "BjAFQ",
	"playContainer": "_2H8hr",
	"volumeContainer": "_1RDJ6",
	"timeContainer": "_2VCoz",
	"fullScreenContainer": "_3Krux"
};

/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var progress_view_1 = tslib_1.__importDefault(__webpack_require__(194));
var video_data_1 = __webpack_require__(25);
var index_1 = __webpack_require__(2);
var keyboard_control_1 = __webpack_require__(33);
var keyboard_interceptor_1 = tslib_1.__importDefault(__webpack_require__(14));
var player_api_decorator_1 = tslib_1.__importDefault(__webpack_require__(12));
var UPDATE_INTERVAL_DELAY = 1000 / 60;
var ProgressControl = /** @class */ (function () {
    function ProgressControl(_a) {
        var engine = _a.engine, liveStateEngine = _a.liveStateEngine, eventEmitter = _a.eventEmitter, textMap = _a.textMap, tooltipService = _a.tooltipService, theme = _a.theme;
        this._engine = engine;
        this._liveStateEngine = liveStateEngine;
        this._eventEmitter = eventEmitter;
        this._textMap = textMap;
        this._tooltipService = tooltipService;
        this._isUserInteracting = false;
        this._currentProgress = 0;
        this._theme = theme;
        this._timeIndicatorsToAdd = [];
        this._bindCallbacks();
        this._initUI();
        this._bindEvents();
        this.view.setPlayed(0);
        this.view.setBuffered(0);
        this._initInterceptor();
    }
    Object.defineProperty(ProgressControl.prototype, "node", {
        get: function () {
            return this.view.getNode();
        },
        enumerable: true,
        configurable: true
    });
    ProgressControl.prototype._bindEvents = function () {
        this._eventEmitter.on(index_1.VIDEO_EVENTS.STATE_CHANGED, this._processStateChange, this);
        this._eventEmitter.on(index_1.VIDEO_EVENTS.LIVE_STATE_CHANGED, this._processLiveStateChange, this);
        this._eventEmitter.on(index_1.VIDEO_EVENTS.CHUNK_LOADED, this._updateBufferIndicator, this);
        this._eventEmitter.on(index_1.VIDEO_EVENTS.DURATION_UPDATED, this._updateAllIndicators, this);
    };
    ProgressControl.prototype._initUI = function () {
        var config = {
            callbacks: {
                onSyncWithLiveClick: this._syncWithLive,
                onChangePlayedProgress: this._changePlayedProgress,
                onSeekToByMouseStart: this._onSeekToByMouseStart,
                onSeekToByMouseEnd: this._onSeekToByMouseEnd,
                onDragStart: this._onUserInteractionStarts,
                onDragEnd: this._onUserInteractionEnds,
            },
            theme: this._theme,
            textMap: this._textMap,
            tooltipService: this._tooltipService,
        };
        this.view = new ProgressControl.View(config);
    };
    ProgressControl.prototype._initInterceptor = function () {
        var _this = this;
        this._interceptor = new keyboard_interceptor_1.default({
            node: this.view.getNode(),
            callbacks: (_a = {},
                _a[keyboard_interceptor_1.KEYCODES.UP_ARROW] = function (e) {
                    e.stopPropagation();
                    e.preventDefault();
                    _this._eventEmitter.emit(index_1.UI_EVENTS.KEYBOARD_KEYDOWN_INTERCEPTED);
                    _this._eventEmitter.emit(index_1.UI_EVENTS.GO_FORWARD_WITH_KEYBOARD_TRIGGERED);
                    _this._engine.goForward(keyboard_control_1.AMOUNT_TO_SKIP_SECONDS);
                },
                _a[keyboard_interceptor_1.KEYCODES.DOWN_ARROW] = function (e) {
                    e.stopPropagation();
                    e.preventDefault();
                    _this._eventEmitter.emit(index_1.UI_EVENTS.KEYBOARD_KEYDOWN_INTERCEPTED);
                    _this._eventEmitter.emit(index_1.UI_EVENTS.GO_BACKWARD_WITH_KEYBOARD_TRIGGERED);
                    _this._engine.goBackward(keyboard_control_1.AMOUNT_TO_SKIP_SECONDS);
                },
                _a[keyboard_interceptor_1.KEYCODES.RIGHT_ARROW] = function (e) {
                    e.stopPropagation();
                    e.preventDefault();
                    _this._eventEmitter.emit(index_1.UI_EVENTS.KEYBOARD_KEYDOWN_INTERCEPTED);
                    _this._eventEmitter.emit(index_1.UI_EVENTS.GO_FORWARD_WITH_KEYBOARD_TRIGGERED);
                    _this._engine.goForward(keyboard_control_1.AMOUNT_TO_SKIP_SECONDS);
                },
                _a[keyboard_interceptor_1.KEYCODES.LEFT_ARROW] = function (e) {
                    e.stopPropagation();
                    e.preventDefault();
                    _this._eventEmitter.emit(index_1.UI_EVENTS.KEYBOARD_KEYDOWN_INTERCEPTED);
                    _this._eventEmitter.emit(index_1.UI_EVENTS.GO_BACKWARD_WITH_KEYBOARD_TRIGGERED);
                    _this._engine.goBackward(keyboard_control_1.AMOUNT_TO_SKIP_SECONDS);
                },
                _a),
        });
        var _a;
    };
    ProgressControl.prototype._destroyInterceptor = function () {
        this._interceptor.destroy();
    };
    ProgressControl.prototype._bindCallbacks = function () {
        this._syncWithLive = this._syncWithLive.bind(this);
        this._updateControlOnInterval = this._updateControlOnInterval.bind(this);
        this._changePlayedProgress = this._changePlayedProgress.bind(this);
        this._onSeekToByMouseStart = this._onSeekToByMouseStart.bind(this);
        this._onSeekToByMouseEnd = this._onSeekToByMouseEnd.bind(this);
        this._onUserInteractionStarts = this._onUserInteractionStarts.bind(this);
        this._onUserInteractionEnds = this._onUserInteractionEnds.bind(this);
        this._processStateChange = this._processStateChange.bind(this);
        this._playVideoOnProgressManipulationEnd = this._playVideoOnProgressManipulationEnd.bind(this);
    };
    ProgressControl.prototype._changePlayedProgress = function (value) {
        if (this._currentProgress === value) {
            return;
        }
        this._currentProgress = value;
        this._changeCurrentTimeOfVideo(this._currentProgress / 100);
    };
    ProgressControl.prototype._startIntervalUpdates = function () {
        if (this._updateControlInterval) {
            this._stopIntervalUpdates();
        }
        this._updateControlOnInterval();
        this._updateControlInterval = setInterval(this._updateControlOnInterval, UPDATE_INTERVAL_DELAY);
    };
    ProgressControl.prototype._onSeekToByMouseStart = function (percent) {
        var durationTime = this._engine.getDurationTime();
        var seekTime = durationTime * percent / 100;
        var time = this._engine.isDynamicContent
            ? seekTime - durationTime
            : seekTime;
        this.view.showProgressTimeTooltip({ time: time, percent: percent });
    };
    ProgressControl.prototype._onSeekToByMouseEnd = function () {
        this.view.hideProgressTimeTooltip();
    };
    ProgressControl.prototype._stopIntervalUpdates = function () {
        clearInterval(this._updateControlInterval);
        this._updateControlInterval = false;
    };
    ProgressControl.prototype._onUserInteractionStarts = function () {
        if (!this._isUserInteracting) {
            this._isUserInteracting = true;
            this._pauseVideoOnProgressManipulationStart();
        }
        this._eventEmitter.emit(index_1.UI_EVENTS.CONTROL_DRAG_START);
    };
    ProgressControl.prototype._onUserInteractionEnds = function () {
        if (this._isUserInteracting) {
            this._isUserInteracting = false;
            this._playVideoOnProgressManipulationEnd();
        }
        this._eventEmitter.emit(index_1.UI_EVENTS.CONTROL_DRAG_END);
    };
    ProgressControl.prototype._updateControlOnInterval = function () {
        this._updatePlayedIndicator();
        this._updateBufferIndicator();
    };
    ProgressControl.prototype._processStateChange = function (_a) {
        var nextState = _a.nextState;
        switch (nextState) {
            case index_1.STATES.SRC_SET:
                this.reset();
                break;
            case index_1.STATES.METADATA_LOADED:
                this._initTimeIndicators();
                if (this._engine.isSeekAvailable) {
                    this.show();
                }
                else {
                    this.hide();
                }
                break;
            case index_1.STATES.PLAYING:
                if (this._liveStateEngine.getState() === index_1.LiveState.SYNC) {
                    this.view.setPlayed(100);
                }
                else {
                    this._startIntervalUpdates();
                }
                break;
            case index_1.STATES.SEEK_IN_PROGRESS:
                this._updatePlayedIndicator();
                this._updateBufferIndicator();
                break;
            default:
                this._stopIntervalUpdates();
                break;
        }
    };
    ProgressControl.prototype._processLiveStateChange = function (_a) {
        var nextState = _a.nextState;
        switch (nextState) {
            case index_1.LiveState.NONE:
                this.view.setLiveSyncStatus(false);
                this.view.setUsualMode();
                break;
            case index_1.LiveState.INITIAL:
                this.view.setLiveMode();
                break;
            case index_1.LiveState.SYNC:
                this.view.setLiveSyncStatus(true);
                break;
            case index_1.LiveState.NOT_SYNC:
                this.view.setLiveSyncStatus(false);
                break;
            case index_1.LiveState.ENDED:
                this.view.setLiveSyncStatus(false);
                this.view.hideSyncWithLive();
                // ensure progress indicators show latest info
                if (this._engine.getCurrentState() === index_1.STATES.PLAYING) {
                    this._startIntervalUpdates();
                }
                else {
                    this._updatePlayedIndicator();
                    this._updateBufferIndicator();
                }
                break;
            default:
                break;
        }
    };
    ProgressControl.prototype._changeCurrentTimeOfVideo = function (percent) {
        var duration = this._engine.getDurationTime();
        this._engine.setCurrentTime(duration * percent);
        this._eventEmitter.emit(index_1.UI_EVENTS.PROGRESS_CHANGE_TRIGGERED, percent);
    };
    ProgressControl.prototype._pauseVideoOnProgressManipulationStart = function () {
        var currentState = this._engine.getCurrentState();
        if (currentState === index_1.STATES.PLAYING ||
            currentState === index_1.STATES.PLAY_REQUESTED) {
            this._shouldPlayAfterManipulationEnd = true;
            this._engine.pause();
        }
        this._eventEmitter.emit(index_1.UI_EVENTS.PROGRESS_MANIPULATION_STARTED);
    };
    ProgressControl.prototype._playVideoOnProgressManipulationEnd = function () {
        if (this._shouldPlayAfterManipulationEnd) {
            this._engine.play();
            this._shouldPlayAfterManipulationEnd = false;
        }
        this._eventEmitter.emit(index_1.UI_EVENTS.PROGRESS_MANIPULATION_ENDED);
    };
    ProgressControl.prototype._updateBufferIndicator = function () {
        var currentTime = this._engine.getCurrentTime();
        var buffered = this._engine.getBuffered();
        var duration = this._engine.getDurationTime();
        this.updateBuffered(video_data_1.getOverallBufferedPercent(buffered, currentTime, duration));
    };
    ProgressControl.prototype._updatePlayedIndicator = function () {
        if (this._liveStateEngine.getState() === index_1.LiveState.SYNC) {
            // TODO: mb use this.updatePlayed(100) here?
            return;
        }
        var currentTime = this._engine.getCurrentTime();
        var duration = this._engine.getDurationTime();
        this.updatePlayed(video_data_1.getOverallPlayedPercent(currentTime, duration));
    };
    ProgressControl.prototype._updateAllIndicators = function () {
        this._updatePlayedIndicator();
        this._updateBufferIndicator();
    };
    ProgressControl.prototype._initTimeIndicators = function () {
        var _this = this;
        this._timeIndicatorsToAdd.forEach(function (time) {
            _this._addTimeIndicator(time);
        });
        this._timeIndicatorsToAdd = [];
    };
    ProgressControl.prototype._addTimeIndicator = function (time) {
        var durationTime = this._engine.getDurationTime();
        if (time > durationTime) {
            // TODO: log error for developers
            return;
        }
        this.view.addTimeIndicator(video_data_1.getTimePercent(time, durationTime));
    };
    ProgressControl.prototype._syncWithLive = function () {
        this._engine.syncWithLive();
    };
    /**
     * Add time indicator to progress bar
     */
    ProgressControl.prototype.addTimeIndicator = function (time) {
        this.addTimeIndicators([time]);
    };
    /**
     * Add time indicators to progress bar
     */
    ProgressControl.prototype.addTimeIndicators = function (times) {
        var _this = this;
        if (!this._engine.isMetadataLoaded) {
            // NOTE: Add indicator after metadata loaded
            (_a = this._timeIndicatorsToAdd).push.apply(_a, times);
            return;
        }
        times.forEach(function (time) {
            _this._addTimeIndicator(time);
        });
        var _a;
    };
    /**
     * Delete all time indicators from progress bar
     */
    ProgressControl.prototype.clearTimeIndicators = function () {
        this.view.clearTimeIndicators();
    };
    ProgressControl.prototype.updatePlayed = function (percent) {
        this._currentProgress = percent;
        this.view.setPlayed(this._currentProgress);
    };
    ProgressControl.prototype.updateBuffered = function (percent) {
        this.view.setBuffered(percent);
    };
    ProgressControl.prototype.hide = function () {
        this.isHidden = true;
        this.view.hide();
    };
    ProgressControl.prototype.show = function () {
        this.isHidden = false;
        this.view.show();
    };
    ProgressControl.prototype._unbindEvents = function () {
        this._eventEmitter.off(index_1.VIDEO_EVENTS.DURATION_UPDATED, this._updateAllIndicators, this);
        this._eventEmitter.off(index_1.VIDEO_EVENTS.STATE_CHANGED, this._processStateChange, this);
        this._eventEmitter.off(index_1.VIDEO_EVENTS.LIVE_STATE_CHANGED, this._processLiveStateChange, this);
        this._eventEmitter.off(index_1.VIDEO_EVENTS.CHUNK_LOADED, this._updateBufferIndicator, this);
    };
    ProgressControl.prototype.reset = function () {
        this.updatePlayed(0);
        this.updateBuffered(0);
        this.clearTimeIndicators();
    };
    ProgressControl.prototype.destroy = function () {
        this._destroyInterceptor();
        this._stopIntervalUpdates();
        this._unbindEvents();
        this.view.destroy();
        delete this.view;
        delete this._eventEmitter;
        delete this._engine;
        delete this._liveStateEngine;
        delete this._timeIndicatorsToAdd;
    };
    ProgressControl.moduleName = 'progressControl';
    ProgressControl.View = progress_view_1.default;
    ProgressControl.dependencies = [
        'engine',
        'liveStateEngine',
        'eventEmitter',
        'textMap',
        'tooltipService',
        'theme',
    ];
    tslib_1.__decorate([
        player_api_decorator_1.default()
    ], ProgressControl.prototype, "addTimeIndicator", null);
    tslib_1.__decorate([
        player_api_decorator_1.default()
    ], ProgressControl.prototype, "addTimeIndicators", null);
    tslib_1.__decorate([
        player_api_decorator_1.default()
    ], ProgressControl.prototype, "clearTimeIndicators", null);
    return ProgressControl;
}());
exports.default = ProgressControl;


/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var index_1 = __webpack_require__(2);
var view_1 = tslib_1.__importDefault(__webpack_require__(10));
var formatTime_1 = tslib_1.__importDefault(__webpack_require__(43));
var getProgressTimeTooltipPosition_1 = tslib_1.__importDefault(__webpack_require__(195));
var templates_1 = __webpack_require__(205);
var htmlToElement_1 = tslib_1.__importDefault(__webpack_require__(6));
var getElementByHook_1 = tslib_1.__importDefault(__webpack_require__(11));
var progress_theme_1 = tslib_1.__importDefault(__webpack_require__(208));
var progress_scss_1 = tslib_1.__importDefault(__webpack_require__(209));
var DATA_PLAYED = 'data-played-percent';
var getPercentBasedOnXPosition = function (event, element) {
    var boundingRect = element.getBoundingClientRect();
    var positionX = event.clientX;
    if (positionX < boundingRect.left) {
        return 0;
    }
    if (positionX > boundingRect.left + boundingRect.width) {
        return 100;
    }
    return (event.clientX - boundingRect.left) / boundingRect.width * 100;
};
var ProgressView = /** @class */ (function (_super) {
    tslib_1.__extends(ProgressView, _super);
    function ProgressView(config) {
        var _this = this;
        var callbacks = config.callbacks, textMap = config.textMap, tooltipService = config.tooltipService, theme = config.theme;
        _this = _super.call(this, theme) || this;
        _this._callbacks = callbacks;
        _this._textMap = textMap;
        _this._tooltipService = tooltipService;
        _this._initDOM();
        _this._bindCallbacks();
        _this._bindEvents();
        _this._setPlayedDOMAttributes(0);
        _this._setBufferedDOMAttributes(0);
        _this.setUsualMode();
        return _this;
    }
    ProgressView.prototype._initDOM = function () {
        this._$node = htmlToElement_1.default(templates_1.progressTemplate({
            styles: this.styleNames,
            themeStyles: this.themeStyles,
        }));
        this._$played = getElementByHook_1.default(this._$node, 'progress-played');
        this._$buffered = getElementByHook_1.default(this._$node, 'progress-buffered');
        this._$seekTo = getElementByHook_1.default(this._$node, 'progress-seek-to');
        this._$timeIndicators = getElementByHook_1.default(this._$node, 'progress-time-indicators');
        this._$syncButton = getElementByHook_1.default(this._$node, 'progress-sync-button');
        this._syncButtonTooltipReference = this._tooltipService.createReference(this._$syncButton, {
            text: this._textMap.get(index_1.TEXT_LABELS.LIVE_SYNC_TOOLTIP),
        });
        this._$hitbox = getElementByHook_1.default(this._$node, 'progress-hitbox');
    };
    ProgressView.prototype._bindCallbacks = function () {
        this._setPlayedByDrag = this._setPlayedByDrag.bind(this);
        this._startDragOnMouseDown = this._startDragOnMouseDown.bind(this);
        this._stopDragOnMouseUp = this._stopDragOnMouseUp.bind(this);
        this._startSeekToByMouse = this._startSeekToByMouse.bind(this);
        this._stopSeekToByMouse = this._stopSeekToByMouse.bind(this);
        this._syncWithLive = this._syncWithLive.bind(this);
    };
    ProgressView.prototype._bindEvents = function () {
        this._$hitbox.addEventListener('mousedown', this._startDragOnMouseDown);
        this._$hitbox.addEventListener('mousemove', this._startSeekToByMouse);
        this._$hitbox.addEventListener('mouseout', this._stopSeekToByMouse);
        window.addEventListener('mousemove', this._setPlayedByDrag);
        window.addEventListener('mouseup', this._stopDragOnMouseUp);
        this._$syncButton.addEventListener('click', this._syncWithLive);
    };
    ProgressView.prototype._unbindEvents = function () {
        this._$hitbox.removeEventListener('mousedown', this._startDragOnMouseDown);
        this._$hitbox.removeEventListener('mousemove', this._startSeekToByMouse);
        this._$hitbox.removeEventListener('mouseout', this._stopSeekToByMouse);
        this._$syncButton.removeEventListener('click', this._syncWithLive);
        window.removeEventListener('mousemove', this._setPlayedByDrag);
        window.removeEventListener('mouseup', this._stopDragOnMouseUp);
    };
    ProgressView.prototype._startDragOnMouseDown = function (event) {
        if (event.button > 1) {
            return;
        }
        var percent = getPercentBasedOnXPosition(event, this._$hitbox);
        this._setPlayedDOMAttributes(percent);
        this._callbacks.onChangePlayedProgress(percent);
        this._startDrag();
    };
    ProgressView.prototype._stopDragOnMouseUp = function (event) {
        if (event.button > 1) {
            return;
        }
        this._stopDrag();
    };
    ProgressView.prototype._startSeekToByMouse = function (event) {
        var percent = getPercentBasedOnXPosition(event, this._$hitbox);
        this._setSeekToDOMAttributes(percent);
        this._callbacks.onSeekToByMouseStart(percent);
    };
    ProgressView.prototype._stopSeekToByMouse = function () {
        this._setSeekToDOMAttributes(0);
        this._callbacks.onSeekToByMouseEnd();
    };
    ProgressView.prototype._setPlayedByDrag = function (event) {
        if (this._isDragging) {
            var percent = getPercentBasedOnXPosition(event, this._$hitbox);
            this._setPlayedDOMAttributes(percent);
            this._callbacks.onChangePlayedProgress(percent);
        }
    };
    ProgressView.prototype._startDrag = function () {
        this._isDragging = true;
        this._callbacks.onDragStart();
        this._$node.classList.add(this.styleNames.isDragging);
    };
    ProgressView.prototype._stopDrag = function () {
        if (this._isDragging) {
            this._isDragging = false;
            this._callbacks.onDragEnd();
            this._$node.classList.remove(this.styleNames.isDragging);
        }
    };
    ProgressView.prototype._setSeekToDOMAttributes = function (percent) {
        this._$seekTo.setAttribute('style', "width:" + percent + "%;");
    };
    ProgressView.prototype._setPlayedDOMAttributes = function (percent) {
        this._$node.setAttribute('aria-valuetext', this._textMap.get(index_1.TEXT_LABELS.PROGRESS_CONTROL_VALUE, { percent: percent }));
        this._$node.setAttribute('aria-valuenow', String(percent));
        this._$node.setAttribute(DATA_PLAYED, String(percent));
        this._$played.setAttribute('style', "width:" + percent + "%;");
    };
    ProgressView.prototype._setBufferedDOMAttributes = function (percent) {
        this._$buffered.setAttribute('style', "width:" + percent + "%;");
    };
    ProgressView.prototype._syncWithLive = function () {
        this._callbacks.onSyncWithLiveClick();
    };
    ProgressView.prototype.showSyncWithLive = function () {
        this._$syncButton.classList.remove(this.styleNames.hidden);
    };
    ProgressView.prototype.hideSyncWithLive = function () {
        this._$syncButton.classList.add(this.styleNames.hidden);
    };
    ProgressView.prototype.setLiveSyncStatus = function (isSync) {
        if (isSync) {
            this._$syncButton.classList.add(this.styleNames.liveSync);
            this._$played.setAttribute('style', "width:100%;");
        }
        else {
            this._$syncButton.classList.remove(this.styleNames.liveSync);
        }
    };
    ProgressView.prototype.showProgressTimeTooltip = function (_a) {
        var _this = this;
        var time = _a.time, percent = _a.percent;
        this._tooltipService.show({
            text: formatTime_1.default(time),
            position: function (tooltipContainerNode) {
                return getProgressTimeTooltipPosition_1.default(percent, _this._$hitbox, tooltipContainerNode);
            },
        });
    };
    ProgressView.prototype.hideProgressTimeTooltip = function () {
        this._tooltipService.hide();
    };
    ProgressView.prototype.setLiveMode = function () {
        this._$node.classList.add(this.styleNames.inLive);
        this.showSyncWithLive();
    };
    ProgressView.prototype.setUsualMode = function () {
        this._$node.classList.remove(this.styleNames.inLive);
        this.hideSyncWithLive();
    };
    ProgressView.prototype.setPlayed = function (percent) {
        this._setPlayedDOMAttributes(percent);
    };
    ProgressView.prototype.setBuffered = function (percent) {
        this._setBufferedDOMAttributes(percent);
    };
    ProgressView.prototype.addTimeIndicator = function (percent) {
        this._$timeIndicators.appendChild(htmlToElement_1.default(templates_1.progressTimeIndicatorTemplate({
            percent: percent,
            styles: this.styleNames,
        })));
    };
    ProgressView.prototype.clearTimeIndicators = function () {
        this._$timeIndicators.innerHTML = '';
    };
    ProgressView.prototype.hide = function () {
        this._$node.classList.add(this.styleNames.hidden);
    };
    ProgressView.prototype.show = function () {
        this._$node.classList.remove(this.styleNames.hidden);
    };
    ProgressView.prototype.getNode = function () {
        return this._$node;
    };
    ProgressView.prototype.destroy = function () {
        this._unbindEvents();
        this._syncButtonTooltipReference.destroy();
        if (this._$node.parentNode) {
            this._$node.parentNode.removeChild(this._$node);
        }
        delete this._$node;
        delete this._$buffered;
        delete this._$hitbox;
        delete this._$played;
        delete this._$seekTo;
        delete this._$syncButton;
        delete this._$timeIndicators;
        delete this._textMap;
    };
    return ProgressView;
}(view_1.default));
ProgressView.setTheme(progress_theme_1.default);
ProgressView.extendStyleNames(progress_scss_1.default);
exports.default = ProgressView;


/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tooltip_1 = __webpack_require__(34);
function calcProgressTimeTooltipCenterX(progressPercent, progressNodeOffsetX, progressNodeWidth) {
    return progressNodeOffsetX + progressPercent * progressNodeWidth / 100;
}
function getProgressTimeTooltipPosition(progressPercent, progressNode, tooltipContainerNode) {
    return tooltip_1.getTooltipPositionByReferenceNode(progressNode, tooltipContainerNode, function (progressNodeOffsetX, progressNodeWidth) {
        return calcProgressTimeTooltipCenterX(progressPercent, progressNodeOffsetX, progressNodeWidth);
    });
}
exports.default = getProgressTimeTooltipPosition;


/***/ }),
/* 196 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = anonymous;
function anonymous(props
/*``*/) {
var out='<div class="'+(props.styles.tooltip)+'" role="tooltip"> <div class="'+(props.styles.tooltipInner)+'" data-hook="tooltipInner"></div></div>';return out;
}

/***/ }),
/* 197 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = anonymous;
function anonymous(props
/*``*/) {
var out='<div class="'+(props.styles.tooltipContainer)+'"></div>';return out;
}

/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(199);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"singleton":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(8)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--9-1!../../../../../node_modules/postcss-loader/lib/index.js??ref--9-2!../../../../../node_modules/sass-loader/lib/loader.js??ref--9-3!./tooltip.scss", function() {
			var newContent = require("!!../../../../../node_modules/css-loader/index.js??ref--9-1!../../../../../node_modules/postcss-loader/lib/index.js??ref--9-2!../../../../../node_modules/sass-loader/lib/loader.js??ref--9-3!./tooltip.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(false);
// imports


// module
exports.push([module.i, "._3x9ae{display:-webkit-box;display:-ms-flexbox;display:flex;padding:0;cursor:pointer;-webkit-transition-duration:.2s;transition-duration:.2s;-webkit-transition-property:opacity;transition-property:opacity;opacity:1;border:0;border-radius:0;outline:none;background-color:transparent;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center}._3x9ae:hover{opacity:.7}._1BxFu{visibility:hidden!important;width:0!important;min-width:0!important;height:0!important;min-height:0!important;margin:0!important;padding:0!important;opacity:0!important}._3FL-1{position:absolute;z-index:100;visibility:hidden;padding:4px 5px;-webkit-transition:opacity .2s,visibility .2s;transition:opacity .2s,visibility .2s;opacity:0;background:rgba(0,0,0,.5)}._3FL-1.mX8z8{visibility:visible;opacity:1}._2K3zA{font-size:11px;line-height:12px;white-space:nowrap;color:#fff}", ""]);

// exports
exports.locals = {
	"controlButton": "_3x9ae",
	"hidden": "_1BxFu",
	"tooltip": "_3FL-1",
	"tooltipVisible": "mX8z8",
	"tooltipInner": "_2K3zA"
};

/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var tooltip_reference_1 = tslib_1.__importDefault(__webpack_require__(201));
var tooltip_container_1 = tslib_1.__importDefault(__webpack_require__(202));
var tooltip_1 = tslib_1.__importDefault(__webpack_require__(44));
var TooltipService = /** @class */ (function () {
    function TooltipService() {
        this._tooltip = new tooltip_1.default();
        this._tooltipContainer = new tooltip_container_1.default(this._tooltip);
    }
    Object.defineProperty(TooltipService.prototype, "isHidden", {
        get: function () {
            return this._tooltip.isHidden;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TooltipService.prototype, "tooltipContainerNode", {
        get: function () {
            return this._tooltipContainer.node;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Set new tooltip title
     */
    TooltipService.prototype.setText = function (text) {
        this._tooltip.setText(text);
    };
    /**
     * Show tooltip with title
     */
    TooltipService.prototype.show = function (options) {
        // NOTE: its important to set tooltip text before update tooltip position styles
        this._tooltip.setText(options.text);
        this._tooltip.setStyle(this._tooltipContainer.getTooltipPositionStyles(options.position));
        this._tooltip.show();
    };
    /**
     * Hide tooltip
     */
    TooltipService.prototype.hide = function () {
        this._tooltip.hide();
    };
    /**
     * Create tooltip reference which show/hide tooltip on hover and focus events
     * @param reference - reference node
     * @param options - tooltip title and other options
     * @returns tooltip reference instance
     */
    TooltipService.prototype.createReference = function (reference, options) {
        return new tooltip_reference_1.default(reference, this, options);
    };
    TooltipService.prototype.destroy = function () {
        this._tooltip.destroy();
        this._tooltipContainer.destroy();
        this._tooltip = null;
        this._tooltipContainer = null;
    };
    TooltipService.moduleName = 'tooltipService';
    return TooltipService;
}());
exports.default = TooltipService;


/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var getTooltipPositionByReferenceNode_1 = tslib_1.__importDefault(__webpack_require__(46));
var SHOW_EVENTS = ['mouseenter', 'focus'];
var HIDE_EVENTS = ['mouseleave', 'blur'];
var TooltipReference = /** @class */ (function () {
    function TooltipReference(reference, tooltipService, options) {
        this._$reference = reference;
        this._options = options;
        this._tooltipService = tooltipService;
        this._eventListeners = [];
        this._bindEvents();
    }
    TooltipReference.prototype._bindEvents = function () {
        var _this = this;
        SHOW_EVENTS.forEach(function (event) {
            var fn = function () {
                _this.show();
            };
            _this._eventListeners.push({ event: event, fn: fn });
            _this._$reference.addEventListener(event, fn);
        });
        HIDE_EVENTS.forEach(function (event) {
            var fn = function () {
                _this.hide();
            };
            _this._eventListeners.push({ event: event, fn: fn });
            _this._$reference.addEventListener(event, fn);
        });
    };
    Object.defineProperty(TooltipReference.prototype, "isHidden", {
        get: function () {
            return this._tooltipService.isHidden;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TooltipReference.prototype, "isDisabled", {
        get: function () {
            return this._isDisabled;
        },
        enumerable: true,
        configurable: true
    });
    TooltipReference.prototype.show = function () {
        if (this._isDisabled) {
            return;
        }
        this._tooltipService.show({
            text: this._options.text,
            position: getTooltipPositionByReferenceNode_1.default(this._$reference, this._tooltipService.tooltipContainerNode),
        });
    };
    TooltipReference.prototype.hide = function () {
        this._tooltipService.hide();
    };
    TooltipReference.prototype.setText = function (text) {
        this._options.text = text;
        this._tooltipService.setText(text);
    };
    TooltipReference.prototype.disable = function () {
        this._isDisabled = true;
    };
    TooltipReference.prototype.enable = function () {
        this._isDisabled = false;
    };
    TooltipReference.prototype.destroy = function () {
        var _this = this;
        this._eventListeners.forEach(function (_a) {
            var event = _a.event, fn = _a.fn;
            _this._$reference.removeEventListener(event, fn);
        });
        this._eventListeners = null;
        this._$reference = null;
        this._tooltipService = null;
        this._options = null;
    };
    return TooltipReference;
}());
exports.default = TooltipReference;


/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var templates_1 = __webpack_require__(45);
var htmlToElement_1 = tslib_1.__importDefault(__webpack_require__(6));
var stylable_1 = tslib_1.__importDefault(__webpack_require__(31));
var types_1 = __webpack_require__(47);
var tooltip_container_scss_1 = tslib_1.__importDefault(__webpack_require__(203));
var TooltipContainer = /** @class */ (function (_super) {
    tslib_1.__extends(TooltipContainer, _super);
    function TooltipContainer(tooltip) {
        var _this = _super.call(this) || this;
        _this._tooltip = tooltip;
        _this._initDOM();
        return _this;
    }
    Object.defineProperty(TooltipContainer.prototype, "node", {
        get: function () {
            return this._$node;
        },
        enumerable: true,
        configurable: true
    });
    TooltipContainer.prototype._initDOM = function () {
        this._$node = htmlToElement_1.default(templates_1.tooltipContainerTemplate({
            styles: this.styleNames,
        }));
        this._$node.appendChild(this._tooltip.node);
    };
    TooltipContainer.prototype.getTooltipPositionStyles = function (position) {
        if (typeof position === 'function') {
            position = position(this._$node);
        }
        if (position.placement === types_1.ITooltipPositionPlacement.TOP) {
            return {
                left: this._getTooltipLeftX(position.x) + "px",
                top: 0,
                bottom: 'initial',
            };
        }
        return {
            left: this._getTooltipLeftX(position.x) + "px",
            top: 'initial',
            bottom: 0,
        };
    };
    TooltipContainer.prototype.destroy = function () {
        this._tooltip = null;
        this._$node = null;
    };
    TooltipContainer.prototype._getTooltipLeftX = function (tooltipCenterX) {
        var tooltipRect = this._tooltip.node.getBoundingClientRect();
        var tooltipContainerRect = this._$node.getBoundingClientRect();
        var tooltipLeftX = tooltipCenterX - tooltipRect.width / 2;
        // ensure `x` is in range of placeholder rect
        tooltipLeftX = Math.max(tooltipLeftX, 0);
        tooltipLeftX = Math.min(tooltipLeftX, tooltipContainerRect.width - tooltipRect.width);
        return tooltipLeftX;
    };
    return TooltipContainer;
}(stylable_1.default));
TooltipContainer.extendStyleNames(tooltip_container_scss_1.default);
exports.default = TooltipContainer;


/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(204);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"singleton":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(8)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--9-1!../../../../../node_modules/postcss-loader/lib/index.js??ref--9-2!../../../../../node_modules/sass-loader/lib/loader.js??ref--9-3!./tooltip-container.scss", function() {
			var newContent = require("!!../../../../../node_modules/css-loader/index.js??ref--9-1!../../../../../node_modules/postcss-loader/lib/index.js??ref--9-2!../../../../../node_modules/sass-loader/lib/loader.js??ref--9-3!./tooltip-container.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(false);
// imports


// module
exports.push([module.i, "._3KsGD{position:absolute;top:0;right:0;bottom:0;left:0;display:-webkit-box;display:-ms-flexbox;display:flex;margin:10px 10px 6px}", ""]);

// exports
exports.locals = {
	"tooltipContainer": "_3KsGD"
};

/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var progress_dot_1 = __webpack_require__(206);
exports.progressTemplate = progress_dot_1.default;
var progressTimeIndicator_dot_1 = __webpack_require__(207);
exports.progressTimeIndicatorTemplate = progressTimeIndicator_dot_1.default;


/***/ }),
/* 206 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = anonymous;
function anonymous(props
/*``*/) {
var out='<div data-hook="progress-control" class="'+(props.styles.seekBlock)+'" tabindex="0"> <div class="'+(props.styles.progressBarsWrapper)+'"> <div class="'+(props.styles.progressBar)+' '+(props.styles.background)+' '+(props.themeStyles.progressBackground)+'"> </div> <div data-hook="progress-buffered" class="'+(props.styles.progressBar)+' '+(props.styles.buffered)+'"> </div> <div data-hook="progress-seek-to" class="'+(props.styles.progressBar)+' '+(props.styles.seekTo)+' '+(props.themeStyles.progressSeekTo)+'"> </div> <div data-hook="progress-played" class="'+(props.styles.progressBar)+' '+(props.styles.played)+' '+(props.themeStyles.progressPlayed)+'"> </div> <div data-hook="progress-time-indicators" class="'+(props.styles.timeIndicators)+'"> </div> </div> <div data-hook="progress-hitbox" class="'+(props.styles.hitbox)+'"> </div> <div data-hook="progress-sync-button" class="'+(props.styles.syncButton)+' '+(props.themeStyles.progressSyncBtn)+'"> </div></div>';return out;
}

/***/ }),
/* 207 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = anonymous;
function anonymous(props
/*``*/) {
var out='<div class="'+(props.styles.timeIndicator)+'" style="left: '+(props.percent)+'%"></div>';return out;
}

/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var theme_1 = __webpack_require__(32);
exports.default = {
    progressPlayed: {
        backgroundColor: function (data) { return data.progressColor; },
        '&:after': {
            backgroundColor: function (data) { return data.progressColor; },
        },
    },
    progressSeekTo: {
        backgroundColor: function (data) { return theme_1.transperentizeColor(data.progressColor, 0.5); },
    },
    progressBackground: {
        backgroundColor: function (data) { return theme_1.transperentizeColor(data.progressColor, 0.25); },
    },
    progressSyncBtn: {
        borderColor: function (data) { return data.progressColor; },
    },
};


/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(210);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"singleton":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(8)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--9-1!../../../../../node_modules/postcss-loader/lib/index.js??ref--9-2!../../../../../node_modules/sass-loader/lib/loader.js??ref--9-3!./progress.scss", function() {
			var newContent = require("!!../../../../../node_modules/css-loader/index.js??ref--9-1!../../../../../node_modules/postcss-loader/lib/index.js??ref--9-2!../../../../../node_modules/sass-loader/lib/loader.js??ref--9-3!./progress.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(false);
// imports


// module
exports.push([module.i, "._2D8BW{display:-webkit-box;display:-ms-flexbox;display:flex;padding:0;cursor:pointer;-webkit-transition-duration:.2s;transition-duration:.2s;-webkit-transition-property:opacity;transition-property:opacity;opacity:1;border:0;border-radius:0;outline:none;background-color:transparent;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center}._2D8BW:hover{opacity:.7}._35E0p{visibility:hidden!important;width:0!important;min-width:0!important;height:0!important;min-height:0!important;margin:0!important;padding:0!important;opacity:0!important}._3gL_1{position:relative;display:block;width:100%;height:6px;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;-webkit-transition:opacity .2s,visibility .2s;transition:opacity .2s,visibility .2s;-ms-touch-action:none;touch-action:none}div[data-hook=player-container][data-in-full-screen=true] ._3gL_1{height:8px}._3gL_1._2VoEB ._22wmo{background-color:#ea492e}._3gL_1._2VoEB ._2vct2{background-color:rgba(234,73,46,.5)}._3gL_1._2VoEB ._1snAn{display:initial}._3gL_1.kwE6m ._3cZzd,._3gL_1:hover ._3cZzd,div[data-hook=player-container][data-in-full-screen=true] ._3gL_1.kwE6m ._3cZzd,div[data-hook=player-container][data-in-full-screen=true] ._3gL_1:hover ._3cZzd{-webkit-transform:scaleY(1);transform:scaleY(1)}._3gL_1.kwE6m ._3cZzd ._2vct2,._3gL_1:hover ._3cZzd ._2vct2{opacity:1}._3gL_1.kwE6m ._3cZzd ._1MVG7:after,._3gL_1.kwE6m ._3cZzd ._22wmo:after,._3gL_1:hover ._3cZzd ._1MVG7:after,._3gL_1:hover ._3cZzd ._22wmo:after{-webkit-transform:scale(1);transform:scale(1)}._3gL_1.kwE6m ._1snAn,._3gL_1:hover ._1snAn{top:-4px;right:-7px;width:8px;height:8px;border-width:3px;border-color:#fff;background-color:#ea492e}div[data-hook=player-container][data-in-full-screen=true] ._3gL_1.kwE6m ._1snAn,div[data-hook=player-container][data-in-full-screen=true] ._3gL_1:hover ._1snAn{top:-4px;right:-8px;width:10px;height:10px}._3gL_1.kwE6m ._1snAn._34KIR,._3gL_1:hover ._1snAn._34KIR{background-color:#fff}._1snAn{position:absolute;z-index:6;top:-2px;right:-5px;display:none;width:6px;height:6px;cursor:pointer;-webkit-transition:width .1s cubic-bezier(0,0,.2,1),height .1s cubic-bezier(0,0,.2,1);transition:width .1s cubic-bezier(0,0,.2,1),height .1s cubic-bezier(0,0,.2,1);border:2px solid #bababa;border-radius:50%;background-color:#9e1110}div[data-hook=player-container][data-in-full-screen=true] ._1snAn{top:-2px;right:-6px;width:8px;height:8px}._1snAn:hover{background-color:#fff}._1snAn._35E0p{display:none}._3cZzd{height:6px;-webkit-transition:-webkit-transform .1s cubic-bezier(0,0,.2,1);transition:-webkit-transform .1s cubic-bezier(0,0,.2,1);transition:transform .1s cubic-bezier(0,0,.2,1);transition:transform .1s cubic-bezier(0,0,.2,1),-webkit-transform .1s cubic-bezier(0,0,.2,1);-webkit-transform:scaleY(.34);transform:scaleY(.34)}div[data-hook=player-container][data-in-full-screen=true] ._3cZzd{height:8px;-webkit-transform:scaleY(.25);transform:scaleY(.25)}._2smMm{position:absolute;height:6px;padding:0}div[data-hook=player-container][data-in-full-screen=true] ._2smMm{height:8px}._22wmo,._22wmo:after{background-color:#fff}._22wmo:after{position:absolute;top:-3px;right:-6px;width:12px;height:12px;content:\"\";-webkit-transition:-webkit-transform .1s cubic-bezier(0,0,.2,1);transition:-webkit-transform .1s cubic-bezier(0,0,.2,1);transition:transform .1s cubic-bezier(0,0,.2,1);transition:transform .1s cubic-bezier(0,0,.2,1),-webkit-transform .1s cubic-bezier(0,0,.2,1);-webkit-transform:scale(0);transform:scale(0);border-radius:50%}div[data-hook=player-container][data-in-full-screen=true] ._22wmo:after{top:-4px;right:-8px;width:16px;height:16px}._32YK9{-webkit-transition:width .2s ease;transition:width .2s ease;background-color:hsla(0,0%,100%,.25)}._1klPx{width:100%}._2vct2{-webkit-transition:opacity .2s;transition:opacity .2s;background-color:hsla(0,0%,100%,.5)}._1Dkmm{overflow-x:hidden;width:100%;height:100%;background-color:transparent}._1Dkmm,._1MVG7,._1MVG7:after{position:absolute}._1MVG7:after{right:-3px;width:6px;height:6px;content:\"\";-webkit-transition:-webkit-transform .1s cubic-bezier(0,0,.2,1);transition:-webkit-transform .1s cubic-bezier(0,0,.2,1);transition:transform .1s cubic-bezier(0,0,.2,1);transition:transform .1s cubic-bezier(0,0,.2,1),-webkit-transform .1s cubic-bezier(0,0,.2,1);-webkit-transform:scale(0);transform:scale(0);opacity:.6;border-radius:50%;background-color:#fff}div[data-hook=player-container][data-in-full-screen=true] ._1MVG7:after{right:-4px;width:8px;height:8px}._1MVG7:after:hover{opacity:1}.ZZ3V8{position:relative;z-index:5;top:-11px;display:block;width:100%;height:16px;cursor:pointer;opacity:0}[data-focus-source=key] [data-hook=progress-control].focus-within,[data-focus-source=script] [data-hook=progress-control].focus-within{opacity:1;-webkit-box-shadow:0 0 0 2px rgba(56,153,236,.8);box-shadow:0 0 0 2px rgba(56,153,236,.8)}", ""]);

// exports
exports.locals = {
	"controlButton": "_2D8BW",
	"hidden": "_35E0p",
	"seekBlock": "_3gL_1",
	"inLive": "_2VoEB",
	"played": "_22wmo",
	"seekTo": "_2vct2",
	"syncButton": "_1snAn",
	"progressBarsWrapper": "_3cZzd",
	"isDragging": "kwE6m",
	"timeIndicator": "_1MVG7",
	"liveSync": "_34KIR",
	"progressBar": "_2smMm",
	"buffered": "_32YK9",
	"background": "_1klPx",
	"timeIndicators": "_1Dkmm",
	"hitbox": "ZZ3V8"
};

/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
}
Object.defineProperty(exports, "__esModule", { value: true });
var play_view_1 = __importDefault(__webpack_require__(212));
var keyboard_interceptor_1 = __importDefault(__webpack_require__(14));
var index_1 = __webpack_require__(2);
var PlayControl = /** @class */ (function () {
    function PlayControl(_a) {
        var engine = _a.engine, eventEmitter = _a.eventEmitter, textMap = _a.textMap, theme = _a.theme;
        this._engine = engine;
        this._eventEmitter = eventEmitter;
        this._textMap = textMap;
        this._theme = theme;
        this._isPlaying = null;
        this._bindCallbacks();
        this._initUI();
        this._bindEvents();
        this.setControlStatus(false);
        this._initInterceptor();
    }
    Object.defineProperty(PlayControl.prototype, "node", {
        get: function () {
            return this.view.getNode();
        },
        enumerable: true,
        configurable: true
    });
    PlayControl.prototype._initInterceptor = function () {
        var _this = this;
        this._interceptor = new keyboard_interceptor_1.default({
            node: this.node,
            callbacks: (_a = {},
                _a[keyboard_interceptor_1.KEYCODES.SPACE_BAR] = function (e) {
                    e.stopPropagation();
                    _this._eventEmitter.emit(index_1.UI_EVENTS.TOGGLE_PLAYBACK_WITH_KEYBOARD_TRIGGERED);
                },
                _a[keyboard_interceptor_1.KEYCODES.ENTER] = function (e) {
                    e.stopPropagation();
                    _this._eventEmitter.emit(index_1.UI_EVENTS.TOGGLE_PLAYBACK_WITH_KEYBOARD_TRIGGERED);
                },
                _a),
        });
        var _a;
    };
    PlayControl.prototype._destroyInterceptor = function () {
        this._interceptor.destroy();
    };
    PlayControl.prototype._bindCallbacks = function () {
        this._togglePlayback = this._togglePlayback.bind(this);
    };
    PlayControl.prototype._bindEvents = function () {
        this._eventEmitter.on(index_1.VIDEO_EVENTS.STATE_CHANGED, this._updatePlayingStatus, this);
    };
    PlayControl.prototype._togglePlayback = function () {
        if (this._isPlaying) {
            this._pauseVideo();
        }
        else {
            this._playVideo();
        }
    };
    PlayControl.prototype._playVideo = function () {
        this._engine.play();
        this._eventEmitter.emit(index_1.UI_EVENTS.PLAY_TRIGGERED);
    };
    PlayControl.prototype._pauseVideo = function () {
        this._engine.pause();
        this._eventEmitter.emit(index_1.UI_EVENTS.PAUSE_TRIGGERED);
    };
    PlayControl.prototype._updatePlayingStatus = function (_a) {
        var nextState = _a.nextState;
        if (nextState === index_1.STATES.SRC_SET) {
            this.reset();
        }
        else if (nextState === index_1.STATES.PLAYING) {
            this.setControlStatus(true);
        }
        else if (nextState === index_1.STATES.PAUSED ||
            nextState === index_1.STATES.ENDED ||
            nextState === index_1.STATES.SEEK_IN_PROGRESS) {
            this.setControlStatus(false);
        }
    };
    PlayControl.prototype._initUI = function () {
        var config = {
            callbacks: {
                onButtonClick: this._togglePlayback,
            },
            theme: this._theme,
            textMap: this._textMap,
        };
        this.view = new PlayControl.View(config);
    };
    PlayControl.prototype.setControlStatus = function (isPlaying) {
        this._isPlaying = isPlaying;
        this.view.setState({ isPlaying: this._isPlaying });
    };
    PlayControl.prototype._unbindEvents = function () {
        this._eventEmitter.off(index_1.VIDEO_EVENTS.STATE_CHANGED, this._updatePlayingStatus, this);
    };
    PlayControl.prototype.reset = function () {
        this.setControlStatus(false);
    };
    PlayControl.prototype.destroy = function () {
        this._destroyInterceptor();
        this._unbindEvents();
        this.view.destroy();
        delete this.view;
        delete this._eventEmitter;
        delete this._engine;
        delete this._textMap;
    };
    PlayControl.moduleName = 'playControl';
    PlayControl.View = play_view_1.default;
    PlayControl.dependencies = ['engine', 'eventEmitter', 'textMap', 'theme'];
    return PlayControl;
}());
exports.default = PlayControl;


/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var index_1 = __webpack_require__(2);
var view_1 = tslib_1.__importDefault(__webpack_require__(10));
var templates_1 = __webpack_require__(213);
var htmlToElement_1 = tslib_1.__importDefault(__webpack_require__(6));
var getElementByHook_1 = tslib_1.__importDefault(__webpack_require__(11));
var play_theme_1 = tslib_1.__importDefault(__webpack_require__(217));
var play_scss_1 = tslib_1.__importDefault(__webpack_require__(218));
var DATA_IS_PLAYING = 'data-is-playing';
var PlayView = /** @class */ (function (_super) {
    tslib_1.__extends(PlayView, _super);
    function PlayView(config) {
        var _this = this;
        var callbacks = config.callbacks, textMap = config.textMap, theme = config.theme;
        _this = _super.call(this, theme) || this;
        _this._callbacks = callbacks;
        _this._textMap = textMap;
        _this._$node = htmlToElement_1.default(templates_1.controlTemplate({
            styles: _this.styleNames,
            texts: {
                label: _this._textMap.get(index_1.TEXT_LABELS.PLAY_CONTROL_LABEL),
            },
        }));
        _this._$playbackControl = getElementByHook_1.default(_this._$node, 'playback-control');
        _this.setState({ isPlaying: false });
        _this._bindEvents();
        return _this;
    }
    PlayView.prototype._bindEvents = function () {
        this._onButtonClick = this._onButtonClick.bind(this);
        this._$playbackControl.addEventListener('click', this._onButtonClick);
    };
    PlayView.prototype._unbindEvents = function () {
        this._$playbackControl.removeEventListener('click', this._onButtonClick);
    };
    PlayView.prototype._onButtonClick = function () {
        this._$playbackControl.focus();
        this._callbacks.onButtonClick();
    };
    PlayView.prototype.setState = function (_a) {
        var isPlaying = _a.isPlaying;
        if (isPlaying) {
            this._$playbackControl.classList.remove(this.styleNames.paused);
            this._$playbackControl.innerHTML = templates_1.pauseIconTemplate({
                styles: this.styleNames,
                themeStyles: this.themeStyles,
            });
            this._$playbackControl.setAttribute('aria-label', this._textMap.get(index_1.TEXT_LABELS.PAUSE_CONTROL_LABEL));
        }
        else {
            this._$playbackControl.classList.add(this.styleNames.paused);
            this._$playbackControl.innerHTML = templates_1.playIconTemplate({
                styles: this.styleNames,
                themeStyles: this.themeStyles,
            });
            this._$playbackControl.setAttribute('aria-label', this._textMap.get(index_1.TEXT_LABELS.PLAY_CONTROL_LABEL));
        }
        this._$node.setAttribute(DATA_IS_PLAYING, isPlaying);
    };
    PlayView.prototype.show = function () {
        this._$node.classList.remove(this.styleNames.hidden);
    };
    PlayView.prototype.hide = function () {
        this._$node.classList.add(this.styleNames.hidden);
    };
    PlayView.prototype.getNode = function () {
        return this._$node;
    };
    PlayView.prototype.destroy = function () {
        this._unbindEvents();
        if (this._$node.parentNode) {
            this._$node.parentNode.removeChild(this._$node);
        }
        delete this._$playbackControl;
        delete this._$node;
        delete this._textMap;
    };
    return PlayView;
}(view_1.default));
PlayView.setTheme(play_theme_1.default);
PlayView.extendStyleNames(play_scss_1.default);
exports.default = PlayView;


/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var playIcon_dot_1 = __webpack_require__(214);
exports.playIconTemplate = playIcon_dot_1.default;
var pauseIcon_dot_1 = __webpack_require__(215);
exports.pauseIconTemplate = pauseIcon_dot_1.default;
var control_dot_1 = __webpack_require__(216);
exports.controlTemplate = control_dot_1.default;


/***/ }),
/* 214 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = anonymous;
function anonymous(props
/*``*/) {
var out='<div class="'+(props.styles.icon)+'"> <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 11 14" preserveAspectRatio="xMidYMin slice" width="100%" style="padding-bottom: 127%; height: 1px; overflow: visible" > <!-- padding-bottom: 100% * height/width --> <path class="'+(props.themeStyles.playSvgFill)+'" d="M.079 0L0 14l10.5-7.181z"/> </svg></div>';return out;
}

/***/ }),
/* 215 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = anonymous;
function anonymous(props
/*``*/) {
var out='<div class="'+(props.styles.icon)+'"> <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 10 14" preserveAspectRatio="xMidYMin slice" width="100%" style="padding-bottom: 140%; height: 1px; overflow: visible" > <!-- padding-bottom: 100% * height/width --> <path class="'+(props.themeStyles.playSvgFill)+'" d="M7 0h3v14H7V0zM0 0h3v14H0V0z"/> </svg></div>';return out;
}

/***/ }),
/* 216 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = anonymous;
function anonymous(props
/*``*/) {
var out='<div class="'+(props.styles.playControl)+'" data-hook="playback-control" data-is-playing="false"> <button class="'+(props.styles.playbackToggle)+' '+(props.styles.controlButton)+'" data-hook="playback-control" aria-label="'+(props.texts.label)+'" type="button" tabindex="0"/></div>';return out;
}

/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    playSvgFill: {
        fill: function (data) { return data.color; },
    },
};


/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(219);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"singleton":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(8)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--9-1!../../../../../node_modules/postcss-loader/lib/index.js??ref--9-2!../../../../../node_modules/sass-loader/lib/loader.js??ref--9-3!./play.scss", function() {
			var newContent = require("!!../../../../../node_modules/css-loader/index.js??ref--9-1!../../../../../node_modules/postcss-loader/lib/index.js??ref--9-2!../../../../../node_modules/sass-loader/lib/loader.js??ref--9-3!./play.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(false);
// imports


// module
exports.push([module.i, "._39GzC{display:-webkit-box;display:-ms-flexbox;display:flex;padding:0;cursor:pointer;-webkit-transition-duration:.2s;transition-duration:.2s;-webkit-transition-property:opacity;transition-property:opacity;opacity:1;border:0;border-radius:0;outline:none;background-color:transparent;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center}._39GzC:hover{opacity:.7}._2OE2i{visibility:hidden!important;width:0!important;min-width:0!important;height:0!important;min-height:0!important;margin:0!important;padding:0!important;opacity:0!important}._1AzLj{position:relative;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-sizing:border-box;box-sizing:border-box;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start}._10GS8{width:26px;min-width:26px;height:26px;min-height:26px}div[data-hook=player-container][data-in-full-screen=true] ._10GS8{width:35px;min-width:35px;height:35px;min-height:35px;background-size:15px 21px}div[data-hook=player-container][data-in-full-screen=true] ._10GS8 ._3RZMI{width:15px;height:21px}div[data-hook=player-container][data-in-full-screen=true] ._10GS8._37hzC{background-size:16px 21px}._10GS8 ._3RZMI{width:11px;height:14px}", ""]);

// exports
exports.locals = {
	"controlButton": "_39GzC",
	"hidden": "_2OE2i",
	"playControl": "_1AzLj",
	"playbackToggle": "_10GS8",
	"icon": "_3RZMI",
	"paused": "_37hzC"
};

/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
}
Object.defineProperty(exports, "__esModule", { value: true });
var time_view_1 = __importDefault(__webpack_require__(221));
var index_1 = __webpack_require__(2);
var UPDATE_INTERVAL_DELAY = 1000 / 60;
var TimeControl = /** @class */ (function () {
    function TimeControl(_a) {
        var eventEmitter = _a.eventEmitter, engine = _a.engine, theme = _a.theme;
        this._eventEmitter = eventEmitter;
        this._engine = engine;
        this._theme = theme;
        this._bindCallbacks();
        this._initUI();
        this._bindEvents();
        this.setCurrentTime(0);
        this.setDurationTime(0);
    }
    Object.defineProperty(TimeControl.prototype, "node", {
        get: function () {
            return this.view.getNode();
        },
        enumerable: true,
        configurable: true
    });
    TimeControl.prototype._bindCallbacks = function () {
        this._updateCurrentTime = this._updateCurrentTime.bind(this);
        this._updateDurationTime = this._updateDurationTime.bind(this);
    };
    TimeControl.prototype._bindEvents = function () {
        this._eventEmitter.on(index_1.VIDEO_EVENTS.STATE_CHANGED, this._toggleIntervalUpdates, this);
        this._eventEmitter.on(index_1.VIDEO_EVENTS.DURATION_UPDATED, this._updateDurationTime, this);
    };
    TimeControl.prototype._initUI = function () {
        var config = {
            theme: this._theme,
        };
        this.view = new TimeControl.View(config);
    };
    TimeControl.prototype._startIntervalUpdates = function () {
        if (this._updateControlInterval) {
            this._stopIntervalUpdates();
        }
        this._updateControlInterval = setInterval(this._updateCurrentTime, UPDATE_INTERVAL_DELAY);
    };
    TimeControl.prototype._stopIntervalUpdates = function () {
        clearInterval(this._updateControlInterval);
        this._updateControlInterval = null;
    };
    TimeControl.prototype._toggleIntervalUpdates = function (_a) {
        var nextState = _a.nextState;
        switch (nextState) {
            case index_1.STATES.SRC_SET:
                this.reset();
                break;
            case index_1.STATES.METADATA_LOADED:
                if (this._engine.isSeekAvailable) {
                    if (this._engine.isDynamicContent) {
                        // TODO: is duration hidden when live ended?
                        this.view.hideDuration();
                    }
                }
                else {
                    this.hide();
                }
                break;
            case index_1.STATES.PLAYING:
                this._startIntervalUpdates();
                break;
            case index_1.STATES.SEEK_IN_PROGRESS:
                this._updateCurrentTime();
                break;
            default:
                this._stopIntervalUpdates();
                break;
        }
    };
    TimeControl.prototype._updateDurationTime = function () {
        this.setDurationTime(this._engine.getDurationTime());
    };
    TimeControl.prototype._updateCurrentTime = function () {
        if (this._engine.isDynamicContent) {
            // TODO: is it same for live ended?
            this.view.setCurrentTimeBackward(!this._engine.isSyncWithLive);
        }
        this.setCurrentTime(this._engine.getCurrentTime());
    };
    TimeControl.prototype.setDurationTime = function (time) {
        this.view.setDurationTime(time);
    };
    TimeControl.prototype.setCurrentTime = function (time) {
        this.view.setCurrentTime(time);
    };
    TimeControl.prototype.hide = function () {
        this.isHidden = true;
        this.view.hide();
    };
    TimeControl.prototype.show = function () {
        this.isHidden = false;
        this.view.show();
    };
    TimeControl.prototype.reset = function () {
        this.setDurationTime(0);
        this.setCurrentTime(0);
        this.view.showDuration();
        this.view.setCurrentTimeBackward(false);
        this.show();
    };
    TimeControl.prototype._unbindEvents = function () {
        this._eventEmitter.off(index_1.VIDEO_EVENTS.STATE_CHANGED, this._toggleIntervalUpdates, this);
        this._eventEmitter.off(index_1.VIDEO_EVENTS.DURATION_UPDATED, this._updateDurationTime, this);
    };
    TimeControl.prototype.destroy = function () {
        this._stopIntervalUpdates();
        this._unbindEvents();
        this.view.destroy();
        delete this.view;
        delete this._eventEmitter;
        delete this._engine;
        this.isHidden = null;
    };
    TimeControl.moduleName = 'timeControl';
    TimeControl.View = time_view_1.default;
    TimeControl.dependencies = ['engine', 'eventEmitter', 'theme'];
    return TimeControl;
}());
exports.default = TimeControl;


/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var view_1 = tslib_1.__importDefault(__webpack_require__(10));
var formatTime_1 = tslib_1.__importDefault(__webpack_require__(43));
var templates_1 = __webpack_require__(222);
var htmlToElement_1 = tslib_1.__importDefault(__webpack_require__(6));
var getElementByHook_1 = tslib_1.__importDefault(__webpack_require__(11));
var time_theme_1 = tslib_1.__importDefault(__webpack_require__(224));
var time_scss_1 = tslib_1.__importDefault(__webpack_require__(225));
var TimeView = /** @class */ (function (_super) {
    tslib_1.__extends(TimeView, _super);
    function TimeView(config) {
        var _this = this;
        var theme = config.theme;
        _this = _super.call(this, theme) || this;
        _this._initDOM();
        return _this;
    }
    TimeView.prototype._initDOM = function () {
        this._$node = htmlToElement_1.default(templates_1.timeTemplate({ styles: this.styleNames, themeStyles: this.themeStyles }));
        this._$currentTime = getElementByHook_1.default(this._$node, 'current-time-indicator');
        this._$durationTime = getElementByHook_1.default(this._$node, 'duration-time-indicator');
    };
    TimeView.prototype.setDurationTime = function (duration) {
        if (duration !== this._duration) {
            this._duration = duration;
            this._updateDurationTime();
        }
    };
    TimeView.prototype.setCurrentTime = function (current) {
        if (current !== this._current) {
            this._current = current;
            this._updateCurrentTime();
        }
    };
    TimeView.prototype.setCurrentTimeBackward = function (_isBackward) {
        this._isBackward = _isBackward;
        this._updateCurrentTime();
    };
    TimeView.prototype._updateDurationTime = function () {
        this._$durationTime.innerHTML = formatTime_1.default(this._duration);
    };
    TimeView.prototype._updateCurrentTime = function () {
        if (this._isBackward) {
            this._$currentTime.innerHTML = formatTime_1.default(this._current - this._duration);
        }
        else {
            this._$currentTime.innerHTML = formatTime_1.default(this._current);
        }
    };
    TimeView.prototype.showDuration = function () {
        this._$durationTime.classList.remove(this.styleNames.hidden);
    };
    TimeView.prototype.hideDuration = function () {
        this._$durationTime.classList.add(this.styleNames.hidden);
    };
    TimeView.prototype.show = function () {
        this._$node.classList.remove(this.styleNames.hidden);
    };
    TimeView.prototype.hide = function () {
        this._$node.classList.add(this.styleNames.hidden);
    };
    TimeView.prototype.getNode = function () {
        return this._$node;
    };
    TimeView.prototype.destroy = function () {
        if (this._$node.parentNode) {
            this._$node.parentNode.removeChild(this._$node);
        }
        delete this._$currentTime;
        delete this._$durationTime;
        delete this._$node;
    };
    return TimeView;
}(view_1.default));
TimeView.setTheme(time_theme_1.default);
TimeView.extendStyleNames(time_scss_1.default);
exports.default = TimeView;


/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var time_dot_1 = __webpack_require__(223);
exports.timeTemplate = time_dot_1.default;


/***/ }),
/* 223 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = anonymous;
function anonymous(props
/*``*/) {
var out='<div data-hook="time-control" class="'+(props.styles.timeWrapper)+' '+(props.themeStyles.timeText)+'"> <span data-hook="current-time-indicator" class="'+(props.styles.time)+'"> </span> <span data-hook="duration-time-indicator" class="'+(props.styles.time)+' '+(props.styles.duration)+'"> </span></div>';return out;
}

/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    timeText: {
        color: function (data) { return data.color; },
    },
};


/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(226);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"singleton":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(8)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--9-1!../../../../../node_modules/postcss-loader/lib/index.js??ref--9-2!../../../../../node_modules/sass-loader/lib/loader.js??ref--9-3!./time.scss", function() {
			var newContent = require("!!../../../../../node_modules/css-loader/index.js??ref--9-1!../../../../../node_modules/postcss-loader/lib/index.js??ref--9-2!../../../../../node_modules/sass-loader/lib/loader.js??ref--9-3!./time.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(false);
// imports


// module
exports.push([module.i, "._2YxKL{display:-webkit-box;display:-ms-flexbox;display:flex;padding:0;cursor:pointer;-webkit-transition-duration:.2s;transition-duration:.2s;-webkit-transition-property:opacity;transition-property:opacity;opacity:1;border:0;border-radius:0;outline:none;background-color:transparent;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center}._2YxKL:hover{opacity:.7}._3eQS8{visibility:hidden!important;width:0!important;min-width:0!important;height:0!important;min-height:0!important;margin:0!important;padding:0!important;opacity:0!important}._2Cmt3{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-flex:0;-ms-flex:0 0 auto;flex:0 0 auto;height:25px;-webkit-box-align:center;-ms-flex-align:center;align-items:center}._2U6I4{font-size:12px}div[data-hook=player-container][data-in-full-screen=true] ._2U6I4{font-size:14px}.KXIQc{margin-left:5px}.KXIQc:before{margin-right:4px;content:\"/\"}.MN2Gc ._1oGmy,.MN2Gc .KXIQc{display:none}", ""]);

// exports
exports.locals = {
	"controlButton": "_2YxKL",
	"hidden": "_3eQS8",
	"timeWrapper": "_2Cmt3",
	"time": "_2U6I4",
	"duration": "KXIQc",
	"liveMode": "MN2Gc",
	"separator": "_1oGmy"
};

/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
}
Object.defineProperty(exports, "__esModule", { value: true });
var volume_view_1 = __importDefault(__webpack_require__(228));
var keyboard_interceptor_1 = __importDefault(__webpack_require__(14));
var keyboard_control_1 = __webpack_require__(33);
var index_1 = __webpack_require__(2);
var VolumeControl = /** @class */ (function () {
    function VolumeControl(_a) {
        var engine = _a.engine, eventEmitter = _a.eventEmitter, textMap = _a.textMap, tooltipService = _a.tooltipService, theme = _a.theme;
        this._engine = engine;
        this._eventEmitter = eventEmitter;
        this._textMap = textMap;
        this._tooltipService = tooltipService;
        this._theme = theme;
        this._isMuted = this._engine.getMute();
        this._volume = this._engine.getVolume();
        this._bindCallbacks();
        this._initUI();
        this._bindEvents();
        this.view.setVolume(this._volume);
        this.view.setMute(this._isMuted);
        this._initInterceptor();
    }
    Object.defineProperty(VolumeControl.prototype, "node", {
        get: function () {
            return this.view.getNode();
        },
        enumerable: true,
        configurable: true
    });
    VolumeControl.prototype._initUI = function () {
        var config = {
            callbacks: {
                onDragStart: this._broadcastDragStart,
                onDragEnd: this._broadcastDragEnd,
                onVolumeLevelChangeFromInput: this._getVolumeLevelFromInput,
                onVolumeLevelChangeFromWheel: this._getVolumeLevelFromWheel,
                onToggleMuteClick: this._toggleMuteStatus,
            },
            theme: this._theme,
            textMap: this._textMap,
            tooltipService: this._tooltipService,
        };
        this.view = new VolumeControl.View(config);
    };
    VolumeControl.prototype._initInterceptor = function () {
        var _this = this;
        this._buttonInterceptor = new keyboard_interceptor_1.default({
            node: this.view.getButtonNode(),
            callbacks: (_a = {},
                _a[keyboard_interceptor_1.KEYCODES.SPACE_BAR] = function (e) {
                    e.stopPropagation();
                    _this._eventEmitter.emit(index_1.UI_EVENTS.KEYBOARD_KEYDOWN_INTERCEPTED);
                    _this._eventEmitter.emit(_this._isMuted
                        ? index_1.UI_EVENTS.UNMUTE_SOUND_WITH_KEYBOARD_TRIGGERED
                        : index_1.UI_EVENTS.MUTE_SOUND_WITH_KEYBOARD_TRIGGERED);
                },
                _a[keyboard_interceptor_1.KEYCODES.ENTER] = function (e) {
                    e.stopPropagation();
                    _this._eventEmitter.emit(index_1.UI_EVENTS.KEYBOARD_KEYDOWN_INTERCEPTED);
                    _this._eventEmitter.emit(_this._isMuted
                        ? index_1.UI_EVENTS.UNMUTE_SOUND_WITH_KEYBOARD_TRIGGERED
                        : index_1.UI_EVENTS.MUTE_SOUND_WITH_KEYBOARD_TRIGGERED);
                },
                _a),
        });
        this._inputInterceptor = new keyboard_interceptor_1.default({
            node: this.view.getInputNode(),
            callbacks: (_b = {},
                _b[keyboard_interceptor_1.KEYCODES.RIGHT_ARROW] = function (e) {
                    e.stopPropagation();
                    e.preventDefault();
                    _this._eventEmitter.emit(index_1.UI_EVENTS.KEYBOARD_KEYDOWN_INTERCEPTED);
                    _this._eventEmitter.emit(index_1.UI_EVENTS.INCREASE_VOLUME_WITH_KEYBOARD_TRIGGERED);
                    _this._engine.increaseVolume(keyboard_control_1.AMOUNT_TO_CHANGE_VOLUME);
                },
                _b[keyboard_interceptor_1.KEYCODES.LEFT_ARROW] = function (e) {
                    e.stopPropagation();
                    e.preventDefault();
                    _this._eventEmitter.emit(index_1.UI_EVENTS.KEYBOARD_KEYDOWN_INTERCEPTED);
                    _this._eventEmitter.emit(index_1.UI_EVENTS.DECREASE_VOLUME_WITH_KEYBOARD_TRIGGERED);
                    _this._engine.decreaseVolume(keyboard_control_1.AMOUNT_TO_CHANGE_VOLUME);
                },
                _b),
        });
        var _a, _b;
    };
    VolumeControl.prototype._destroyInterceptor = function () {
        this._buttonInterceptor.destroy();
        this._inputInterceptor.destroy();
    };
    VolumeControl.prototype._bindEvents = function () {
        this._eventEmitter.on(index_1.VIDEO_EVENTS.VOLUME_STATUS_CHANGED, this._updateVolumeStatus, this);
    };
    VolumeControl.prototype._bindCallbacks = function () {
        this._getVolumeLevelFromInput = this._getVolumeLevelFromInput.bind(this);
        this._toggleMuteStatus = this._toggleMuteStatus.bind(this);
        this._getVolumeLevelFromWheel = this._getVolumeLevelFromWheel.bind(this);
        this._broadcastDragStart = this._broadcastDragStart.bind(this);
        this._broadcastDragEnd = this._broadcastDragEnd.bind(this);
    };
    VolumeControl.prototype._broadcastDragStart = function () {
        this._eventEmitter.emit(index_1.UI_EVENTS.CONTROL_DRAG_START);
    };
    VolumeControl.prototype._broadcastDragEnd = function () {
        this._eventEmitter.emit(index_1.UI_EVENTS.CONTROL_DRAG_END);
    };
    VolumeControl.prototype._changeVolumeLevel = function (level) {
        this._engine.setVolume(level);
        this._eventEmitter.emit(index_1.UI_EVENTS.VOLUME_CHANGE_TRIGGERED, level);
    };
    VolumeControl.prototype._toggleMuteStatus = function () {
        this._engine.setMute(!this._isMuted);
        this._eventEmitter.emit(index_1.UI_EVENTS.MUTE_STATUS_TRIGGERED, !this._isMuted);
    };
    VolumeControl.prototype._getVolumeLevelFromWheel = function (delta) {
        var adjustedVolume = this._volume + delta / 10;
        var validatedVolume = Math.min(100, Math.max(0, adjustedVolume));
        this._changeVolumeStatus(validatedVolume);
    };
    VolumeControl.prototype._getVolumeLevelFromInput = function (level) {
        this._changeVolumeStatus(level);
    };
    VolumeControl.prototype._changeVolumeStatus = function (level) {
        this._changeVolumeLevel(level);
        if (this._isMuted) {
            this._toggleMuteStatus();
        }
    };
    VolumeControl.prototype._updateVolumeStatus = function () {
        this.setVolumeLevel(this._engine.getVolume());
        this.setMuteStatus(this._engine.getMute());
    };
    VolumeControl.prototype.setVolumeLevel = function (level) {
        if (level === this._volume) {
            return;
        }
        this._volume = level;
        this.view.setVolume(this._volume);
        this.view.setMute(Boolean(!this._volume));
    };
    VolumeControl.prototype.setMuteStatus = function (isMuted) {
        if (isMuted === this._isMuted) {
            return;
        }
        this._isMuted = isMuted;
        this.view.setVolume(this._isMuted ? 0 : this._volume);
        this.view.setMute(this._isMuted || Boolean(!this._volume));
    };
    VolumeControl.prototype.hide = function () {
        this.isHidden = true;
        this.view.hide();
    };
    VolumeControl.prototype.show = function () {
        this.isHidden = false;
        this.view.show();
    };
    VolumeControl.prototype._unbindEvents = function () {
        this._eventEmitter.off(index_1.VIDEO_EVENTS.VOLUME_STATUS_CHANGED, this._updateVolumeStatus, this);
    };
    VolumeControl.prototype.destroy = function () {
        this._destroyInterceptor();
        this._unbindEvents();
        this.view.destroy();
        delete this.view;
        delete this._eventEmitter;
        delete this._engine;
        delete this._textMap;
    };
    VolumeControl.moduleName = 'volumeControl';
    VolumeControl.View = volume_view_1.default;
    VolumeControl.dependencies = [
        'engine',
        'eventEmitter',
        'textMap',
        'tooltipService',
        'theme',
    ];
    return VolumeControl;
}());
exports.default = VolumeControl;


/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var index_1 = __webpack_require__(2);
var templates_1 = __webpack_require__(229);
var view_1 = tslib_1.__importDefault(__webpack_require__(10));
var htmlToElement_1 = tslib_1.__importDefault(__webpack_require__(6));
var getElementByHook_1 = tslib_1.__importDefault(__webpack_require__(11));
var volume_theme_1 = tslib_1.__importDefault(__webpack_require__(234));
var volume_scss_1 = tslib_1.__importDefault(__webpack_require__(235));
var DATA_IS_MUTED = 'data-is-muted';
var DATA_VOLUME = 'data-volume-percent';
var MAX_VOLUME_ICON_RANGE = 50;
var getPercentBasedOnXPosition = function (event, element) {
    var boundingRect = element.getBoundingClientRect();
    var positionX = event.clientX;
    if (positionX < boundingRect.left) {
        return 0;
    }
    if (positionX > boundingRect.left + boundingRect.width) {
        return 100;
    }
    return (event.clientX - boundingRect.left) / boundingRect.width * 100;
};
var VolumeView = /** @class */ (function (_super) {
    tslib_1.__extends(VolumeView, _super);
    function VolumeView(config) {
        var _this = this;
        var callbacks = config.callbacks, textMap = config.textMap, tooltipService = config.tooltipService, theme = config.theme;
        _this = _super.call(this, theme) || this;
        _this._callbacks = callbacks;
        _this._textMap = textMap;
        _this._tooltipService = tooltipService;
        _this._bindCallbacks();
        _this._initDOM();
        _this._bindEvents();
        return _this;
    }
    VolumeView.prototype._initDOM = function () {
        this._$node = htmlToElement_1.default(templates_1.controlTemplate({
            styles: this.styleNames,
            themeStyles: this.themeStyles,
            texts: {
                muteLabel: this._textMap.get(index_1.TEXT_LABELS.MUTE_CONTROL_LABEL),
                volumeLabel: this._textMap.get(index_1.TEXT_LABELS.VOLUME_CONTROL_LABEL),
            },
        }));
        this._$muteButton = getElementByHook_1.default(this._$node, 'mute-button');
        this._$volumeNode = getElementByHook_1.default(this._$node, 'volume-input-block');
        this._$hitbox = getElementByHook_1.default(this._$node, 'volume-hitbox');
        this._$volume = getElementByHook_1.default(this._$node, 'volume-input');
        this._muteButtonTooltipReference = this._tooltipService.createReference(this._$muteButton, {
            text: this._textMap.get(index_1.TEXT_LABELS.MUTE_CONTROL_TOOLTIP),
        });
    };
    VolumeView.prototype._bindCallbacks = function () {
        this._onButtonClick = this._onButtonClick.bind(this);
        this._startDragOnMouseDown = this._startDragOnMouseDown.bind(this);
        this._stopDragOnMouseUp = this._stopDragOnMouseUp.bind(this);
        this._setVolumeByWheel = this._setVolumeByWheel.bind(this);
        this._setVolumeByClick = this._setVolumeByClick.bind(this);
        this._setVolumeByDrag = this._setVolumeByDrag.bind(this);
    };
    VolumeView.prototype._bindEvents = function () {
        this._$hitbox.addEventListener('wheel', this._setVolumeByWheel);
        this._$hitbox.addEventListener('mousedown', this._startDragOnMouseDown);
        window.addEventListener('mousemove', this._setVolumeByDrag);
        window.addEventListener('mouseup', this._stopDragOnMouseUp);
        this._$muteButton.addEventListener('click', this._onButtonClick);
    };
    VolumeView.prototype._unbindEvents = function () {
        this._$hitbox.removeEventListener('wheel', this._setVolumeByWheel);
        this._$hitbox.removeEventListener('mousedown', this._startDragOnMouseDown);
        window.removeEventListener('mousemove', this._setVolumeByDrag);
        window.removeEventListener('mouseup', this._stopDragOnMouseUp);
        this._$muteButton.removeEventListener('click', this._onButtonClick);
    };
    VolumeView.prototype._startDragOnMouseDown = function (event) {
        if (event.button > 1) {
            return;
        }
        this._setVolumeByClick(event);
        this._startDrag();
    };
    VolumeView.prototype._stopDragOnMouseUp = function (event) {
        if (event.button > 1) {
            return;
        }
        this._stopDrag();
    };
    VolumeView.prototype._setVolumeByClick = function (event) {
        this._$volumeNode.focus();
        var percent = getPercentBasedOnXPosition(event, this._$hitbox);
        this._callbacks.onVolumeLevelChangeFromInput(percent);
    };
    VolumeView.prototype._setVolumeByDrag = function (event) {
        var percent = getPercentBasedOnXPosition(event, this._$hitbox);
        if (this._isDragging) {
            this._callbacks.onVolumeLevelChangeFromInput(percent);
        }
    };
    VolumeView.prototype._setVolumeByWheel = function (e) {
        e.preventDefault();
        var value = e.deltaX || e.deltaY * -1;
        if (!value) {
            return;
        }
        this._callbacks.onVolumeLevelChangeFromWheel(value);
    };
    VolumeView.prototype._startDrag = function () {
        this._isDragging = true;
        this._$node.classList.add(this.styleNames.isDragging);
        this._callbacks.onDragStart();
    };
    VolumeView.prototype._stopDrag = function () {
        if (this._isDragging) {
            this._isDragging = false;
            this._$node.classList.remove(this.styleNames.isDragging);
            this._callbacks.onDragEnd();
        }
    };
    VolumeView.prototype._setVolumeDOMAttributes = function (percent) {
        this._$volumeNode.setAttribute('value', String(percent));
        this._$volumeNode.setAttribute('aria-valuetext', this._textMap.get(index_1.TEXT_LABELS.VOLUME_CONTROL_VALUE, { percent: percent }));
        this._$volumeNode.setAttribute('aria-valuenow', String(percent));
        this._$volumeNode.setAttribute(DATA_VOLUME, String(percent));
        this._$volume.setAttribute('style', "width:" + percent + "%;");
        this._$node.setAttribute(DATA_VOLUME, String(percent));
        var iconTemplateProps = {
            styles: this.styleNames,
            themeStyles: this.themeStyles,
        };
        if (percent >= MAX_VOLUME_ICON_RANGE) {
            this._$muteButton.innerHTML = templates_1.volume100IconTemplate(iconTemplateProps);
        }
        else if (percent > 0) {
            this._$muteButton.innerHTML = templates_1.volume50IconTemplate(iconTemplateProps);
        }
        else {
            this._$muteButton.innerHTML = templates_1.volume0IconTemplate(iconTemplateProps);
        }
    };
    VolumeView.prototype._onButtonClick = function () {
        this._$muteButton.focus();
        this._callbacks.onToggleMuteClick();
    };
    VolumeView.prototype.setVolume = function (volume) {
        this._setVolumeDOMAttributes(volume);
    };
    VolumeView.prototype.setMute = function (isMuted) {
        this._setMuteDOMAttributes(isMuted);
    };
    VolumeView.prototype._setMuteDOMAttributes = function (isMuted) {
        if (isMuted) {
            this._$muteButton.innerHTML = templates_1.volume0IconTemplate({
                styles: this.styleNames,
                themeStyles: this.themeStyles,
            });
        }
        this._$node.setAttribute(DATA_IS_MUTED, isMuted);
        this._$muteButton.setAttribute('aria-label', isMuted
            ? this._textMap.get(index_1.TEXT_LABELS.UNMUTE_CONTROL_LABEL)
            : this._textMap.get(index_1.TEXT_LABELS.MUTE_CONTROL_LABEL));
        this._muteButtonTooltipReference.setText(isMuted
            ? this._textMap.get(index_1.TEXT_LABELS.UNMUTE_CONTROL_TOOLTIP)
            : this._textMap.get(index_1.TEXT_LABELS.MUTE_CONTROL_TOOLTIP));
    };
    VolumeView.prototype.show = function () {
        this._$node.classList.remove(this.styleNames.hidden);
    };
    VolumeView.prototype.hide = function () {
        this._$node.classList.add(this.styleNames.hidden);
    };
    VolumeView.prototype.getNode = function () {
        return this._$node;
    };
    VolumeView.prototype.getButtonNode = function () {
        return this._$muteButton;
    };
    VolumeView.prototype.getInputNode = function () {
        return this._$volumeNode;
    };
    VolumeView.prototype.destroy = function () {
        this._unbindEvents();
        this._muteButtonTooltipReference.destroy();
        if (this._$node.parentNode) {
            this._$node.parentNode.removeChild(this._$node);
        }
        delete this._$muteButton;
        delete this._$node;
        delete this._textMap;
    };
    return VolumeView;
}(view_1.default));
VolumeView.setTheme(volume_theme_1.default);
VolumeView.extendStyleNames(volume_scss_1.default);
exports.default = VolumeView;


/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var volume0Icon_dot_1 = __webpack_require__(230);
exports.volume0IconTemplate = volume0Icon_dot_1.default;
var volume50Icon_dot_1 = __webpack_require__(231);
exports.volume50IconTemplate = volume50Icon_dot_1.default;
var volume100Icon_dot_1 = __webpack_require__(232);
exports.volume100IconTemplate = volume100Icon_dot_1.default;
var control_dot_1 = __webpack_require__(233);
exports.controlTemplate = control_dot_1.default;


/***/ }),
/* 230 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = anonymous;
function anonymous(props
/*``*/) {
var out='<div class="'+(props.styles.icon)+'"> <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 17 14" preserveAspectRatio="xMidYMin slice" width="100%" style="padding-bottom: 82%; height: 1px; overflow: visible" > <!-- padding-bottom: 100% * height/width --> <!--width="16"--> <!--height="13"--> <g class="'+(props.themeStyles.volumeSvgFill)+'"> <path d="M0 3.919h2.993v5.97H0V3.92zm2.995-.015L7 .924v12L2.995 9.882v-5.98z"/> <path fill-rule="nonzero" d="M13 6.257l-2.05-2.05-.743.743L12.257 7l-2.05 2.05.743.743L13 7.743l2.05 2.05.743-.743L13.743 7l2.05-2.05-.743-.743L13 6.257z"/> </g> </svg></div>';return out;
}

/***/ }),
/* 231 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = anonymous;
function anonymous(props
/*``*/) {
var out='<div class="'+(props.styles.icon)+'"> <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 17 14" preserveAspectRatio="xMidYMin slice" width="100%" style="padding-bottom: 82%; height: 1px; overflow: visible" > <!-- padding-bottom: 100% * height/width --> <g fill="none" fill-rule="evenodd"> <path class="'+(props.themeStyles.volumeSvgFill)+'" d="M0 3.919h2.993v5.97H0V3.92zm2.995-.015L7 .924v12L2.995 9.882v-5.98z"/> <path class="'+(props.themeStyles.volumeSvgStroke)+'" d="M9.853 10.837a5.45 5.45 0 0 0 0-7.707"/> </g> </svg></div>';return out;
}

/***/ }),
/* 232 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = anonymous;
function anonymous(props
/*``*/) {
var out='<div class="'+(props.styles.icon)+'"> <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 17 14" preserveAspectRatio="xMidYMin slice" width="100%" style="padding-bottom: 82%; height: 1px; overflow: visible" > <!-- padding-bottom: 100% * height/width --> <g fill="none" fill-rule="evenodd"> <path class="'+(props.themeStyles.volumeSvgFill)+'" d="M0 3.919h2.993v5.97H0V3.92zm2.995-.015L7 .924v12L2.995 9.882v-5.98z"/> <path class="'+(props.themeStyles.volumeSvgStroke)+'" d="M12.793 13.716a9.607 9.607 0 0 0 0-13.586M9.853 10.837a5.45 5.45 0 0 0 0-7.707"/> </g> </svg></div>';return out;
}

/***/ }),
/* 233 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = anonymous;
function anonymous(props
/*``*/) {
var out='<div class="'+(props.styles.volumeControl)+'" data-hook="volume-control" data-volume-percent="100" data-is-muted="false"> <button class="'+(props.styles.muteButton)+' '+(props.styles.controlButton)+'" data-hook="mute-button" aria-label="'+(props.texts.muteLabel)+'" type="button" tabindex="0"> </button> <div class="'+(props.styles.volumeInputBlock)+'" data-hook="volume-input-block" aria-label="'+(props.texts.volumeLabel)+'" aria-valuemin="0" aria-valuenow="0" aria-valuemax="100" tabindex="0"> <div class="'+(props.styles.progressBar)+' '+(props.styles.background)+' '+(props.themeStyles.volumeProgressBackground)+'"> </div> <div class="'+(props.styles.progressBar)+' '+(props.styles.volume)+' '+(props.themeStyles.volumeProgress)+'" data-hook="volume-input"> </div> <div class="'+(props.styles.hitbox)+'" data-hook="volume-hitbox"> </div> </div></div>';return out;
}

/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var theme_1 = __webpack_require__(32);
exports.default = {
    volumeSvgFill: {
        fill: function (data) { return data.color; },
    },
    volumeSvgStroke: {
        stroke: function (data) { return data.color; },
    },
    volumeProgress: {
        backgroundColor: function (data) { return data.color; },
        '&:after': {
            backgroundColor: function (data) { return data.color; },
        },
    },
    volumeProgressBackground: {
        backgroundColor: function (data) { return theme_1.transperentizeColor(data.color, 0.25); },
    },
};


/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(236);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"singleton":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(8)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--9-1!../../../../../node_modules/postcss-loader/lib/index.js??ref--9-2!../../../../../node_modules/sass-loader/lib/loader.js??ref--9-3!./volume.scss", function() {
			var newContent = require("!!../../../../../node_modules/css-loader/index.js??ref--9-1!../../../../../node_modules/postcss-loader/lib/index.js??ref--9-2!../../../../../node_modules/sass-loader/lib/loader.js??ref--9-3!./volume.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(false);
// imports


// module
exports.push([module.i, ".E2kua{display:-webkit-box;display:-ms-flexbox;display:flex;padding:0;cursor:pointer;-webkit-transition-duration:.2s;transition-duration:.2s;-webkit-transition-property:opacity;transition-property:opacity;opacity:1;border:0;border-radius:0;outline:none;background-color:transparent;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.E2kua:hover{opacity:.7}._3C4MF{visibility:hidden!important;width:0!important;min-width:0!important;height:0!important;min-height:0!important;margin:0!important;padding:0!important;opacity:0!important}.FUvDX{position:relative;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;-webkit-transition:width .2s;transition:width .2s;-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start;-webkit-box-align:center;-ms-flex-align:center;align-items:center}div[data-hook=player-container][data-in-full-screen=true] .FUvDX{height:35px}.FUvDX._2zAYu ._1UYhz,.FUvDX:hover ._1UYhz{width:50px;margin-right:5px;opacity:1}div[data-hook=player-container][data-in-full-screen=true] .FUvDX._2zAYu ._1UYhz,div[data-hook=player-container][data-in-full-screen=true] .FUvDX:hover ._1UYhz{width:90px;margin-right:10px}._2MmwS{width:26px;min-width:26px;height:26px;min-height:26px;padding:0}div[data-hook=player-container][data-in-full-screen=true] ._2MmwS{width:35px;min-width:35px;height:35px;min-height:35px}div[data-hook=player-container][data-in-full-screen=true] ._2MmwS ._2jYGL{width:25px;height:21px}._2MmwS ._2jYGL{width:17px;height:14px}._1UYhz{position:relative;display:block;width:0;height:25px;margin-left:2px;-webkit-transition:opacity .2s,width .2s;transition:opacity .2s,width .2s;opacity:0}div[data-hook=player-container][data-in-full-screen=true] ._1UYhz{margin-left:5px}._2o3KY{position:absolute;top:11.5px;height:2px;padding:0}._1trKj:after{position:absolute;top:-3px;right:-4px;width:8px;height:8px;content:\"\";-webkit-transition:opacity .2s;transition:opacity .2s;border-radius:50%}div[data-hook=player-container][data-in-full-screen=true] ._1trKj:after{top:-4px;right:-5px;width:10px;height:10px}._2qbKK,.jT-Dn{width:100%}._2qbKK{position:relative;z-index:5;display:block;height:25px;cursor:pointer;opacity:0}[data-focus-source=key] [data-hook=volume-control] .focus-within._1UYhz,[data-focus-source=script] [data-hook=volume-control] .focus-within._1UYhz{width:50px;margin-right:5px;opacity:1;-webkit-box-shadow:0 0 0 2px rgba(56,153,236,.8);box-shadow:0 0 0 2px rgba(56,153,236,.8)}div[data-hook=player-container][data-in-full-screen=true] [data-focus-source=key] [data-hook=volume-control] .focus-within._1UYhz,div[data-hook=player-container][data-in-full-screen=true] [data-focus-source=script] [data-hook=volume-control] .focus-within._1UYhz{width:90px;margin-right:10px}", ""]);

// exports
exports.locals = {
	"controlButton": "E2kua",
	"hidden": "_3C4MF",
	"volumeControl": "FUvDX",
	"volumeInputBlock": "_1UYhz",
	"isDragging": "_2zAYu",
	"muteButton": "_2MmwS",
	"icon": "_2jYGL",
	"progressBar": "_2o3KY",
	"volume": "_1trKj",
	"background": "jT-Dn",
	"hitbox": "_2qbKK"
};

/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var index_1 = __webpack_require__(2);
var keyboard_interceptor_1 = tslib_1.__importDefault(__webpack_require__(14));
var full_screen_view_1 = tslib_1.__importDefault(__webpack_require__(238));
var FullScreenControl = /** @class */ (function () {
    function FullScreenControl(_a) {
        var eventEmitter = _a.eventEmitter, fullScreenManager = _a.fullScreenManager, textMap = _a.textMap, tooltipService = _a.tooltipService, theme = _a.theme;
        this._eventEmitter = eventEmitter;
        this._fullScreenManager = fullScreenManager;
        this._textMap = textMap;
        this._theme = theme;
        this._tooltipService = tooltipService;
        this._isInFullScreen = null;
        this._bindCallbacks();
        this._initUI();
        this._bindEvents();
        this.setControlStatus(false);
        if (!this._fullScreenManager.isEnabled) {
            this.hide();
        }
        this._initInterceptor();
    }
    Object.defineProperty(FullScreenControl.prototype, "node", {
        get: function () {
            return this.view.getNode();
        },
        enumerable: true,
        configurable: true
    });
    FullScreenControl.prototype._bindCallbacks = function () {
        this._toggleFullScreen = this._toggleFullScreen.bind(this);
    };
    FullScreenControl.prototype._bindEvents = function () {
        this._eventEmitter.on(index_1.UI_EVENTS.FULLSCREEN_STATUS_CHANGED, this.setControlStatus, this);
    };
    FullScreenControl.prototype._initUI = function () {
        var config = {
            callbacks: {
                onButtonClick: this._toggleFullScreen,
            },
            textMap: this._textMap,
            tooltipService: this._tooltipService,
            theme: this._theme,
        };
        this.view = new FullScreenControl.View(config);
    };
    FullScreenControl.prototype._initInterceptor = function () {
        var _this = this;
        this._interceptor = new keyboard_interceptor_1.default({
            node: this.node,
            callbacks: (_a = {},
                _a[keyboard_interceptor_1.KEYCODES.SPACE_BAR] = function (e) {
                    e.stopPropagation();
                    _this._eventEmitter.emit(index_1.UI_EVENTS.KEYBOARD_KEYDOWN_INTERCEPTED);
                },
                _a[keyboard_interceptor_1.KEYCODES.ENTER] = function (e) {
                    e.stopPropagation();
                    _this._eventEmitter.emit(index_1.UI_EVENTS.KEYBOARD_KEYDOWN_INTERCEPTED);
                },
                _a),
        });
        var _a;
    };
    FullScreenControl.prototype._destroyInterceptor = function () {
        this._interceptor.destroy();
    };
    FullScreenControl.prototype._toggleFullScreen = function () {
        if (this._isInFullScreen) {
            this._exitFullScreen();
        }
        else {
            this._enterFullScreen();
        }
    };
    FullScreenControl.prototype._enterFullScreen = function () {
        this._fullScreenManager.enterFullScreen();
    };
    FullScreenControl.prototype._exitFullScreen = function () {
        this._fullScreenManager.exitFullScreen();
    };
    FullScreenControl.prototype.setControlStatus = function (isInFullScreen) {
        this._isInFullScreen = isInFullScreen;
        this.view.setState({ isInFullScreen: this._isInFullScreen });
    };
    FullScreenControl.prototype.hide = function () {
        this.isHidden = true;
        this.view.hide();
    };
    FullScreenControl.prototype.show = function () {
        this.isHidden = false;
        this.view.show();
    };
    FullScreenControl.prototype._unbindEvents = function () {
        this._eventEmitter.off(index_1.UI_EVENTS.FULLSCREEN_STATUS_CHANGED, this.setControlStatus, this);
    };
    FullScreenControl.prototype.destroy = function () {
        this._destroyInterceptor();
        this._unbindEvents();
        this.view.destroy();
        delete this.view;
        delete this._eventEmitter;
        delete this._fullScreenManager;
        delete this._textMap;
        delete this.isHidden;
    };
    FullScreenControl.moduleName = 'fullScreenControl';
    FullScreenControl.View = full_screen_view_1.default;
    FullScreenControl.dependencies = [
        'eventEmitter',
        'fullScreenManager',
        'textMap',
        'tooltipService',
        'theme',
    ];
    return FullScreenControl;
}());
exports.default = FullScreenControl;


/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var index_1 = __webpack_require__(2);
var view_1 = tslib_1.__importDefault(__webpack_require__(10));
var templates_1 = __webpack_require__(239);
var htmlToElement_1 = tslib_1.__importDefault(__webpack_require__(6));
var getElementByHook_1 = tslib_1.__importDefault(__webpack_require__(11));
var full_screen_theme_1 = tslib_1.__importDefault(__webpack_require__(243));
var full_screen_scss_1 = tslib_1.__importDefault(__webpack_require__(244));
var DATA_IS_IN_FULL_SCREEN = 'data-is-in-full-screen';
var FullScreenView = /** @class */ (function (_super) {
    tslib_1.__extends(FullScreenView, _super);
    function FullScreenView(config) {
        var _this = this;
        var callbacks = config.callbacks, textMap = config.textMap, tooltipService = config.tooltipService, theme = config.theme;
        _this = _super.call(this, theme) || this;
        _this._callbacks = callbacks;
        _this._textMap = textMap;
        _this._$node = htmlToElement_1.default(templates_1.controlTemplate({
            styles: _this.styleNames,
            texts: {
                label: _this._textMap.get(index_1.TEXT_LABELS.ENTER_FULL_SCREEN_LABEL),
            },
        }));
        _this._$toggleFullScreenControl = getElementByHook_1.default(_this._$node, 'full-screen-button');
        _this._tooltipReference = tooltipService.createReference(_this._$toggleFullScreenControl, {
            text: _this._textMap.get(index_1.TEXT_LABELS.ENTER_FULL_SCREEN_TOOLTIP),
        });
        _this.setState({ isInFullScreen: false });
        _this._bindEvents();
        return _this;
    }
    FullScreenView.prototype._bindEvents = function () {
        this._onButtonClick = this._onButtonClick.bind(this);
        this._$toggleFullScreenControl.addEventListener('click', this._onButtonClick);
    };
    FullScreenView.prototype._unbindEvents = function () {
        this._$toggleFullScreenControl.removeEventListener('click', this._onButtonClick);
    };
    FullScreenView.prototype._onButtonClick = function () {
        this._$toggleFullScreenControl.focus();
        this._callbacks.onButtonClick();
    };
    FullScreenView.prototype.setState = function (_a) {
        var isInFullScreen = _a.isInFullScreen;
        if (isInFullScreen) {
            this._$toggleFullScreenControl.classList.add(this.styleNames.inFullScreen);
            this._$toggleFullScreenControl.innerHTML = templates_1.exitFullScreenIconTemplate({
                styles: this.styleNames,
                themeStyles: this.themeStyles,
            });
            this._$toggleFullScreenControl.setAttribute('aria-label', this._textMap.get(index_1.TEXT_LABELS.EXIT_FULL_SCREEN_LABEL));
            this._tooltipReference.setText(this._textMap.get(index_1.TEXT_LABELS.EXIT_FULL_SCREEN_TOOLTIP));
        }
        else {
            this._$toggleFullScreenControl.classList.remove(this.styleNames.inFullScreen);
            this._$toggleFullScreenControl.innerHTML = templates_1.enterFullScreenIconTemplate({
                styles: this.styleNames,
                themeStyles: this.themeStyles,
            });
            this._$toggleFullScreenControl.setAttribute('aria-label', this._textMap.get(index_1.TEXT_LABELS.ENTER_FULL_SCREEN_LABEL));
            this._tooltipReference.setText(this._textMap.get(index_1.TEXT_LABELS.ENTER_FULL_SCREEN_TOOLTIP));
        }
        this._$node.setAttribute(DATA_IS_IN_FULL_SCREEN, isInFullScreen);
    };
    FullScreenView.prototype.hide = function () {
        this._$node.classList.add(this.styleNames.hidden);
    };
    FullScreenView.prototype.show = function () {
        this._$node.classList.remove(this.styleNames.hidden);
    };
    FullScreenView.prototype.getNode = function () {
        return this._$node;
    };
    FullScreenView.prototype.destroy = function () {
        this._unbindEvents();
        this._tooltipReference.destroy();
        if (this._$node.parentNode) {
            this._$node.parentNode.removeChild(this._$node);
        }
        delete this._$toggleFullScreenControl;
        delete this._$node;
        delete this._textMap;
    };
    return FullScreenView;
}(view_1.default));
FullScreenView.setTheme(full_screen_theme_1.default);
FullScreenView.extendStyleNames(full_screen_scss_1.default);
exports.default = FullScreenView;


/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var enterFullScreenIcon_dot_1 = __webpack_require__(240);
exports.enterFullScreenIconTemplate = enterFullScreenIcon_dot_1.default;
var exitFullScreenIcon_dot_1 = __webpack_require__(241);
exports.exitFullScreenIconTemplate = exitFullScreenIcon_dot_1.default;
var control_dot_1 = __webpack_require__(242);
exports.controlTemplate = control_dot_1.default;


/***/ }),
/* 240 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = anonymous;
function anonymous(props
/*``*/) {
var out='<div class="'+(props.styles.icon)+'"> <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 14" preserveAspectRatio="xMidYMin slice" width="100%" style="padding-bottom: 100%; height: 1px; overflow: visible"> <!-- padding-bottom: 100% * height/width --> <path class="'+(props.themeStyles.fullScreenSvgFill)+'" fill-rule="evenodd" d="M2 10H0v4h4v-2H2v-2zM0 1v3h2V2h2V0H0v1zm14-1h-4v2h2v2h2V0zm-2 12h-2v2h4v-4h-2v2z"/> </svg></div>';return out;
}

/***/ }),
/* 241 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = anonymous;
function anonymous(props
/*``*/) {
var out='<div class="'+(props.styles.icon)+'"> <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 21" preserveAspectRatio="xMidYMin slice" width="100%" style="padding-bottom: 100%; height: 1px; overflow: visible" > <!-- padding-bottom: 100% * height/width --> <path class="'+(props.themeStyles.fullScreenSvgFill)+'" fill-rule="evenodd" d="M4 21h2v-6H0v2h4v4zM6 0H4v4H0v2h6V0zm9 6h6V4h-4V0h-2v6zm2 11h4v-2h-6v6h2v-4z"/> </svg></div>';return out;
}

/***/ }),
/* 242 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = anonymous;
function anonymous(props
/*``*/) {
var out='<div class="'+(props.styles.fullScreenControl)+'" data-hook="full-screen-control" data-is-in-full-screen="false"> <button class="'+(props.styles.fullScreenToggle)+' '+(props.styles.controlButton)+'" data-hook="full-screen-button" aria-label="'+(props.texts.label)+'" type="button" tabindex="0"/></div>';return out;
}

/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    fullScreenSvgFill: {
        fill: function (data) { return data.color; },
    },
};


/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(245);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"singleton":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(8)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--9-1!../../../../../node_modules/postcss-loader/lib/index.js??ref--9-2!../../../../../node_modules/sass-loader/lib/loader.js??ref--9-3!./full-screen.scss", function() {
			var newContent = require("!!../../../../../node_modules/css-loader/index.js??ref--9-1!../../../../../node_modules/postcss-loader/lib/index.js??ref--9-2!../../../../../node_modules/sass-loader/lib/loader.js??ref--9-3!./full-screen.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(false);
// imports


// module
exports.push([module.i, "._3kRRE{display:-webkit-box;display:-ms-flexbox;display:flex;padding:0;cursor:pointer;-webkit-transition-duration:.2s;transition-duration:.2s;-webkit-transition-property:opacity;transition-property:opacity;opacity:1;border:0;border-radius:0;outline:none;background-color:transparent;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center}._3kRRE:hover{opacity:.7}._2Emqs{visibility:hidden!important;width:0!important;min-width:0!important;height:0!important;min-height:0!important;margin:0!important;padding:0!important;opacity:0!important}._2nu2C{position:relative;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}._2dq3D{width:26px;min-width:26px;height:26px;min-height:26px;-webkit-transition:-webkit-transform .2s;transition:-webkit-transform .2s;transition:transform .2s;transition:transform .2s,-webkit-transform .2s}div[data-hook=player-container][data-in-full-screen=true] ._2dq3D{width:35px;min-width:35px;height:35px;min-height:21px}div[data-hook=player-container][data-in-full-screen=true] ._2dq3D .QPQ4K{width:21px;height:21px}._2dq3D .QPQ4K{width:14px;min-width:14px;height:14px;min-height:14px}._2dq3D:hover{-webkit-transform:scale(1.18);transform:scale(1.18)}._2dq3D._1PxDA:hover{-webkit-transform:scale(.8);transform:scale(.8)}", ""]);

// exports
exports.locals = {
	"controlButton": "_3kRRE",
	"hidden": "_2Emqs",
	"fullScreenControl": "_2nu2C",
	"fullScreenToggle": "_2dq3D",
	"icon": "QPQ4K",
	"inFullScreen": "_1PxDA"
};

/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var player_api_decorator_1 = tslib_1.__importDefault(__webpack_require__(12));
var keyboard_interceptor_1 = tslib_1.__importDefault(__webpack_require__(14));
var index_1 = __webpack_require__(2);
var logo_view_1 = tslib_1.__importDefault(__webpack_require__(247));
var Logo = /** @class */ (function () {
    function Logo(_a) {
        var engine = _a.engine, eventEmitter = _a.eventEmitter, config = _a.config, textMap = _a.textMap, tooltipService = _a.tooltipService;
        this._eventEmitter = eventEmitter;
        this._engine = engine;
        this._textMap = textMap;
        this._tooltipService = tooltipService;
        this._bindCallbacks();
        this._initUI();
        this._initInterceptor();
        var logoConfig = tslib_1.__assign({}, config.logo);
        this.setLogo(logoConfig.src);
        this.setLogoClickCallback(logoConfig.callback);
    }
    Object.defineProperty(Logo.prototype, "node", {
        get: function () {
            return this.view.getNode();
        },
        enumerable: true,
        configurable: true
    });
    Logo.prototype._bindCallbacks = function () {
        this._triggerCallback = this._triggerCallback.bind(this);
    };
    Logo.prototype._initUI = function () {
        var config = {
            callbacks: {
                onLogoClick: this._triggerCallback,
            },
            textMap: this._textMap,
            tooltipService: this._tooltipService,
        };
        this.view = new Logo.View(config);
    };
    Logo.prototype._initInterceptor = function () {
        var _this = this;
        this._interceptor = new keyboard_interceptor_1.default({
            node: this.node,
            callbacks: (_a = {},
                _a[keyboard_interceptor_1.KEYCODES.SPACE_BAR] = function (e) {
                    e.stopPropagation();
                    _this._eventEmitter.emit(index_1.UI_EVENTS.KEYBOARD_KEYDOWN_INTERCEPTED);
                    _this._triggerCallback();
                },
                _a[keyboard_interceptor_1.KEYCODES.ENTER] = function (e) {
                    e.stopPropagation();
                    _this._eventEmitter.emit(index_1.UI_EVENTS.KEYBOARD_KEYDOWN_INTERCEPTED);
                    _this._triggerCallback();
                },
                _a),
        });
        var _a;
    };
    Logo.prototype._destroyInterceptor = function () {
        this._interceptor.destroy();
    };
    Logo.prototype._triggerCallback = function () {
        if (this._callback) {
            this._callback();
        }
    };
    /**
     * Method for setting source of image, that would be used as logo
     * @param src - Source of logo
     * @example
     * player.setLogo('https://example.com/logo.png');
     *
     */
    Logo.prototype.setLogo = function (src) {
        this.view.setLogo(src);
    };
    /**
     * Method for attaching callback for click on logo
     *
     * @param callback - Your function
     *
     * @example
     * const callback = () => {
     *   console.log('Click on title);
     * }
     * player.setLogoClickCallback(callback);
     *
     */
    Logo.prototype.setLogoClickCallback = function (callback) {
        this._callback = callback;
        this.view.setDisplayAsLink(Boolean(this._callback));
    };
    Logo.prototype.hide = function () {
        this.isHidden = true;
        this.view.hide();
    };
    Logo.prototype.show = function () {
        this.isHidden = false;
        this.view.show();
    };
    Logo.prototype.destroy = function () {
        this._destroyInterceptor();
        this.view.destroy();
        delete this.view;
        delete this._engine;
        delete this._eventEmitter;
        delete this._textMap;
        delete this.isHidden;
    };
    Logo.moduleName = 'logo';
    Logo.View = logo_view_1.default;
    Logo.dependencies = [
        'engine',
        'config',
        'eventEmitter',
        'textMap',
        'tooltipService',
    ];
    tslib_1.__decorate([
        player_api_decorator_1.default()
    ], Logo.prototype, "setLogo", null);
    tslib_1.__decorate([
        player_api_decorator_1.default()
    ], Logo.prototype, "setLogoClickCallback", null);
    return Logo;
}());
exports.default = Logo;


/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var index_1 = __webpack_require__(2);
var view_1 = tslib_1.__importDefault(__webpack_require__(10));
var templates_1 = __webpack_require__(248);
var htmlToElement_1 = tslib_1.__importDefault(__webpack_require__(6));
var getElementByHook_1 = tslib_1.__importDefault(__webpack_require__(11));
var logo_scss_1 = tslib_1.__importDefault(__webpack_require__(250));
var LogoView = /** @class */ (function (_super) {
    tslib_1.__extends(LogoView, _super);
    function LogoView(config) {
        var _this = _super.call(this) || this;
        var callbacks = config.callbacks, textMap = config.textMap, tooltipService = config.tooltipService;
        _this._callbacks = callbacks;
        _this._textMap = textMap;
        _this._$node = htmlToElement_1.default(templates_1.logoTemplate({
            styles: _this.styleNames,
            texts: {
                label: _this._textMap.get(index_1.TEXT_LABELS.LOGO_LABEL),
            },
        }));
        _this._$logo = getElementByHook_1.default(_this._$node, 'company-logo');
        _this._$placeholder = getElementByHook_1.default(_this._$node, 'logo-placeholder');
        _this._tooltipReference = tooltipService.createReference(_this._$node, {
            text: _this._textMap.get(index_1.TEXT_LABELS.LOGO_TOOLTIP),
        });
        _this.setLogo(config.logo);
        _this._bindCallbacks();
        _this._bindEvents();
        return _this;
    }
    LogoView.prototype.setLogo = function (url) {
        if (url) {
            this._$logo.classList.remove(this.styleNames.hidden);
            this._$placeholder.classList.add(this.styleNames.hidden);
            this._$logo.setAttribute('src', url);
        }
        else {
            this._$logo.classList.add(this.styleNames.hidden);
            this._$placeholder.classList.remove(this.styleNames.hidden);
            this._$logo.removeAttribute('src');
        }
    };
    LogoView.prototype.setDisplayAsLink = function (flag) {
        if (flag) {
            this._$node.classList.add(this.styleNames.link);
        }
        else {
            this._$node.classList.remove(this.styleNames.link);
        }
    };
    LogoView.prototype._bindCallbacks = function () {
        this._onNodeClick = this._onNodeClick.bind(this);
    };
    LogoView.prototype._bindEvents = function () {
        this._$node.addEventListener('click', this._onNodeClick);
    };
    LogoView.prototype._unbindEvents = function () {
        this._$node.removeEventListener('click', this._onNodeClick);
    };
    LogoView.prototype._onNodeClick = function () {
        this._$node.focus();
        this._callbacks.onLogoClick();
    };
    LogoView.prototype.show = function () {
        this._$node.classList.remove(this.styleNames.hidden);
    };
    LogoView.prototype.hide = function () {
        this._$node.classList.remove(this.styleNames.hidden);
    };
    LogoView.prototype.getNode = function () {
        return this._$node;
    };
    LogoView.prototype.destroy = function () {
        this._unbindEvents();
        this._tooltipReference.destroy();
        if (this._$node.parentNode) {
            this._$node.parentNode.removeChild(this._$node);
        }
        delete this._$node;
        delete this._$logo;
        delete this._$placeholder;
        delete this._tooltipReference;
        delete this._textMap;
    };
    return LogoView;
}(view_1.default));
LogoView.extendStyleNames(logo_scss_1.default);
exports.default = LogoView;


/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var logo_dot_1 = __webpack_require__(249);
exports.logoTemplate = logo_dot_1.default;


/***/ }),
/* 249 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = anonymous;
function anonymous(props
/*``*/) {
var out='<div class="'+(props.styles.logoWrapper)+'"> <img class="'+(props.styles.companyLogo)+'" data-hook="company-logo" aria-label="'+(props.texts.label)+'" role="button" tab-index="0" /> <div class="'+(props.styles.logoPlaceholder)+'" data-hook="logo-placeholder"> <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 14" preserveAspectRatio="xMidYMin slice" width="100%" style="padding-bottom: 127%; height: 1px; overflow: visible"> <path fill="#FFF" fill-rule="evenodd" d="M2 12h10v-2h2v4H0V0h4v2H2v10zm10-8.515L7.414 8.071 6 6.657 10.657 2H9.004V0H14v5.005h-2v-1.52z"/> </svg> </div></div>';return out;
}

/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(251);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"singleton":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(8)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--9-1!../../../../../node_modules/postcss-loader/lib/index.js??ref--9-2!../../../../../node_modules/sass-loader/lib/loader.js??ref--9-3!./logo.scss", function() {
			var newContent = require("!!../../../../../node_modules/css-loader/index.js??ref--9-1!../../../../../node_modules/postcss-loader/lib/index.js??ref--9-2!../../../../../node_modules/sass-loader/lib/loader.js??ref--9-3!./logo.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(false);
// imports


// module
exports.push([module.i, "._1MKu4{display:-webkit-box;display:-ms-flexbox;display:flex;padding:0;cursor:pointer;-webkit-transition-duration:.2s;transition-duration:.2s;-webkit-transition-property:opacity;transition-property:opacity;opacity:1;border:0;border-radius:0;outline:none;background-color:transparent;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center}._1MKu4:hover{opacity:.7}.l7l_2{visibility:hidden!important;width:0!important;min-width:0!important;height:0!important;min-height:0!important;margin:0!important;padding:0!important;opacity:0!important}._2xUpl{position:relative;z-index:3;display:-webkit-box;display:-ms-flexbox;display:flex;cursor:pointer;-webkit-transition:opacity .2s,visibility .2s;transition:opacity .2s,visibility .2s;-webkit-transition-duration:.2s;transition-duration:.2s;opacity:1;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center}._2xUpl:hover ._3Vl69,._2xUpl:hover img{opacity:.7}._2xUpl._3d_RS{cursor:pointer}._108Hk{max-width:125px;max-height:26px;-webkit-transition:opacity .2s,visibility .2s;transition:opacity .2s,visibility .2s}div[data-hook=player-container][data-max-width~=\"550px\"] ._108Hk{max-width:90px;max-height:20px}div[data-hook=player-container][data-max-width~=\"350px\"] ._108Hk{max-width:70px;max-height:18px}div[data-hook=player-container][data-in-full-screen=true] ._108Hk{max-width:450px;max-height:36px}._3Vl69{width:14px;min-width:14px;height:14px;min-height:14px;-webkit-transition:-webkit-transform .2s;transition:-webkit-transform .2s;transition:transform .2s;transition:transform .2s,-webkit-transform .2s}div[data-hook=player-container][data-in-full-screen=true] ._3Vl69{width:21px;min-width:21px;height:21px;min-height:21px}._3Vl69:hover{-webkit-transform:scale(1.2);transform:scale(1.2)}", ""]);

// exports
exports.locals = {
	"controlButton": "_1MKu4",
	"hidden": "l7l_2",
	"logoWrapper": "_2xUpl",
	"logoPlaceholder": "_3Vl69",
	"link": "_3d_RS",
	"companyLogo": "_108Hk"
};

/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
}
Object.defineProperty(exports, "__esModule", { value: true });
var native_1 = __importDefault(__webpack_require__(253));
var constants_1 = __webpack_require__(2);
var defaultPlaybackAdapters = [
    native_1.default(constants_1.MediaStreamTypes.DASH, constants_1.MediaStreamDeliveryPriority.NATIVE_ADAPTIVE),
    native_1.default(constants_1.MediaStreamTypes.HLS, constants_1.MediaStreamDeliveryPriority.NATIVE_ADAPTIVE),
    native_1.default(constants_1.MediaStreamTypes.MP4, constants_1.MediaStreamDeliveryPriority.NATIVE_PROGRESSIVE),
    native_1.default(constants_1.MediaStreamTypes.WEBM, constants_1.MediaStreamDeliveryPriority.NATIVE_PROGRESSIVE),
];
exports.default = defaultPlaybackAdapters;


/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var constants_1 = __webpack_require__(2);
var video_data_1 = __webpack_require__(25);
var environment_detection_1 = __webpack_require__(37);
var NATIVE_ERROR_CODES = {
    ABORTED: 1,
    NETWORK: 2,
    DECODE: 3,
    SRC_NOT_SUPPORTED: 4,
};
function getNativeAdapterCreator(streamType, deliveryPriority) {
    var NativeAdapter = /** @class */ (function () {
        function NativeAdapter(eventEmitter) {
            this.mediaStreams = null;
            this.eventEmitter = eventEmitter;
            this.currentLevel = 0;
            this._bindCallbacks();
        }
        NativeAdapter.isSupported = function () {
            return environment_detection_1.NativeEnvironmentSupport[streamType];
        };
        Object.defineProperty(NativeAdapter.prototype, "currentUrl", {
            get: function () {
                return this.mediaStreams[this.currentLevel].url;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(NativeAdapter.prototype, "syncWithLiveTime", {
            get: function () {
                // TODO: implement syncWithLiveTime for `native`
                return undefined;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(NativeAdapter.prototype, "isDynamicContent", {
            get: function () {
                return !isFinite(this.videoElement.duration);
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(NativeAdapter.prototype, "isDynamicContentEnded", {
            get: function () {
                // TODO: implement isDynamicContentEnded
                return false;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(NativeAdapter.prototype, "isSyncWithLive", {
            get: function () {
                // TODO: implement isSyncWithLive for `native`
                return false;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(NativeAdapter.prototype, "isSeekAvailable", {
            get: function () {
                return true;
                //Need to find better solution
                /*
                if (this.isDynamicContent) {
                  return false;
                }
          
                return Boolean(this.videoElement.seekable.length);
                */
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(NativeAdapter.prototype, "mediaStreamDeliveryPriority", {
            get: function () {
                return deliveryPriority;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(NativeAdapter.prototype, "mediaStreamType", {
            get: function () {
                return streamType;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(NativeAdapter.prototype, "debugInfo", {
            get: function () {
                if (this.videoElement) {
                    var _a = this.videoElement, buffered = _a.buffered, currentTime = _a.currentTime;
                    var overallBufferLength = video_data_1.geOverallBufferLength(buffered);
                    var nearestBufferSegInfo = video_data_1.getNearestBufferSegmentInfo(buffered, currentTime);
                    return tslib_1.__assign({}, this.mediaStreams[0], { deliveryPriority: this.mediaStreamDeliveryPriority, overallBufferLength: overallBufferLength,
                        nearestBufferSegInfo: nearestBufferSegInfo });
                }
                return {};
            },
            enumerable: true,
            configurable: true
        });
        NativeAdapter.prototype._bindCallbacks = function () {
            this.broadcastError = this.broadcastError.bind(this);
        };
        NativeAdapter.prototype.canPlay = function (mediaType) {
            return mediaType === streamType;
        };
        NativeAdapter.prototype.setMediaStreams = function (mediaStreams) {
            this.mediaStreams = mediaStreams;
        };
        NativeAdapter.prototype.logError = function (error, errorEvent) {
            this.eventEmitter.emit(constants_1.VIDEO_EVENTS.ERROR, {
                errorType: error,
                streamType: streamType,
                streamProvider: 'native',
                errorInstance: errorEvent,
            });
        };
        NativeAdapter.prototype.broadcastError = function () {
            var error = this.videoElement.error;
            switch (error.code) {
                case NATIVE_ERROR_CODES.ABORTED:
                    //No need for broadcasting
                    break;
                case NATIVE_ERROR_CODES.NETWORK:
                    this.logError(constants_1.ERRORS.CONTENT_LOAD, error);
                    break;
                case NATIVE_ERROR_CODES.DECODE:
                    this.logError(constants_1.ERRORS.MEDIA, error);
                    break;
                case NATIVE_ERROR_CODES.SRC_NOT_SUPPORTED:
                    /*
                      Our url checks would not allow not supported formats, so only case would be
                       when video tag couldn't retriev any info from endpoit
                    */
                    this.logError(constants_1.ERRORS.CONTENT_LOAD, error);
                    break;
                default:
                    this.logError(constants_1.ERRORS.UNKNOWN, error);
                    break;
            }
        };
        NativeAdapter.prototype.attach = function (videoElement) {
            this.videoElement = videoElement;
            this.videoElement.addEventListener('error', this.broadcastError);
            this.videoElement.src = this.mediaStreams[this.currentLevel].url;
        };
        NativeAdapter.prototype.detach = function () {
            this.videoElement.removeEventListener('error', this.broadcastError);
            this.videoElement.src = '';
            this.videoElement = null;
        };
        return NativeAdapter;
    }());
    return NativeAdapter;
}
exports.default = getNativeAdapterCreator;


/***/ })
/******/ ]);
});


// WEBPACK FOOTER //
// playable.bundle.min.js